{
  "common": {
    "btn": {
      "create": "Create",
      "create-new": "Create New",
      "create-account": "Create account",
      "later": "Later",
      "add": "Add",
      "clone": "Clone",
      "clone-resource": "Clone",
      "renew": "Renew",
      "update": "Update",
      "confirm": "Confirm",
      "submit": "Submit",
      "sign-in": "Sign in",
      "edit": "Edit",
      "delete": "Delete",
      "new-record": "New record",
      "generate": "Generate",
      "close": "Close",
      "cancel": "Cancel",
      "manage": "Manage",
      "print": "Print",
      "download": "Download",
      "action": {
        "label": "Actions",
        "option": {
          "view": "View details",
          "edit": "Edit",
          "delete": "Delete",
          "manage": "Manage"
        }
      }
    },
    "main-header": {
      "edit-profile": "Edit profile",
      "change-pwd": "Change password",
      "sign-out": "Sign out",
      "admin-setting": "Admin settings"
    },
    "footer": {
      "privacy": "Privacy",
      "term": "Terms",
      "support": "Supports",
      "feedback": "Feedback"
    },
    "aiml-app": {
      "main-header": {
        "my-task": "My tasks",
        "my-applications": "My applications"
      },
      "sub-header1": {
        "title": "All apps"
      }
    },
    "required": "Required",
    "confirmation": "Confirmation",
    "a11y": {
      "loading": "Loading…"
    },
    "delete-message-one-item": "Delete an item of {entity_name}? This action cannot be reversed.",
    "delete-message-multiple-items": "Delete {selected_item_count} items of {entity_name}? This action cannot be reversed."
  },
  "public": {
    "sing-in": {
      "header": "Sign in to OptimalHR",
      "email": "Email",
      "password": "Password"
    },
    "register": {
      "header": "Register new tenant",
      "first-name": {
        "label": "First name",
        "description": "Your given name"
      },
      "last-name": {
        "label": "Last name",
        "description": "Your family name"
      },
      "email": {
        "label": "Email",
        "description": "Your working email address",
        "error-message-invalid-email": "This email is invalid. Please use another valid email address.",
        "error-message-email-already-exits": "This email is already used in AIML Apps. Please use another valid email address.",
        "error-message-no-email": "A valid email address is required"
      },
      "organization": {
        "label": "Organization",
        "description": "Your tenant's name. This could be the name of your business, school, nonprofit organization, etc."
      },
      "process": {
        "header": "Successfully created new tenant",
        "title": "OptimalHR is creating system resources required for your tenant's identity and isolation. This may take a moment.",
        "create-user-and-identity-directory": "Creating user and identity pools.",
        "create-policy-and-role": "Creating policies and roles.",
        "apply-policy-and-role": "Applying policies to roles.",
        "create-admin-user-and-tenant-records": "Creating admin user and other records necessary for your tenant to start using the system.",
        "message": "Your login information sent to {email_address}",
        "back": "Go to",
        "login-screen": "Login screen"
      }
    },
    "confirm-tenant": {
      "main-title": "Congratulations on your successful login!",
      "description": "Please change your password before proceeding.",
      "current-password": {
        "title": "Current password",
        "description": "The temporary password sent to your email."
      },
      "new-password": {
        "title": "New password",
        "description": "Minimum password length is 8. Required uppercase letters, lowercase letters and numbers."
      },
      "confirm-password": {
        "title": "Confirm new password",
        "description": "Repeat your new password."
      },
      "error-messaga": {
        "pwd-not-match": "Passwords do not match.",
        "pwd-required": "Current, new, and confirm passwords are required. Please enter these values.",
        "pwd-required-type": "Password must contain uppercase letters, lowercase letters, numbers and 8 characters minimum."
      }
    },
    "change-pwd": {
      "main-title": "Change password",
      "description": " ",
      "current-pwd": {
        "title": "Current password",
        "description": " "
      },
      "new-pwd": {
        "title": "New password",
        "description": "Minimum password length is 8. Required uppercase letters, lowercase letters and numbers."
      },
      "confirm-pwd": {
        "title": "Confirm new password",
        "description": "Repeat your new password."
      },
      "error-messaga": {
        "pwd-not-match": "Passwords do not match.",
        "pwd-required": "Current, new, and confirm passwords are required. Please enter these values.",
        "pwd-required-type": "Password must contain uppercase letters, lowercase letters, numbers and 8 characters minimum."
      }
    },
    "edit-profile": {
      "main-title": "Edit profile",
      "description": " ",
      "first-name": "First name",
      "last-name": "Last name"
    }
  },
  "aimlApp": {
    "my-tasks": {
      "main-header": "My tasks",
      "placeholder-search": "Search tasks by name"
    },
    "my-applications": {
      "main-header": "My applications",
      "placeholder-search": "Search apps by name",
      "all-apps": {
        "title": "All apps",
        "group-human-capital-management": "Human Capital Managment",
        "group-administration": "Administration"
      },
      "recently-visited": {
        "title": "Recently visited apps"
      }
    }
  },
  "acm": {
    "messageProvisionedResources": {
      "header": "",
      "message": ""
    },
    "user": {
      "list": {
        "main-title": "Users",
        "filter-box-placeholder": "Filter by user name, first name, last name, ...",
        "description": " ",
        "table-name": "user",
        "table-header": {
          "user-name": "User name",
          "first-name": "First name",
          "last-name": "Last name",
          "role": "Role",
          "create-at": "Created at",
          "create-by": "Created by"
        },
        "filter-key": {
          "user-name": "Filter by User name",
          "first-name": "Filter by First name",
          "last-name": "Filter by Last name",
          "role": "Filter by Role"
        }
      },
      "form": {
        "main-title-create": "Create new user",
        "main-title-edit": "Edit user",
        "description": "",
        "user-identity": {
          "title": "User identity",
          "user-name": {
            "label": "User name",
            "description": "",
            "placeholder": "Must be a valid email address"
          },
          "first-name": {
            "label": "First name",
            "description": " ",
            "placeholder": "For example, Bopha"
          },
          "last-name": {
            "label": "Last name",
            "description": "",
            "placeholder": "For example, CHAN"
          },
          "line-employee": {
            "label": "Linked employee",
            "description": "",
            "placeholder": ""
          }
        },
        "user-permission": {
          "title": "User permission",
          "system-base-role": {
            "label": "System based role",
            "tenant-user": "Tenant user",
            "tenant-admin": "Tenant admin(administers other users)",
            "description": ""
          },
          "job-base-role": {
            "label": "Job based role",
            "description": "",
            "placeholder": "Select an existing role for this user"
          },
          "policy": {
            "label": "Policy",
            "description": "",
            "placeholder": "Select existing policies defining permissions for those users"
          }
        }
      },
      "detail": {
        "main-title": "User details",
        "description": "",
        "user-identity": {
          "title": "User identity",
          "user-name": "User name",
          "first-name": "First name",
          "last-name": "Last name",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "permission": {
          "title": "User permission",
          "system-based-role": "System based role",
          "job-based-role": "Job based role",
          "policies": "Policies"
        }
      }
    },
    "policy": {
      "list": {
        "main-title": "Policies",
        "filter-box-placeholder": "Filter by policy name",
        "description": " ",
        "table-name": "policy",
        "table-header": {
          "name": "Name",
          "statements": "Statements",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "filter-key": {
          "name": "Filter by policy name"
        }
      },
      "form": {
        "main-title-create": "Create policy",
        "main-title-edit": "Edit policy",
        "description": "",
        "general-info": {
          "title": "General information",
          "name": {
            "label": "Name",
            "description": "",
            "placeholder": "For example, HR Assistant"
          }
        },
        "statements": {
          "title": "Statements",
          "discription": "A policy statement defines a set of permissions used to a assign to a either a Role, User or User Group. A policy can have multiple statements, e.g. Statement 1 define permissions to access resources under Directory service while Statement 2 is for Employees service",
          "statement-name": {
            "label": "Statement name",
            "description": "",
            "placeholder": "E.g. Directory Service"
          },
          "serviec-name": {
            "label": "Service name",
            "description": "",
            "placeholder": "Select the service to which you want to have access control"
          },
          "resources": {
            "label": "Resources",
            "description": "",
            "placeholder": "Select those resource(s) to which you want to have access control"
          },
          "action": {
            "label": "Actions",
            "description": "",
            "placeholder": "Select those action(operations) to include in this statement"
          },
          "effect": {
            "label": "Effect",
            "description": "Specify whether to Allow or Deny above Actions/Operations under this statement",
            "allow": "Allow",
            "deny": "Deny"
          }
        }
      },
      "detail": {
        "main-title": "Policy details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "policy-type": "Policy type",
          "policy-name": "Policy name",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "statement": {
          "title": "Statements",
          "name": "Name",
          "service": "Service",
          "details": {
            "view-detail": "View details",
            "title": "Statement details",
            "name": "Name",
            "service": "Service",
            "effect": "Effect",
            "resources": "Resources",
            "actions": "Actions"
          }
        }
      }
    },
    "role": {
      "list": {
        "main-title": "Roles",
        "filter-box-placeholder": "Filter by role name",
        "description": " ",
        "table-name": "role",
        "table-header": {
          "name": "Name",
          "statements": "Policies",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "filter-key": {
          "name": "Filter by role name"
        }
      },
      "form": {
        "main-title-create": "Create role",
        "main-title-edit": "Edit role",
        "description": "",
        "general-info": {
          "title": "General information",
          "name": {
            "label": "Name",
            "description": "",
            "placeholder": "For example, HR Executive"
          }
        },
        "permissions": {
          "title": "Permissions",
          "policies": {
            "label": "Policies",
            "description": "",
            "placeholder": "Select one or more existing policies to define permissions"
          }
        }
      },
      "detail": {
        "main-title": "Role details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "policy-type": "Role name",
          "policy-name": "Role type",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "permission": {
          "title": "Permission",
          "policies": "Policies"
        }
      }
    },
    "user-group": {
      "list": {
        "main-title": "User groups",
        "filter-box-placeholder": "Filter by group name",
        "description": " ",
        "table-name": "user group",
        "table-header": {
          "group-name": "Group name",
          "user": "User",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by group name"
        }
      },
      "form": {
        "main-title-create": "Create user group",
        "main-title-edit": "Edit user group",
        "description": "",
        "group-name": {
          "label": "Group name",
          "description": "",
          "placeholder": "For example, HR Interns"
        },
        "group-members": {
          "label": "Group members",
          "description": "",
          "placeholder": "Select existing users to become members of the group"
        },
        "group-permissions": {
          "label": "Group permissions",
          "description": "",
          "placeholder": "Select existing policies defining permissions for those users"
        }
      },
      "detail": {
        "main-title": "User group details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "group-name": "Group name",
          "group-members": "Group members",
          "group-permission": "Group permission",
          "created-at": "Created at",
          "created-by": "Created by"
        }
      }
    }
  },
  "directory": {
    "messageProvisionedResources": {
      "header": "Initialize Default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "people": "People",
      "organizations": "Organizations",
      "data-migrations": "Data Migrations"
    },
    "people": {
      "list": {
        "main-title": "People",
        "filter-box-placeholder": "Filter by Full Name",
        "table-header": {
          "full-name": "Full Name",
          "gender": "Gender",
          "phone-number": "Phone Number",
          "email-address": "Email Address"
        },
        "filter-key": {
          "full-name": "Filter by Full Name",
          "middle-name": "Filter by Middle Name",
          "last-name": "Filter by Last Name"
        }
      },
      "delete-message": "Are you sure you want to delete this record ?",
      "form": {
        "main-title-create": "Create Individual Profile",
        "main-title-edit": "Edit Individual Profile",
        "personal-data": {
          "sub-title": "Personal data",
          "title": {
            "label": "Title",
            "description": " "
          },
          "full-name": {
            "label": "Full name",
            "description": "You can enter their family name and given name, for example SOK Sovatha"
          },
          "first-name": {
            "label": "First name",
            "description": " "
          },
          "last-name": {
            "label": "Last name",
            "description": " "
          },
          "middle-name": {
            "label": "Middle name",
            "description": " "
          },
          "gender": {
            "label": "Gender",
            "description": " ",
            "options": {
              "male": "Male",
              "female": "Female"
            }
          },
          "phone-number": {
            "label": "Phone number",
            "description": "Mobile number(s)"
          },
          "email-address": {
            "label": "Email address",
            "description": "Email address(es)"
          },
          "date-of-birth": {
            "label": "Date of birth",
            "description": " "
          },
          "country-of-birth": {
            "label": "Country of birth",
            "description": " "
          },
          "province-of-birth": {
            "label": "Province of birth",
            "description": " "
          },
          "nationality": {
            "label": "Nationality",
            "description": " "
          },
          "national-id": {
            "label": "National id",
            "description": " "
          },
          "marital-status": {
            "label": "Marital status",
            "description": " "
          },
          "profile-photo": {
            "label": "Profile Photo",
            "description": " "
          },
          "profile-summary": {
            "label": "Profile summary",
            "description": " "
          },
          "achievement": {
            "label": "Achievement",
            "description": " "
          }
        },
        "contact-info": {
          "sub-title": "Contact Information",
          "contact-type": {
            "label": "Contact Type",
            "description": " "
          },
          "contact-value": {
            "label": "Contact Value",
            "description": " "
          }
        }
      },
      "details": {
        "main-title": "Profile Details",
        "personal-data": {
          "sub-title": "Personal Data",
          "first-name": "First Name",
          "middle-name": "Middle Name",
          "last-name": "Last Name",
          "gender": "Gender",
          "date-of-birth": "Date Of Birth",
          "place-of-birth": "Place Of Birth",
          "nationality": "Nationality",
          "marital-status": "Marital Status"
        },
        "contact-info": {
          "sub-title": "Contact Information"
        }
      }
    },
    "organizations": {
      "basic-form": {
        "main-header-create": "Create organization profile",
        "main-header-edit": "Edit organization profile",
        "basic-data": {
          "title": "Basic data",
          "offical-name": "Official name",
          "short-name": "Short name",
          "nature": "Nature",
          "industry": "Industry"
        }
      }
    }
  },
  "employment": {
    "messageProvisionedResources": {
      "header": "Initialize default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "employer": "Employers"
    },
    "employer": {
      "executiveOversight": {
        "search": "Search by project or overseer...",
        "executiveOversightForm": {
          "title": "Assign Executive Overseer",
          "editForm": {
            "title": "Edit Oversight Assignment"
          },
          "outsourcingProject": {
            "title": "Outsourcing Project / Company",
            "description": "Select the managed company for oversight assignment",
            "search": "-- Select Project --"
          },
          "SLTMembers": {
            "title": "SLT Members",
            "description": "Select one or more Senior Leadership Team members to assign",
            "search": "Search employees..."
          }
        },
        "assignOverseer": "Assigned Overseers",
        "noAssignOverseer": "No overseers assigned",
        "alreadyAssigned": "Already assigned"
      },
      "list": {
        "main-title": "Employers",
        "filter-box-placeholder": "Filter by full name, abbreviated name, ...",
        "description": "If you manage different businesses, branches or projects, you can use employers to group their respective employees, payrolls and their other related data all under your tenant. Note that your tenant employer {organization_name}, has already been created for you by the system.",
        "table-name": "employer",
        "table-header": {
          "full-name": "Full name",
          "abbreviated-name": "Abbreviated name",
          "employee-id-format": "Employee ID format",
          "type": "Type",
          "active-employee": "Active employee"
        },
        "filter-key": {
          "full-name": "Filter by Full name",
          "abbreviated-name": "Filter by Abbreviated name",
          "type": "Filter by type"
        }
      },
      "delete-message": "Are you sure want to delete this employer?",
      "detail": {
        "main-title": "Employer details",
        "sub-title1": {
          "title": "General information",
          "full-name": "Full name",
          "abbreviated-name": "Abbreviated name",
          "employee-id-format": "Employee ID format",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "sub-title2": {
          "title": "Other info",
          "phone-number": "Phone number(s)",
          "email-address": "Email address(es)",
          "street-address": "Street address",
          "website": "Website",
          "logo": "Logo"
        }
      },
      "form": {
        "main-title-create": "Create new employer",
        "main-title-edit": "Edit employer",
        "description": "For a quick creation, you enter just the basic data first while other datails could be entered any time later.",
        "general-info": {
          "title": "General information",
          "full-name": {
            "label": "Full name",
            "description": "What is the full name of the employer entity? E.g. Angkor Brilliant Consulting."
          },
          "abbreviated-name": {
            "label": "Abbreviated name",
            "description": "What is its short name? E.g. ABC"
          },
          "employee-id-format": {
            "label": "Employee ID format",
            "description": "The placeholder of employee ID. E.g. ABC-00000"
          }
        },
        "details": {
          "title": "Other info",
          "phone-number": {
            "label": "Phone number(s)",
            "description": "One or more phone numbers"
          },
          "email-address": {
            "label": "Email address(es)",
            "description": "One or more email addresses."
          },
          "street-address": {
            "label": "Address",
            "description": "Street address."
          },
          "website": {
            "label": "Website",
            "description": "Website URL e.g www.abc-consulting.com"
          },
          "logo": {
            "label": "Logo",
            "description": "Image(.jpeg or .png)."
          }
        }
      },
      "manage": {
        "main-title": "Employer's management",
        "description": "Below are the summaries for your employer. Select one of the sections below to go inside it to administer its records in detail.",
        "app-sections": {
          "employee": {
            "title": "Employees",
            "description": "Manage employee profiles",
            "active": "Active"
          },
          "department": {
            "title": "Departments",
            "description": "Manage departments/sections",
            "active": "Active"
          },
          "job-profile": {
            "title": "Job Profiles",
            "description": "Manage job profiles",
            "active": "Active"
          }
        }
      }
    },
    "employee": {
      "list": {
        "main-title": "Employees",
        "filter-box-placeholder": "Filter by full name, job title, ...",
        "description": " ",
        "table-name": "employee",
        "table-header": {
          "employee-id": "Employee ID",
          "employee-name": "Full name",
          "employee-status": "Status",
          "job-title": "Job title",
          "department": "Department",
          "work-contacts": "Work contacts"
        },
        "filter-key": {
          "employee-id": "Filter by Employee ID",
          "employee-name": "Filter by Full name",
          "employee-status": "Filter by Status",
          "job-title": "Filter by Job title",
          "department": "Filter by Department",
          "work-email": "Filter by Work email"
        }
      },
      "delete-message": "Deleting this employee will delete all his/her related data. Are you sure you want to delete this employee?",
      "form": {
        "main-title-create": "Create new employee",
        "main-title-edit": "Edit employee",
        "description": "For a quick creation, you enter just the employee's personal and job summaries while their other details could be added any time later.",
        "personal-summary": {
          "title": "Personal summary",
          "full-name": {
            "label": "Full name",
            "description": "You can enter their family name and given name, for example SOK Sovatha"
          },
          "gender": {
            "label": "Gender",
            "description": " ",
            "male": "Male",
            "female": "Female"
          },
          "phone-number": {
            "label": "Phone number",
            "description": "Mobile number(s)"
          },
          "email-address": {
            "label": "Email",
            "description": "Email address(es)"
          }
        },
        "job-summary": {
          "title": "Job summary",
          "hire-data": {
            "label": "Hire date",
            "description": "The exact data the employee starts working. Note that this could be different from the date you create this record."
          },
          "employee-classification": {
            "label": "Employee classification",
            "description1": "Employees with fixed duration contracts (FDCs) or undetermined duration contracts (UDCs).",
            "description2": "Employees performing work temporarily, intermittently or seasonally.",
            "regular": "Regular",
            "casual": "Casual"
          }
        }
      },
      "detail": {
        "main-title": "Employee details",
        "description": "To have more accurate profile, you need to update the following sections to reflect the employee's current job. To edit data for a section, click on Edit button on the right of the section title.",
        "summaries": {
          "title": "Summaries",
          "employee-id": "Employee ID",
          "full-name": "Full name",
          "employment-status": "Employment status",
          "employee-classification": "Employee classification",
          "position": "Position",
          "department": "Department",
          "hire-date": "Hire date",
          "end-date": "End date",
          "phone-number": "Phone number"
        },
        "employment-detail": {
          "employment-detail": {
            "title": "Employment Details",
            "subsection": {
              "current-job": "Current Job",
              "compensation": "Compensation and Benefits",
              "employment-contract": "Contracts",
              "bank-info": "Bank Information",
              "family-member": "Family Members",
              "work-contact": "Contacts",
              "insurance": "Insurance"
            }
          },
          "personal-detail": {
            "title": "Personal Details",
            "subsection": {
              "bio-data": "Bio Data",
              "contact": "Contacts",
              "dependent": "Dependents",
              "parent": "Parent Information",
              "insurance": "Insurance Membership/NSSF",
              "work-permit": "Workbook/Work Permit"
            }
          },
          "employment-contract": {
            "list": {
              "main-title": "Employment contracts",
              "filter-box-placeholder": "Filter by Job Title, Type, ... ",
              "table-name": "Employment contract",
              "table-header": {
                "job-title": "Job title",
                "type": "Type",
                "status": "Status",
                "start-date": "Start date",
                "end-date": "End date"
              },
              "filter-key": {
                "job-title": "Filter by Job Title",
                "type": "Filter by Type",
                "status": "Filter by Status",
                "start-date": "Filter by Start Date",
                "end-date": "Filter by End Date"
              }
            },
            "form": {
              "main-title-create": "Create new contract",
              "main-title-edit": "Edit contract",
              "main-title-renew": "Renew contract",
              "type": {
                "label": "Type",
                "description": "FDC: Fixed Duration Contract, UDC: Undetermined Duration Contract, Select PROBATION if the contract for the employee covers just the probation period."
              },
              "employment-type": {
                "label": "Employment type",
                "description": " "
              },
              "start-date": {
                "label": "Start date",
                "description": " "
              },
              "end-date": {
                "label": "End date",
                "description": " "
              },
              "enable-reminder": "Enable reminder",
              "period": "With probation period, end date",
              "send-email-reminder": "Send email reminder at",
              "send-to": "Send to",
              "job-role": {
                "label": "Job role",
                "description": " ",
                "placeholder": "Select a job profile"
              },
              "department": {
                "label": "Department",
                "description": " ",
                "placeholder": "Select a department"
              },
              "line-manager": {
                "label": "Line manager",
                "description": " ",
                "placeholder": "Select line manager"
              },
              "basic-salary": {
                "label": "Basic salary (monthly)",
                "description": " ",
                "placeholder": " "
              },
              "upload-document": {
                "label": "Upload document",
                "description": " "
              }
            },
            "detail": {
              "main-title": "Employment contract details",
              "job": {
                "current-job": "Current Job",
                "modify": "Modify via Employment Change",
                "position": "Position",
                "department": "Department",
                "employment-type": "Employment Type",
                "contract-type": "Contract Type",
                "reports-to": "Reports To",
                "org-unit": "Org. Unit",
                "project-client": "Project / Client",
                "hire-date": "Hire Date",
                "work-location": "Work Location",
                "working-hours": "Working Hours",
                "employment-change-note": "Position, department and contract changes are governed by Employment Change — every modification creates an auditable event with effective date, reason, and approval trail.",
                "start-one": "Start one →"
              },
              "overview": {
                "sub-title": "Overview",
                "contract-type": "Contract type",
                "employment-type": "Employment type",
                "job-role": "Job role",
                "department": "Department",
                "line-manager": "Line manager",
                "start-date": "Start date",
                "end-date": "End date",
                "enable-reminder": "Enable Reminder",
                "period": "Probation period end date",
                "send-email-reminder": "Send email reminder at",
                "send-to": "Send to"
              },
              "related-events": {
                "list": {
                  "main-title": "Employment changes",
                  "table-name": "employment change",
                  "table-header": {
                    "type": "Change type",
                    "effective-date": "Effective date",
                    "description": "Description",
                    "created-date": "Created at",
                    "Created-by": "Created by"
                  }
                },
                "form": {
                  "main-title-create": "Create new employment change",
                  "main-title-edit": "Edit employment change",
                  "description": "Fill in those required and any of optional fields below to soundly reflect this change for the employee.",
                  "type": {
                    "label": "Type",
                    "description": "Select a type applicable to change"
                  },
                  "employment-type": {
                    "label": "Employment type",
                    "description": "Specify a employment type"
                  },
                  "effective-date": {
                    "label": "Effective date",
                    "description": "Specify the date from which the change takes effect."
                  },
                  "reason": {
                    "label": "Reason",
                    "description": "What is the motive for the change?"
                  },
                  "job-role": {
                    "label": "Job role",
                    "description": "If the change affects new job role, specify it one below."
                  },
                  "basic-salary": {
                    "label": "Basic salary (monthly)",
                    "description": "If the change affects new basic salary, specify it below."
                  },
                  "department": {
                    "label": "Department",
                    "description": "If the change affects new department/section, specify it below."
                  },
                  "line-manager": {
                    "label": "Line manager",
                    "description": "If the change affects new line manager, specify it below."
                  }
                },
                "detail": {
                  "main-title": "Employment change details",
                  "desciprtion": "",
                  "type": "Change type",
                  "reason": "Reason",
                  "effective-date": "Effective date",
                  "employment-type": "Employment type",
                  "job-role": "Job role",
                  "department": "Department",
                  "line-manager": "Line manager",
                  "created-at": "Created at",
                  "created-by": "Created by",
                  "updated-at": "Updated at",
                  "updated-by": "Updated by",
                  "benefits": {
                    "sub-title": "Benefits"
                  }
                }
              }
            }
          },
          "current-job": {
            "main-title": "Current job",
            "description": " ",
            "job-profile": {
              "see-detail": "See details",
              "sub-titile": "Job profile",
              "position": "Position",
              "grade": "Grade",
              "level": "Level",
              "working-hours-per-week": "Working hours per week",
              "responsibilities": "Responsibilities",
              "requirements": "Requirements",
              "job-description": "Job description"
            },
            "organizational-structure": {
              "sub-titile": "Organizational structure",
              "department": "Department",
              "number-of-subordinates": "Subordinates",
              "line-manager": "Line manager"
            },
            "employment": {
              "sub-titile": "Employment",
              "status": "Status",
              "type": "Type",
              "contract": "Contract",
              "basic-salary": "Basic salary (monthly)",
              "work-schedule": "Work schedule",
              "annual-leave-balance": "Annual leave balance"
            }
          }
        },
        "responsibilities": {
          "responsibilitiesDescription": "Describe the key duties and accountabilities of this role."
        },
        "requirements": {
          "requirementsDescription": "List required skills, experience and qualifications."
        },
        "jobGradeDescription": "Used for compensation and career progression.",
        "employmentLevelDescription": "Defines seniority and role classification.",
        "day": "Days",
        "entitlementType": {
          "title": "Entitlements",
          "entitlementType": "Entitlement Type",
          "column": {
            "daysEarned": "Days Earned",
            "notes": "Notes",
            "openingBalance": "Opening Balance",
            "carriedForward": "Carried Forward",
            "monthlyAccrual": "Monthly Accrual",
            "seniorityAccrual": "Seniority Accrual"
          }
        }
      },
      "employmentDetails": "Employment Details",
      "jobTitle": "Job Title",
      "jobGrade": "Job Grade",
      "employmentLevel": "Employment Level",
      "baseSalary": "Base Salary",
      "workingHoursPerWeek": "Working Hours per Week",
      "workLocation": "Work Location",
      "scheduleName": "Schedule Name",
      "responsibilities": "Responsibilities",
      "requirements": "Requirements",
      "reportingStructure": "Reporting Structure",
      "directManager": "Direct Manager",
      "reports": "Reports",
      "viewReports": "View Reports",
      "organizationalUnit": "Organizational Unit",
      "organizationalLayer": "Organizational Layer",
      "workingSchedule": "Working Schedule",
      "workingDays": "Working Days",
      "totalWeeklyHours": "Total Weekly Hours"
    },
    "leave": {
      "entitlementsSummary": "Leave Entitlements Summary",
      "totalEntitlement": "Total Entitlement",
      "annualLeaveTaken": "Annual Leave Taken",
      "annualLeaveBalance": "Annual Leave Balance",
      "periodSummary": "Leave Period Summary"
    },
    "job-profile": {
      "list": {
        "main-title": "Job profiles",
        "filter-box-placeholder": "Filter by position, level, grade....",
        "description": " ",
        "table-name": "Job profile",
        "table-header": {
          "position-title": "Position title",
          "level": "Level",
          "grade": "Grade",
          "min-salary": "Min salary",
          "max-salary": "Max salary",
          "working-hours": "Working hours"
        },
        "filter-key": {
          "position-title": "Filter by Position title",
          "grade": "Filter by Job grade",
          "level": "Filter by Job level",
          "min-salary": "Filter by Min salary",
          "max-salary": "Filter by Max salary",
          "working-hours": "Filter by Working hours"
        }
      },
      "form": {
        "main-title-create": "Create new job profile",
        "main-title-edit": "Edit job profile",
        "description": " ",
        "general-info": {
          "sub-title": "General information",
          "position": {
            "label": "Position",
            "description": " ",
            "placeholder": "Select a position"
          },
          "job-grade": {
            "label": "Job grade",
            "description": " ",
            "placeholder": "Select a job grade"
          },
          "job-level": {
            "label": "Job level",
            "description": " ",
            "placeholder": "Select a job level"
          },
          "min-salary": {
            "label": "Min. salary",
            "description": " ",
            "placeholder": " "
          },
          "max-salary": {
            "label": "Max. salary",
            "description": " ",
            "placeholder": " "
          },
          "base-currency": {
            "label": "Base currency",
            "description": " ",
            "placeholder": "Select a base currency"
          },
          "working-hours-per-week": {
            "label": "Working hours/per week",
            "description": " ",
            "placeholder": " "
          }
        },
        "responsibilities": {
          "sub-title": "Responsibilities"
        },
        "requirements": {
          "sub-title": "Requirements"
        },
        "required-competency": {
          "sub-title": "Required competencies",
          "description": " "
        },
        "competencies": {
          "sub-title": "Competencies"
        }
      },
      "detail": {
        "main-title": "Job profile details",
        "general-info": {
          "sub-title": "General information",
          "position-title": "Position title",
          "grade": "Grade",
          "level": "Level",
          "min-salary": "Min salary",
          "max-salary": "Max salary",
          "working-hour": "Working hour",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "responsibilities": "Responsibilities",
        "requirements": "Requirements"
      }
    },
    "department": {
      "list": {
        "main-title": "Departments",
        "filter-box-placeholder": "Filter by full name, abbreviated name, ...",
        "description": " ",
        "table-name": "department",
        "table-header": {
          "full-name": "Full name",
          "abbreviated-name": "Abbreviated name",
          "status": "Status",
          "parent-department": "Parent department"
        },
        "filter-key": {
          "full-name": "Filter by Full name",
          "abbreviated-name": "Filter by  Abbreviated name",
          "status": "Filter by Status",
          "parent-department": "Filter by Parent department"
        }
      },
      "form": {
        "main-title-create": "Create new department",
        "main-title-edit": "Edit department",
        "full-name": {
          "label": "Full name",
          "description": "Full name for the department/section",
          "placeholder": " "
        },
        "abbreviated-name": {
          "label": "Abbreviated Name",
          "description": "Select an abbreviated name for the department/section",
          "placeholder": " "
        },
        "parent-department": {
          "label": "Parent department",
          "description": "Select a parent for the department/section",
          "placeholder": "Select a parent for the department/section"
        }
      },
      "delete-message": "Are you sure want to delete this department?",
      "detail": {
        "general-info": {
          "sub-title": "General information",
          "full-name": "Full name",
          "status": "Status",
          "abbreviated-name": "Abbreviated name",
          "parent-department": "Parent department",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        }
      }
    },
    "compensation": {
      "detail": {
        "main-title": "Compensation and benefits",
        "description": "You use this section to record those compensation and benefits offered to the employee.",
        "basic-salary": {
          "sub-title": "Base salary",
          "salary": "Basic salary (monthly)"
        },
        "pay-structure": {
          "sub-title": "Pay structure",
          "pay-structure": "Linked pay structure"
        },
        "pay-structure-form": {
          "main-title": "Edit employee pay structure",
          "description": "The selected pay structure below will be assigned to the {count_employee} selected employee(s).",
          "pay-structure": {
            "label": "Pay structure",
            "description": " "
          }
        }
      }
    },
    "bank-info": {
      "main-title": "Bank information details",
      "sub-header": "Bank information",
      "full-name": "Full name",
      "short-name": "Short name",
      "account-name": "Account name",
      "account-number": "Account number",
      "form": {
        "main-title": "Edit bank information",
        "bank-full-name": "Bank full name",
        "account-name": "Account name",
        "account-number": "Account number"
      }
    },
    "family-member": {
      "main-title": "Family members",
      "spouse": "Spouse",
      "children": "Children",
      "parent": "Parents",
      "table-name-spouse": "spouse",
      "table-name-child": "child",
      "table-name-parent": "parent",
      "btn-lable-spouse": "Edit spouse",
      "btn-lable-children": "Edit children",
      "btn-lable-parent": "Edit parent",
      "table": {
        "name": "Full name",
        "gender": "Gender",
        "date-of-birth": "Date of birth",
        "dependent": "Dependent"
      },
      "form": {
        "edit-spouse": "Edit spouse",
        "edit-child": "Edit child",
        "edit-parent": "Create parent",
        "name": "Full name",
        "gender": "Gender",
        "dependent": {
          "title": "Dependent",
          "true": "True",
          "false": "False"
        }
      }
    },
    "work-contact": {
      "main-title": "Contacts",
      "description": " ",
      "list": {
        "main-title": "Work contacts",
        "description": " ",
        "table": {
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      },
      "form": {
        "main-title": "Edit work contacts",
        "contact-type": "Contact type",
        "contact-value": "Contact value"
      }
    },
    "personal-detail": {
      "personal-contact": {
        "main-title": "Contacts",
        "description": " ",
        "list": {
          "title": "Personal contacts",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        },
        "form": {
          "title": "Edit personal contact",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      },
      "emergency-contact": {
        "main-title": "Emergency contacts",
        "description": " ",
        "list": {
          "name": "Name",
          "relationship": "Relationship",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        },
        "form": {
          "title": "Edit emergency contact",
          "name": "Name",
          "relationship": "Relationship",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      }
    },
    "job-grade": {
      "mainTabelHeader": "Job Grades & Salary Bands",
      "column": {
        "grade": "Grade Level",
        "level": "Level",
        "typical-titles": "Typical Job Titles",
        "salary-range-currency": "Salary Currency",
        "salary-ranges": "Salary Band"
      },
      "filter-text": "Search by grade level, or job title…"
    }
  },
  "leave": {
    "messageProvisionedResources": {
      "header": "Initialize default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "leave": "Leave"
    },
    "leave-type": {
      "list": {
        "main-title": "Leave Types",
        "filter-box-placeholder": "Filter by Name, Code, ...",
        "description": "Leave types refers to the different categories or types of leave that employees can take from work. Some common types of leave are vacation leave, sick leave, personal leave or emergency leave, parental or family leave, and bereavement leave.",
        "table-header": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status"
        },
        "filter-key": {
          "title": "Filter by Title:",
          "code": "Filter by Code:"
        }
      },
      "delete-message": "Are you sure want to delete this leave type?",
      "detail": {
        "main-title": "Leave type details",
        "general": "General Information",
        "general-info": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        }
      },
      "form": {
        "main-title-create": "Create leave type",
        "main-title-edit": "Edit leave type",
        "general-info": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "availability-des": "ON_AVAILABLE generally applies to ANNUAL_LEAVE, ON_GRANTED generally applies to MATERNITY_LEAVE, ALWAYS generally applies to SICK_LEAVE.",
          "status": "Status",
          "on-available": "ON_AVAILABLE",
          "on-granted": "ON_GRANTED",
          "always": "ALWAYS",
          "active": "Active",
          "inactive": "Inactive"
        }
      }
    },
    "leave-request": {
      "list": {
        "main-title": "Leave Requests",
        "filter-box-placeholder": "Filter by LeaveType.Code, Status, ...",
        "description": " Leave request is an important part of workforce management, as it helps ensure that employees have access to the time off they need while also ensuring that the business can continue to operate effectively.",
        "table-header": {
          "employee-name": "Employee Name",
          "leave-type": "Leave Type",
          "from-date": "From Date",
          "to-date": "To Date",
          "status": "Status"
        },
        "table-field": {
          "employee-name": "Employee.Name",
          "leave-type": "LeaveType.Title",
          "from-date": "FromDate",
          "to-date": "ToDate",
          "status": "Status"
        },
        "filter-key": {
          "code": "Filter by LeaveType.Code:",
          "status": "Filter by Status:"
        }
      },
      "delete-message": "Are you sure want to delete this leave request?",
      "delete-applied-date-message": "Are you sure want to delete this applied date?",
      "submit-message": "Are you sure want to submit this leave request?",
      "approve-message": "Are you sure want to approve this leave request?",
      "detail": {
        "main-title": "Leave request details",
        "general": "General Information",
        "approve": "Approve",
        "reject": "Reject",
        "reason": "Reason",
        "cancel": "Cancel",
        "general-info": {
          "employee-name": "Employee name",
          "leave-type": "Leave type",
          "date": "Date",
          "reason": "Reason",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by",
          "validated-at": "Validated at",
          "validated-by": "Validated by"
        }
      },
      "form": {
        "main-title-create": "Create Leave Request",
        "main-title-edit": "Edit Leave Request",
        "general-info": {
          "leave-type": "Leave Type",
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status",
          "date": "Date",
          "period-day": "Period of day",
          "whole-day": "WHOLE DAY",
          "whole-day-value": "WHOLE_DAY",
          "apply-date-create": "Create apply dates",
          "apply-date-edit": "Edit applied date",
          "morning": "MORNING",
          "afternoon": "AFTERNOON",
          "on-available": "ON_AVAILABLE",
          "on-available-des": "This generally applies to ANNUAL_LEAVE",
          "on-granted": "ON_GRANTED",
          "on-granted-des": "This generally applies to MATERNITY_LEAVE, etc.",
          "always": "ALWAYS",
          "always-des": "This generally applies to SICK_LEAVE, etc.",
          "active": "Active",
          "inactive": "Inactive",
          "leave-balance": "Remaining Leave",
          "reasons": "Reason",
          "manager": "Line Manager",
          "cc": "Line Manager CC"
        }
      }
    }
  },
  "payroll": {
    "messageProvisionedResources": {
      "header": "Initialize Default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "employer": {
      "list": {
        "main-title": "Employers",
        "element": {
          "active-employee": "Active employees",
          "pay-structure": "Pay structures",
          "created-payrolls": "Created payrolls"
        }
      },
      "details": {
        "main-title": "Employer details",
        "employees": {
          "title": "Employees",
          "active": "Active"
        },
        "payrolls": {
          "title": "Payrolls",
          "created-payrolls": "Created payrolls"
        },
        "pay-structures": {
          "title": "Payroll structures",
          "created-pay-structure": "Created payroll structures"
        }
      }
    },
    "payroll": {
      "list": {
        "main-title": "Payrolls",
        "description": "",
        "table-name": "payroll",
        "filter-box-placeholder": "Filter by pay structure name, ...",
        "table-header": {
          "pay-structure": "Pay structure name",
          "pay-period": "Pay period",
          "payroll-template": "Payroll Template",
          "staff": "Staff",
          "status": "Status"
        },
        "filter-key": {
          "pay-structure": "Filter by pay structure name"
        }
      },
      "delete-message": "Are you sure want to delete this payroll?",
      "detail": {
        "main-title": "Payroll detail",
        "general-info": {
          "title": "General Information",
          "pay-structure": "Pay structure name",
          "pay-period": "Pay period",
          "template": "Template name",
          "exchange-rate": "Exchange rates",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "process-status": {
          "title": "Process overview"
        },
        "current-step": {
          "title": "Current step",
          "step-status": "Step Status"
        },
        "step-detail": {
          "title": "Current Step details",
          "pay-structure": "Pay structure",
          "pay-period": "Pay period",
          "payroll-template": "Payroll Template",
          "exchange-rate": "Exchange rates",
          "document": "Document"
        },
        "validate-employee": {
          "result": "Results",
          "included-emloyee": "Found {value} employee(s) included in this payroll",
          "excluded-employee": "Found {value} employee(s) excluded from this payroll"
        }
      },
      "form": {
        "main-title-create": "Create new payroll",
        "main-title-edit": "Edit payroll",
        "description": "The following data are used to identify a payroll based on its Pay Structure, Pay Period and Pay Frequency under a specific Employer.",
        "pay-structure": {
          "label": "Pay structure",
          "description": "What is the pay structure of the payroll entity? E.g. Default Pay Structure."
        },
        "pay-period": {
          "label": "Pay period",
          "description": "What is its pay period? E.g. January"
        },
        "payroll-tempate": {
          "label": "Payroll template",
          "description": "What is its payroll template? E.g. First Payroll Template"
        },
        "exchange-rate": {
          "label": "Exchange rates",
          "description": "Input exchange rates (US$ : KHR) to apply in this payroll. E.g. 1$ = 4000R"
        }
      }
    },
    "employee-incomes-expense": {
      "list": {
        "main-title": "Employees' Incomes/Expenses",
        "table-name": "incomes/expenses",
        "description": " ",
        "filter-key": {
          "employee-name": "Filter by employee name",
          "employee-id": "Filter by employee id"
        },
        "label-btn": {
          "download-record-template": "Download record template (.xlsx)",
          "upload-record": "Upload records (.xlsx)",
          "new-record-manual-input": "New record (manual input)"
        }
      },
      "form": {
        "main-title-create": "Employees' income/expense",
        "employee-name": {
          "label": "Employee name",
          "description": " ",
          "placeholder": "Select the employee needed to add a component pay record"
        },
        "employee-id": {
          "label": "Employee ID",
          "description": " "
        },
        "table": {
          "pay-component": "Pay Component",
          "amount": "Amount (USD)",
          "description": "Description",
          "document": "Document"
        },
        "main-title-edit": "Edit Employees' income/expense",
        "component": {
          "label": "Component",
          "placeholder": "Select a user-input component to record income/expense"
        },
        "amount": "Amount (USD)",
        "description": "Description",
        "upload-document": "Upload document"
      }
    },
    "employee-pay-record": {
      "list": {
        "main-title": "Employee pay records",
        "table-name": "employee pay record"
      },
      "detail-history": {
        "main-title": "Pay record edit history",
        "employee": "Employee",
        "table": {
          "data-time": "Edited at",
          "edited-by": "Edited by",
          "component": "Component",
          "from": "From",
          "to": "To",
          "reason": "Reason"
        }
      }
    },
    "pay-structure": {
      "list": {
        "main-title": "Pay Structures",
        "description": "If you don't have any pay structures yet, you can create one by making an identical copy of the general template from AIML SaaS system. Click <strong> Clone </strong> button to create new one for your tenant.",
        "table-name": "pay structure",
        "filter-box-placeholder": "Filter by name, ...",
        "table-header": {
          "name": "Name",
          "employee": "Employee",
          "pay-interval": "Pay Interval",
          "pay-component": "Pay Components",
          "status": "Status"
        },
        "filter-key": {
          "name": "Filter by name"
        }
      },
      "delete-message": "Are you sure want to delete this pay structure?",
      "detail": {
        "main-title": "Pay structure details",
        "basic-info": {
          "title": "Basic Information",
          "name": "Name",
          "legal-requirement": "Legal requirement",
          "pay-method": "Pay method",
          "pay-interval": "Pay Interval",
          "pay-frequency": "Pay frequency",
          "pay-date": "Pay date",
          "pay-process": "Pay process",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "menu": {
          "pay-roll-component": "Payroll Components",
          "pay-period": "Pay Periods",
          "payroll-template": "Payroll Templates",
          "payroll-exchange-rate": "Exchange Rates"
        }
      },
      "form": {
        "main-title-create": "Create new pay structure",
        "main-title-edit": "Edit pay structure",
        "description": "",
        "legal-requirement": {
          "label": "Legal requirement",
          "description": " "
        },
        "name": {
          "label": "Name",
          "description": " "
        },
        "pay-method": {
          "label": "Pay method",
          "description": " "
        },
        "pay-interval": {
          "label": "Pay interval",
          "description": " "
        },
        "pay-frequency": {
          "label": "Pay frequency",
          "description": " "
        },
        "pay-date": {
          "label": "Pay date",
          "description": " "
        },
        "pay-process": {
          "label": "Pay process",
          "description": " "
        }
      }
    },
    "payroll-component": {
      "list": {
        "main-title": "Payroll Components",
        "table-name": "payroll component",
        "filter-box-placeholder": "",
        "table-header": {
          "title": "Title",
          "type": "Type",
          "category": "Category",
          "tax-applicability": "Tax applicability",
          "status": "Status",
          "order": "Order",
          "currency-conversion": "Currency conversion",
          "exchange-rate": "Exchange rate",
          "actions": "Actions"
        },
        "filter-key": {
          "title": "Filter by title",
          "type": "Filter by type",
          "category": "Filter by category",
          "tax-applicability": "Filter by tax applicability",
          "status": "Filter by status",
          "currency-conversion": "Filter by currency conversion",
          "exchange-rate": "Filter by exchange rate"
        }
      },
      "form": {
        "main-title-create": "Create payroll component",
        "main-title-edit": "Edit payroll component",
        "title": {
          "title": "Title",
          "placeholder": "E.g. Salary Deduction"
        },
        "group": {
          "title": "Group",
          "placeholder": "Select a group for the component"
        },
        "category": {
          "title": "Category"
        },
        "tax-applicability": {
          "title": "Tax applicability"
        },
        "code": {
          "title": "Code"
        },
        "source-of-value": {
          "title": "Source of value"
        },
        "reference": {
          "title": "Reference"
        },
        "use-as": {
          "title": "Use as"
        },
        "currency": {
          "title": "Currency"
        },
        "status": {
          "title": "Status"
        }
      }
    },
    "payroll-process": {
      "list": {
        "main-title": "Payroll Processes",
        "description": " ",
        "table-name": "payroll process",
        "filter-box-placeholder": "Filter by name, status ...",
        "table-header": {
          "name": "Name",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by name",
          "status": "Filter by status"
        }
      },
      "delete-message": "Are you sure want to delete this payroll process?",
      "detail": {
        "main-title": "Payroll process details",
        "name": "Name",
        "status": "Status",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new payroll process",
        "main-title-edit": "Edit payroll process",
        "description": "",
        "overview": {
          "title": "Overview",
          "name": {
            "label": "Name",
            "description": " "
          },
          "status": {
            "label": "Status",
            "description": " "
          }
        }
      }
    },
    "pay-period": {
      "list": {
        "main-title": "Pay Periods",
        "description": "",
        "table-name": "pay period",
        "filter-box-placeholder": "Filter by title, status ...",
        "table-header": {
          "period-name": "Title",
          "start-date": "Start date",
          "end-date": "End date",
          "status": "Status"
        },
        "filter-key": {
          "name": "Filter by title",
          "status": "Filter by status"
        }
      },
      "delete-message": "Are you sure want to delete this pay period?",
      "detail": {
        "main-title": "Pay period details",
        "title": "Title",
        "start-date": "Start date",
        "end-date": "End date",
        "status": "Status",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new pay period",
        "main-title-edit": "Edit pay period",
        "description": "",
        "title": {
          "label": "Title",
          "description": " "
        },
        "start-date": {
          "label": "Start date",
          "description": " "
        },
        "end-date": {
          "label": "End date",
          "description": " "
        },
        "status": {
          "label": "Status",
          "description": " "
        }
      }
    },
    "payroll-template": {
      "list": {
        "main-title": "Payroll Templates",
        "description": "",
        "table-name": "payroll template",
        "filter-box-placeholder": "Filter by name, pay frequency ...",
        "table-header": {
          "name": "Name",
          "pay-frequency": "Pay frequency",
          "created-by": "Created by",
          "created-at": "Created at"
        },
        "filter-key": {
          "name": "Filter by name",
          "status": "Filter by pay frequency"
        }
      },
      "delete-message": "Are you sure want to delete this payroll template?",
      "detail": {
        "main-title": "Payroll template details",
        "overview": "Overview",
        "components": "Components",
        "name": "Name",
        "pay-frequency": "Pay frequency",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by",
        "table": {
          "title": "Title",
          "type": "Type",
          "category": "Category",
          "tax-applicability": "Tax applicability",
          "status": "Status",
          "order": "Order"
        }
      },
      "form": {
        "main-title-create": "Create new template",
        "main-title-edit": "Edit template",
        "description": "",
        "name": {
          "label": "Name",
          "description": " "
        },
        "pay-frequency": {
          "label": "Pay frequency",
          "description": " "
        },
        "pay-component": {
          "label": "Pay component",
          "description": " "
        }
      }
    },
    "payroll-comparison": {
      "list": {
        "main-title": "Comparison",
        "btn-label": "Get Comparison"
      }
    },
    "exchange-rate": {
      "list": {
        "main-title": "Exchange Rates",
        "description": "",
        "table-name": "Exchange rate",
        "filter-box-placeholder": "Filter by title ...",
        "table-header": {
          "name": "Name",
          "default": "Default",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by name"
        }
      },
      "detail": {
        "main-title": "Exchange rate details",
        "title": "Name",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new exchange rate",
        "main-title-edit": "Edit exchange rate",
        "description": "",
        "name": {
          "label": "Name",
          "description": "The name of exchange rate, e.g. GDT for that received from General Department of Taxation, NSSF for that received from NSSF."
        },
        "default-status": {
          "label": "Default",
          "description": "When set to “true”, this exchange rate will be selected by default when used with a pay component having Currency Conversion set to “true”"
        }
      }
    }
  },
  "v2": {
    "app": {
      "name": "OptimalHR"
    },
    "ui": {
      "column-customizer": {
        "title": "Customize table",
        "subtitle": "Choose which columns to show and drag to reorder them. Required columns cannot be hidden.",
        "summary": "column selected · drag to reorder | columns selected · drag to reorder",
        "required": "Required",
        "locked": "Locked",
        "reset": "Reset to default",
        "apply": "Apply",
        "drag-hint": "Drag to reorder",
        "cannot-reorder": "Cannot reorder",
        "move-up": "Move {label} up",
        "move-down": "Move {label} down",
        "toggle-aria": "{label} — {state}",
        "shown": "shown",
        "hidden": "hidden"
      },
      "column-chooser": {
        "button": "Columns",
        "button-aria": "Choose columns ({shown} of {total} shown)",
        "title": "Show columns",
        "required": "(always shown)",
        "summary": "{shown} of {total} shown",
        "reset": "Reset"
      },
      "edit-history": {
        "title": "Edit history",
        "loading": "Loading edit history",
        "error-title": "Couldn't load the edit history",
        "error-body": "Something went wrong. Try again.",
        "retry": "Try again",
        "empty-title": "No changes yet",
        "empty-body": "Changes to this record will appear here.",
        "unavailable-title": "Edit history isn't available here",
        "unavailable-body": "The audit trail is not switched on in this environment yet.",
        "count": "{count} change | {count} changes",
        "load-more": "Load more",
        "col": {
          "when": "When",
          "who": "Who",
          "field": "Field",
          "change": "Old → New"
        },
        "old": "Old",
        "new": "New",
        "value-hidden": "Hidden (sensitive)",
        "value-not-kept": "Too large to show",
        "system-actor": "System",
        "action": {
          "create": "Created",
          "update": "Updated",
          "delete": "Deleted",
          "unknown": "Changed"
        },
        "close": "Close",
        "forbidden-title": "You don't have access to this history",
        "forbidden-body": "Ask an administrator if you need to see who changed this record.",
        "id-ref": "(id)",
        "id-refs": "({count} id) | ({count} ids)",
        "fields": {
          "Name": "Name",
          "NameKm": "Name (Khmer)",
          "Code": "Code",
          "Title": "Title",
          "Description": "Description",
          "Status": "Status",
          "EmployerId": "Company",
          "ParentId": "Parent",
          "OrgUnitId": "Org unit",
          "LocationId": "Location",
          "Version": "Version",
          "CreatedAt": "Created at",
          "CreatedBy": "Created by",
          "UpdatedAt": "Updated at",
          "UpdatedBy": "Updated by",
          "DeactivatedAt": "Deactivated at",
          "DeactivatedBy": "Deactivated by",
          "ReactivatedAt": "Reactivated at",
          "ReactivatedBy": "Reactivated by",
          "RemovedAt": "Removed at",
          "RemovedBy": "Removed by"
        }
      }
    },
    "shell": {
      "org-chip": {
        "switch": "Switch scope",
        "loading": "Loading scopes…",
        "empty": "No scopes available",
        "global-label": "All Scopes",
        "global-sub": "Cross-scope oversight",
        "global-short": "All Scopes",
        "companies": "Companies",
        "projects": "Projects",
        "clients": "Clients",
        "vendors": "Vendors",
        "direct": "Direct",
        "company-group": "Company",
        "company-tag": "company",
        "clients-projects": "Clients ▸ Projects",
        "vendors-projects": "Vendors ▸ Projects",
        "oversight": "oversight",
        "context-client": "Client",
        "context-vendor": "Vendor",
        "context-project": "Project",
        "context-company": "Company",
        "show-more": "Show more ({count})",
        "show-less": "Show less",
        "create-company": "Create new company",
        "direct-workforce": "Direct Workforce",
        "direct-short": "Direct",
        "direct-sub": "{company} · own workforce",
        "company-sub": "{company} · company"
      },
      "search": {
        "label": "Search"
      },
      "notifications": {
        "label": "Notifications"
      },
      "resume-pill": {
        "label": "Resume Payroll",
        "title": "Continue the in-progress payroll run"
      },
      "user-menu": {
        "profile": "Profile",
        "change-password": "Change password",
        "switch-language": "Switch language",
        "sign-out": "Sign out"
      },
      "nav": {
        "home": "Home",
        "people": "People",
        "work": "HR Ops",
        "pay": "Payroll",
        "billing": "Billing",
        "workmgmt": "Work Mgmt",
        "perform": "Performance",
        "fieldops": "Field Ops",
        "insights": "Insights",
        "moreapps": "More Apps",
        "organization": "Organization"
      }
    },
    "auth": {
      "brand-panel": {
        "tagline": "HR Operations · Cambodia",
        "hero-title": "Welcome back",
        "hero-lede": "Sign in to manage attendance, leave, overtime, travel, expenses and payroll for your team — all in one place.",
        "bullets": {
          "compliance": "Cambodian compliance built-in — NSSF, payroll tax, public holidays",
          "outsourced": "Outsourced staff & External Line Manager approval routing",
          "mobile": "Mobile self-service for your team — request & approve on the go"
        },
        "copyright": "© {year} OptimalHR · A product of Optimal P HR Strategic Partner Co., Ltd.",
        "address": "Phnom Penh, Cambodia · {email}"
      },
      "aria": {
        "locale-switcher": "Switch language"
      },
      "welcome": {
        "title": "Welcome",
        "subtitle": "Enter your workspace to continue.",
        "workspace-label": "Workspace",
        "workspace-placeholder": "optimalp",
        "workspace-hint": "Lowercase letters, numbers, and hyphens only. Provided by your HR Admin.",
        "continue": "Continue",
        "continuing": "Loading workspace…",
        "recent-label": "Recent workspaces",
        "find-prefix": "Don't know your workspace?",
        "find-link": "Find my workspace",
        "find-toast": "Contact your HR Admin for the workspace name",
        "privacy": {
          "title": "How is my workspace protected?",
          "intro": "Your workspace name is a public address — like {hostExample}. Knowing it doesn't grant access. Your account stays secure through:",
          "items": {
            "mfa": {
              "title": "Password + MFA",
              "desc": "HR Admins and Payroll roles are required to use multi-factor authentication."
            },
            "monitoring": {
              "title": "Smart monitoring",
              "desc": "Rate limits and account lockout block automated attacks; unusual sign-ins trigger an alert."
            },
            "audit": {
              "title": "Full audit log",
              "desc": "Every sign-in (success and failure) is recorded and visible to your Admin."
            },
            "hidden": {
              "title": "Private workspace mode",
              "desc": "Enterprise clients can hide their login page entirely — access via signed invite link only."
            }
          },
          "footer": "Questions? Contact {email}"
        },
        "errors": {
          "workspace-required": "Enter your workspace to continue.",
          "workspace-invalid": "Use lowercase letters, numbers, and hyphens only.",
          "workspace-not-found": "We couldn't find that workspace. Check the spelling and try again."
        }
      },
      "sign-in": {
        "switch-workspace": "← Switch workspace",
        "title-template": "Sign in to {name}",
        "subtitle": "Welcome back. Enter your details to access your account.",
        "method-email": "Email",
        "method-phone": "Phone + OTP",
        "work-email": "Work email",
        "email-placeholder": "you\\@optimal-p.com",
        "password": "Password",
        "forgot": "Forgot?",
        "remember": "Remember me for 30 days",
        "submit": "Sign in",
        "submitting": "Signing in…",
        "fine-print": "By signing in, you agree to the {terms} and {privacy}.",
        "errors": {
          "fields-required": "Email and password are required",
          "workspace-required": "Workspace ID is required",
          "workspace-not-found": "Workspace not found"
        },
        "reset-success": "Your password has been reset. Sign in with your new password."
      },
      "forgot": {
        "title": "Reset password",
        "subtitle": "Enter the work email associated with your account and we'll send you a confirmation code.",
        "send-code": "Send code",
        "sending": "Sending…",
        "back-to-sign-in": "← Back to sign in",
        "errors": {
          "email-required": "Email is required",
          "code-mismatch": "That code is incorrect. Check the email and try again.",
          "expired-code": "That code has expired. Request a new one below.",
          "limit-exceeded": "Too many attempts. Please wait a few minutes and try again.",
          "user-not-found": "We couldn't find an account for that email.",
          "invalid-password": "That password doesn't meet the requirements. Use at least 8 characters with letters, numbers and a symbol.",
          "generic": "Something went wrong. Please try again."
        },
        "work-email": "Work email",
        "contact-hint": "Still stuck? Contact your HR Admin to recover your account.",
        "strength": {
          "empty": "Strength: empty",
          "weak": "Strength: weak",
          "medium": "Strength: medium",
          "strong": "Strength: strong",
          "excellent": "Strength: excellent"
        }
      },
      "confirm-forgot": {
        "title": "Set a new password",
        "code": "Confirmation code",
        "new-password": "New password",
        "confirm-password": "Confirm password",
        "submit": "Reset password",
        "submitting": "Resetting…",
        "errors": {
          "code-required": "Confirmation code is required",
          "mismatch": "Passwords do not match",
          "weak-password": "Choose a stronger password — at least 8 characters with a mix of letters, numbers and symbols.",
          "missing-username": "Your reset session expired. Start over from the forgot-password screen.",
          "code-mismatch": "That code is incorrect. Check the email and try again.",
          "expired-code": "That code has expired. Request a new one below.",
          "limit-exceeded": "Too many attempts. Please wait a few minutes and try again.",
          "user-not-found": "We couldn't find an account for that email.",
          "invalid-password": "That password doesn't meet the requirements. Use at least 8 characters with letters, numbers and a symbol.",
          "generic": "Something went wrong. Please try again."
        },
        "subtitle": "We sent a code to {email}. Enter it below with a new password you haven't used before.",
        "start-over": "← Start over",
        "no-code": "Didn't get the code?",
        "resend": "Resend code",
        "resending": "Resending…",
        "resent": "A new code is on its way — check your inbox.",
        "success-title": "Password updated",
        "success-subtitle": "Your password has been reset. You can now sign in with your new password.",
        "success-cta": "Continue to sign in"
      },
      "force-change": {
        "title": "Set a new password",
        "subtitle": "Your account requires a new password before continuing.",
        "submit": "Continue",
        "submitting": "Saving…"
      },
      "mfa": {
        "title": "Two-step verification",
        "subtitle-sms": "Enter the 6-digit code sent to your phone.",
        "subtitle-totp": "Enter the 6-digit code from your authenticator app.",
        "code": "6-digit code",
        "submit": "Verify",
        "submitting": "Verifying…",
        "errors": {
          "code-required": "Code is required"
        }
      },
      "change-password": {
        "title": "Change password",
        "current-password": "Current password",
        "save": "Save",
        "saving": "Saving…",
        "cancel": "Cancel",
        "success-toast": "Password updated",
        "errors": {
          "fields-required": "All fields are required",
          "mismatch": "New passwords do not match"
        }
      },
      "legal-links": {
        "terms": "Terms of Service",
        "privacy": "Privacy Policy"
      }
    },
    "home": {
      "welcome-fallback": "there",
      "global": {
        "title": "All Scopes",
        "subtitle": "Consolidated view across every company, client, vendor and project.",
        "error": "Could not load the cross-scope overview.",
        "retry": "Retry",
        "empty-title": "Nothing to show yet",
        "empty-desc": "Once scopes have people and contracts, their consolidated metrics appear here.",
        "preview-note": "Preview · sample data shown below until cross-scope feeds are wired",
        "kpi": {
          "expiring": "Contracts expiring ≤30d",
          "understaffed": "Understaffed projects",
          "probation": "On probation",
          "onboarding": "Onboarding in progress",
          "headcount": "Active headcount"
        },
        "persona": {
          "clients": "Clients",
          "vendors": "Vendors",
          "projects": "{count} active projects"
        }
      },
      "hero": {
        "greeting": "Welcome back",
        "today-pill": "Today",
        "subtitle-tail": "Your dashboard for today",
        "announce": "Announce",
        "quick-add": "Quick add"
      },
      "toasts": {
        "announce": "Announce — broadcast to all employees",
        "quick-add": "Quick add — pick employee / time / leave / expense"
      },
      "alert": {
        "compliance": {
          "text": "{count} compliance item(s) due or overdue in next 7 days",
          "cta": "View compliance"
        }
      },
      "action-center": {
        "title": "Action Center",
        "subtitle": "What needs your attention now"
      },
      "action-tiles": {
        "approvals": "Approvals waiting",
        "compliance": "Compliance · 7-day",
        "payroll": "Payroll blockers",
        "issues": "Issues to resolve"
      },
      "kpi": {
        "attendance": {
          "label": "Attendance today",
          "title": "Open Attendance · Daily Snapshot",
          "detail": "{present} of {total} present",
          "vs-yesterday": "vs yesterday"
        },
        "payroll": {
          "label": "Payroll cycle",
          "title": "Open Pay · current cycle",
          "step": "Step {step}/{total}",
          "cutoff-in": "cut-off in",
          "cutoff-days": "{days} days"
        },
        "eor": {
          "label": "EOR pulse",
          "title": "Open Outsourced Workforce",
          "detail": "Outsourced staff · {projects} active projects",
          "stale": "{count} stale External LM(s)"
        },
        "compliance": {
          "label": "Compliance score",
          "title": "Open Compliance Overview"
        }
      },
      "people-card": {
        "title": "People Centric — this week",
        "count": "{count} events",
        "more": "more",
        "empty": "No notable people events this week"
      },
      "people-events": {
        "joining": "joining this week",
        "separating": "separated this week (MOL declaration due)",
        "upcoming-exit": "upcoming exit (next 30d)",
        "probation-due": "probation review due (next 30d)",
        "on-leave-today": "on leave today",
        "on-leave-static": "on extended leave (status)",
        "returning-today": "returning today"
      },
      "activity-card": {
        "title": "Recent activity",
        "count": "{count} events",
        "empty": "No recent activity",
        "open": "Open Compliance"
      },
      "payroll-card": {
        "title": "Payroll cycle",
        "cutoff": "Cut-off {date}",
        "pay-date": "Pay date {date}",
        "blockers": "{count} blocker(s)",
        "clear-before": "clear before cut-off",
        "no-blockers": "No blockers",
        "resume": "Resume Payroll"
      },
      "calendar-card": {
        "title": "This week",
        "count": "{count} events",
        "empty": "No events scheduled this week",
        "open": "Open Compliance"
      }
    },
    "shared": {
      "stub-panel": {
        "v6-tag": "v6 stub",
        "tbd-tag": "Detail design TBD"
      }
    },
    "work": {
      "title": "HR Ops",
      "subtitle": "Optimal P · Apr 2026 · HR operations",
      "tabs": {
        "attendance": "Attendance",
        "leave": "Leave",
        "overtime": "Overtime",
        "travel": "Travel",
        "expenses": "Expenses",
        "approvals": "Approvals",
        "approvals-count": "Approvals ({count})",
        "scheduling": "Scheduling"
      },
      "attendance": {
        "pills": {
          "snapshot": "Daily Snapshot",
          "reports": "Attendance Reports",
          "records": "Detailed Time Records",
          "attrec": "Attendance Records",
          "rostersrc": "Roster Source"
        },
        "error": "Could not load attendance data.",
        "retry": "Retry",
        "loading": "Loading attendance…",
        "focus": {
          "present": "Present",
          "absent": "Absent / no clock-in",
          "onleave": "On leave",
          "exception": "Exceptions"
        },
        "dow": {
          "sun": "Sun",
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri",
          "sat": "Sat"
        },
        "lock": {
          "open": "Lock Attendance Period",
          "count": "{n} locked period | {n} locked periods",
          "title": "Lock Attendance Period",
          "records": "{n} record(s)",
          "unresolved": "{n} unresolved exception(s)",
          "cancel": "Cancel",
          "confirm": "Lock period",
          "anyway": "Lock anyway — freeze {n} unresolved",
          "ack": "**Acknowledgement required:** {n} unresolved exception(s) will be FROZEN into the Payroll snapshot and can no longer be corrected. Payroll will receive them as-is. Click **Lock anyway** to confirm, or Cancel and resolve them first.",
          "note": "Locking officially closes this attendance period and freezes its snapshot for Payroll. Records inside a locked period can no longer be corrected, approved or fed to OT. Oversight scopes read locked snapshots only."
        },
        "snapshot": {
          "title": "Daily Snapshot",
          "prev": "Previous rostered day",
          "next": "Next rostered day",
          "date": "Snapshot date",
          "empty": "No staff expected on {date} in this company — no published roster covers it and no fixed/flexible schedule has working hours that day.",
          "empty-hint": "Check schedule assignments (HR Ops → Scheduling), publish a roster for rotation staff.",
          "empty-hint-range": "Check schedule assignments (HR Ops → Scheduling), publish a roster for rotation staff, or pick a rostered date ({from} – {to}).",
          "rosters": "Published roster(s) covering this day",
          "ot": "OT requests on this day",
          "kpi-title": {
            "present": "View who is present — opens Attendance Records",
            "absent": "View who is absent — opens Attendance Records",
            "onleave": "View who is on leave — opens Attendance Records",
            "exception": "View exceptions — opens Attendance Records"
          },
          "expected": "Expected today:",
          "rostered": "{n} rostered",
          "fixed": "{n} fixed schedule",
          "flexible": "{n} flexible",
          "rotation-note": "· rotation staff appear when their roster is published",
          "exc-title": "Exceptions on this day",
          "need-action": "{n} need action",
          "all-clear": "All clear — no exceptions to action on this day.",
          "group": {
            "late": "late arrival(s) vs planned start",
            "absent": "missing clock-in (absent)",
            "early": "early leave vs planned end",
            "returning": "returning from leave today"
          },
          "pending-lm": "Pending LM",
          "resolved": "Resolved",
          "send-reminder": "Send reminder",
          "on-behalf": "Submit on behalf",
          "on-behalf-title": "Submit on behalf — fallback for staff without mobile access",
          "reminded-just-now": "Reminded just now",
          "reminded-m": "Reminded {n}m ago",
          "reminded-h": "Reminded {n}h ago",
          "reminded-d": "Reminded {n}d ago",
          "exc-note": "Same exceptions as the Attendance Records tab — resolve before payroll cycle to avoid blockers.",
          "feed-title": "Punch feed",
          "simulated": "simulated",
          "view-all": "View all records →",
          "no-punches": "No punches on this day.",
          "clocked-in": "clocked in",
          "clocked-out": "clocked out",
          "tone-late": "Late",
          "tone-early": "Early out",
          "tone-ok": "On time",
          "feed-note": "Most recent first · derived from this day's attendance records (simulated punches).",
          "dept-title": "Attendance by Org Unit · {date}",
          "rate": "Rate (of rostered):",
          "legend-healthy": "≥80% healthy",
          "legend-watch": "60–79% watch",
          "legend-concern": "<60% concern",
          "dept-note": "Spot teams that need a supervisor nudge · denominator = staff rostered this day.",
          "footnote": "Counts are derived from **published rosters** (planned) and the same per-record engine as the **Attendance Records** tab (actual). Punches are **simulated** for preview — device integration pending, no pay impact."
        },
        "grid": {
          "from": "From",
          "to": "To",
          "days": "{n} day | {n} days",
          "capped": "(capped — narrow range or use Reports tab for full month)",
          "filters": "Filters",
          "filters-n": "Filters ({n})",
          "only-issues": "Only show issues ({n})",
          "clear": "Clear filters",
          "employee": "Employee",
          "all-employees": "All Employees ({n})",
          "org": "Org. Unit",
          "all-org": "All Org Units",
          "location": "Location",
          "all-locations": "All Locations",
          "no-locations": "(no locations on roster)",
          "type": "Employment Type",
          "all-types": "All Types",
          "status": "Status",
          "all-statuses": "All Statuses",
          "note-reports": "Filters apply to the donut chart and the records table simultaneously.",
          "note-records": "Filters & date range are shared with Attendance Reports — switch tabs to see the same filtered set.",
          "no-match": "No employees match these filters.",
          "col": {
            "name": "Full Name",
            "code": "Employee ID",
            "org": "Org. Unit",
            "shift": "Shift",
            "issues": "Issues"
          },
          "totals": "Totals",
          "issues-n": "Issues · {n}",
          "remind-title": "Send reminder to {name} via mobile",
          "ok": "OK",
          "legend": "Legend:"
        },
        "reports": {
          "donut-label": "Attendance breakdown · {n} total slots",
          "total-slots": "total slots",
          "seg": {
            "on-time": "On Time",
            "late-in": "Late In",
            "missed-clock-out": "Missed Clock Out",
            "absent": "Absent",
            "leave": "Leave",
            "day-off": "Day Off",
            "ph": "PH"
          },
          "records": "Attendance Records ({n})",
          "records-of": "Attendance Records ({n} / {total})",
          "totals-range": "Totals (in this range)",
          "legend": {
            "present": "Present (P)",
            "late": "Late In (La)",
            "missed": "Missed Clock-Out (Mc)",
            "absent": "Absent",
            "leave": "Leave",
            "day-off": "Day Off",
            "ph": "Public Holiday"
          },
          "note": "**Issues** = unresolved Absent + Missed Clock-Out days. These must be reconciled (approve absence as leave, fix punch-out, or mark as unpaid) before payroll can close. Click any \"Issues · N\" chip to open that employee's reconciliation."
        },
        "detail": {
          "title": "Time Records ({n})",
          "title-of": "Time Records ({n} / {total})",
          "issues": "Issues ({n})",
          "col": {
            "status": "Status",
            "in": "Clock-In",
            "out": "Clock-Out",
            "duration": "Duration",
            "remark": "Remark",
            "hrs": "Hrs"
          },
          "remark": {
            "day-off": "Day Off",
            "public-holiday": "Public Holiday",
            "on-leave": "On Leave (LV)",
            "absence": "Absence",
            "on-time": "On time",
            "late-23": "Late by 23 min",
            "missed-clock-out": "Missed clock-out"
          },
          "note": "Detailed view is capped to **14 days max** for readability (each day spans 5 columns). For wider ranges use **Attendance Reports** which compacts to one cell per day. Issues = Absent + Missed Clock-Out — must be reconciled before payroll closes."
        },
        "rec": {
          "banner": "**Attendance Records (prototype).** Lifecycle: Detected → Reviewed → Pending Approval → Resolved → Locked. Resolution requests route by workforce type and never edit the record. Actual punches simulated — no device, no pay impact.",
          "focus": "Showing **{label}** · {date} (from Daily Snapshot KPI)",
          "clear-focus": "Clear filter",
          "focus-empty": "No {label} records on {date}.",
          "view-as": "View as:",
          "lens-note": "(prototype role lens — capability preview only)",
          "cap-title": "Capability matrix",
          "cap-active": "active",
          "cap-note": "— HR Admin owns the record; External Client LM is approval-only for outsourced staff",
          "cap": {
            "role": "Role",
            "capture": "Capture",
            "correct": "Correct",
            "approve": "Approve",
            "own": "Own",
            "lock": "Lock",
            "rollup": "View Rollup",
            "payroll": "Payroll Feed"
          },
          "vis": {
            "line": "Visibility — {role}: {label} · **{n}** record(s) visible",
            "hradmin": "All records in active company / scope",
            "supervisor": "Site / Area: **{area}**",
            "clientlm": "Outsourced workforce only · **{client} ▸ {project}** (no Direct staff)",
            "pm": "Project rollup only · **{project}**",
            "employee": "Own records only"
          },
          "empty-role": "No records visible to {role} in their assigned scope.",
          "empty": "No attendance records yet. Publish a roster (Scheduling → Auto-Roster) or select a company with active staff to generate records.",
          "kpi": {
            "records": "Records",
            "exceptions": "Exceptions",
            "pending": "Pending approval",
            "resolved": "Resolved",
            "locked": "Locked"
          },
          "pm": {
            "title": "Project / Site rollup — **read-only** (Project Manager view)",
            "col": {
              "scope": "Client · Project · Site",
              "pending": "Pending"
            },
            "empty": "No records in scope."
          },
          "pay": {
            "title": "Payable time · attendance-driven pay input",
            "bases": "Hourly / Daily rate bases",
            "staff": "{n} staff",
            "empty": "No hourly/daily-rated staff in the current view. Monthly-salaried staff need exception handling only — their pay does not vary with attendance units.",
            "per-case": "**{n}** per-case (service) worker(s) excluded — paid per completed duty, not per attendance unit.",
            "col": {
              "employee": "Employee",
              "basis": "Rate basis",
              "units": "Payable units",
              "locked": "of which Locked",
              "rate": "Unit rate",
              "amount": "Est. amount",
              "ready": "Payroll readiness"
            },
            "hours": "{n} h",
            "days": "{n} day | {n} days",
            "day": "day",
            "locked-amt": "(${amt} locked)",
            "ready": "Payroll-ready",
            "n-locked": "{n}/{total} locked",
            "foot": "Illustrative pay input, **not a payslip**: units from simulated punches (hours = raw in–out span, breaks not deducted in prototype); amounts are never stored. Only **Locked** records count as payroll-ready — Payroll hand-off itself is deferred (PAY-BL1).",
            "foot-per-case": "{n} per-case (service) worker(s) excluded — paid per completed duty (15% WHT), not per attendance unit."
          },
          "count": "{n} record(s) · Roster-based + Open/raw · Client▸Project▸Site retained for rollup",
          "count-capped": "{n} record(s) (showing {cap}) · Roster-based + Open/raw · Client▸Project▸Site retained for rollup",
          "col": {
            "employee": "Employee",
            "date": "Date",
            "mode": "Mode",
            "expected": "Expected",
            "actual": "Actual",
            "provenance": "Provenance",
            "exception": "Exception",
            "lifecycle": "Lifecycle",
            "action": "Action"
          },
          "direct": "Direct",
          "ok": "OK",
          "open": "Open",
          "open-aria": "Open the exception review for {name} on {date}",
          "ot": {
            "sanctioned": "OT sanctioned",
            "requested": "OT requested",
            "detected": "OT detected (review)"
          }
        },
        "drawer": {
          "title": "Exception Review",
          "close": "Close",
          "outside-title": "Outside your visibility scope",
          "outside": "This record is not visible to {role}.",
          "facts": "Detected facts (read-only)",
          "fact": {
            "employee": "Employee",
            "workforce": "Workforce",
            "cps": "Client ▸ Project ▸ Site",
            "date": "Date",
            "mode": "Mode",
            "expected": "Expected",
            "actual": "Actual",
            "provenance": "Source / provenance",
            "exception": "Exception",
            "ot": "OT advisory"
          },
          "absent-no-punch": "Absent (no punch)",
          "ot": {
            "sanctioned": "Sanctioned",
            "requested": "Requested (pending)",
            "detected": "Detected (review, no pay)"
          },
          "lifecycle": "Lifecycle",
          "routing": "Approval routing ({wf})",
          "next": "Next action:",
          "ot-title": "OT advisory",
          "ot-detected": "Punches suggest work beyond the planned end",
          "ot-pay-note": "OT pays only via a verified OT request.",
          "ot-create": "Create OT request from punches",
          "ot-requested": "OT request pending for this day — verify in the Overtime module.",
          "ot-sanctioned": "OT sanctioned for this day (approved request).",
          "raise-title": "Raise resolution request",
          "select-type": "— Select request type —",
          "raise": "Raise request",
          "timeline": "Activity timeline",
          "adr": "Per ATT-ADR-1: detection is read-only; requests/approvals write only to the in-session workflow — the record is never edited.",
          "adr-open": "No pay impact.",
          "adr-locked": "This record is **Locked** (payroll lock prep) — no further changes. Payroll integration deferred.",
          "readonly": "Read-only in All Scopes — switch to a company workspace.",
          "locked": "Locked — no further changes.",
          "review": "Mark reviewed",
          "approve": "Approve",
          "reject": "Reject",
          "lock": "Lock (payroll)",
          "blk": {
            "review": "Review is owned by Site Supervisor / HR",
            "approve-ext": "Approval is owned by External Client LM",
            "approve-sup": "Approval is owned by Site Supervisor / HR",
            "lock": "Lock is owned by HR Admin"
          },
          "no-action": "No action for this role at this stage."
        },
        "resolve": {
          "title": "Resolve Attendance Issue",
          "staff": "{n} staff",
          "subtitle": "Submit for Line Manager approval · {date}",
          "best-title": "Best practice: ask the employee to self-resolve via mobile",
          "best-text": "This screen is for **submit on behalf** — use only when self-service isn't possible (no smartphone, on leave, factory floor, etc.). Submitting here is logged as **hr-on-behalf** in the audit trail.",
          "remind-instead": "Send reminder instead",
          "detected": "{type} detected",
          "type": {
            "missed-out": "Missed Clock-Out",
            "absent": "Absent",
            "wrong-location": "Wrong Location",
            "system-error": "System Error"
          },
          "desc": {
            "missed-out": "No clock-out recorded. Provide the correct end time.",
            "absent": "No clock-in recorded for this date. Choose how to resolve.",
            "wrong-location": "System recorded the wrong location for this punch.",
            "system-error": "Punch recorded but data is wrong (time, device, or sync issue)."
          },
          "res": {
            "use-scheduled": "Use scheduled end time — Defaults to shift end (most common)",
            "set-actual": "Set actual time — Type the time the employee actually left",
            "half-day": "Convert to half-day absence — Employee left early without clocking out",
            "convert-leave": "Convert to leave — Use leave balance — opens Leave request",
            "approved-exc": "Approved exception — Emergency, family, or pre-agreed reason",
            "unpaid": "Confirm as unpaid absence — Default — no leave balance used",
            "fix-location": "Fix location — Pick the correct location",
            "note-only": "Log note only — IT or HR will investigate; no time change"
          },
          "issue-type": "Issue Type",
          "type-locked": "🔒 pre-filled from your attendance record — cannot be changed",
          "apply-all": "Apply same resolution to all {n} staff",
          "apply-all-on": "Set the resolution + reason once below. Each request still routes to its own LM.",
          "apply-all-off": "Each staff has their own resolution row below.",
          "bulk-title": "Resolution (applied to all {n})",
          "resolution": "Resolution",
          "default-in": "Default Clock-In",
          "default-out": "Default Clock-Out",
          "reason": "Reason / Note",
          "reason-all-ph": "Brief explanation — applies to all",
          "reason-ph": "Brief reason — required",
          "affected": "Affected staff",
          "affected-routing": "Affected staff & routing",
          "already": "Already submitted as {id} · status: **{status}**",
          "skip": "Skip",
          "routes-to": "Routes to:",
          "external-lm": "External LM",
          "escalates": "Escalates",
          "no-primary": "(no Primary LM — escalates to HR)",
          "no-manager": "(no direct manager — escalates to HR)",
          "clock-in": "Clock-In (existing)",
          "clock-out": "Clock-Out",
          "routing-note": "Each request is routed individually to the staff's Line Manager. **Direct staff** route to their direct manager. **Outsourced staff** route to the project's Primary External LM (or Backup if Primary is unavailable). Status: Pending LM → Approved/Rejected. HR is notified on resolution.",
          "reason-required": "⚠ Reason is required",
          "clockout-required": "⚠ Default Clock-Out is required",
          "cancel": "Cancel",
          "submit": "Submit for Approval"
        },
        "src": {
          "empty": "No **published rosters** for this company yet. Publish a roster in Schedule → Auto-Roster to see planned vs actual attendance here.",
          "empty-note": "Draft rosters are not shown.",
          "banner": "**Roster Source (read-only / advisory).** Planned shifts come from **Published Rosters** in the Schedule module. Actual punches are simulated for preview (device integration pending) — no pay impact.",
          "kpi": {
            "planned": "Planned shifts",
            "on-time": "On time",
            "exceptions": "Exceptions",
            "on-leave": "On leave"
          },
          "planned": "Planned shift vs actual attendance · {n} planned shift(s)",
          "planned-capped": "Planned shift vs actual attendance · {n} planned shift(s) (showing {cap})",
          "col": {
            "employee": "Employee",
            "date": "Date",
            "shift": "Planned Shift",
            "time": "Planned Time",
            "status": "Attendance Status",
            "exception": "Exception"
          },
          "night": "night",
          "on-time": "On time",
          "unplanned-title": "Rest-day & unplanned attendance exceptions",
          "no-unplanned": "No rest-day / unplanned attendance exceptions."
        },
        "port": {
          "label": "Attendance oversight",
          "sub-tenant": "All Scopes · Executive Attendance Operations Dashboard · aggregate KPIs + locked snapshots · read-only",
          "sub-client": "{name} · attendance rollup · read-only",
          "sub-company": "{name} · attendance hierarchy · read-only (operations live at owning scopes)",
          "client": "Client",
          "all-scopes": "All Scopes",
          "direct": "Direct Workforce",
          "direct-sub": "Attendance owner · company-owned staff",
          "project-sub": "{id} · attendance owner",
          "rollup": "Client rollup · read-only",
          "kpi": {
            "workspaces": "Workspaces",
            "units": "Units",
            "attention": "{label} requiring attention",
            "attention-tip": "{label} with an amber or red risk indicator",
            "employees": "Employees affected",
            "employees-tip": "Employees with at least one unresolved attendance exception",
            "completion": "Attendance completion",
            "completion-tip": "Days locked ÷ expected days in the Attendance earning period (not the Payroll payment period) ({locked}/{total})",
            "oldest": "Oldest outstanding exception",
            "oldest-tip": "Open since {date}{name}",
            "oldest-none": "No outstanding exceptions"
          },
          "days": "{n}d",
          "top": "Top priority",
          "cut-chip": "cut-off {date} ({n}d)",
          "cut-tip": "{label} · pay date {pay}",
          "review": "Review",
          "review-tip": "Drill into this workspace",
          "ready": {
            "ready": "✅ Ready",
            "waiting": "⚠ Waiting",
            "blocked": "❌ Blocked"
          },
          "ready-tip": {
            "ready": "Every expected day of the Attendance earning period is locked (or none expected) — snapshot frozen for Payroll",
            "waiting": "Period not fully locked yet — no blocking exceptions",
            "blocked": "Unresolved attendance exceptions must be cleared before the payroll cut-off"
          },
          "col": {
            "workspace": "Workspace",
            "scope": "Scope",
            "risk": "Risk",
            "employees": "Employees",
            "exc": "In-flight exceptions",
            "pending": "Pending approvals",
            "progress": "Progress (days locked)",
            "ready": "Payroll ready",
            "trend": "Trend",
            "cutoff": "Next cut-off (attendance-dependent)",
            "cutoff-tip": "Next payroll run that consumes attendance (advance runs are skipped)",
            "locks": "Locked periods",
            "period": "Attendance period",
            "records": "Records",
            "present": "Present",
            "absent": "Absent",
            "onleave": "On leave",
            "exceptions": "Exceptions",
            "locked": "Locked",
            "status": "Status",
            "date": "Date",
            "employee": "Employee",
            "project": "Project",
            "expected": "Expected",
            "in": "In",
            "out": "Out",
            "exception": "Exception",
            "state": "State"
          },
          "affected": "{n} employee(s) affected",
          "progress-tip": "{locked} of {total} day(s) locked in the Attendance earning period",
          "trend": "{n}% vs prior period",
          "trend-none": "Not enough history for a trend",
          "no-calendar": "No payroll calendar configured",
          "open": "Open",
          "open-co-tip": "Open the company workspace — attendance operations live at its owning scopes",
          "open-unit-tip": "Open the attendance workspace — owning scope (operations)",
          "summary": "Summary",
          "summary-tip": "View latest locked snapshot (read-only)",
          "locks-tip": "Locked attendance periods for this unit",
          "l1-empty": "No workspaces match this filter.",
          "foot-l1": "Executive Attendance Operations Dashboard · as of {asOf} (latest attendance date) · cut-offs = next ATTENDANCE-DEPENDENT payroll run from the Payroll Processing Calendar (advance runs skipped) · aggregate KPIs only — operations live at owning scopes · rows ranked by risk · click a row to drill",
          "l2-lead": "Attendance operations live at the owning scopes (Direct Workforce / Project).",
          "l2-text": "This level shows aggregate in-flight KPIs and locked-period snapshots only. Client rows are consolidated rollups (read-only).",
          "cut": "{date} · {label} ({n}d, pay {pay})",
          "window": "Attendance earning period ({from} → {to}]",
          "foot-l2": "Next attendance-dependent payroll cut-off: {cut}{window} · as of {asOf} · click a row for its locked periods",
          "l3-empty": "No locked attendance periods for this scope yet — the owning workspace closes periods via “Lock Attendance Period”.",
          "l3-foot": "Click a period to open its frozen snapshot (read-only)",
          "l4-missing": "Locked snapshot not found.",
          "l4-lead": "Locked attendance period — frozen snapshot (read-only).",
          "l4-text": "Locked {at} by {by} · {recs} records · {exc} exceptions ({unresolved} unresolved at lock). This snapshot is what Payroll consumes; no attendance operations exist at oversight scopes."
        },
        "data": {
          "state": {
            "detected": "Detected",
            "reviewed": "Reviewed",
            "pending-approval": "Pending Approval",
            "resolved": "Resolved",
            "locked": "Locked"
          },
          "mode": {
            "roster-based": "Roster-based",
            "fixed": "Fixed",
            "flexible": "Flexible",
            "open": "Open"
          },
          "status": {
            "present": "Present",
            "absent": "Absent",
            "on-leave": "On Leave",
            "exception": "Exception"
          },
          "exception": {
            "missing-clock-in": "Missing clock-in",
            "missing-clock-out": "Missing clock-out",
            "late-against-planned-start": "Late against planned start",
            "early-leave": "Early leave",
            "worked-on-rest-off-day": "Worked on rest/off day",
            "unplanned-attendance": "Unplanned attendance"
          },
          "provenance": {
            "leave-overlay": "Leave overlay",
            "correction-request": "Correction request",
            "device-punch-sim": "Device punch (sim)"
          },
          "action": {
            "review-site-supervisor-hr": "Review — Site Supervisor / HR",
            "raise-correction-employee-supervisor-or-send-to-approval": "Raise correction (Employee / Supervisor) or send to approval",
            "approve-external-client-lm-optimal-hr": "Approve — External Client LM → Optimal HR",
            "approve-site-supervisor-hr": "Approve — Site Supervisor / HR",
            "lock-hr-admin": "Lock — HR Admin",
            "none-locked": "None (locked)"
          },
          "stage": {
            "detection": "Detection",
            "review": "Review",
            "request": "Request",
            "approval": "Approval",
            "resolution": "Resolution",
            "rejected": "Rejected",
            "locked": "Locked",
            "employee": "Employee",
            "external-client-lm": "External Client LM",
            "supervisor": "Supervisor",
            "hr": "HR"
          },
          "workforce": {
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "source": {
            "schedule": "Schedule",
            "roster": "Roster"
          },
          "request": {
            "missing-punch": "Missing Punch",
            "wrong-punch": "Wrong Punch",
            "late-arrival": "Late Arrival",
            "early-departure": "Early Departure",
            "ot-dispute": "OT Dispute"
          },
          "role": {
            "hradmin": "HR Admin",
            "supervisor": "Site Supervisor",
            "clientlm": "External Client LM",
            "pm": "Project Manager",
            "employee": "Employee (ESS)"
          }
        }
      },
      "schedules": {
        "pills": {
          "schedules": "Schedules",
          "holidays": "Holidays",
          "meals": "Meal Breaks"
        },
        "create": {
          "schedule": "New Schedule",
          "holiday": "New Holiday",
          "meal": "New Meal Break"
        },
        "create-toast": "{name} — wizard coming in a subsequent slice",
        "created-toast": "{name} created",
        "search": {
          "schedules": "Search by name, type, day off…",
          "holidays": "Search by name, code, year…",
          "meals": "Search by name…"
        },
        "showing": "Showing {filtered} of {total} {kind}",
        "kind": {
          "schedules": "schedules",
          "holidays": "holiday lists",
          "meals": "meal breaks"
        },
        "kpi": {
          "schedules": "Schedules",
          "employees-assigned": "Employees assigned",
          "unused-templates": "Unused templates",
          "avg-hours": "Avg hours/week",
          "holiday-lists": "Holiday lists",
          "active": "Active",
          "total-dates": "Total dates",
          "current-year": "Current year ({year})",
          "meal-breaks": "Meal breaks",
          "schedules-using-breaks": "Schedules using breaks",
          "avg-duration": "Avg duration",
          "cambodia-standard": "Cambodia standard"
        },
        "filters": {
          "all": "All",
          "all-years": "All years",
          "all-statuses": "All statuses",
          "active": "Active",
          "inactive": "Inactive"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "export": "Export",
          "edit": "Edit",
          "delete": "Delete"
        },
        "schedules-table": {
          "name": "Name",
          "type": "Type",
          "weekly-day-off": "Weekly Day Off",
          "hours-week": "Scheduled hrs",
          "employees": "Employees",
          "edit": "Edit",
          "empty": "No schedules match these filters",
          "info": "Schedules are templates — HR assigns one when onboarding (Step 2 of the Add Person wizard). Editing here updates all assigned staff going forward.",
          "empty-none": "No schedules yet — create one to assign working weeks."
        },
        "holidays-table": {
          "name": "Name",
          "code": "Code",
          "year": "Year",
          "type": "Type",
          "dates": "Dates",
          "status": "Status",
          "edit": "Edit",
          "empty": "No holidays match these filters",
          "info": "Standard PH lists are maintained by Optimal HR. Each tenant can clone a year and customise (add/remove specific dates, regional variants). Cambodia has ~22 PH per year — annual refresh in January.",
          "empty-none": "No holiday lists yet — create one for a calendar year."
        },
        "meals-table": {
          "name": "Name",
          "start": "Start Time",
          "end": "End Time",
          "duration": "Duration",
          "schedules-using": "Schedules using",
          "edit": "Edit",
          "minutes": "{n} min",
          "empty": "No meal breaks match this search",
          "info": "Meal breaks are reusable — pick one when you create a Schedule. Most Optimal P schedules use a 60-minute lunch break (12:00–13:00). Cambodia LL doesn't strictly mandate a break, but 60 min is industry standard.",
          "empty-none": "No meal breaks yet — create one to reuse across schedules."
        },
        "drawer": {
          "close": "Close",
          "fields": {
            "type": "Type",
            "days-off": "Weekly Day Off",
            "hours-week": "Hours / week",
            "assigned": "Employees assigned",
            "public-holiday": "Public holiday list",
            "other-holidays": "Other holidays",
            "year": "Year",
            "code": "Code",
            "status": "Status",
            "dates": "Dates",
            "start": "Start",
            "end": "End",
            "duration": "Duration",
            "schedules-using": "Schedules using this break",
            "activity": "Activity",
            "weekly-hours": "Weekly hours"
          },
          "no-value": "—"
        },
        "modal": {
          "schedule": {
            "title": "Create Schedule",
            "lede": "Working week template",
            "fields": {
              "name": "Name",
              "type": "Type"
            },
            "placeholders": {
              "name": "e.g. OP_Field_Crew"
            },
            "validation": {
              "name-required": "Schedule name is required."
            }
          },
          "holiday": {
            "title": "Create Holiday list",
            "lede": "Public-holiday list for a calendar year",
            "fields": {
              "name": "Name",
              "code": "Code",
              "year": "Year"
            },
            "placeholders": {
              "name": "e.g. Standard public holiday for 2027",
              "code": "Standard / Custom-XX"
            },
            "validation": {
              "name-required": "Holiday list name is required.",
              "code-required": "Code is required.",
              "year-invalid": "Year must be a 4-digit number."
            }
          },
          "meal": {
            "title": "Create Meal Break",
            "lede": "Reusable lunch / dinner break",
            "fields": {
              "name": "Name",
              "start": "Start time",
              "end": "End time"
            },
            "placeholders": {
              "name": "e.g. OP_Field_Lunch Break"
            },
            "validation": {
              "name-required": "Meal break name is required.",
              "time-required": "Start and end time are required.",
              "time-order": "End time must be after start time."
            }
          },
          "cancel": "Cancel",
          "submit": "Create"
        },
        "error": "Couldn’t load this data.",
        "retry": "Retry",
        "deleted-toast": "{name} deleted",
        "action-failed": "Something went wrong. Please try again.",
        "col-extra": {
          "status": "Status",
          "calendar": "Holiday calendar",
          "paid": "Paid / Unpaid"
        },
        "export": {
          "xlsx": "Excel (.xlsx)",
          "csv": "CSV (.csv)",
          "empty": "Nothing to export",
          "file": {
            "schedules": "Work Schedules",
            "holidays": "Holiday Calendars",
            "meals": "Meal Breaks"
          }
        },
        "history": {
          "action": "Edit history",
          "aria": "Edit history of {name}",
          "title": "Edit history — {name}",
          "fields": {
            "Name": "Name",
            "Type": "Type",
            "Status": "Status",
            "Days": "Working days",
            "WeeklyOffDays": "Weekly off",
            "MealBreakIds": "Meal breaks",
            "PublicHolidayListId": "Public holiday calendar",
            "OtherHolidayListIds": "Other holiday calendars",
            "ScheduleKind": "Schedule kind",
            "Code": "Code",
            "Year": "Year",
            "Region": "Region",
            "Start": "Start",
            "End": "End",
            "Paid": "Paid"
          }
        }
      },
      "leave": {
        "new-request": "New Leave Request",
        "views": {
          "records": "Records",
          "calendar": "Calendar",
          "balances": "Balances"
        },
        "kpi": {
          "pending": "Pending",
          "approved": "Approved (in range)",
          "active-today": "On leave today",
          "rejected": "Rejected"
        },
        "filters": {
          "toggle": "Filters",
          "toggle-n": "Filters ({n})",
          "remove": "Remove filter {label}",
          "clear": "Clear filters",
          "org": "Org. Unit",
          "all-orgs": "All Org Units",
          "employee": "Employee",
          "all-employees": "All Employees",
          "type": "Type",
          "all-types": "All types",
          "status": "Status",
          "all-statuses": "All statuses"
        },
        "include-outsourced": "Include Outsourced",
        "by-type": "Approved days in range — by type",
        "type": {
          "annual-leave": "Annual Leave",
          "sick-leave": "Sick Leave",
          "special-leave": "Special Leave",
          "maternity-leave": "Maternity Leave",
          "paternity-leave": "Paternity Leave",
          "unpaid-leave": "Unpaid Leave"
        },
        "type-short": {
          "annual-leave": "Annual",
          "sick-leave": "Sick",
          "special-leave": "Special",
          "maternity-leave": "Maternity",
          "paternity-leave": "Paternity",
          "unpaid-leave": "Unpaid"
        },
        "status": {
          "pending-lm": "Pending LM",
          "pending": "Pending",
          "approved": "Approved",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "outsourced-note": "For Outsourced staff: leave is granted per Optimal HR policy; the External LM approves the request (Optimal owns the employment relationship). Direct staff route to their direct manager.",
        "exported": "✓ Exported {n} leave request(s) → {name}",
        "records": {
          "title": "Leave Records",
          "labels": "Labels:",
          "fh": "FH — First Half",
          "sh": "SH — Second Half",
          "fd": "FD — Full Day",
          "open-approvals": "Open Approvals",
          "export": "Export",
          "empty": "No leave requests match these filters.",
          "eor": "EOR",
          "demo": "demo",
          "demo-tip": "Demo seed",
          "locked-tip": "Inside a locked Leave period — read-only",
          "escalates": "Escalates"
        },
        "col": {
          "request": "Request No.",
          "name": "Full Name",
          "employee-id": "Employee ID",
          "org": "Org. Unit",
          "requested": "Requested",
          "details": "Leave Request Details",
          "total": "Total",
          "approver": "Approver",
          "status": "Status",
          "type": "Type",
          "date": "Date",
          "duration": "Duration"
        },
        "calendar": {
          "pending-suffix": "(pending)",
          "dow": {
            "sun": "Sun",
            "mon": "Mon",
            "tue": "Tue",
            "wed": "Wed",
            "thu": "Thu",
            "fri": "Fri",
            "sat": "Sat"
          },
          "more": "+{n} more",
          "today": "Today",
          "pending": "Pending LM (dashed border)",
          "hint": "Click a leave chip to open the request detail."
        },
        "balances": {
          "title": "Leave balances · per employee × per type",
          "policy-line": "SRS-aligned · {method} · Seniority +{d}d/{y}yrs (Art 166) · {year}",
          "yearly-grant": "Yearly Grant {d}d AL",
          "year-type": {
            "calendar_year": "calendar year",
            "fiscal_year": "fiscal year"
          },
          "employee": "Employee",
          "type": "Type",
          "service": "Service",
          "years": "{n}yr",
          "on-demand": "on demand",
          "cell": "{alloc}{bonus} alloc · {used} used",
          "cfwd": " · {n} cfwd",
          "empty": "No eligible employees in this scope.",
          "outsourced": "Outsourced",
          "direct": "Direct",
          "reading-lead": "Reading the cells:",
          "reading": "big number = available · small line shows allocation (with seniority bonus in brackets), used, and carry-forward from previous year.",
          "defaults-lead": "Defaults shown:",
          "defaults": "AL {al}d/yr · Sick {sick}d/yr · Special {special}d/yr (deducts from AL) · Maternity {maternity}d · Paternity {paternity}d. All tenant-configurable in Leave Settings."
        },
        "detail": {
          "title": "Leave Request {id} · {name}",
          "subtitle": "{type} · {days} day(s) · {status}",
          "approved-on": "Approved on {at}",
          "rejected-on": "Rejected on {at}",
          "submitted": "Submitted {at} · awaiting LM",
          "approve": "Approve",
          "reject": "Reject",
          "locked": "Locked period",
          "details": "Request details",
          "employee": "Employee:",
          "org": "Org. Unit:",
          "type": "Type:",
          "total": "Total:",
          "days-unit": "day(s)",
          "routes-to": "Routes to:",
          "external-lm": "External LM",
          "escalates": "Escalates to HR",
          "reason": "Reason:",
          "dates": "Dates ({n})",
          "history": "Audit history ({n})",
          "no-history": "No history.",
          "by": "{action} by {who}",
          "action": {
            "approved": "Approved",
            "rejected": "Rejected",
            "submitted": "Submitted",
            "cancelled": "Cancelled"
          },
          "approve-reason": "Approval reason (required by policy):",
          "reject-reason": "Reason for rejection (required):"
        },
        "new": {
          "title": "New Leave Request",
          "subtitle": "Submit on behalf of employee · routes to Line Manager",
          "bp-title": "Best practice: ask the employee to self-submit via mobile",
          "bp-body": "This screen is for submit on behalf — use only when self-service isn't possible. Submitting here is logged as hr-on-behalf in the audit trail.",
          "employee": "Employee",
          "select-employee": "— Select employee —",
          "type": "Leave Type",
          "special-lead": "Special Leave by law deducts from Annual Leave balance.",
          "special-al": "Employee's current AL balance: {n} day(s).",
          "special-block": "⚠ Cannot proceed — AL insufficient and tenant policy does not allow additional special leave.",
          "sick-lead": "Medical certificate required.",
          "sick-body": "Sick leave > {n} days requires a medical certificate attached on submission. Long sick (>{long}d) follows ILO payment structure: M1 {m1}% · M2-3 {m2}% · M4-6 {m4}%.",
          "unpaid-lead": "Unpaid Leave.",
          "unpaid-body": "No salary will be paid for the leave period. Used when other leave types are exhausted or inappropriate.",
          "maternity-lead": "Maternity Leave — {n} days (Cambodia LL).",
          "paternity-lead": "Paternity Leave — {n} days.",
          "event-body": "Pick a Start Date; the system fills in the consecutive {n} days.",
          "advance-grant": "Advance grant by HR allowed.",
          "al-insufficient": "⚠ Insufficient Annual Leave balance",
          "al-short": "{name}'s current balance: {balance} day(s) · This request: {days} day(s) · Shortfall: {short} day(s)",
          "al-policy": "Tenant policy allowAlInAdvance is off — cannot create overdraft.",
          "switch-unpaid": "Switch to Unpaid Leave",
          "switched": "Switched to Unpaid Leave",
          "badge": {
            "female-only": "Female only",
            "male-only": "Male only",
            "deducts-al": "Deducts from AL",
            "advance-exempt": "No advance-days rule",
            "no-balance": "No balance"
          },
          "balance-line": "Current balance: {balance} day(s) · This request: {days} day(s) · After: {after} day(s)",
          "overdraft": "⚠ Overdraft warning",
          "routes-to": "Routes to:",
          "no-lm": "No LM — escalates to HR",
          "unpaid-line": "This request: {days} day(s) · No balance check (unpaid by definition)",
          "start": "Start date",
          "policy-days": "Days (per policy)",
          "end": "End date (auto)",
          "return": "Will return on {date}. {n} consecutive calendar day(s) — auto-filled from your start date.",
          "select-dates": "Select dates",
          "selected": "({n} selected · total {days} day(s))",
          "half-on": "Half-day enabled · pick FD / FH / SH per date",
          "half-off": "Full day only (half-day disabled in policy)",
          "date-n": "Date {n}",
          "duration-n": "Duration of date {n}",
          "remove-date": "Remove date {n}",
          "add-date": "Add date",
          "reason": "Reason / Note",
          "reason-ph": "Brief reason for this leave",
          "after-note": "After submission, the request appears in the LM's Approvals queue with status Pending LM. On approval, the days are deducted from the employee's balance automatically.",
          "advance-note": "Minimum {n} days advance required for {type}.",
          "required": "* Required",
          "submit": "Submit for Approval",
          "submitted": "✓ Leave request {id} submitted · {days} day(s) · routes to {to}",
          "block": {
            "employee": "⚠ Employee is required",
            "type": "⚠ Leave Type is required",
            "reason": "⚠ Reason is required",
            "dates": "⚠ Add at least one date",
            "start": "⚠ Start date is required",
            "al-insufficient": "⚠ Annual Leave balance insufficient · tenant policy blocks advance. Use Switch to Unpaid Leave button.",
            "special-al": "⚠ Special leave by law deducts from AL; AL balance {avail}d insufficient for {days}d (config allowAdditionalSpecialLeave is off)"
          }
        }
      },
      "overtime": {
        "send-reminder": "Send Reminder",
        "new-request": "New OT Request",
        "kpi": {
          "action": "Needs your action",
          "action-sub": "{v} to verify · {i} with issue",
          "pending": "Pending approval",
          "pending-sub": "{amount} estimated",
          "progress": "In progress / Approved",
          "progress-sub": "{now} happening now · {sch} scheduled",
          "paid": "Verified / Paid (period)",
          "paid-sub": "{amount} total"
        },
        "chips-label": "Overtime status",
        "chip": {
          "all": "All",
          "needs-action": "⚑ Needs Action",
          "pending": "Pending",
          "approved": "Approved",
          "in-progress": "In Progress",
          "needs-verify": "Needs Verification",
          "issue": "Issue to Resolve",
          "verified": "Verified",
          "paid": "Paid",
          "rejected": "Rejected"
        },
        "search": "Filter by employee name…",
        "search-clear": "Clear search",
        "showing": "Showing {n} of {total}",
        "col": {
          "id": "ID",
          "employee": "Employee",
          "date": "Date",
          "time": "Time",
          "day-type": "Day Type",
          "hours": "Hours",
          "amount": "Amount",
          "status": "Status"
        },
        "payable": "payable {v}",
        "payable-tip": "Payable on actual punches + HR override (what the OT lock snapshot and Payroll consume)",
        "locked-tip": "In a locked OT period — read-only",
        "demo-tip": "Demo seed",
        "empty": "No OT requests matching this filter.",
        "multipliers-lead": "Cambodia OT multipliers:",
        "multipliers": "Weekday day 1.5× · Night (22:00–06:00) 2.0× · Weekend / Day Off 2.0× · PH on Day Off 2.0× · PH on Working Day 1.0× (PH wage already paid). No hard cap (tenant configurable in Settings).",
        "status": {
          "pending": "Pending",
          "approved": "Approved",
          "rejected": "Rejected",
          "in-progress": "In Progress",
          "needs-verification": "Needs Verification",
          "issue-to-resolve": "Issue to Resolve",
          "verified": "Verified",
          "paid": "Paid",
          "cancelled": "Cancelled"
        },
        "day-type": {
          "weekday": "Weekday",
          "weekend": "Weekend",
          "dayoff": "Day Off",
          "ph-working": "PH (working day)",
          "ph-dayoff": "PH (day off)"
        },
        "issue": {
          "missed-clockout": "Missed Clock-out",
          "no-show": "No Show",
          "outside-window": "Outside Window",
          "excessive-drift": "Excessive Drift"
        },
        "detail": {
          "title": "Overtime Request Detail",
          "issue": "Issue: {label}",
          "needs-verify": "Needs verification",
          "needs-verify-note": "Actual hours differ from planned — confirm before payroll.",
          "verified": "Verified{on}{by} — ready for payroll.",
          "on": " on {at}",
          "by": " by {name}",
          "paid": "Paid",
          "in-run": " in run",
          "in-progress": "OT window open right now. Employee clocked in at {at}.",
          "request": "Request",
          "date": "Date:",
          "project": "Project:",
          "internal": "Internal",
          "reason": "Reason:",
          "pva": "Planned vs Actual",
          "planned": "Planned",
          "actual": "Actual (from punches)",
          "not-clocked": "Pending — not yet clocked",
          "payable": "Payable (actuals + override): {h} · {a}",
          "slice2": "OT Window linkage and clock-time validation arrive in Slice 2.",
          "calc": "Calculation breakdown",
          "rate": "Hourly rate {hourly} = {gross} / ({weekly}h × 52 / 12 = {monthly}h/mo)",
          "segment": "Segment",
          "multiplier": "Multiplier",
          "hourly": "Hourly",
          "night": "Night (22:00–06:00)",
          "day": "Day (06:00–22:00)",
          "total": "Total",
          "chain": "Approval chain",
          "requested-by": "Requested by:",
          "ext-lm": "External Line Manager:",
          "lm": "Line Manager:",
          "external-lm-name": "{name} (External LM)",
          "reject-reason": "Rejection reason: {reason}",
          "activity": "Activity log",
          "no-activity": "No activity yet.",
          "computed": "Computed at {at} · Subject to final HR approval"
        },
        "new": {
          "title": "New Overtime Request",
          "subtitle": "Pick dates and time slots · live multiplier + amount calculation",
          "project": "Project",
          "shift-none": "Mon–Fri 08:00–17:00",
          "shift-default": "Mon–Fri 08:00–17:00 (default)",
          "rule-shift": "Normal shift (from schedule):",
          "rule-shift-tail": "OT must be outside this window",
          "rule-ll": "Cambodia Labour Law: max 12 hrs OT / week · Multipliers: Weekday 1.5× day / 2.0× night · Weekend & Day Off 2.0× · PH on Day Off 2.0× · PH on Working Day 1.0×",
          "rule-clock": "Clock tolerance: ±15 min · OT window auto-flags punches outside the approved range",
          "select-dates": "Select OT dates",
          "dates-count": "({d} date(s) · {s} slot(s))",
          "date": "OT date",
          "add-date": "Add date",
          "totals-lead": "{d} day(s) · {s} slot(s)",
          "hrs": "hrs",
          "estimated": "estimated",
          "warn-overlap": "⛔ One or more slots overlap the regular shift window. Adjust before submitting.",
          "warn-ll": "⚠ Total OT exceeds 12 hrs/week in at least one week — Cambodia LL cap. Manager + HR will be notified on approval.",
          "slots": "Time slots",
          "no-dates": "Add an OT date above to add time slots",
          "kind": {
            "holiday": "Holiday",
            "weekend": "Weekend",
            "weekday": "Weekday"
          },
          "add-slot": "Add slot",
          "slot-start": "Start of slot {n} on {d}",
          "slot-end": "End of slot {n} on {d}",
          "overlaps": "⛔ overlaps shift",
          "remove-slot": "Remove slot",
          "objective": "Objective of request",
          "objective-ph": "Describe why overtime is needed (e.g., production deploy, client demo prep, month-end close)",
          "route-note": "Approval routes to the employee's Line Manager. On approval, an OT window is created so the employee can clock in/out during the period; punches outside the window are flagged.",
          "route-note-ext": "Approval routes to the employee's Line Manager (External LM for outsourced staff). On approval, an OT window is created so the employee can clock in/out during the period; punches outside the window are flagged.",
          "error": {
            "employee": "⚠ Pick an employee",
            "reason": "⚠ Objective must be at least 10 characters",
            "dates": "⚠ Select at least one date and time slot",
            "slot": "⚠ Add at least one time slot"
          },
          "submitted": "✓ OT request {id} submitted ({hours} hrs estimated)"
        }
      },
      "lvot": {
        "locked-periods": "{n} locked period | {n} locked periods",
        "from": "From",
        "to": "To",
        "cancel": "Cancel",
        "lock-period": "Lock period",
        "ack-lead": "Acknowledgement required:",
        "lock-anyway-word": "Lock anyway",
        "client-fallback": "Client rollup",
        "all-scopes": "All Scopes",
        "direct": "Direct Workforce",
        "kpi": {
          "attention-workspaces": "Workspaces requiring attention",
          "attention-units": "Units requiring attention",
          "attention-workspaces-tip": "Workspaces with an amber or red risk indicator",
          "attention-units-tip": "Units with an amber or red risk indicator",
          "waiting": "Employees waiting",
          "submitted": "Submitted {date}{name}"
        },
        "col": {
          "workspace": "Workspace",
          "risk": "Risk",
          "employees": "Employees",
          "progress": "Progress (days locked)",
          "ready": "Payroll ready",
          "trend": "Trend",
          "scope": "Scope",
          "locked-periods": "Locked periods",
          "requests": "Requests",
          "locked": "Locked",
          "status": "Status",
          "employee": "Employee",
          "type": "Type",
          "status-at-lock": "Status at lock"
        },
        "cut-line": "{date} · {label} ({days}d, pay {pay})",
        "top-priority": "Top priority",
        "cut-tip": "{label} · pay date {pay}",
        "cut-chip": "cut-off {date} ({days}d)",
        "cut-none": "No payroll calendar configured",
        "review": "Review",
        "review-tip": "Drill into this workspace",
        "no-match": "No workspaces match this filter.",
        "waiting-tip": "{n} employee(s) waiting",
        "trend": "{arrow}{pct}% vs prior period",
        "trend-none": "Not enough history for a trend",
        "trend-tip": "Requests: {prev} ({prevMonth}) → {cur} ({curMonth})",
        "open": "Open",
        "l2-banner": "This level shows aggregate in-flight KPIs and locked-period snapshots only. Client rows are consolidated rollups (read-only).",
        "rollup-chip": "Client rollup · read-only",
        "summary": "Summary",
        "summary-tip": "View latest locked snapshot (read-only)",
        "l3-foot": "Click a period to open its frozen snapshot (read-only)",
        "locked": "Locked",
        "frozen": "(frozen)",
        "l4-no-rows": "No requests in this period.",
        "ready": {
          "ready": "Ready",
          "waiting": "Waiting",
          "blocked": "Blocked"
        },
        "risk": {
          "leave": {
            "cutoff": "{n} pending request(s) · payroll cut-off in {days}d",
            "oldest": "oldest pending request {age}d old",
            "rate": "{pct}% of employees waiting",
            "open": "{n} pending request(s)",
            "open-cutoff": "{n} pending request(s) · cut-off in {days}d",
            "not-locked": "period not locked · cut-off in {days}d",
            "none": "no pending leave requests"
          },
          "ot": {
            "cutoff": "{n} unresolved OT request(s) · payroll cut-off in {days}d",
            "oldest": "oldest unresolved OT request {age}d old",
            "rate": "{pct}% of employees waiting",
            "open": "{n} unresolved OT request(s)",
            "open-cutoff": "{n} unresolved OT request(s) · cut-off in {days}d",
            "not-locked": "period not locked · cut-off in {days}d",
            "none": "no unresolved OT requests"
          }
        },
        "leave": {
          "lock-btn": "Lock Leave Period",
          "sub-tenant": "All Scopes · Executive Leave Operations Dashboard · aggregate KPIs + locked snapshots · read-only",
          "sub-client": "{name} · leave rollup · read-only",
          "sub-company": "{name} · leave hierarchy · read-only (operations live at owning scopes)",
          "kpi": {
            "waiting-tip": "Employees with at least one pending leave request",
            "completion": "Leave completion",
            "completion-tip": "Locked days ÷ expected days of the Leave earning period ({locked}/{total}) — units with no approved leave in the period count as complete",
            "oldest": "Oldest pending request",
            "oldest-none": "No pending leave requests"
          },
          "col": {
            "open": "Pending requests",
            "cutoff": "Next cut-off (leave-dependent)",
            "cutoff-tip": "Next payroll run that consumes leave (advance runs are skipped)",
            "approved-days": "Approved days",
            "liability": "Liability (days)",
            "period": "Leave period",
            "approved": "Approved",
            "pending-frozen": "Pending frozen",
            "days": "Days",
            "by-type": "By type",
            "dates-in-period": "Dates in period",
            "balance-snapshot": "Balance snapshot at lock"
          },
          "owner-direct": "Leave owner · company-owned staff",
          "owner-project": "{id} · leave owner",
          "l1-foot": "Executive Leave Operations Dashboard · as of {asOf} (latest request date) · cut-offs = next LEAVE-DEPENDENT payroll run from the Payroll Processing Calendar (advance runs skipped) · aggregate KPIs only — operations live at owning scopes · rows ranked by risk · click a row to drill",
          "l2-foot": "Next leave-dependent payroll cut-off: {cut}{win} · as of {asOf} · click a row for its locked periods",
          "win-line": " · Leave earning period ({from} → {to}]",
          "l2-banner-lead": "Leave operations live at the owning scopes (Direct Workforce / Project).",
          "l3-empty": "No locked Leave periods for this scope yet — the owning workspace closes periods via “Lock Leave Period”.",
          "l4-lead": "Locked Leave period — frozen snapshot (read-only).",
          "l4-banner": "Locked {at} by {by} · {reqs} request(s) · {days} approved day(s){tail}. This snapshot — approved leave + balances — is what Payroll consumes; no leave operations exist at oversight scopes.",
          "l4-frozen": " · {n} pending frozen (acknowledged at lock)",
          "progress-tip": "{locked} of {total} day(s) of the Leave earning period locked",
          "ready-tip": {
            "ready": "Approved leave of the Leave earning period is locked (or none to consume) — snapshot frozen for Payroll",
            "waiting": "Approved leave in the earning period is not locked yet — no pending requests blocking",
            "blocked": "Pending leave requests must be decided before the payroll cut-off"
          },
          "open-company-tip": "Open the company workspace — leave operations live at its owning scopes",
          "open-unit-tip": "Open the Leave workspace — owning scope (operations)",
          "locked-periods-tip": "Locked Leave periods for this unit",
          "draft-title": "Lock Leave Period — {company} · {unit}",
          "draft-counts": "{n} approved request(s) · {days} day(s)",
          "draft-unresolved": "{n} pending request(s)",
          "lock-anyway": "Lock anyway — freeze {n} pending",
          "ack": "{lead} {n} pending request(s) in this range will be FROZEN undecided — Payroll consumes the snapshot without them and they can no longer be approved or rejected for these dates. Click {anyway} to confirm, or Cancel and decide them first.",
          "draft-note": "Locking officially closes this Leave period: approved leave and a balance snapshot are frozen for Payroll. Requests touching a locked period can no longer be submitted, approved or rejected. Oversight scopes read locked snapshots only.",
          "l4-no-balances": "No balances captured."
        },
        "ot": {
          "lock-btn": "Lock OT Period",
          "sub-tenant": "All Scopes · Executive OT Operations Dashboard · aggregate KPIs + locked snapshots · read-only",
          "sub-client": "{name} · OT rollup · read-only",
          "sub-company": "{name} · OT hierarchy · read-only (operations live at owning scopes)",
          "kpi": {
            "waiting-tip": "Employees with at least one unresolved OT request",
            "completion": "OT completion",
            "completion-tip": "Locked days ÷ expected days of the OT earning period ({locked}/{total}) — units with no verified OT in the period count as complete; not the Payroll payment period",
            "oldest": "Oldest unresolved request",
            "oldest-none": "No unresolved OT requests"
          },
          "col": {
            "open": "Unresolved",
            "cutoff": "Next cut-off (OT-dependent)",
            "cutoff-tip": "Next payroll run that consumes OT (advance runs are skipped)",
            "verified-hrs": "Verified hrs",
            "amount": "Amount",
            "period": "OT period",
            "verified": "Verified",
            "unresolved-frozen": "Unresolved frozen",
            "hours": "Hours",
            "date": "Date",
            "time": "Time",
            "payable-hrs": "Payable hrs",
            "occurrence": "Occurrence period"
          },
          "owner-direct": "OT owner · company-owned staff",
          "owner-project": "{id} · OT owner",
          "l1-foot": "Executive OT Operations Dashboard · as of {asOf} (latest OT date) · cut-offs = next OT-DEPENDENT payroll run from the Payroll Processing Calendar (advance runs skipped) · aggregate KPIs only — operations live at owning scopes · rows ranked by risk · click a row to drill",
          "l2-foot": "Next OT-dependent payroll cut-off: {cut}{win} · as of {asOf} · click a row for its locked periods",
          "win-line": " · OT earning period ({from} → {to}]",
          "l2-banner-lead": "Overtime operations live at the owning scopes (Direct Workforce / Project).",
          "l3-empty": "No locked OT periods for this scope yet — the owning workspace closes periods via “Lock OT Period”.",
          "l4-lead": "Locked OT period — frozen snapshot (read-only).",
          "l4-banner": "Locked {at} by {by} · {reqs} request(s) · {hours}h verified · {amount}{tail}. This snapshot — Verified OT hours + amounts — is what Payroll consumes; no OT operations exist at oversight scopes.",
          "l4-frozen": " · {n} unresolved frozen (acknowledged at lock)",
          "progress-tip": "{locked} of {total} day(s) of the OT earning period locked (not the Payroll payment period)",
          "ready-tip": {
            "ready": "Verified OT of the OT earning period is locked (or none to consume) — snapshot frozen for Payroll",
            "waiting": "Verified OT in the earning period is not locked yet — no unresolved requests blocking",
            "blocked": "Unresolved OT requests must be decided before the payroll cut-off"
          },
          "open-company-tip": "Open the company workspace — OT operations live at its owning scopes",
          "open-unit-tip": "Open the Overtime workspace — owning scope (operations)",
          "locked-periods-tip": "Locked OT periods for this unit",
          "draft-title": "Lock OT Period — {company} · {unit}",
          "draft-counts": "{n} verified request(s) · {hours}h · {amount}",
          "draft-unresolved": "{n} unresolved request(s)",
          "lock-anyway": "Lock anyway — freeze {n} unresolved",
          "ack": "{lead} {n} unresolved OT request(s) in this range will be FROZEN undecided — Payroll consumes the Verified snapshot without them and they can no longer be approved, verified or resolved for these dates. Click {anyway} to confirm, or Cancel and decide them first.",
          "draft-note": "Locking officially closes this OT earning period: Verified OT and an hours/amount snapshot are frozen for Payroll. Requests dated inside a locked period can no longer be submitted, approved, verified or resolved. Oversight scopes read locked snapshots only.",
          "override": "override {h}h",
          "override-tip": "Verified with override",
          "occurrence-tip": "Occurrence period — when the OT was worked (never overwritten by the payroll pickup period)"
        }
      },
      "notice": {
        "item": {
          "not-found": "Item not found"
        },
        "reason-required": "⚠ Reason is required",
        "reject": {
          "reason-required": "⚠ Rejection cancelled — reason required"
        },
        "lock": {
          "invalid-range": "Invalid period range."
        },
        "handoff": {
          "oversight": "The Finance handoff happen at the owning scope (Direct Workforce / Project) — oversight is read-only."
        },
        "att": {
          "oversight": "Attendance reviews happen at the owning scope (Direct Workforce / Project) — oversight is read-only review.",
          "locked": "This attendance period is locked — no further changes.",
          "request-type-required": "Select a request type.",
          "wrong-state": {
            "review": "This record is not awaiting review.",
            "request": "A resolution request can only be raised on a Detected or Reviewed record.",
            "approval": "This record is not pending approval.",
            "lock": "Only Resolved records can be locked."
          },
          "ot": {
            "duplicate": "OT request {id} already exists for {name} on {date}",
            "no-planned-end": "No planned end time on this record — raise OT from the Overtime tab.",
            "created": "OT request created (Pending) — pre-filled from attendance punches"
          },
          "lock": {
            "oversight": "Attendance locks happen at the owning scope (Direct Workforce / Project) — oversight is read-only review.",
            "overlap": "This range overlaps an existing locked period.",
            "empty": "No attendance records in this range — nothing to lock.",
            "ack-required": "{count} unresolved exception(s) will be FROZEN into the Payroll snapshot and can no longer be corrected. Payroll will receive them as-is.",
            "done": "Attendance period locked — snapshot frozen for Payroll"
          },
          "resolve": {
            "submitted": "✓ {submitted} request(s) submitted to LMs · awaiting approval",
            "submitted-skipped": "✓ {submitted} request(s) submitted to LMs · {skipped} already in progress",
            "none": "No staff selected.",
            "reason-required": "⚠ Reason required for {name}",
            "clock-out-required": "⚠ Clock-Out time required for {name}"
          },
          "reminder": {
            "sent": "✓ Reminder sent to {sent} staff via mobile push notification",
            "sent-skipped": "✓ Reminder sent to {sent} staff via mobile · {skipped} already submitted (skipped)",
            "none": "All in this group have already submitted — nothing to remind"
          }
        },
        "attendance": {
          "oversight": "Attendance approvals happen at the owning scope (Direct Workforce / Project) — oversight is read-only review.",
          "approved": "✓ Attendance {id} approved",
          "rejected": "✕ Attendance {id} rejected"
        },
        "leave": {
          "oversight": "Leave approvals happen at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "oversight-decision": "Leave decisions happen at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "locked": "This request falls inside a locked Leave period — the period is closed for Payroll.",
          "reason-required": "⚠ Policy requires a reason on approval",
          "approved": "✓ Leave {id} approved · {days} day(s) deducted from balance",
          "rejected": "✕ Leave {id} rejected · returned to HR/employee",
          "cancelled": "✓ {id} cancelled · balance restored",
          "cancel-disabled": "⚠ Cancellation disabled by policy",
          "already-cancelled": "Already cancelled",
          "submit": {
            "incomplete": "Employee, leave type and at least one date are required.",
            "oversight": "New leave requests are created at the owning scope (Direct Workforce / Project) — oversight is read-only.",
            "locked": "One or more dates fall inside a locked Leave period — the period is closed.",
            "reason-required": "⚠ A reason is required for leave requests (policy)"
          },
          "submitted": "✓ Leave {id} submitted",
          "lock": {
            "oversight": "Leave locks happen at the owning scope (Direct Workforce / Project) — oversight is read-only review.",
            "overlap": "This range overlaps an existing locked Leave period.",
            "empty": "No leave requests in this range — nothing to lock.",
            "ack-required": "{count} pending request(s) in this range will be FROZEN undecided — Payroll consumes the snapshot without them and they can no longer be approved or rejected for these dates.",
            "done": "Leave period locked — approved leave + balance snapshot frozen for Payroll"
          }
        },
        "ot": {
          "oversight": "Overtime approvals happen at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "oversight-decision": "Overtime decisions happen at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "locked": "This OT request is inside a locked OT period — no further changes.",
          "not-pending": "Only Pending OT requests can be approved (current status: {status}).",
          "approved": "✓ Overtime {id} approved",
          "rejected": "✕ Overtime {id} rejected",
          "lock": {
            "oversight": "Overtime locks happen at the owning scope (Direct Workforce / Project) — oversight is read-only review.",
            "overlap": "This range overlaps an existing locked OT period.",
            "empty": "No OT requests in this range — nothing to lock.",
            "ack-required": "{count} unresolved OT request(s) in this range will be FROZEN undecided — Payroll consumes the Verified snapshot without them and they can no longer be approved, verified or resolved for these dates.",
            "done": "OT period locked — Verified OT + hours/amount snapshot frozen for Payroll"
          },
          "submitted": "✓ OT request {id} submitted",
          "submit": {
            "oversight": "New OT requests are created at the owning scope (Direct Workforce / Project) — oversight is read-only.",
            "locked": "This date is inside a locked OT period — no further OT can be requested for it."
          }
        },
        "travel": {
          "oversight": "Travel approvals happen at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "oversight-decision": "Travel decisions happen at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "not-pending": "Only Pending travel requests can be approved (current status: {status}).",
          "not-approved": "Only Approved travel requests can be handed to Finance (current status: {status}).",
          "approved": "✓ Travel {id} approved",
          "rejected": "✕ Travel {id} rejected",
          "handed": "✓ Travel {id} handed to Finance — settlement continues in TRV/EXP-FIN",
          "saved": "✓ Travel request saved"
        },
        "expense": {
          "oversight": "Expense approvals happen at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "oversight-decision": "Expense decisions happen at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "not-pending": "Only Pending expense claims can be approved (current status: {status}).",
          "not-approved": "Only Approved expense claims can be handed to Finance (current status: {status}).",
          "approved": "✓ Expense {id} approved",
          "rejected": "✕ Expense {id} rejected",
          "handed": "✓ Expense {id} handed to Finance — settlement continues in TRV/EXP-FIN",
          "saved": "✓ Expense claim saved"
        },
        "policy": {
          "company-only": "Travel & Expense policy is company-owned — manage it at the company context (company root).",
          "saved": "✓ Policy saved"
        },
        "sched": {
          "no-company": "Select a company workspace.",
          "oversight": "Roster operations live at the owning scope (Direct Workforce / Project) — oversight is read-only.",
          "shift": {
            "saved": "✓ Shift saved",
            "deleted": "✓ Shift deleted"
          },
          "rule": {
            "saved": "✓ Rule saved",
            "deleted": "✓ Rule deleted"
          },
          "pattern": {
            "saved": "✓ Work pattern saved",
            "deleted": "✓ Work pattern deleted"
          },
          "coverage": {
            "saved": "✓ Coverage plan saved",
            "deleted": "✓ Coverage plan deleted"
          },
          "roster": {
            "saved": "✓ Roster saved",
            "deleted": "✓ Roster deleted"
          },
          "pool": {
            "saved": "✓ Pool saved",
            "deleted": "✓ Pool deleted"
          },
          "rw": {
            "locked": "Published rosters change via logged amendments only",
            "published-locked": "Published roster is locked — use a logged amendment or publish a new version.",
            "must-approve": "Roster must be approved before publishing",
            "title-required": "Roster title is required — name this roster before publishing",
            "cell-set": "{name} · {day} → {value}",
            "cell-removed": "{name} removed · {day} (gap opens to refill)",
            "cell-reset": "{name} · {day} reset to original",
            "already": "{name} is already assigned that day",
            "filled": "{name} assigned to {group}",
            "filled-ot": "{name} added on overtime · {group}",
            "filled-oc": "{name} called in (on-call) · {group}",
            "filled-amend": "{name} assigned — logged as post-publish amendment",
            "fill-removed": "{name} removed from {group}",
            "regenerated": "Regenerated · new Draft v{ver}",
            "submit-blocked": "Resolve {n} must-fix issue(s) before submitting",
            "submitted": "Submitted for approval",
            "approved": "Roster approved · ready to publish",
            "sent-back": "Sent back to draft — audit note added",
            "sent-back-run": "Sent back to Draft — audit note added",
            "withdrawn": "Submission withdrawn — back to Draft",
            "voided": "Approval voided — back to Draft · audit note added",
            "published": "Roster published & saved · v{ver}",
            "fresh": "Fresh workspace ready",
            "parked": "Run parked in All Rosters ({status}) · fresh workspace ready",
            "resumed": "Resumed \"{title}\" · {status}",
            "resumed-current": "Resumed",
            "no-run": "This roster has no saved run data",
            "reopened": "Reopened published roster · {week}",
            "waived": "Issue accepted · logged to audit trail",
            "surplus-removed": "Surplus shift removed — labour cost saved"
          },
          "not-built": "This part of Scheduling is not available yet."
        }
      },
      "header": {
        "subtitle": "{company} · HR operations",
        "all-companies": "All Companies (oversight)",
        "this-company": "this company"
      },
      "empty-notice": "No {label} records for {company}. These are recorded per operating company — this company has none in the prototype sample data. Switch to an operating company (e.g. Optimal P) or All Scopes.",
      "tx": {
        "close": "Close",
        "cancel": "Cancel",
        "ok": "OK",
        "remove": "Remove",
        "loading": "Loading…",
        "load-error": "Could not load these records.",
        "retry": "Retry",
        "settings": "Settings",
        "export": "Export",
        "hand": "Hand to Finance →",
        "resolve": "Resolve",
        "issue": "Issue: {label}",
        "with-finance-b": "With Finance",
        "open-id": "Open {id}",
        "open-record": "Open {id}",
        "recovered": "{amount} recovered from employee",
        "paid-out": "{amount} paid out to employee",
        "zero-balance": "zero balance",
        "rejected-reason": "Rejected: {reason}",
        "cancelled-reason": "Cancelled: {reason}",
        "request": "Request",
        "purpose": "Purpose",
        "purpose-reason": "Purpose / business reason",
        "net-balance": "Net balance",
        "owed-by-employee": "(owed by employee)",
        "due-to-employee": "(due to employee)",
        "zero": "(zero)",
        "owed": "owed",
        "due": "due",
        "requested-by": "Requested by:",
        "approver": "Approver:",
        "external-lm": "External Line Manager:",
        "approver-external": "{name} (External LM)",
        "approver-self-md": "Self-approval (MD)",
        "advance-disbursed": "Advance disbursed:",
        "amount-via": "{amount} via {via}",
        "via": "via {via}",
        "activity": "Activity log",
        "no-activity": "No activity yet.",
        "employee": "Employee",
        "select-employee": "— Select employee —",
        "submit-approval": "Submit for Approval",
        "save-changes": "Save Changes",
        "settings-foot": "Changes apply to this session only · Full per-tenant persistence comes with Admin Settings build",
        "include-outsourced": "Include Outsourced",
        "showing": "Showing {n} of {total}",
        "search-ph": "Filter by employee name…",
        "clear-search": "Clear search",
        "clear-filters": "Clear filters",
        "outsourced": "Outsourced",
        "demo": "demo",
        "demo-tip": "Demo seed · TRVEXP-OWN-104",
        "col": {
          "id": "ID",
          "employee": "Employee",
          "status": "Status"
        },
        "kpi": {
          "needs-action": "Needs your action",
          "pending": "Pending approval",
          "advance-outstanding": "Advance outstanding"
        },
        "who": {
          "hr-system": "HR System",
          "system": "System"
        },
        "status": {
          "pending": "Pending",
          "approved": "Approved",
          "disbursed": "Disbursed",
          "in-travel": "In Travel",
          "returned": "Returned",
          "awaiting-settlement": "Awaiting Settlement",
          "handed-to-finance": "Handed to Finance",
          "closed": "Closed",
          "rejected": "Rejected",
          "cancelled": "Cancelled",
          "issue-to-resolve": "Issue to Resolve",
          "clearance-submitted": "Clearance Submitted",
          "clearance-overdue": "Clearance Overdue",
          "reimbursed": "Reimbursed",
          "settled": "Settled",
          "awaiting-approval": "Awaiting Approval",
          "paid": "Paid",
          "submitted": "Submitted",
          "verified": "Verified",
          "overdue": "Overdue"
        },
        "policy": {
          "owned": "Company-owned policy",
          "effective-from": "Effective from",
          "each-save": "each save adds an audited, effective-dated version.",
          "readonly": "Read-only here — editing is restricted to company-level policy roles in the company workspace. Operating scopes (Direct / Project) consume the applicable policy read-only; Client/Project overrides require an explicit override model (future slice).",
          "version": "effective {eff} — saved {at} by {by}",
          "no-versions": "No saved company versions yet — session defaults shown."
        },
        "port": {
          "readonly": "read-only monitoring layer",
          "travel": {
            "title": "Executive Travel Operations Dashboard",
            "note": "Travel is a Finance/AP module — no payroll consumption, cut-offs or period locks. HR hands approved requests to Finance; Verify → Disburse → Settle → Completed continue in the Finance module (TRV/EXP-FIN). Operations happen at the owning scopes (Direct Workforce / Project)."
          },
          "expense": {
            "title": "Executive Expense Operations Dashboard",
            "note": "Expense is a Finance/AP reimbursement module — no payroll consumption or period locks. HR hands approved claims to Finance; Verify → Disburse → Settle/Reimburse → Completed continue in the Finance module (TRV/EXP-FIN). Operations happen at the owning scopes (Direct Workforce / Project)."
          },
          "kpi": {
            "inflight": "In-flight (counts only)",
            "inflight-tip": "Pre-handoff work belongs to the owning scopes — record detail is not exposed upward (PO D1)",
            "committed": "Committed spend",
            "committed-sub": "Approved · awaiting handoff",
            "committed-tip": "Aggregate KPI only — no pending transaction detail upward (PO D1)",
            "handed": "Handed to Finance",
            "handed-sub": "{amount} · with Finance (TRV/EXP-FIN)",
            "handed-tip": "HR-terminal handoff state — displayed exactly as Handed to Finance (PO D2)",
            "done": "Finance-complete / declined",
            "done-sub": "{done} settled-era · {rej} rejected/cancelled",
            "done-tip": "Legacy Finance-complete demo records + declined requests"
          },
          "oldest": "oldest {n}d",
          "col": {
            "unit": "OWNING UNIT",
            "inflight": "IN-FLIGHT",
            "committed": "COMMITTED",
            "handed": "HANDED TO FINANCE",
            "done": "COMPLETE/DECLINED",
            "actions": "Actions"
          },
          "direct": "Direct Workforce",
          "inflight-cell-tip": "In-flight records are counts-only above the owning scope (PO D1) — no record-level drill before the Finance handoff",
          "committed-cell-tip": "Committed spend (Approved, awaiting handoff) — aggregate amount only",
          "records": "Records",
          "hide": "Hide",
          "counts-only": "counts-only",
          "counts-only-tip": "No HR-terminal records to review yet",
          "no-terminal": "No HR-terminal records yet — in-flight work stays at the owning scope until Handed to Finance.",
          "empty": "No records in scope."
        }
      },
      "travel": {
        "new-request": "New Request",
        "empty": "No travel requests matching this filter.",
        "exported": "✓ Exported {n} rows → {name}",
        "totals": "Totals ({n} of {total})",
        "tracking-note": "Plan → Authorize → Travel → Expense Report → Settled. The \"Actual\" and \"Balance\" columns are pulled from the linked Expense Report (single source of truth).",
        "flow-note-b": "New consolidated flow:",
        "flow-note": "Travel handles authorization + advance. After the trip, employees submit an {report} for actual receipts (single source of truth for spending). Balance computed there flows back to Travel status (Returned → Awaiting Settlement → Closed).",
        "view": {
          "requests": "All Requests",
          "tracking": "Tracking Report"
        },
        "kind": {
          "local": "Local",
          "overseas": "Overseas"
        },
        "accom": {
          "shared": "Shared room",
          "dedicated": "Dedicated room"
        },
        "kpi": {
          "needs-sub": "{submit} to submit · {verifying} verifying · {issue} issue",
          "pending-sub": "Awaiting LM/MD review",
          "in-travel": "In travel / Disbursed",
          "in-travel-sub": "{trip} on trip · {pre} pre-departure",
          "advance-sub": "Paid but trip not yet closed"
        },
        "chip": {
          "all": "All",
          "needs-action": "Needs Action",
          "pending": "Pending",
          "approved": "Approved",
          "handed": "Handed to Finance",
          "disbursed": "Disbursed",
          "in-travel": "In Travel",
          "returned": "Returned",
          "awaiting-settlement": "Awaiting Settlement",
          "closed": "Closed",
          "issue": "Issue",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "col": {
          "destination": "Destination",
          "dates": "Dates",
          "plan-dates": "Plan Dates",
          "estimate": "Estimate",
          "advance": "Advance",
          "exp-rpt": "Exp Rpt",
          "expense-rpt": "Expense Rpt",
          "adv-status": "Adv Status",
          "actual": "Actual",
          "balance": "Balance",
          "trip-status": "Trip Status"
        },
        "meal": {
          "breakfast": "breakfast",
          "lunch": "lunch",
          "dinner": "dinner"
        },
        "line": {
          "mission": "Mission allowance (client covers travel) — {rate}/day × {days} days",
          "meals-daytrip": "Meals (day trip, dep {time}) — {meals} = {amount}",
          "meals-day1": "Meals — Day 1 (dep {time}): {meals}",
          "meals-inter": "Meals — intermediate days (B+L+D × {days} days)",
          "meals-return": "Meals — return day (ret {time}, {km}km): {meals}",
          "transport": "Transportation (round trip to {dest}, {km}km)",
          "in-area": "In-area travel — {rate}/day × {days} days",
          "company-car": "Transportation — company vehicle (no allowance per policy 3.3)",
          "accom-shared": "Accommodation (shared) — {rate}/night × {nights} nights",
          "accom-dedicated": "Accommodation (dedicated) — {rate}/night × {nights} nights",
          "per-diem-single-half": "Per diem ({tier} {label}) — ½ day × {rate}/day",
          "per-diem-single-full": "Per diem ({tier} {label}) — 1 day × {rate}/day",
          "per-diem-full": "Per diem ({label}) — {days} full day(s) × {rate}/day",
          "per-diem-return-half": "Per diem — return day (back {time} local) — ½ day",
          "per-diem-return-full": "Per diem — return day (back {time} local) — full day",
          "accom-ceiling": "Accommodation (ceiling) — {rate}/night × {nights} nights",
          "airport": "Airport transfer (RT, ceiling) — {rate} × 2",
          "flight": "Flight (Economy, est.)",
          "visa": "Visa fee",
          "insurance": "Travel insurance",
          "roaming": "Roaming / SIM (cap {cap})",
          "baggage": "Excess baggage (work-related)"
        },
        "detail": {
          "title": "Travel Request Detail",
          "foot": "Clearance form (employee submits actual + receipts) arrives in Slice 2b",
          "approved-b": "Approved",
          "approved": "HR handoff pending. Hand this request to Finance for advance disbursement and settlement (continues in the Finance module · TRV/EXP-FIN).",
          "with-finance": "handed to Finance on {at}. Verify → Disburse → Settle → Completed continue in the Finance module (TRV/EXP-FIN). HR Operations owns no further actions on this record.",
          "returned-b": "Returned",
          "returned": "submit an Expense Report with actual receipts within {days} working days. All travel-related spending is now reconciled via Expense (single source of truth).",
          "submit-exp": "Submit Expense Report →",
          "awaiting-b": "Expense Report {id} submitted",
          "awaiting": "actual {actual} vs advance {advance}. Awaiting Finance verification.",
          "closed-b": "Trip closed",
          "closed-1": "settled via Expense Report",
          "closed-2": "Actual {actual} vs advance {advance} →",
          "in-travel": "Currently in travel. Returns {date}.",
          "disbursed": "Advance {amount} disbursed on {at} via {via}. Trip starts {start}.",
          "trip": "Trip",
          "advance": "Advance",
          "expense-report": "Expense Report",
          "country": "Country",
          "destination": "Destination",
          "itinerary": "Itinerary",
          "start": "Start",
          "end": "End",
          "days": "Days",
          "return-time": "Return time",
          "depart-time": "Depart time",
          "departure-time": "Departure time",
          "accommodation": "Accommodation",
          "nights": "{n} nights",
          "company-car": "Company vehicle — no transport / in-area allowance per policy 3.3",
          "client-pays": "Client covers travel — mission allowance only",
          "estimate": "Authorization estimate (Optimal P policy)",
          "estimate-overseas": "Overseas — per diem + accommodation ceiling + transfers + items",
          "estimate-local": "Local — meals + transportation + accommodation + in-area travel",
          "ceiling": " (ceiling — actual capped)",
          "total-estimate": "Total estimate",
          "cash-advance": "Cash advance ({pct}%)",
          "actual-spent": "Actual spent (from Expense Report",
          "chain-overseas": "Approval chain (LM → Dept Head → MD → Finance)",
          "chain-local": "Approval chain (LM → MD)",
          "resolve-later": "Travel resolve flow — coming later",
          "not-found": "Travel record not found"
        },
        "new": {
          "title": "New Travel Authorization",
          "subtitle": "Itemized cost auto-calculates from Optimal P policy. {pct}% advance disbursed after approval.",
          "type": "Travel type:",
          "local": "Local (Cambodia)",
          "overseas": "Overseas",
          "select-province": "— Select province —",
          "select-country": "— Select country —",
          "transport": "transport",
          "tier-group": "{label} — {perDiem}/day · accom {accom}",
          "start": "Start date",
          "end": "End date",
          "depart-origin": "Depart time (local origin)",
          "nights": "Nights",
          "company-car": "Use company vehicle (no transport/in-area allowance)",
          "client-pays": "Client covers travel (mission allowance only)",
          "visa": "Visa fee (USD)",
          "insurance": "Insurance (USD)",
          "roaming": "Roaming/SIM (USD)",
          "baggage": "Excess baggage (USD)",
          "flight": "Est. flight fare (Economy)",
          "airport": "Include airport transfer round-trip (ceiling per tier)",
          "live": "Cost estimate (live)",
          "total": "Total:",
          "pick-dest-hint": "Select a destination to see breakdown",
          "pick-country-hint": "Select a country to see breakdown",
          "advance": "Advance to be disbursed ({pct}%):",
          "purpose-ph": "e.g., Q2 client visits — meet 4 prospective customers",
          "itinerary": "Itinerary (optional)",
          "itinerary-ph": "Day 1: travel + meeting. Day 2: site visit. Day 3: report + return.",
          "policy-note": "Lead time per policy: 5 working days (local) / 10 (overseas). Approval chain: LM → MD (local) · LM → Dept Head → MD → Finance (overseas). Outsourced staff route to External LM.",
          "submitted": "✓ Travel request submitted — awaiting LM approval",
          "err": {
            "pick-employee": "⚠ Pick an employee",
            "enter-dates": "⚠ Enter dates",
            "purpose": "⚠ Purpose is required",
            "pick-dest": "⚠ Pick a destination",
            "pick-country": "⚠ Pick a country",
            "end-before-start": "⚠ End date cannot be before start date"
          }
        },
        "settings": {
          "title": "Travel Settings",
          "subtitle": "Tenant-configurable DSA rates, advance %, lead time, clearance window",
          "globals": "Globals",
          "advance-pct": "Advance %",
          "advance-pct-hint": "% of estimate paid in advance",
          "lead-local": "Local lead time (days)",
          "lead-overseas": "Overseas lead time (days)",
          "cancel-return": "Cancel return (days)",
          "cancel-return-hint": "Days to return advance on cancel",
          "clear-local": "Local clearance window",
          "clear-overseas": "Overseas clearance window",
          "clear-hint": "Working days after return",
          "local-meals": "Local — Meals + In-area + Mission allowance",
          "breakfast": "Breakfast (USD)",
          "lunch": "Lunch (USD)",
          "dinner": "Dinner (USD)",
          "in-area": "In-area travel/day",
          "mission-local": "Mission /day (client-paid)",
          "destinations": "Local destinations ({n})",
          "add-destination": "Add destination",
          "transport-rt": "Transport (RT)",
          "accom-ded": "Accom (dedicated)",
          "accom-shr": "Accom (shared)",
          "tiers": "Overseas — Tier rates",
          "tier": "Tier",
          "per-diem": "Per diem/day",
          "accom-ceiling": "Accom ceiling/night",
          "airport": "Airport transfer (each way)",
          "mission-overseas": "Mission allowance (client-paid overseas):",
          "mission-overseas-tail": "per day · Roaming/SIM caps: T1–2 $20, T3 $40",
          "countries": "Overseas countries ({n})",
          "add-country": "Add country",
          "source": "Source policies: Optimal P Local Travel Policy + Overseas Travel Policy. Per-row destination/country editing comes with the full Admin Settings build.",
          "later": "Add/edit/remove — coming with Admin Settings build",
          "refused": "Travel policy is company-owned — editing is restricted to company-level policy roles (open the company workspace).",
          "saved": "✓ Travel policy saved to the company workspace (effective-dated)"
        }
      },
      "expenses": {
        "new-claim": "New Claim",
        "empty": "No claims matching this filter.",
        "internal": "Internal",
        "linked": "linked {id}",
        "days-overdue": "{n} days overdue",
        "kind-filter": "Claim kind",
        "kind": {
          "both": "Both kinds",
          "advance-only": "Advance only",
          "reimb-only": "Reimbursement only"
        },
        "kind-chip": {
          "advance": "Advance",
          "reimb": "Reimb."
        },
        "flows-b": "Two flows.",
        "flows-adv-b": "Advance",
        "flows-adv": "request advance → LM approves → Finance disburses → employee spends → submits clearance with receipts → Finance verifies → balance settled (recovered from or paid out to employee).",
        "flows-reimb-b": "Reimbursement",
        "flows-reimb": "employee pays out of pocket → submits receipts → LM approves → Finance reimburses via payroll/cash/bank.",
        "flows-tail": "Both can be tagged to a Project and optionally linked to a Travel request (TA-xxx).",
        "kpi": {
          "needs-sub": "{overdue} overdue · {issue} issue",
          "pending-sub": "Awaiting LM review",
          "advance-sub": "Paid but not yet cleared",
          "reimb": "Reimbursement pending",
          "reimb-sub": "Approved or awaiting approval"
        },
        "chip": {
          "all": "All",
          "needs-action": "Needs Action",
          "pending": "Pending",
          "approved": "Approved",
          "handed": "Handed to Finance",
          "disbursed": "Disbursed",
          "returned": "Returned",
          "clearance-submitted": "Clr. Submitted",
          "clearance-overdue": "Clr. Overdue",
          "reimbursed": "Reimbursed",
          "settled": "Settled",
          "issue": "Issue",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "col": {
          "kind": "Kind",
          "purpose": "Purpose / Project",
          "date": "Date",
          "requested": "Requested",
          "paid-out": "Paid Out",
          "actual": "Actual"
        },
        "detail": {
          "title": "Expense Claim Detail",
          "foot": "Approve / Reject / Clearance / Reimburse actions come in Slice 2",
          "resolve-later": "Resolve issue flow — Slice 2",
          "clearance-later": "Clearance form — Slice 2",
          "overdue": "Clearance overdue",
          "overdue-days": "({n} days)",
          "overdue-note": "Past the {days}-working-day clearance window. May be recovered via the configured settlement channel if not cleared.",
          "settle": "Settle",
          "returned": "Spending completed — clearance due within {days} working days. Submit actual receipts.",
          "clr-submitted": "Clearance submitted on {at} (actual {amount}) — awaiting Finance verification.",
          "with-finance-chip": "With Finance · TRV/EXP-FIN",
          "with-finance-tip": "Finance verification continues in the Finance module (TRV/EXP-FIN)",
          "disbursed": "Advance {amount} disbursed on {at} via {via}. Submit clearance after spending.",
          "settled": "Settled — actual {actual} vs advance {advance} → {result} via {via}.",
          "reimbursed": "Reimbursed {amount} on {at} via {via}.",
          "with-finance": "handed to Finance on {at}. Verify → Disburse → Settle/Reimburse → Completed continue in the Finance module (TRV/EXP-FIN). HR Operations owns no further actions on this record.",
          "approved-advance": "hand to Finance for advance disbursement ({amount}) · continues in TRV/EXP-FIN.",
          "approved-reimb": "hand to Finance for reimbursement ({amount}) · continues in TRV/EXP-FIN.",
          "authorized-by": "Authorized by Travel",
          "clearance-kind": "Travel-clearance kind — reconciled against Travel advance of",
          "trip-dates": "Trip dates {start} → {end}.",
          "overall": "Overall",
          "clearance": "Clearance",
          "reimbursement": "Reimbursement",
          "kind": "Kind",
          "kind-advance": "Advance Request",
          "kind-reimb": "Direct Reimbursement",
          "project": "Project",
          "linked-travel": "Linked Travel",
          "amounts": "Amounts",
          "requested-advance": "Requested advance",
          "disbursed-lbl": "Disbursed",
          "actual-receipts": "Actual (from receipts)",
          "reimb-requested": "Reimbursement requested",
          "status": "Status",
          "paid-on": "Paid on",
          "paid-via": "Paid via",
          "line-items": "Line items",
          "none-yet": "(none yet)",
          "line-items-sub": "Each line gets its own GL account; receipts attached individually",
          "lines-total": "Lines total:",
          "category": "Category",
          "description": "Description",
          "receipt": "Receipt",
          "amount": "Amount",
          "has-receipt": "Receipt attached",
          "no-receipt": "No receipt",
          "no-lines": "No line items yet (advance not yet cleared)",
          "chain": "Approval chain",
          "approver-lm": "Approver (LM):",
          "verified-by": "Clearance verified by:",
          "reimbursed-lbl": "Reimbursed:"
        },
        "new": {
          "title": "New Expense Claim",
          "subtitle": "Request advance up-front, or claim reimbursement after spending",
          "type": "Claim type:",
          "link-travel": "Link to Travel request (optional)",
          "none": "— None —",
          "purpose-ph": "e.g., Client entertainment dinner for Acme prospects",
          "advance-request": "Advance request",
          "requested-amount": "Requested amount (USD)",
          "advance-note": "After approval, Finance disburses {pct}% of this amount. You submit clearance with actual receipts after spending.",
          "reimb-lines": "Reimbursement — line items",
          "add-line": "Add line",
          "remove-line": "Remove line",
          "line-ph": "What was this for?",
          "amount-usd": "Amount (USD)",
          "total-reimburse": "Total to reimburse:",
          "routing-note": "Approval routes to your Line Manager (or External LM for outsourced staff). Finance verifies and pays out / disburses after LM approves.",
          "linked-to": "Linked to {id}",
          "linked-note": "Pre-filled with the policy-estimated DSA breakdown. Edit each line to match your actual receipts. Advance to reconcile against:",
          "clearance-purpose": "Travel clearance for {id} {dest}",
          "submitted": "✓ Claim submitted — awaiting LM approval",
          "err": {
            "pick-employee": "⚠ Pick an employee",
            "purpose": "⚠ Purpose is required",
            "advance-amount": "⚠ Advance amount must be > 0",
            "add-line": "⚠ Add at least one line item with an amount"
          }
        },
        "settings": {
          "title": "Expense Settings",
          "subtitle": "Tenant-configurable categories, approval tiers, advance/reimbursement policy, receipt rules, notifications, projects, currency",
          "tab": {
            "cats": "Categories",
            "approval": "Approval Tiers",
            "policy": "Advance / Reimb.",
            "receipt": "Receipt Rules",
            "notif": "Notifications",
            "projects": "Projects",
            "fx": "Currency / FX"
          },
          "categories": "Categories ({n})",
          "categories-sub": "Manage labels, GL accounts, per-category caps, receipt thresholds (−1 = use global), default payment method",
          "add-category": "Add category",
          "new-category": "New category",
          "remove-category-confirm": "Remove this category? (Historical claims keep their reference)",
          "receipt-inherit": "-1 = use global threshold",
          "categories-note": "Deactivating a category preserves history. Cap is optional (blank = no cap). Receipt threshold −1 means inherit the global ({amount}).",
          "col": {
            "label": "Label",
            "active": "Active",
            "cap": "Cap (USD)",
            "receipt": "Receipt ≥",
            "method": "Default method",
            "project": "Project name",
            "budget": "Budget cap (USD)",
            "claimants": "Allowed claimants"
          },
          "tiered": "Tiered approval by amount",
          "tiered-sub": "Approvers required based on the total claim amount.",
          "up-to": "Up to (USD)",
          "required": "Required approvers",
          "tier-n": "Tier {n}",
          "no-upper": "no upper bound",
          "add-tier": "Add tier",
          "overrides": "Per-category overrides",
          "overrides-sub": "Always require these approvers for the category, regardless of amount (in addition to the tier).",
          "override-approvers": "Override approvers (additional)",
          "role": {
            "LM": "Line Manager",
            "DH": "Department Head",
            "MD": "Managing Director",
            "FIN": "Finance"
          },
          "advance-policy": "Advance policy",
          "adv-pct": "Advance % of request",
          "adv-pct-hint": "% of requested amount disbursed",
          "max-adv": "Max advance per request",
          "max-adv-hint": "USD ceiling per single request",
          "clr-window": "Clearance window (days)",
          "clr-window-hint": "Working days after spending",
          "overdue": "Overdue threshold (days)",
          "overdue-hint": "Days past window before flagged",
          "max-conc": "Max concurrent advances per employee",
          "auto-recover": "Auto-recover overdue advances via next payroll",
          "reimb-policy": "Reimbursement policy",
          "reimb-target": "Target days to reimburse",
          "reimb-target-hint": "From submission to payout",
          "monthly-cap": "Monthly claim cap per employee",
          "def-method": "Default payment method",
          "allowed-methods": "Allowed payment methods",
          "receipt-thresh": "Mandatory receipt threshold (USD)",
          "receipt-thresh-hint": "Any line ≥ this requires a receipt",
          "receipt-max": "Max file size (MB)",
          "formats": "Allowed file formats",
          "ocr": "Enable OCR auto-extract for receipts",
          "ocr-later": "(coming with v7)",
          "receipt-note": "Per-category receipt thresholds override the global value. Set a category's threshold to −1 to inherit this global setting.",
          "lm-mode": "LM notification mode",
          "immediate": "Immediate (push + email)",
          "digest": "Daily digest (one email per day)",
          "overdue-every": "Overdue reminder (every N days)",
          "escalate": "Escalate to MD when overdue > (days)",
          "notify-approve": "Notify employee when claim is approved",
          "notify-reject": "Notify employee when claim is rejected (with reason)",
          "projects": "Projects ({n})",
          "projects-sub": "Manage project list, budget caps (blank = unlimited), eligible claimants",
          "add-project": "Add project",
          "new-project": "New project",
          "remove-project-confirm": "Remove this project?",
          "projects-note": "Deactivating preserves history. \"Allowed claimants\" can be \"All\" or a free-text descriptor (employee selector comes in Admin Settings build).",
          "fx-title": "Currency & FX",
          "base-currency": "Base currency",
          "fx-source": "FX rate source",
          "fx-nbc": "NBC daily (Cambodia)",
          "fx-open": "OpenExchange Rates API",
          "fx-manual": "Manual entry per claim",
          "multi-currency": "Accept multi-currency claims",
          "accepted": "Accepted currencies (for claim entry)",
          "fx-note": "Non-base-currency claims are converted at the FX rate on the claim date. If \"Manual\" is selected, the employee enters the rate per line.",
          "gov-readonly": "Company-owned policy — read-only here ({history}). Edit in the company workspace with a policy role.",
          "gov-version": "· eff. {eff} ({at})",
          "gov-none": "no saved versions",
          "refused": "Expense policy is company-owned — editing is restricted to company-level policy roles (open the company workspace).",
          "saved": "✓ Expense policy saved to the company workspace (effective-dated)"
        }
      },
      "approvals": {
        "title-oversight": "Approvals — HR Oversight",
        "title-queue": "My Queue",
        "acting-as": "(acting as {name})",
        "sub-oversight": "Company-wide view across all approvers. Chase, override, or step into a queue.",
        "sub-queue": "Items routed to {who} for direct approval. Click any row for full detail.",
        "you": "you",
        "view": {
          "oversight": "Oversight",
          "queue": "My Queue"
        },
        "kpi": {
          "total": "Total pending",
          "total-sub": "Across {n} approver(s)",
          "aging": "Aging > 5 days",
          "aging-sub": "{mid} more in 3–5d window · {fresh} fresh (≤2d)",
          "blocking": "Blocking payroll",
          "blocking-sub": "Attendance + OT — must clear before cut-off",
          "external": "External LMs",
          "external-sub": "Client-side approvers with pending items"
        },
        "kind": {
          "all": "All",
          "attendance": "Attendance",
          "leave": "Leave",
          "overtime": "OT",
          "travel": "Travel",
          "expense": "Expense"
        },
        "initial": {
          "attendance": "A",
          "leave": "L",
          "overtime": "O",
          "travel": "T",
          "expense": "E"
        },
        "by-approver": "Pending by approver ({n})",
        "by-approver-sub": "Sorted by oldest pending. Chase reminds the LM; Act As lets you handle their queue.",
        "all-items": "All pending items ({n})",
        "all-items-sub": "Click a row to view the full request. Use Override only when an LM is unreachable and the deadline is at risk.",
        "col": {
          "approver": "Approver",
          "count": "Count",
          "avg-age": "Avg Age",
          "oldest": "Oldest",
          "kinds": "Kinds",
          "actions": "Actions",
          "kind": "Kind",
          "summary": "Summary",
          "amount": "Amount",
          "age": "Age",
          "submitted": "Submitted"
        },
        "internal-lm": "Internal LM",
        "external-lm": "External LM",
        "self-approval": "Self-approval",
        "self-short": "Self (MD)",
        "external": "External",
        "chase": "Chase",
        "chase-aria": "Chase {name}",
        "chased": "📲 Reminder sent to {name} — chase logged",
        "act-as": "Act As",
        "act-as-aria": "Act as {name}",
        "acting": "Acting as {name} — view shows their queue",
        "exited": "Exited Act-As mode",
        "acting-banner-1": "Acting as",
        "acting-banner-2": "— viewing their personal queue. Approve/Reject actions here are logged as HR-on-behalf.",
        "exit-act-as": "Exit Act-As",
        "none": "No pending items",
        "queue-empty": "Your personal queue is empty. Switch to Oversight to see the company-wide view.",
        "view-btn": "View",
        "view-aria": "View {id}",
        "override": "Override",
        "override-tip": "HR override-approve with reason",
        "override-aria": "Override-approve {id}",
        "override-prompt": "HR override — provide reason (required):",
        "override-cancelled": "⚠ Override cancelled — reason required",
        "override-approved": "✓ {kind} {id} approved via HR override",
        "approve": "Approve",
        "approve-aria": "Approve {id}",
        "reject": "Reject",
        "reject-aria": "Reject {id}",
        "reject-prompt": "Reason for rejection (required):",
        "reject-cancelled": "⚠ Rejection cancelled — reason required",
        "owning-only": "Owning scope only",
        "owning-only-tip": "Decisions happen at the owning scope (Direct Workforce / Project) — oversight is read-only",
        "ago": "{n}d ago",
        "days": "{n} day(s)",
        "persona-b": "Persona note:",
        "persona-note": "HR roles default to Oversight; LMs default to My Queue. Use the toggle at top-right to switch. HR can also Act As any approver from Oversight to clear their backlog (e.g., LM on leave).",
        "issue": {
          "missed-out": "Missed Clock-Out",
          "absent": "Absent",
          "wrong-location": "Wrong Location",
          "system-error": "System Error"
        },
        "exp-kind": {
          "advance": "Advance",
          "reimbursement": "Reimb.",
          "clearance": "Travel-Clr"
        },
        "ar": {
          "title": "Request {id} · {name}",
          "resolved-on": "Resolved on {at}",
          "returned-on": "Returned on {at}",
          "submitted": "Submitted {at} · awaiting LM",
          "details": "Request details",
          "org-unit": "Org. Unit",
          "type": "Type",
          "date": "Date affected",
          "clock-in": "Clock-In",
          "clock-out": "Clock-Out",
          "location": "Location",
          "routes-to": "Routes to",
          "escalates": "Escalates to HR",
          "reason": "Reason",
          "history": "Audit history ({n})",
          "no-history": "No history.",
          "by": "by",
          "foot": "Request {id} · {status}"
        }
      },
      "sched": {
        "all-companies": "All Companies",
        "yes": "Yes",
        "no": "No",
        "edit": "Edit",
        "edit-named": "Edit {name}",
        "view": "View",
        "view-named": "View {name}",
        "deactivate": "Deactivate",
        "deactivate-named": "Deactivate {name}",
        "activate": "Activate",
        "archive": "Archive",
        "archive-named": "Archive {name}",
        "more": "More",
        "more-named": "More actions for {name}",
        "duplicate": "Duplicate / Clone",
        "history": "View Version History",
        "coming-soon-history": "Version history — coming soon",
        "save": "Save",
        "create": "Create",
        "close": "Close",
        "saving": "Saving…",
        "loading": "Loading scheduling data…",
        "no-data": "There is no scheduling data for this scope yet.",
        "confirm-remove": "Remove \"{name}\"?",
        "col": {
          "actions": "Actions",
          "edit": "Edit"
        },
        "drawer": {
          "close": "Close",
          "cancel": "Cancel"
        },
        "status": {
          "Active": "Active",
          "Inactive": "Inactive",
          "Draft": "Draft",
          "Archived": "Archived"
        },
        "group": {
          "Fixed": "Fixed",
          "Rotation": "Rotation",
          "Flexible": "Flexible"
        },
        "toast": {
          "select-company": "Select a company workspace.",
          "no-permission-coverage": "No permission to manage coverage here.",
          "oversight": "Roster operations live at the owning scope (Direct Workforce / Project) — oversight is read-only."
        },
        "nav": {
          "label": "Scheduling",
          "dashboard": "Dashboard",
          "setup": "SETUP",
          "templates": "Templates",
          "schedules": "Work Schedules",
          "planning": "PLANNING",
          "coverage": "Coverage Plans",
          "pools": "Employee Pools",
          "rosters": "ROSTERS",
          "roster": "Roster Workspace",
          "all": "All Rosters"
        },
        "tpl": {
          "shifts": "Shift",
          "patterns": "Work Pattern",
          "meals": "Meal Break",
          "holidays": "Holiday",
          "rules": "Rule & Policy"
        },
        "new": {
          "schedule": "New Schedule",
          "coverage": "New Coverage Plan",
          "shift": "New Shift",
          "pattern": "New Work Pattern",
          "meal": "New Meal Break",
          "holiday": "New Holiday",
          "rule": "New Rule / Policy"
        },
        "dash": {
          "title": "Dashboard",
          "sub": "Scheduling status for {company} — live from this company's libraries, runs and published rosters.",
          "fixed": "Fixed schedule",
          "fixed-sub": "Mon–Fri patterns, back office",
          "on-fixed": "Staff on fixed",
          "unassigned": "No schedule assigned",
          "unassigned-tip": "The schedule service does not report unassigned employees yet.",
          "flex": "Flexible schedule",
          "flex-sub": "Presence-based, lump-sum hours",
          "on-flex": "Staff on flexible",
          "hours": "Hours",
          "hours-att": "tracked in Attendance",
          "rot": "Rotation schedule",
          "rot-sub": "24/7 shifts, needs roster",
          "on-rot": "Staff on rotation",
          "coverage": "Coverage",
          "gaps-runs": "Open gaps / Unpublished runs",
          "rot-gaps": "Rotation — roster and coverage gaps",
          "by-plan": "COVERAGE BY PLAN ({company})",
          "no-roster": "— no roster yet",
          "no-plans": "No coverage plans in this company yet — create one in Coverage Plans.",
          "attention": "ROSTERS NEEDING ATTENTION",
          "no-inflight": "No in-progress rosters — everything published or not started.",
          "open-roster": "Open Roster Workspace"
        },
        "shift": {
          "kpi": {
            "shifts": "Shifts",
            "day": "Day shifts",
            "night": "Night shifts",
            "cross": "Cross-midnight"
          },
          "note": "Reusable shift master — consumed by Schedules and (later) Rotation Patterns · Coverage Planning · Auto-Roster. Day/Night is derived from the times, never set manually.",
          "col": {
            "shift": "Shift",
            "start": "Start",
            "end": "End",
            "duration": "Duration",
            "cross": "Cross-Midnight",
            "night": "Night hrs"
          },
          "empty": "No shifts configured for this company. Click {cta}.",
          "cta": "+ New Shift",
          "break": "break: {name}",
          "new": "New Shift",
          "edit": "Edit Shift",
          "subtitle": "{company} · reusable shift master",
          "create": "Create Shift",
          "save": "Save Shift",
          "sec": {
            "info": "1 · Shift Information",
            "hours": "2 · Working Hours",
            "indicators": "3 · System Indicators (read-only)",
            "notes": "4 · Notes"
          },
          "f": {
            "name": "Shift Name",
            "name-ph": "e.g. Morning, Night, Relief",
            "code": "Shift Code (auto)",
            "code-empty": "— builds from the name —",
            "code-hint": "Generated from the name. Not editable.",
            "start": "Start Time",
            "end": "End Time",
            "meal": "Meal Break",
            "meal-none": "— None —"
          },
          "ind": {
            "duration": "Duration",
            "cross": "Cross Midnight",
            "night": "Night Hours (22:00–06:00)",
            "full": "Start = End → a full 24-hour shift (the maximum). Pair it with rest days in a Rotation Pattern.",
            "hint": "Auto-derived from Start/End. Weekly hours, rotation cycle & coverage are decided later by Schedule / Rotation, not the Shift master."
          },
          "required": "Please fill the required fields (Name, Start, End).",
          "dur-tag": {
            "full": "full 24-hour duty",
            "extended": "extended duty",
            "long": "long shift"
          },
          "usage": {
            "named": "{count} work pattern(s): {names}",
            "count": "{count} work pattern(s)"
          },
          "confirm": {
            "edit-title": "Save changes to a shift in use?",
            "edit-body": "“{name}” is used by {patterns}. Saving changes the plan of {employees} employee(s) on those patterns, including past days.",
            "remove-title": "Deactivate shift?",
            "remove-body": "Deactivate “{name}”? It is hidden from the list and can no longer be added to work patterns.",
            "remove-body-used": "Deactivate “{name}”? It is used by {patterns} ({employees} employee(s)). Those patterns keep using it, but it can no longer be added to work patterns."
          },
          "conflict-reload": "The list has been refreshed — close this drawer and open the shift again to edit the latest version."
        },
        "rule": {
          "kpi": {
            "total": "Rules & policies",
            "coverage": "Coverage rules",
            "safety": "Safety rules",
            "mode": "Mode"
          },
          "advisory": "Advisory",
          "note": "Advisory rules surfaced as {warnings} and {alerts} (operational), not hard blocks.",
          "note-warnings": "roster warnings",
          "note-alerts": "coverage alerts",
          "col": {
            "rule": "Rule / Policy",
            "setting": "Setting",
            "used-for": "Used For"
          },
          "empty": "No rules configured for this company yet.",
          "new": "New Rule / Policy",
          "edit": "Edit Rule / Policy",
          "f": {
            "name": "Rule Name",
            "kind": "Rule Kind",
            "value": "Value",
            "value-ph": "e.g. 10 hours",
            "status": "Status",
            "used-for": "Used For",
            "used-for-ph": "e.g. Roster validation",
            "notes": "Notes"
          },
          "advisory-note": "Advisory only — surfaced as roster warnings / coverage alerts later. No enforcement engine in this build.",
          "required": "Rule Name is required.",
          "kind": {
            "min_rest": "Minimum Rest Hours",
            "max_consec": "Maximum Consecutive Days",
            "night_elig": "Night Shift Eligibility",
            "ot_holiday": "Overtime / Holiday",
            "coverage": "Coverage Requirement"
          }
        },
        "pattern": {
          "count": "{n} work pattern(s) — Fixed or Rotation shift sequences, used by Work Schedules / Coverage Planning / Auto-Roster.",
          "col": {
            "pattern": "Pattern",
            "cycle": "Cycle",
            "work-rest": "Work/Rest",
            "hours": "Hours",
            "sequence": "Sequence"
          },
          "empty": "No work patterns yet. Click {cta}.",
          "cta": "+ New Work Pattern",
          "new": "New Work Pattern",
          "edit": "Edit Work Pattern",
          "sec": {
            "info": "1 · Pattern Information",
            "cycle": "2 · Cycle & Sequence",
            "preview": "3 · System Preview",
            "notes": "4 · Notes"
          },
          "f": {
            "name": "Pattern Name",
            "suggested": "Suggested code-name:",
            "use": "Use",
            "type": "Pattern Type",
            "code": "Pattern Code (auto)",
            "code-empty": "— builds automatically from the sequence —",
            "code-hint": "Generated by the system from the cycle & sequence. Not editable.",
            "cycle": "Cycle Length (days)",
            "cycle-hint": "Set automatically once you build the Shift Sequence below — each shift or off day adds one day to the cycle.",
            "sequence": "Shift Sequence",
            "seq-empty": "No entries yet. Add shifts and Off days (repeats allowed).",
            "add-shift": "+ Add shift…",
            "add-off": "+ Off Day",
            "seq-hint": "Use ◀ ▶ on a day to reorder · ✕ to remove. Order defines the cycle.",
            "notes": "Notes",
            "new-shift": "New shift",
            "new-shift-title": "Create a new shift in the Shift master and add it here",
            "cap": "A cycle can have at most {n} days."
          },
          "kind": {
            "rotation": "Rotation Pattern",
            "fixed": "Fixed Pattern",
            "fixed-hint": "Fixed → creates a Fixed schedule (one shift on working days, fixed off-days).",
            "rotation-hint": "Rotation → creates a Rotation schedule (multi-day rotating cycle) · auto-roster eligible.",
            "flex-hint": "Flexible schedules need no pattern."
          },
          "move-earlier": "Move earlier",
          "move-later": "Move later",
          "remove-entry": "Remove",
          "pv": {
            "cycle": "Cycle preview:",
            "work": "Working days:",
            "rest": "Rest days:",
            "hours": "Scheduled hours:",
            "cross": "Cross-midnight:",
            "night": "Night:",
            "empty": "Sequence is empty.",
            "no-shifts": "No Shifts exist for this company — create Shifts first."
          },
          "required": "Pattern Name is required.",
          "move-earlier-n": "Move day {n} earlier",
          "move-later-n": "Move day {n} later",
          "remove-entry-n": "Remove day {n}",
          "need-shift": "Add at least one shift to the Shift Sequence.",
          "conflict-reload": "The list has been refreshed — close this drawer and open the work pattern again to edit the latest version.",
          "confirm": {
            "edit-title": "Save changes to a work pattern in use?",
            "edit-body": "“{name}” is used by {schedules}. Saving changes the plan of {employees} employee(s) on those schedules, including past days.",
            "remove-title": "Deactivate work pattern?",
            "remove-body": "Deactivate “{name}”? It is hidden from the list and can no longer be linked to a schedule.",
            "remove-body-used": "Deactivate “{name}”? It is used by {schedules} ({employees} employee(s)). Those schedules keep following it, but it can no longer be linked to a schedule."
          },
          "usage": {
            "named": "{count} schedule(s): {names}",
            "count": "{count} schedule(s)"
          }
        },
        "cov": {
          "kpi": {
            "active": "Active Coverage Plans",
            "required": "Total Required Headcount",
            "sites": "Sites Covered",
            "expiring": "Expiring Soon"
          },
          "count": "{n} coverage plan(s) — required headcount by shift/day, consumed by Coverage Alerts & (later) Auto-Roster.",
          "col": {
            "plan": "Coverage Plan",
            "jobs": "Job Titles",
            "hc": "Req HC",
            "shift": "Shift",
            "status": "Status",
            "action": "Action"
          },
          "empty": "No coverage plans yet. Click {cta}.",
          "cta": "+ New Coverage Plan",
          "no-jobs": "No job titles — edit to add.",
          "total": "Total",
          "demo": "demo",
          "demo-tip": "Demo seed ({tag})",
          "plan": "Plan",
          "duplicated": "Coverage plan duplicated",
          "required": "Plan Name is required.",
          "ed": {
            "new": "Add New Coverage Plan",
            "edit": "Edit Coverage Plan",
            "view": "View Coverage Plan",
            "sub": "Define the expected demand by role across shifts and days.",
            "create": "Create Coverage Plan",
            "save": "Save Coverage Plan",
            "details": "Plan Details",
            "name": "Plan Name",
            "name-ph": "e.g. Weekday Coverage Plan",
            "period": "Effective Period",
            "desc": "Description",
            "desc-ph": "Add a description (optional)",
            "jobs": "Job Titles · rows",
            "jobs-ms": "Job titles",
            "jobs-hint": "From Org Unit hierarchy. Selected titles appear as rows below.",
            "shifts": "Shifts · columns",
            "shifts-ms": "Shifts",
            "shifts-hint": "Selected shifts appear as columns (per day) below.",
            "matrix": "Coverage Matrix (Job Title)",
            "matrix-sub": "Set the required headcount for each shift and day.",
            "copy-mon": "Copy Mon → all days",
            "job-title": "Job Title",
            "total-required-1": "Total",
            "total-required-2": "Required",
            "total-required": "Total Required",
            "notes": "Notes (optional)",
            "notes-ph": "Add any notes or special instructions for this coverage plan..."
          }
        },
        "pool": {
          "kpi": {
            "total": "Total Pools",
            "total-sub": "All active & inactive",
            "employees": "Employees in Pools",
            "employees-sub": "Across all pools",
            "active": "Active Pools",
            "active-sub": "Currently active",
            "unused": "Pools not used",
            "unused-sub": "No schedules yet"
          },
          "search": "Search pools by name, type, or description...",
          "f-status": "Status",
          "f-based": "Based On",
          "status-all": "Status: All",
          "based-all": "Based On: All",
          "based": {
            "Job Title": "Job Title",
            "Skill": "Skill",
            "Work Type": "Work Type",
            "Contract Type": "Contract Type",
            "Availability": "Availability",
            "Criteria": "Criteria"
          },
          "new": "New Pool",
          "count": "{n} pool(s) — grouped employees consumed by Auto-Roster. Only rotation-eligible employees are pooled.",
          "col": {
            "name": "Pool Name",
            "based": "Based On",
            "desc": "Description",
            "employees": "Employees",
            "used": "Used In",
            "status": "Status",
            "updated": "Last Updated"
          },
          "used-in": "{n} Schedules",
          "last-used": "Last used: {when}",
          "never": "Never used",
          "by": "by {name}",
          "empty": "No pools match these filters.",
          "required": "Pool name is required",
          "dr": {
            "new": "Add New Employee Pool",
            "edit": "Edit Employee Pool",
            "sub": "Create a pool of employees for scheduling.",
            "basic": "Basic Information",
            "name": "Pool Name",
            "name-ph": "e.g. Production Operators",
            "desc": "Description (optional)",
            "desc-ph": "Add a description...",
            "based-on": "Based On",
            "type": "Type",
            "type-hint": "Define the criteria for employees in this pool.",
            "scope": "Scope",
            "dept": "Department (optional)",
            "dept-all": "All Departments",
            "active-only": "Only include active employees",
            "rotation-only": "Only rotation-schedule employees are eligible for pools.",
            "status": "Status",
            "save": "Save Pool"
          }
        },
        "hol": {
          "new": "New Holiday",
          "edit": "Edit Holiday",
          "f": {
            "name": "Calendar Name",
            "year": "Year",
            "status": "Status",
            "date": "Holiday date {n}",
            "date-name": "Holiday name",
            "date-type": "Holiday type",
            "type": "Calendar type",
            "region": "Region (optional)",
            "name-km": "Khmer name",
            "from": "First day of holiday {n}",
            "to": "Last day of holiday {n} (optional)"
          },
          "type": {
            "Public": "Public",
            "Company": "Company",
            "Regional": "Regional"
          },
          "dates": "Holiday dates",
          "no-dates": "No dates yet.",
          "add-date": "Add Date",
          "remove-date": "Remove date",
          "required": "Calendar Name and Year are required.",
          "kind": {
            "public": "Public holiday calendar",
            "other": "Other holiday calendar",
            "standard": "Standard list (Optimal HR)"
          },
          "kind-short": {
            "public": "Public",
            "other": "Other",
            "standard": "Standard"
          },
          "kind-hint": {
            "public": "A schedule observes it as its public-holiday calendar.",
            "other": "Company or regional days a schedule can observe on top of public holidays."
          },
          "row": {
            "name": "Give this holiday a name.",
            "from": "Choose the first day.",
            "to-before-from": "The last day must be on or after the first day.",
            "too-long": "A holiday can span at most {n} days.",
            "outside-year": "Every day must fall in {year}.",
            "duplicate": "This day is already on another holiday."
          },
          "day-total": "{n} day | {n} days",
          "too-many": "A calendar can save at most {n} dates at once — this one has {count}.",
          "loading-dates": "Loading this calendar’s dates…",
          "load-failed": "Couldn’t load this calendar’s dates.",
          "retry": "Retry",
          "series": "Also observed: {years}",
          "series-hint": "Schedules that use this calendar also observe its other years.",
          "standard-readonly": "Standard lists are maintained by Optimal HR and can’t be edited here.",
          "saved-toast": "{name} saved",
          "saved-partial": "{name} was created, but its dates were not saved: {detail} Fix them and press Save again.",
          "reload": "Close the drawer and open the calendar again to see the latest version.",
          "fill": {
            "action": "Fill from public holidays {year}",
            "none": "No reference public holidays are available for {year} yet.",
            "added": "Added {n} public holiday dates. Review them, then save.",
            "already": "Every {year} public holiday is already on this calendar.",
            "failed": "Couldn’t load the public holidays. Try again."
          },
          "import": {
            "action": "Import public holidays",
            "title": "Import public holidays",
            "desc": "Copy Cambodia’s official public holidays for a year into a company calendar.",
            "year": "Year",
            "year-invalid": "Enter a year between 1970 and 2999.",
            "loading": "Loading public holidays…",
            "empty": "No reference public holidays are available for {year} yet.",
            "error": "Couldn’t load the public holidays.",
            "count": "{n} public holiday date in {year} | {n} public holiday dates in {year}",
            "col": {
              "date": "Date",
              "name": "Holiday",
              "name-km": "Khmer name"
            },
            "will-create": "Creates the calendar “{name}” with these dates.",
            "exists": "“{name}” already exists for {year}. Updating adds these dates and corrects their names; its other days stay.",
            "create": "Create calendar",
            "update": "Update its dates",
            "done-created": "Created {name} with {n} dates",
            "done-updated": "Updated the dates of {name}"
          },
          "clone": {
            "action": "Clone to next year",
            "aria": "Clone {name} to another year",
            "title": "Clone to another year",
            "desc": "Copies “{name}” and its dates into another year. The copy belongs to the same calendar series, so schedules that use it observe both years.",
            "name": "Name of the copy",
            "name-required": "Give the copy a name.",
            "same-year": "Choose a year other than {year}.",
            "submit": "Clone",
            "exists": "A {year} copy of this calendar already exists.",
            "done": "Created {name}",
            "skipped": "Not copied — no such day in {year}: {dates}",
            "rename-failed": "The copy was made, but it could not be renamed: {detail}",
            "name-taken": "A calendar named “{name}” already exists for {year}.",
            "rolled-back": "Nothing was copied — the copy could not be named: {detail}"
          }
        },
        "meal": {
          "new": "New Meal Break",
          "edit": "Edit Meal Break",
          "f": {
            "name": "Name",
            "start": "Start Time",
            "end": "End Time",
            "paid": "Paid / Unpaid",
            "notes": "Notes"
          },
          "unpaid": "Unpaid",
          "paid": "Paid",
          "duration": "Duration",
          "required": "Name, Start and End are required.",
          "saved": "Meal break “{name}” saved"
        },
        "all": {
          "title": "All Rosters",
          "sub": "The full roster lifecycle — Draft, Pending approval, Approved, Published, Closed. Park runs here and work many lines in parallel; the workspace edits one run at a time.",
          "new": "New roster",
          "filter": "Filter by status",
          "empty": "No rosters in this filter.",
          "st": {
            "all": "All",
            "Draft": "Draft",
            "Pending approval": "Pending approval",
            "Approved": "Approved",
            "Published": "Published",
            "Closed": "Closed"
          },
          "col": {
            "period": "Roster period",
            "scope": "Scope",
            "version": "Version",
            "coverage": "Coverage",
            "status": "Status",
            "by": "By / when"
          },
          "act": {
            "edit": "Edit — resume in workspace",
            "approve": "Approve (approver)",
            "send-back": "Send back (approver · audited)",
            "publish": "Publish — release to staff",
            "workspace": "Go to workspace — editing voids approval",
            "reopen": "Reopen in workspace (amend)"
          }
        },
        "rw": {
          "step": {
            "inputs": "Select inputs",
            "draft": "Draft",
            "review": "Review",
            "approve": "Approve",
            "publish": "Publish"
          },
          "inputs-title": "Select inputs for this roster run",
          "generate": "Generate Draft Roster",
          "locked": "Inputs locked for this run · use Regenerate to rebuild",
          "f": {
            "ws": "Work schedule(s)",
            "cov": "Coverage",
            "pool": "Employee pool(s)",
            "dates": "Date range",
            "start": "Start date",
            "end": "End date",
            "title": "Roster title",
            "title-ph": "e.g. Line A night rotation",
            "title-hint": "Required · suggestion: coverage plan + period (e.g. \"{example}\")"
          },
          "not-selected": "Not selected",
          "add": "+ Add",
          "clear-named": "Clear {name}",
          "lib-empty": "Nothing in this company's library yet — create it in the Setup tabs above (Work Schedules / Coverage Plans / Employee Pools).",
          "cp-empty": "No saved coverage plans for this schedule in this company — create one in Coverage Plans, or use Quick / Manual mode.",
          "ws-first": "Choose the work schedule first.",
          "prev-first": "Choose the previous field first.",
          "mode": {
            "plan": "Saved plan",
            "quick": "Quick",
            "none": "Manual"
          },
          "mode-locked": "Locked for this run · Regenerate to change",
          "quick-hint": "Min staff per position · drives gap detection.",
          "manual-hint": "No target — build the roster by hand. The system won't flag coverage shortfalls; you can still edit any cell in Draft.",
          "compat": "All selected inputs are compatible · Est. coverage fulfilment:",
          "incomplete": "Select the required inputs (work schedule, employee pool, dates — plus a coverage plan if using Saved plan mode) to generate.",
          "empty": "Select the inputs above, then {cta} to build the roster.",
          "rotation-only": "Rotation / shift rostering only — Fixed-schedule staff assign their Work Schedule on the employee record.",
          "required": "Required {n}",
          "bn": {
            "pub": "Published · {label}",
            "pub-amended": "Published · Amended · {label}",
            "pub-sub": "Version {ver} · published {when} by {by} · employees & line managers can now see their shifts.",
            "pub-amended-sub": "Version {ver} · {n} post-publish amendment(s) · logged for audit",
            "submitted": "Submitted for approval",
            "submitted-sub": "Draft v{ver} · submitted by {by} · review the draft, then Approve or Send back.",
            "approved": "Approved · ready to publish",
            "approved-sub": "Draft v{ver} · approved · publish to make it the official roster."
          },
          "tag": {
            "published": "Published",
            "submitted": "Pending approval",
            "approved": "Approved",
            "unpublished": "Unpublished",
            "draft": "Draft"
          },
          "act": {
            "view-all": "View in All Rosters",
            "new-run": "New roster run",
            "approve": "Approve",
            "send-back": "Send back",
            "withdraw": "Withdraw submission",
            "withdraw-tip": "Pull the submission back to Draft (audited)",
            "publish": "Publish",
            "void": "Edit (voids approval)",
            "void-tip": "Editing an approved roster voids the approval — back to Draft for re-approval (audited)",
            "save-new": "Save & start new",
            "save-new-tip": "Park this run in All Rosters and start another — work multiple lines in parallel",
            "discard": "Discard draft",
            "regenerate": "Regenerate",
            "submit": "Submit for approval",
            "submit-soft": "Submit · {n} warning(s)",
            "submit-hard": "Resolve {n} legal issue(s) to submit",
            "review": "Review Issues"
          },
          "kpi": {
            "coverage": "Coverage",
            "coverage-tip": "Share of required shifts that are filled.",
            "assigned": "Employees assigned",
            "assigned-tip": "Distinct employees placed on this roster.",
            "unfilled": "Unfilled shifts",
            "unfilled-tip": "Required shifts with nobody assigned. Fill from pool or offer overtime.",
            "rules": "Rule violations",
            "rules-tip": "Assignments breaking a scheduling rule — here, minimum rest between shifts. Fix the pattern or Accept & note.",
            "rules-tip-pub": "Assignments breaking a scheduling rule. Locked — published rosters change via logged amendments or a new version.",
            "over": "Overstaffed",
            "over-tip": "A position-day with MORE staff than the plan requires — wasted labour cost. Click to see which shift and fix it (redeploy, remove, or accept).",
            "over-tip-pub": "More staff than the plan requires. Locked — published rosters change via logged amendments or a new version."
          },
          "range": {
            "full": "{days}-day roster · full period",
            "week": "{days}-day roster · week {w} of {c}",
            "week-n": "Week {n}",
            "month": "Full month",
            "all": "All {n} days",
            "scroll": "scroll →",
            "note": "Weekly-pattern view: assignments and gap-fills repeat each week — editing any week edits the pattern for all weeks. Per-day variation across weeks arrives with the real data wiring."
          },
          "dh": {
            "draft": "Draft roster · Version {ver}",
            "published": "Published roster · Version {ver}",
            "view": "Grid view",
            "coverage": "Coverage",
            "roster": "Roster"
          },
          "gaps": "{n} gaps",
          "one-over": "1 over-staffed",
          "fully-staffed": "fully staffed — ready to publish",
          "cg": {
            "position": "Position / shift",
            "req": "Req",
            "shift": "Shift",
            "coverage": "Coverage %",
            "status": "Status",
            "met": "Met",
            "under": "Understaffed",
            "short": "Shortfall"
          },
          "grid": {
            "employee": "Employee",
            "tag": "Tag",
            "morning": "Morning",
            "evening": "Evening",
            "night": "Night",
            "set-off": "Set off",
            "remove": "Remove from shift",
            "reset": "Reset to original",
            "cell-aria": "Edit shift of {name} on {day}",
            "replaced": "Replaced",
            "swapped": "Swapped",
            "ot-tip": "Overtime shift",
            "plus-ot-tip": "Picked up an extra overtime shift",
            "on-call": "on-call",
            "added": "added",
            "unfilled": "Unfilled",
            "filled": "filled",
            "gap-aria": "Fill {n} open slot(s) in {group}",
            "qualified": "Qualified & available",
            "no-free": "No free qualified staff — offer overtime below.",
            "on-leave": "On leave",
            "already-on": "Already on {group}",
            "not-qualified": "Not qualified · {skill}",
            "offer-ot": "On rest day · offer overtime",
            "rest-ot": "Rest day → OT",
            "on-call-h": "On call · flexible staff",
            "flex-oc": "Flexible → on-call",
            "lg-m": "M morning",
            "lg-e": "E evening",
            "lg-n": "N night",
            "lg-ot": "overtime (ring on shift)",
            "lg-oc": "on-call",
            "lg-short": "-N = short by N · click + to fill",
            "lg-edit": "click any shift to edit"
          },
          "amend-history": "Amendment history",
          "audit": "Audit trail",
          "al": {
            "title": "Alerts & warnings",
            "none": "No open issues — roster is ready to publish.",
            "cover": "{n} coverage shortfall | {n} coverage shortfalls",
            "cover-sub": "Required shifts still unfilled — can submit/publish acknowledged; keep filling post-publish",
            "skill": "{n} skill mismatch | {n} skill mismatches",
            "skill-sub": "Assigned staff not qualified for the role",
            "rest": "{n} rest-rule violation | {n} rest-rule violations",
            "rest-sub": "Short rest between shifts — LEGAL: fix the pattern or Accept & note (justification recorded)",
            "over": "1 over-staffed shift",
            "over-sub": "More staff than the plan requires · extra cost",
            "leave": "{n} employee on leave | {n} employees on leave",
            "leave-sub": "During this period · informational",
            "fix": "Fix now",
            "resolved": "Resolved & accepted ({n})",
            "undo": "Undo",
            "auto": "Auto"
          },
          "res": {
            "cover": "Coverage complete",
            "cover-sub": "All required shifts filled",
            "manual": "Manual roster",
            "manual-sub": "No coverage target set · shifts built by hand",
            "skill": "Skill mismatch — accepted",
            "skill-sub": "Accepted by manager",
            "skill-ok": "No skill mismatch",
            "skill-ok-sub": "Picker only offers qualified staff",
            "rest": "Rest-rule review — accepted",
            "rest-sub": "Accepted by manager",
            "rest-ok": "No rest-rule violations",
            "rest-ok-sub": "Minimum rest between shifts respected",
            "over": "Over-staffing — accepted",
            "over-sub": "Accepted by manager",
            "over-ok": "Over-staffing resolved",
            "over-ok-sub": "Surplus shift removed"
          },
          "bar": {
            "working": "Current working draft",
            "published": "Published roster",
            "from": "Generated from:",
            "engine": "Engine:",
            "status": "Status:",
            "generated": "Generated:"
          },
          "pub": {
            "title": "Publish roster",
            "body": "Publish the {period} roster (Draft v{ver})? This locks the draft as the official published roster and makes shifts visible to employees and line managers.",
            "cov": "Coverage {n}%",
            "assigned": "{n} assigned",
            "open": "{n} open warning | {n} open warnings",
            "soft": "{n} soft warning(s) still open — you can publish, but they are recorded as unresolved on the roster.",
            "confirm": "Confirm & publish"
          },
          "confirm": {
            "regenerate": "Regenerate a fresh draft? This creates a new version and clears any manual gap-fills.",
            "discard": "Discard this draft roster and all manual changes? You will return to input selection.",
            "withdraw": "Withdraw this submission? The roster returns to Draft (recorded in the audit trail).",
            "void": "Edit this APPROVED roster? Editing voids the approval: the roster returns to Draft and must be re-approved before publishing. This is recorded in the audit trail.",
            "dup": "A published roster already covers {scope} · {period} (\"{title}\"). Publish as a NEW VERSION and close the existing one? (Two live rosters for the same scope and period would double-schedule staff.)",
            "pool-dup": "Employee pool \"{pool}\" is already committed to \"{title}\" for the same period — the same staff may be double-booked. Continue anyway?"
          },
          "iss": {
            "skill-h": "Skill mismatch · {n} assignment(s)",
            "skill-none": "No current skill mismatches — every assigned employee is qualified for their role.",
            "skill-needs": "Role needs {need} · employee holds {has}",
            "remove": "Remove",
            "rest-h": "Rest-rule violations · {n}",
            "rest-gap": "{h} rest · policy min 11h",
            "rest-sol": "Insert a rest day between the two shifts, or move the later shift to another qualified employee. If the employee agreed to the short rest and it is within policy limits, choose Accept & note to record the exception.",
            "over-h": "Over-staffing · 1 position-day",
            "over-detail": "19 assigned vs 18 required · +1 over — likely surplus Rith Kong (M)",
            "over-sol": "No open shortfalls to redeploy to, so removing the surplus shift is the cheapest fix. If the extra cover is intentional (training or an expected-absence buffer), Accept & note.",
            "over-sol-gaps": "Redeploy the surplus person to a shift that is still short ({n} open) — turning wasted cost into coverage. Otherwise remove the extra shift. If the extra cover is intentional (training / expected absence), Accept & note.",
            "affected": "Affected",
            "recommended": "Recommended solution",
            "remove-surplus": "Remove surplus shift",
            "accept": "Accept & note…",
            "reason": "Reason for accepting this issue (kept in the audit trail):"
          },
          "no-issues": "No open issues — roster is ready."
        },
        "port": {
          "sub": {
            "tenant": "All Scopes · Executive Scheduling Operations Dashboard · published coverage + aggregate in-flight counts · read-only",
            "client": "{client} · scheduling rollup · read-only",
            "company": "{company} · scheduling hierarchy · read-only (roster operations live at owning scopes)"
          },
          "client-rollup": "Client rollup",
          "client": "Client",
          "all-scopes": "All Scopes",
          "direct": "Direct Workforce",
          "direct-sub": "Roster owner · company-owned staff",
          "project-sub": "{id} · roster owner",
          "snapshot": "Roster snapshot",
          "kpi": {
            "attention-workspaces": "Workspaces requiring attention",
            "attention-workspaces-tip": "Workspaces with an amber or red risk indicator",
            "attention-units": "Units requiring attention",
            "attention-units-tip": "Units with an amber or red risk indicator",
            "uncovered": "Upcoming uncovered shifts",
            "uncovered-tip": "Plan-days without a published roster + unfilled shift slots inside the planning window",
            "coverage": "Window coverage",
            "coverage-tip": "Published coverage of plan-days across the planning window (operational — not a payroll period)",
            "oldest": "Oldest in-flight run",
            "oldest-tip": "Oldest in-flight roster run started {date} · {name}",
            "nothing": "Nothing in flight"
          },
          "top": "Top priority",
          "review": "Review",
          "ready": {
            "ready": "✅ Ready",
            "gaps": "❌ Gaps"
          },
          "ready-tip": {
            "ready": "All required roster coverage within the planning window is Published",
            "gaps": "Coverage gaps, unassigned shifts, or unpublished rosters exist within the planning window"
          },
          "risk": {
            "uncovered": "{n} plan-day(s) with NO published roster in the next {days}d window",
            "gaps": "{n} unfilled shift slot(s) in published window coverage",
            "inflight": "{n} in-flight run(s): {d} draft · {p} pending approval · {a} approved unpublished",
            "oldest": "oldest {n}d",
            "published": "planning window fully published · nothing in flight",
            "no-plans": "no coverage plans require rostering"
          },
          "inflight-tip": "{d} draft · {p} pending approval · {a} approved unpublished — aggregate counts only; roster rows live at the owning scope",
          "col": {
            "workspace": "Workspace",
            "scope": "Scope",
            "risk": "Risk",
            "employees": "Employees",
            "plans": "Plans",
            "plans-tip": "Active coverage plans requiring rostered coverage",
            "published": "Published",
            "published-tip": "Published rosters (live)",
            "window": "Window cov.",
            "uncovered": "Uncovered",
            "inflight": "In-flight D · P · A",
            "inflight-tip": "Draft · Pending approval · Approved unpublished (counts only — PO rule)",
            "oldest": "Oldest",
            "ready": "Ready",
            "worst": "Highest-risk scope",
            "worst-tip": "Owning scope with the highest scheduling risk in this workspace",
            "roster": "Roster",
            "period": "Period",
            "ver": "Ver",
            "coverage": "Coverage",
            "by": "By / when",
            "status": "Status",
            "date": "Date",
            "shift": "Shift",
            "assigned": "Assigned"
          },
          "open": "Open",
          "open-co-tip": "Open the company workspace — roster operations live at its owning scopes",
          "open-tip": "Open the Scheduling workspace — owning scope (operations)",
          "no-open": "This unit has no counterpart in your organisation to open.",
          "rosters": "Rosters",
          "rosters-tip": "Published / closed rosters (read-only)",
          "rollup": "Client rollup · read-only",
          "n-inflight": "{n} in-flight",
          "no-match": "No workspaces match this filter.",
          "foot-l1": "Executive Scheduling Operations Dashboard · planning window = next {days} days from {date} (operational — not a payroll period) · in-flight rosters appear as aggregate counts only; rows, assignments and actions live at the owning scopes · rows ranked by risk · click a row to drill",
          "foot-l2": "Planning window = next {days} days from {date} · click a unit for its published rosters (read-only)",
          "l2-lead": "Roster operations live at the owning scopes (Direct Workforce / Project).",
          "l2-text": "This level shows published summaries, window coverage and aggregate in-flight COUNTS only — no roster rows, employee assignments or actions. Client rows are consolidated rollups (read-only).",
          "l3-empty": "No published rosters for this scope yet — the owning workspace publishes via the Roster Workspace.",
          "l3-note": "Published and closed rosters only — in-flight runs never appear at oversight (PO rule). Click a roster for its snapshot.",
          "not-found": "Published roster not found.",
          "l4-lead": "Published roster — read-only snapshot.",
          "l4-text": "{title} · {period} · v{ver} · published by {by} ({when}). Amendments happen in the owning workspace through controlled roster amendments with audit history — never here.",
          "l4-no-cells": "Cell-level detail for this roster lives in the owning workspace. Open the owning scope — Roster Workspace · All Rosters — to view the full grid.",
          "no-cells": "No cells in this roster record."
        },
        "sa": {
          "new": "New Work Schedule",
          "edit": "Edit Work Schedule",
          "delete": "Delete",
          "cancel": "Cancel",
          "reload": "Reload",
          "none": "— None —",
          "next-day": "+1 day",
          "rolling": "Rolling 24×7",
          "rolling-note": "A rolling schedule has no fixed week; its days are kept as they are unless you change them.",
          "no-meals": "No meal breaks yet — create one under Templates › Meal Break.",
          "no-other": "No other holiday calendars yet.",
          "sec": {
            "info": "1 · Schedule Information",
            "pattern": "2 · Work Pattern",
            "preview": "3 · System Preview"
          },
          "f": {
            "name": "Schedule Name",
            "type": "Schedule Type",
            "status": "Status",
            "days": "Working week",
            "meal": "Meal breaks",
            "holiday": "Public holiday calendar",
            "other": "Other holiday calendars"
          },
          "type": {
            "FullTime": "Full-Time",
            "PartTime": "Part-Time"
          },
          "status": {
            "Active": "Active",
            "Inactive": "Inactive"
          },
          "col": {
            "day": "Day",
            "start": "Start",
            "end": "End",
            "half": "Half day"
          },
          "day": {
            "Monday": "Monday",
            "Tuesday": "Tuesday",
            "Wednesday": "Wednesday",
            "Thursday": "Thursday",
            "Friday": "Friday",
            "Saturday": "Saturday",
            "Sunday": "Sunday"
          },
          "day-short": {
            "Mon": "Mon",
            "Tue": "Tue",
            "Wed": "Wed",
            "Thu": "Thu",
            "Fri": "Fri",
            "Sat": "Sat",
            "Sun": "Sun"
          },
          "aria": {
            "working": "{day} is a working day",
            "start": "{day} start time",
            "end": "{day} end time",
            "half": "{day} is a half day"
          },
          "err": {
            "name-required": "Schedule Name is required.",
            "name-too-long": "Schedule Name can be at most 200 characters.",
            "name-taken": "A schedule with this name already exists in this company.",
            "no-working-day": "Tick at least one working day.",
            "incomplete": "{day}: give both a start and an end time.",
            "bad-time": "{day}: times are written on a 24-hour clock, e.g. 08:00.",
            "same-time": "{day}: the start and end can’t be the same time.",
            "half-too-long": "{day}: a half day can be at most 4 hours.",
            "too-many-meals": "A schedule can have at most 10 meal breaks.",
            "too-many-other": "A schedule can have at most 20 other holiday calendars.",
            "version": "This schedule was changed by someone else since you opened it. Reload it and make your change again.",
            "generic": "The schedule couldn’t be saved. Please try again."
          },
          "preview": {
            "hours": "Hours / week",
            "working": "Working days",
            "off": "Weekly off",
            "linked": "Linked",
            "meal": "Meal",
            "holiday": "Holiday",
            "other": "Other",
            "assigned": "Assigned",
            "assigned-n": "{n} employee(s) on this schedule",
            "assigned-none": "none yet — assign people after saving"
          },
          "confirm": {
            "edit-title": "Change a schedule in use?",
            "edit-body": "This changes the plan of {n} employee(s), including past days.",
            "edit-ok": "Save changes",
            "delete-title": "Delete this schedule?",
            "delete-body": "Delete “{name}”? This can’t be undone.",
            "delete-body-assigned": "{n} employee(s) are on “{name}”. Move them to another schedule first — it can’t be deleted while anyone is on it.",
            "remove-title": "Delete this item?",
            "remove-body": "Delete “{name}”? This can’t be undone.",
            "remove-body-used": "“{name}” is used by {n} schedule(s). Remove it from those schedules first — it can’t be deleted while in use."
          },
          "toast": {
            "created": "Schedule “{name}” created",
            "saved": "Schedule “{name}” saved",
            "deleted": "“{name}” deleted",
            "no-changes": "Nothing changed."
          },
          "rotation": {
            "kind": {
              "fixed": "Fixed",
              "rotation": "Rotation"
            },
            "kind-locked": "{n} employee(s) are on this schedule, so its type can’t change. Move them to another schedule first.",
            "f": {
              "pattern": "Rotation Pattern",
              "sequence": "Shift sequence",
              "summary": "Rotation Summary (read-only)",
              "holiday": "Holiday Calendar"
            },
            "select-pattern": "— Select a Rotation Pattern —",
            "stray-pattern": "{name} (no longer offered)",
            "new-pattern": "New pattern",
            "new-pattern-title": "Create a new Rotation Pattern and link it here",
            "pattern-hint": "The schedule reuses this pattern’s shift / off-day sequence and cycle. Edit the pattern to change the sequence.",
            "linked": "Defined by the linked Rotation Pattern",
            "no-pattern": "Select or create a Rotation Pattern above — it defines the shift / off-day sequence and cycle for this schedule.",
            "loading": "Loading Work Patterns…",
            "load-error": "The Work Patterns couldn’t be loaded.",
            "retry": "Retry",
            "err": {
              "pattern-required": "A rotation schedule needs a Rotation Pattern."
            },
            "sum": {
              "cycle": "Cycle Length",
              "days": "{n} days",
              "sequence": "Sequence",
              "working": "Working Days",
              "rest": "Rest Days",
              "night": "Night Shifts",
              "cross": "Cross-Midnight Shifts",
              "hours": "Scheduled Hours",
              "auto": "Applies to Auto-Roster",
              "yes": "Yes",
              "no": "No",
              "off": "Off / Rest day",
              "anchor": "Cycle day 1: {date} · repeats every {n} days",
              "anchor-new": "Cycle day 1: the day this schedule is created · repeats every {n} days",
              "source": "Derived from linked Rotation Pattern · derived automatically, not editable."
            },
            "preview": {
              "type": "Type",
              "pattern": "Pattern",
              "line": "{n} shift(s), cycle {cycle}d",
              "auto": "auto-roster"
            },
            "warn": {
              "no-pattern": "Rotation has no shifts in its sequence — link a Rotation Pattern.",
              "no-shifts": "No Shifts exist for this company yet — create Shifts first."
            },
            "row": {
              "pattern": "Pattern: {name}",
              "pattern-cycle": "Pattern: {name} · {n}-day cycle"
            }
          }
        },
        "assign": {
          "title": "Employees",
          "count": "{n} on this schedule",
          "assign-btn": "Assign employees",
          "search": "Search name or code…",
          "search-aria": "Search employees on this schedule",
          "col": {
            "code": "Code",
            "name": "Name",
            "since": "Effective from",
            "actions": "Actions"
          },
          "move": "Move…",
          "end": "End…",
          "move-aria": "Move {name} to another schedule",
          "end-aria": "End {name}'s assignment",
          "empty": "Nobody is on this schedule yet.",
          "empty-search": "No one on this schedule matches “{q}”.",
          "loading": "Loading employees…",
          "error": "Couldn't load who is on this schedule.",
          "retry": "Retry",
          "modal": {
            "title": "Assign employees to {name}",
            "effective": "Effective from",
            "search": "Search name, code or position…",
            "search-aria": "Search employees",
            "show-assigned": "Show already-scheduled staff ({n}) — view only, cannot be selected",
            "allow-move": "Move already-scheduled people too",
            "on": "on {name}",
            "on-this": "already on this schedule",
            "help": "Only employees without a schedule can be selected. An employee follows one work schedule at a time, so already-scheduled staff are hidden by default; tick the box above to view them (locked).",
            "selected": "{n} selected",
            "select-all": "Select all shown",
            "clear": "Clear selection",
            "none": "No unassigned employees — tick “Show already-scheduled staff” to view assigned ones.",
            "no-match": "No employees match “{q}”.",
            "too-many": "Showing the first {n} — refine your search to see the rest.",
            "submit": "Assign {n}",
            "cancel": "Cancel",
            "done": "Done",
            "progress": "Assigning… {done} of {total}",
            "loading": "Loading employees…",
            "error": "Couldn't load employees.",
            "retry": "Retry",
            "date-required": "Choose the date the schedule starts.",
            "list-label": "Employees to assign"
          },
          "result": {
            "title": "Result",
            "assigned": "{n} assigned",
            "unchanged": "{n} already on this schedule",
            "skipped": "{n} skipped",
            "stopped": "Stopped: {detail} {n} not sent."
          },
          "reason": {
            "NOT_FOUND": "Not found in this company",
            "MODE_NOT_CLASSIC": "On another scheduling model",
            "BACKDATE_BEFORE_CURRENT": "The date is before their current schedule started",
            "Unknown": "Not assigned"
          },
          "change": {
            "move-title": "Move {name}",
            "assign-title": "Assign a work schedule to {name}",
            "end-title": "End {name}'s schedule",
            "schedule": "Work schedule",
            "from": "Effective from",
            "to": "Last day on the schedule",
            "end-body": "{name} leaves {schedule} after this day. The history keeps the period.",
            "choose": "Choose a schedule",
            "no-templates": "There is no other active schedule to choose.",
            "submit-move": "Move",
            "submit-assign": "Assign",
            "submit-end": "End assignment",
            "required": "Choose a schedule and a date.",
            "date-required": "Choose a date."
          },
          "toast": {
            "assigned": "{n} assigned to {name}",
            "moved": "{name} moved to {schedule}",
            "ended": "{name}'s schedule ended"
          },
          "err": {
            "generic": "The change was refused. Please try again."
          },
          "upcoming-from": "from {date}",
          "upcoming-title": "Moves on to this schedule on {date}",
          "until": "until {date}"
        },
        "monthly": {
          "nav": "Monthly Schedule",
          "title": "Monthly Schedule",
          "subtitle": "The planned days of every employee on a classic work schedule.",
          "prev": "Previous month",
          "next": "Next month",
          "this-month": "This month",
          "from": "From",
          "to": "To",
          "range": "{from} – {to}",
          "window-error": {
            "invalid": "Enter a valid start and end date.",
            "order": "The start date must not be after the end date.",
            "too-long": "Choose at most {max} days. This window has {days}."
          },
          "schedule": "Work schedule",
          "schedule-all": "All work schedules",
          "search-label": "Search employees",
          "search": "Name, code or schedule",
          "excluded": "{n} employee on an office or roster pattern is not shown here. | {n} employees on office or roster patterns are not shown here.",
          "showing": "Showing {shown} of {loaded} loaded employees",
          "updating": "Updating…",
          "more-available": "More employees are available. Load more to include them in the grid and the export.",
          "load-more": "Load more",
          "chip": {
            "schedule": "Schedule: {name}",
            "search": "Search: {q}",
            "remove": "Remove filter {label}"
          },
          "clear-filters": "Clear filters",
          "empty": "No classic employees in this window.",
          "empty-filtered": "No employees match these filters.",
          "error": "The monthly schedule could not be loaded.",
          "retry": "Retry",
          "scroll-label": "Monthly schedule grid, scrollable",
          "grid-label": "Monthly schedule from {from} to {to}",
          "hours-short": "{h} h",
          "col": {
            "employee": "Employee",
            "code": "Employee code",
            "name": "Name",
            "schedule": "Work schedule",
            "hours": "Hours",
            "work-days": "Work days",
            "ph": "PH",
            "off": "OFF"
          },
          "foot": {
            "working": "Working · hours",
            "day": "{n} working · {h} h"
          },
          "code": {
            "half": "½",
            "off": "OFF",
            "ph": "PH",
            "ovr": "OVR",
            "none": "—",
            "unknown": "?"
          },
          "legend": {
            "work": "Working day",
            "half": "Half day",
            "off": "Day off",
            "ph": "Public holiday",
            "ovr": "Changed day",
            "none": "Not on a schedule that day",
            "weekend": "Weekend"
          },
          "ovr": {
            "CHANGE_DAY_OFF": "Day off moved",
            "DAY_CHANGE": "Hours changed",
            "DAY_OFF": "Extra day off",
            "WORKING_DAY": "Extra working day",
            "HOLIDAY_WORK": "Working on a holiday",
            "Unknown": "Changed day"
          },
          "dow": {
            "0": "Sun",
            "1": "Mon",
            "2": "Tue",
            "3": "Wed",
            "4": "Thu",
            "5": "Fri",
            "6": "Sat"
          },
          "months": {
            "1": "January",
            "2": "February",
            "3": "March",
            "4": "April",
            "5": "May",
            "6": "June",
            "7": "July",
            "8": "August",
            "9": "September",
            "10": "October",
            "11": "November",
            "12": "December"
          },
          "rotation": {
            "legend": "Rotation shift — the shift code above its hours",
            "pattern": "Pattern: {name}",
            "cycle-day": "Cycle day {n}",
            "shift": "Shift: {code}",
            "shift-named": "Shift: {code} ({name})",
            "planned": "Planned shift: {code} {time}",
            "missing-shift": "The pattern's shift for this day cannot be found",
            "missing-pattern": "The rotation pattern cannot be read"
          }
        },
        "live": {
          "not-built": {
            "title": "Not available yet",
            "body": "Shifts and Work Patterns are being connected to the live service. They will appear here as soon as that work is released."
          },
          "error": "The list could not be loaded.",
          "retry": "Try again"
        }
      }
    },
    "workmgmt": {
      "title": "Work Management",
      "subtitle": "{scope} · {active} active work items · {critical} critical",
      "tabs": {
        "dashboard": "Dashboard",
        "mywork": "My Work",
        "teamwork": "Team Work",
        "queues": "Work Queues",
        "recurring": "Recurring Work",
        "reviews": "Reviews",
        "reports": "Reports"
      },
      "dashboard": {
        "heading": "Operational overview",
        "heading-sub": "{review} awaiting review · {overdue} overdue · {critical} critical · {active} active",
        "request-work": "Request work",
        "new-work": "New work item",
        "create-toast": "New work-item wizard coming in a subsequent slice",
        "request-toast": "Request-work form coming in a subsequent slice",
        "banner-lead": "Work Management",
        "banner-body": "orchestrates operational execution. Approvals stay in their source modules (Leave / OT / Travel / Expense). Reviewers may rate completed work — rating is optional and feeds Contribution Score for Performance Management.",
        "view-all": "View all",
        "kpi": {
          "my-open": "My open work",
          "my-open-meta": "In progress + open",
          "awaiting-review": "Awaiting review",
          "awaiting-review-meta": "Submitted, with reviewer",
          "overdue": "Overdue",
          "overdue-meta": "Needs attention",
          "contribution": "My contribution score",
          "contribution-meta": "Quarterly rolling score",
          "vs-prev": "vs prev 90d",
          "no-rated": "No rated work yet"
        },
        "table": {
          "work-item": "Work item",
          "type": "Type",
          "status": "Status",
          "priority": "Priority",
          "assignee": "Assignee",
          "due": "Due"
        },
        "awaiting": {
          "heading": "Awaiting my review",
          "sub": "{pending} pending · {active} in progress",
          "empty": "No work items awaiting your review."
        },
        "workload": {
          "heading": "Team workload",
          "sub": "Active work per person",
          "view-team": "View team",
          "active": "{n} active",
          "overdue": "{n} overdue",
          "empty": "No team members in scope."
        },
        "contributors": {
          "heading": "Top contributors (90 days)",
          "sub": "Ranked by Contribution Score",
          "all-scores": "All scores",
          "rated": "{n} rated",
          "empty": "No rated work yet."
        },
        "activity": {
          "heading": "Workspace activity",
          "sub": "Last 30 days",
          "active": "Active work",
          "completed": "Completed (30d)",
          "overdue": "Overdue",
          "avg-score": "Avg contribution score"
        },
        "recent": {
          "heading": "My recent work",
          "sub": "Open + in progress + awaiting review",
          "empty": "No recent work in your queue."
        },
        "drawer": {
          "assignee": "Assignee",
          "reviewer": "Reviewer",
          "assigner": "Assigner",
          "due": "Due",
          "dept": "Department",
          "linked-module": "Linked module",
          "rating": "Contribution rating",
          "review-comment": "Reviewer comment",
          "close": "Close"
        }
      },
      "mywork": {
        "heading": "My Work",
        "heading-sub": "{total} total",
        "self-work": "Self work",
        "create-toast": "Self-work creation form coming in a subsequent slice",
        "kpi": {
          "open": "Open",
          "progress": "In progress",
          "review": "Review",
          "overdue": "Overdue"
        },
        "filters": {
          "search-placeholder": "Search by title or ID…",
          "all-statuses": "All statuses",
          "status-open": "Open",
          "status-progress": "In progress",
          "status-review": "Review",
          "status-done": "Done",
          "all-types": "All work types",
          "type-adhoc": "Ad-hoc",
          "type-recurring": "Recurring",
          "all-priorities": "All priorities",
          "priority-high": "High",
          "priority-med": "Medium",
          "priority-low": "Low"
        },
        "stub": {
          "title": "My work items",
          "lede": "Personal task board grouped by status with overdue badges, recurring instances, and contribution-rating callbacks. The grid view + drawer-based task detail land in a subsequent slice; data shape mirrors the proto's `wmRenderTaskList()` helper."
        }
      },
      "teamwork": {
        "heading": "Team Work",
        "heading-sub": "Work you review · {total} total",
        "heading-sub-admin": "All workspace work · {total} total",
        "assign-work": "Assign work",
        "create-toast": "Assign-work form coming in a subsequent slice",
        "result-count": "{n} work items",
        "kpi": {
          "open": "Open",
          "progress": "In progress",
          "review": "Review",
          "overdue": "Overdue"
        },
        "filters": {
          "search-placeholder": "Search…",
          "all-statuses": "All statuses",
          "all-types": "All work types",
          "all-assignees": "All assignees"
        },
        "table": {
          "work-item": "Work item",
          "type": "Type",
          "status": "Status",
          "priority": "Priority",
          "assignee": "Assignee",
          "due": "Due"
        },
        "empty": {
          "title": "No work items match",
          "lede": "Loosen a filter or clear the search to see more work."
        },
        "drawer": {
          "close": "Close drawer",
          "dept": "Dept · {dept}",
          "description": "Description",
          "assignee": "Assignee",
          "reviewer": "Reviewer",
          "assigner": "Assigned by",
          "due": "Due",
          "start": "Start",
          "linked": "Linked to",
          "tags": "Tags"
        }
      },
      "queues": {
        "heading": "Work Queues",
        "heading-sub": "Optimal P · {total} active work items across queues",
        "banner-lead": "Work Queues",
        "banner-body": "group active work by operational area for monitoring at a glance. The Critical Queue surfaces overdue and at-risk items needing immediate attention.",
        "view-all": "View all in queue",
        "all-clear": "All clear in this queue",
        "card-aria": "Open {name} detail",
        "counts": {
          "active": "Active",
          "at-risk": "At Risk",
          "overdue": "Overdue"
        },
        "cards": {
          "payroll": {
            "name": "Payroll Queue",
            "desc": "Payroll operations & follow-ups"
          },
          "hrops": {
            "name": "HR Ops Queue",
            "desc": "HR operations, onboarding, employee changes"
          },
          "compliance": {
            "name": "Compliance Queue",
            "desc": "Statutory declarations, audits, permits"
          },
          "fieldops": {
            "name": "Field Ops Queue",
            "desc": "Site inspections, field execution"
          },
          "critical": {
            "name": "Critical Queue",
            "desc": "Urgent attention required (overdue, at-risk, critical)"
          }
        },
        "drawer": {
          "sub": "{n} active",
          "empty": "No active work in this queue.",
          "close": "Close drawer",
          "cols": {
            "work-item": "Work item",
            "status": "Status",
            "assignee": "Assignee",
            "due": "Due"
          }
        }
      },
      "recurring": {
        "heading": "Recurring Work",
        "heading-sub": "Auto-generated on a schedule from operational templates · {total} active",
        "new-template": "New template",
        "create-toast": "Template editor coming in a subsequent slice",
        "banner": "Templates generate operational work on a schedule (e.g., monthly NSSF declaration, weekly site inspection). Editor for checklists, reviewer rules, and SLA defaults lands in a subsequent slice.",
        "result-count": "{n} work items",
        "kpi": {
          "open": "Open",
          "progress": "In progress",
          "review": "Review",
          "overdue": "Overdue"
        },
        "filters": {
          "search-placeholder": "Search…",
          "all-statuses": "All statuses",
          "all-priorities": "All priorities",
          "all-assignees": "All assignees"
        },
        "table": {
          "work-item": "Work item",
          "type": "Type",
          "status": "Status",
          "priority": "Priority",
          "assignee": "Assignee",
          "due": "Due"
        },
        "empty": {
          "title": "No recurring work matches",
          "lede": "Loosen a filter or clear the search to see more recurring work."
        },
        "drawer": {
          "close": "Close drawer",
          "dept": "Dept · {dept}",
          "description": "Description",
          "assignee": "Assignee",
          "reviewer": "Reviewer",
          "assigner": "Assigned by",
          "due": "Due",
          "start": "Start",
          "linked": "Linked to",
          "tags": "Tags"
        }
      },
      "reviews": {
        "heading": "Reviews",
        "heading-sub": "{pending} awaiting your review",
        "export-evidence": "Export evidence pack",
        "export-toast": "Performance evidence pack — coming with Performance module",
        "banner-lead": "Contribution review:",
        "banner-body": "When a reviewer rates a work item (4 dimensions × 1–5 stars), each gets a score. Scores aggregate by employee over 90 days, weighted by impact (high × 2.0, medium × 1.5, low × 1.0). Rating is optional — accepting without rating is fine for low-stakes work.",
        "empty": "No work items here.",
        "system": "System",
        "unknown": "Unknown",
        "contrib": {
          "label": "My contribution score · last 90 days",
          "meta": "Based on {count} rated work items · {arrow} {delta} vs previous period"
        },
        "pills": {
          "pending": "Pending review ({n})",
          "received": "Ratings received ({n})",
          "given": "Ratings given ({n})"
        },
        "cols": {
          "work-item": "Work item",
          "type": "Type",
          "status": "Status",
          "priority": "Priority",
          "assignee": "Assignee",
          "due": "Due",
          "score": "Score",
          "q": "Q",
          "time": "Time",
          "init": "Init",
          "coll": "Coll",
          "badge": "Badge",
          "rated": "Rated"
        },
        "status": {
          "open": "Open",
          "progress": "In Progress",
          "review": "Awaiting Review",
          "done": "Completed",
          "revision": "Needs Revision",
          "overdue": "Overdue",
          "cancelled": "Cancelled"
        },
        "type": {
          "assigned": "Assigned",
          "request": "Work Request",
          "self": "Self Work",
          "recurring": "Recurring",
          "system": "System"
        },
        "priority": {
          "low": "Low",
          "normal": "Normal",
          "high": "High",
          "urgent": "Urgent"
        },
        "impact": {
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        },
        "sla": {
          "warning": "At Risk",
          "critical": "Critical",
          "breached": "Overdue"
        },
        "aging": {
          "overdue": "{n}d overdue",
          "today": "Due today",
          "tomorrow": "Due tomorrow",
          "in-days": "Due in {n}d"
        },
        "rel": {
          "in-days": "in {n}d",
          "today": "today",
          "days-ago": "{n}d ago",
          "weeks-ago": "{n}w ago",
          "months-ago": "{n}mo ago",
          "years-ago": "{n}y ago"
        },
        "dim": {
          "quality": {
            "label": "Quality",
            "help": "Met the standard?"
          },
          "timeliness": {
            "label": "Timeliness",
            "help": "On time?"
          },
          "initiative": {
            "label": "Initiative",
            "help": "Took ownership?"
          },
          "collab": {
            "label": "Collaboration",
            "help": "Worked well with others?"
          }
        },
        "badge": {
          "helpful": "Helpful",
          "fast": "Fast Response",
          "reliable": "Reliable",
          "accurate": "Accurate",
          "solver": "Problem Solver",
          "collab": "Collaborative",
          "proactive": "Proactive",
          "above": "Above & Beyond"
        },
        "aside": {
          "dim-heading": "My dimension breakdown",
          "dim-sub": "Average per dimension",
          "top-heading": "Top contributors",
          "top-sub": "Ranked by Contribution Score",
          "rated-count": "{n} rated",
          "you-tag": "You"
        },
        "drawer": {
          "close": "Close drawer",
          "assigned-by": "Assigned by {name}",
          "due": "Due {date}",
          "description": "Description",
          "assignee": "Assignee",
          "reviewer": "Reviewer",
          "start": "Started",
          "due-label": "Due",
          "linked-module": "Linked module",
          "linked-record": "Linked record",
          "impact-label": "{level} impact",
          "rating-heading": "Rating",
          "overall-label": "Overall score",
          "overall-meta": "Rated by {name} · {when}",
          "badge-label": "Badge",
          "no-rating": "Not rated yet — rating is optional and can be added when accepting the work."
        }
      },
      "reports": {
        "heading": "Reports",
        "heading-sub": "Operational analytics across modules",
        "toast-open": "Open {name} report",
        "tiles": {
          "throughput": {
            "label": "Throughput",
            "desc": "Completed work-items per period · by team / queue / individual."
          },
          "cycle-time": {
            "label": "Cycle Time",
            "desc": "Mean / median time from open → done, broken down by status transitions."
          },
          "sla": {
            "label": "SLA Adherence",
            "desc": "% within SLA, miss reasons, recurring offenders."
          },
          "workload": {
            "label": "Workload Distribution",
            "desc": "Per-assignee load balance with overload / starve detection."
          }
        }
      }
    },
    "perform": {
      "title": "Performance",
      "subtitle": "Continuous Performance · Workforce Intelligence · evidence-driven · governed by HR & LM",
      "persona": {
        "current": "Current view",
        "demo-label": "Demo · switch persona",
        "admin": {
          "label": "HR Admin / HR Director",
          "note": "Governance · templates · cycles · calibration · fairness oversight · audit"
        },
        "lm": {
          "label": "Line Manager",
          "note": "Coaching · KPI alignment · evidence validation · manager review"
        },
        "employee": {
          "label": "Employee",
          "note": "Self-development · propose KPIs · log progress · acknowledge"
        }
      },
      "tabs": {
        "dashboard": "Dashboard",
        "cycles": "Cycles",
        "templates": "Templates",
        "competency": "Competency Library",
        "goals": "Goals & KPI",
        "reviews": "Reviews",
        "calibration": "Calibration",
        "devplans": "Development Plans",
        "reports": "Reports",
        "settings": "Settings"
      },
      "dashboard": {
        "title": "HR Admin Dashboard",
        "view-mode": "View",
        "view-standard": "Standard",
        "view-executive": "Executive",
        "exec-view-toast": "Executive view — coming in a follow-up slice",
        "cycle-sub": "{cycle} · {stage} stage · {participants} eligible employees",
        "banner": "{cycle} · {stage} stage · {selfPct}% self-reviews submitted · {mgrPct}% manager reviews submitted · Manager Review deadline {deadline}",
        "action": {
          "settings": "Settings",
          "open-cycle": "Open active cycle"
        },
        "attention": {
          "title": "Attention required",
          "open-cycle": "Open cycle →",
          "overdue-rev": {
            "title": "14 manager reviews past deadline",
            "sub": "H1 2026 · escalation due to dept heads",
            "cta": "Resolve"
          },
          "calib-stalled": {
            "title": "Calibration session stalled at Step 2 of 4",
            "sub": "HR + Finance calibration · 5 days idle",
            "cta": "Reopen"
          },
          "risk-flagged": {
            "title": "3 employees flagged High risk for the cycle",
            "sub": "Below-expectations + missed 1:1s in last 60 days",
            "cta": "Triage"
          },
          "feedback-gap": {
            "title": "Feedback coverage at 38% — target 70%",
            "sub": "Most-missing: Engineering pod B · Customer Success",
            "cta": "Nudge"
          }
        },
        "kpi": {
          "section": "KPI overview",
          "active-cycles": {
            "label": "Active review cycles",
            "meta": "H1 2026 · Manager Review stage"
          },
          "pending-evals": {
            "label": "Pending evaluations",
            "meta": "Awaiting manager review · due 25 May"
          },
          "overdue-mgr": {
            "label": "Overdue manager reviews",
            "meta": "Past cycle deadline · escalation due"
          },
          "calibration-pending": {
            "label": "Calibration pending",
            "meta": "HR + Finance ready to calibrate"
          },
          "completed": {
            "label": "Completed reviews",
            "meta": "41% of cycle complete"
          },
          "below-expect": {
            "label": "Below expectations",
            "meta": "Employees needing support"
          },
          "top-performers": {
            "label": "Top performers",
            "meta": "Outstanding + Exceeds"
          },
          "dev-pending": {
            "label": "Dev plans pending",
            "meta": "Awaiting your approval"
          }
        },
        "stub": {
          "title": "Below-the-fold dashboard sections",
          "lede": "Variance heatmap · risk index · distribution chart · cycle progress timeline · top-5 most-late managers. Ports incrementally in P19+."
        },
        "watchlist": {
          "title": "Performance Risk Index",
          "formula": "Composite of attendance · OT · SLA · delayed goals · calibration variance · engagement",
          "hint": "High-priority individuals · {n} on the watchlist · click row to open the risk profile",
          "bucket": {
            "low-sub": "Performing well · no flags",
            "med-sub": "1–2 signals · watch list",
            "high-sub": "3+ signals · intervention needed",
            "critical-sub": "Immediate intervention"
          },
          "tier": {
            "low": "Low",
            "med": "Medium",
            "high": "High",
            "critical": "Critical"
          },
          "col": {
            "employee": "Employee",
            "dept": "Dept",
            "signals": "Risk signals",
            "score": "Score",
            "tier": "Tier",
            "actions": "Actions"
          },
          "action": {
            "open": "Open full detail",
            "coaching": "Create coaching plan",
            "schedule": "Schedule 1:1",
            "coaching-toast": "Coaching plan for {name} — coming in a follow-up slice",
            "schedule-toast": "Schedule 1:1 with {name} — coming in a follow-up slice"
          },
          "drawer": {
            "title": "Risk profile · {name}",
            "subtitle": "Risk score {score}/100 · {tier}",
            "close": "Close",
            "devplans": "Open dev plans",
            "banner": {
              "critical": "composite risk score · immediate intervention recommended",
              "high": "composite risk score · intervention recommended within 2 weeks",
              "med": "composite risk score · watch list · check in monthly",
              "low": "composite risk score · low priority"
            },
            "why-title": "Why this score · weighted breakdown",
            "composite": "Composite risk = {points} points (signals) ≈ {score}/100 (normalised)",
            "col": {
              "signal": "Signal",
              "weight": "Weight",
              "source": "Data source"
            },
            "scale": "Scale: {scale}. Signals refresh nightly from connected modules · last refresh: this morning 04:00.",
            "context": "Employee context",
            "kv": {
              "role": "Role",
              "dept": "Department",
              "manager": "Manager",
              "score": "Current risk score"
            },
            "actions-title": "Recommended actions",
            "actions": {
              "schedule-1on1": "Schedule 1:1 with manager within 7 days",
              "review-devplan": "Review development plan · adjust if needed",
              "reduce-workload": "Reduce workload / OT if applicable",
              "coaching-engagement": "Consider coaching engagement or wellness check-in",
              "monitor-weekly": "Monitor signals weekly",
              "recheck-cycle": "Re-check at next cycle",
              "add-watchlist": "Add to manager's watch list",
              "maintain": "Maintain current trajectory",
              "reevaluate": "Re-evaluate quarterly"
            },
            "copilot-title": "AI Copilot actions"
          }
        }
      },
      "lm": {
        "tabs": {
          "my-perf": "My Performance",
          "my-goals": "My Goals",
          "my-review": "My Review",
          "my-feedback": "Feedback Received",
          "my-dev": "Development & History",
          "team-reviews": "My Team Reviews",
          "team-goals": "Team Goals",
          "feedback-given": "Feedback Given",
          "team-snapshot": "Team Snapshot"
        },
        "stubs": {
          "my-perf": {
            "title": "My Performance",
            "lede": "Personal performance dashboard — current cycle progress, rating preview, manager evidence, KPI attainment. Port lands in Phase B."
          },
          "my-goals": {
            "title": "My Goals",
            "lede": "Your goal lifecycle (Active · Proposal · Draft · Closed), cascade to team goals, KPI progress, milestones. Port lands in Phase B."
          },
          "my-review": {
            "title": "My Review",
            "lede": "Self-review form (current cycle) + manager review preview + acknowledge after release. Port lands in Phase B."
          },
          "my-feedback": {
            "title": "Feedback Received",
            "lede": "Feedback from your manager, peers, and skip-level. Filterable by tag, period, sentiment. Port lands in Phase B."
          },
          "my-dev": {
            "title": "Development & History",
            "lede": "Your active development plan, completed cycles, rating history, training completed. Port lands in Phase B."
          },
          "team-reviews": {
            "title": "Team Reviews",
            "lede": "Per-direct-report review state · evidence trail · manager review form · approve & submit. Port lands in Phase B."
          },
          "team-goals": {
            "title": "Team Goals",
            "lede": "Filtered cascade view of your direct reports' goals · pending approvals · KPI thresholds. Port lands in Phase B."
          },
          "feedback-given": {
            "title": "Feedback Given",
            "lede": "Feedback log of what you sent to your team. Drafts, scheduled, and historical. Port lands in Phase B."
          },
          "team-snapshot": {
            "title": "Team Snapshot",
            "lede": "One-glance team health — review completion, rating distribution preview, attendance/eng signals from HR Ops. Port lands in Phase B."
          }
        }
      },
      "ee": {
        "tabs": {
          "my-perf": "My Performance",
          "my-goals": "My Goals",
          "my-review": "My Review",
          "my-feedback": "Feedback Received",
          "my-dev": "Development & History"
        },
        "stubs": {
          "my-perf": {
            "title": "My Performance",
            "lede": "Personal performance dashboard — current cycle progress, rating preview, manager evidence, KPI attainment. Port lands in Phase B."
          },
          "my-goals": {
            "title": "My Goals",
            "lede": "Your goal lifecycle (Active · Proposal · Draft · Closed), KPI progress, milestones. Port lands in Phase B."
          },
          "my-review": {
            "title": "My Review",
            "lede": "Self-review form (current cycle) + manager review preview + acknowledge after release. Port lands in Phase B."
          },
          "my-feedback": {
            "title": "Feedback Received",
            "lede": "Feedback from your manager, peers, and skip-level. Filterable by tag, period, sentiment. Port lands in Phase B."
          },
          "my-dev": {
            "title": "Development & History",
            "lede": "Your active development plan, completed cycles, rating history, training completed. Port lands in Phase B."
          }
        }
      },
      "cycles": {
        "title": "Review cycles",
        "subtitle": "All review cycles · {total} total · {active} active",
        "templates-btn": "Templates",
        "create": "Create cycle",
        "banner-strong": "{templates} evaluation templates",
        "banner-rest": "available · used by {usage} employees across all cycles",
        "confirm-close": "Close this cycle? All non-final reviews will be archived.",
        "col": {
          "cycle": "Cycle",
          "period": "Period",
          "status": "Status",
          "stage": "Stage",
          "progress": "Progress",
          "participants": "Participants",
          "actions": "Actions"
        },
        "cell": {
          "self-mgr": "{self} self · {mgr} mgr",
          "overall": "{pct}% overall"
        },
        "action": {
          "view": "View",
          "edit": "Edit"
        },
        "timeline": {
          "setup": "Setup",
          "self": "Self-Review",
          "mgr": "Manager Review",
          "calib": "Calibration",
          "close": "Closed"
        },
        "drawer": {
          "close": "Close",
          "close-cta": "Close",
          "close-cycle": "Close cycle",
          "edit-timeline": "Edit timeline",
          "sub": "{period} · {count} eligible employees · Status: {status}",
          "id": "Cycle ID",
          "type": "Type",
          "template": "Template",
          "mixed": "Mixed (per role family)",
          "current-stage": "Current stage",
          "self-reviews": "Self-reviews",
          "mgr-reviews": "Manager reviews",
          "calibrated": "Calibrated",
          "submitted": "{done}/{total} submitted",
          "timeline": "Timeline"
        },
        "toast": {
          "closed": "Cycle closed · {name}"
        },
        "wizard": {
          "rail-title": "Setup steps",
          "cancel": "Cancel",
          "back": "Back",
          "next": "Next",
          "save-draft": "Save draft",
          "save-changes": "Save changes",
          "create-launch": "Create & launch",
          "title": {
            "create": "Create new review cycle",
            "edit": "Edit cycle — {name}",
            "unnamed": "unnamed",
            "sub": "Step {n} of {total} · {label}"
          },
          "step": {
            "setup": {
              "label": "Setup",
              "desc": "Cycle name, type, and overall period."
            },
            "eligibility": {
              "label": "Eligibility",
              "desc": "Who is included in this cycle."
            },
            "template": {
              "label": "Template",
              "desc": "Which evaluation template applies."
            },
            "calibration": {
              "label": "Calibration",
              "desc": "Calibration window and rules."
            },
            "notify": {
              "label": "Notifications",
              "desc": "Who is notified and when."
            },
            "review": {
              "label": "Review & Create",
              "desc": "Final check before launch."
            }
          },
          "setup": {
            "name": "Cycle name",
            "name-ph": "e.g. H2 2026 Performance Review",
            "type": "Cycle type",
            "start": "Period start",
            "end": "Period end",
            "self-deadline": "Self-review deadline",
            "mgr-deadline": "Manager-review deadline",
            "period-label": "Period"
          },
          "type": {
            "half-yearly": "Half-yearly",
            "quarterly": "Quarterly",
            "annual": "Annual",
            "project-based": "Project-based",
            "probation": "Probation",
            "mid-cycle": "Mid-cycle"
          },
          "elig": {
            "dept": "Department",
            "dept-all": "All departments",
            "emp-type": "Employment type",
            "emp-all": "All (Direct + Outsourced)",
            "emp-direct": "Direct staff only",
            "emp-outsourced": "Outsourced only",
            "emp-external": "External (client) — typically excluded",
            "emp-hint": "External employees usually skip performance review (managed by client).",
            "manager": "Manager (optional · narrow to one manager's team)",
            "manager-all": "All managers",
            "live-preview": "Eligible employees · live preview",
            "empty": "No employees match. Loosen filters.",
            "sample": "Computed live from active employees + filters."
          },
          "tpl": {
            "pick": "Pick an evaluation template",
            "meta": "{comps} components · {usage} in use"
          },
          "calib": {
            "required": "Calibration required?",
            "yes": "Yes (recommended) — ratings discussed before final lock",
            "no": "No — manager rating is final",
            "deadline": "Calibration deadline",
            "window": "Calibration window (days)",
            "w7": "1 week",
            "w14": "2 weeks (typical)",
            "w21": "3 weeks",
            "w30": "1 month",
            "info": "During calibration, HR + managers discuss outliers and variance. Ratings are locked at the end of this window.",
            "skip": "Skipping calibration is not recommended — manager-rating variance won't be checked."
          },
          "notify": {
            "launch": "Send launch announcement",
            "launch-hint": "Email all eligible employees when the cycle opens.",
            "r7": "7-day deadline reminder",
            "r7-hint": "Auto-reminder one week before each deadline.",
            "r1": "1-day deadline reminder",
            "r1-hint": "Final reminder 24 hours before each deadline.",
            "mgr": "Manager nudges",
            "mgr-hint": "Daily digest to managers showing pending reviews.",
            "exec": "Executive summary",
            "exec-hint": "Weekly summary to HR Director and CEO during the cycle.",
            "welcome": "Welcome message to participants (optional)",
            "welcome-ph": "Optional message included in launch email."
          },
          "review": {
            "ready": "Ready to launch. Review the summary below and confirm.",
            "missing": "Cycle is missing required information ({bits}). Go back to fix.",
            "no-name": "name",
            "no-elig": "no eligible employees",
            "eligible": "Eligible count",
            "selected": "Selected",
            "yes": "Yes",
            "no": "No",
            "on": "On",
            "off": "Off"
          },
          "toast": {
            "missing": "Cannot launch — fix the missing info on the Review step.",
            "saved": "Cycle saved · {name}",
            "launched": "Cycle \"{name}\" created and launched ({count} participants).",
            "draft": "Cycle \"{name}\" saved as draft."
          }
        }
      },
      "templates": {
        "title": "Evaluation Templates",
        "subtitle": "{count} templates · used by {employees} employees in current cycle",
        "create": "New template",
        "create-toast": "Template editor — coming in a follow-up slice",
        "open-toast": "Template detail drawer — coming in a follow-up slice",
        "usage": "Used by {n} employees",
        "usage-suffix": "{n} in use",
        "weight-distribution": "Component weight distribution",
        "components-head": "Components ({n})",
        "more": "+{n} more",
        "open-cta": "Click to view / edit →",
        "versions": "no versions | {n} version | {n} versions",
        "cycles": "no cycles | {n} cycle | {n} cycles",
        "version": {
          "active": "active",
          "archived": "archived"
        },
        "items": {
          "tpl-mgmt": {
            "name": "Strategic / Management",
            "roles": "Department Heads · Senior Managers · Directors",
            "owner": "HR Director"
          },
          "tpl-ops": {
            "name": "Operational / Back-Office",
            "roles": "Finance · HR · IT · Operations · Admin",
            "owner": "Operations Director"
          },
          "tpl-sales": {
            "name": "Sales",
            "roles": "Sales Reps · Field Sales · Sales Supervisors",
            "owner": "Sales Director"
          },
          "tpl-tech": {
            "name": "Engineering / Tech",
            "roles": "Engineers · Designers · Data",
            "owner": ""
          }
        }
      },
      "competency": {
        "title": "Competency Library",
        "subtitle": "{total} competencies · {system} system default · {tenant} tenant custom · reusable across reviews, development plans, succession & job profiles",
        "import": "Import",
        "export": "Export",
        "new": "New competency",
        "result-count": "Showing {n} of {total}",
        "action": {
          "import-toast": "Import CSV / XLSX — coming in a follow-up slice",
          "export-toast": "Export filtered list — coming in a follow-up slice",
          "new-toast": "Competency editor — coming in a follow-up slice",
          "add-category-toast": "Add category — coming in a follow-up slice",
          "bulk-archive-toast": "Archive {n} selected — coming in a follow-up slice",
          "row-edit-toast": "Edit {name} — coming in a follow-up slice",
          "row-clone-toast": "Clone {name} to tenant library — coming in a follow-up slice",
          "row-archive-toast": "Archive {name} — coming in a follow-up slice",
          "row-delete-toast": "Delete {name} — coming in a follow-up slice",
          "view": "View",
          "edit": "Edit",
          "clone": "Clone to edit",
          "archive": "Archive",
          "delete": "Delete"
        },
        "summary": {
          "total": "Total competencies",
          "total-sub": "{system} system · {tenant} tenant",
          "categories": "Active categories",
          "categories-sub": "of {total} available",
          "templates": "Templates using",
          "templates-sub": "of {total} templates link a competency",
          "draft": "Draft competencies",
          "draft-sub": "{archived} archived total"
        },
        "sidebar": {
          "title": "Categories",
          "all": "All competencies",
          "add": "Add a new category",
          "expand": "Expand sidebar",
          "collapse": "Collapse sidebar",
          "hint": "Tip · click + above to add a tenant-specific category."
        },
        "filter": {
          "search-placeholder": "Search by name or description…",
          "search-aria": "Search competencies",
          "advanced": "Show advanced settings",
          "source": {
            "label": "Source",
            "all": "All sources"
          },
          "type": {
            "label": "Type",
            "all": "All types"
          },
          "status": {
            "label": "Status",
            "all": "All statuses"
          }
        },
        "view": {
          "label": "View toggle",
          "cards": "Cards view",
          "table": "Table view"
        },
        "bulk": {
          "aria": "Bulk actions",
          "selected": "competency selected | competencies selected",
          "archive": "Archive",
          "clear": "Clear"
        },
        "source": {
          "system": "System default",
          "tenant": "Tenant custom"
        },
        "status": {
          "active": "Active",
          "draft": "Draft",
          "archived": "Archived"
        },
        "card": {
          "templates": "template | templates",
          "versions": "version | versions",
          "owner": "Governance owner",
          "updated": "Last updated"
        },
        "table": {
          "select-all": "Select all rows",
          "name": "Competency name",
          "category": "Category",
          "type": "Type",
          "levels": "Levels",
          "templates": "Linked templates",
          "templates-suffix": "template | templates",
          "status": "Status",
          "updated": "Last updated",
          "version": "Version",
          "actions": "Actions"
        },
        "empty": {
          "archived": {
            "title": "No archived competencies",
            "body": "Archived competencies appear here. None of your tenant competencies have been archived yet.",
            "cta": "Show active competencies"
          },
          "category": {
            "title": "Nothing in {label} yet",
            "body": "No competencies are tagged with this category. Create one or browse all categories from the sidebar.",
            "cta": "All competencies"
          },
          "search": {
            "title": "No results for \"{q}\"",
            "body": "Try a shorter term or check the spelling. Search looks at name and description.",
            "cta": "Clear search"
          },
          "filter": {
            "title": "No competencies match the current filter combination",
            "body": "Try clearing one or more filters to widen the result set.",
            "cta": "Clear all filters"
          }
        },
        "drawer": {
          "close": "Close drawer",
          "close-cta": "Close",
          "system-readonly": "System default (read-only)",
          "system-banner": {
            "title": "System Default",
            "body": "provided by Optimal HR as a starter. Read-only — to customise, clone to your tenant library."
          },
          "description": "Description",
          "no-desc": "No description.",
          "category": "Category",
          "type": "Competency type",
          "source-k": "Library source",
          "status": "Status",
          "owner": "Governance owner",
          "scale": "Proficiency scale",
          "version": "Active version",
          "cloned-from": "Cloned from",
          "levels": "Proficiency levels ({n})",
          "usage": "Usage mapping",
          "usage-templates": "Templates ({n})",
          "usage-departments": "Departments",
          "no-templates": "Not yet linked to any template — safe to delete",
          "all-depts": "All departments",
          "history": "Version history ({n})",
          "clone": "Clone to Tenant Library",
          "duplicate": "Duplicate",
          "archive": "Archive",
          "edit": "Edit"
        }
      },
      "goals": {
        "title": "Goals & OKRs",
        "subtitle": "Hybrid SMART + OKR · {total} goals ({smart} SMART · {okr} OKR) · {aligned} cascaded",
        "cascade": "Cascade corporate",
        "cascade-toast": "Corporate cascade drawer — coming in a follow-up slice",
        "create": "New goal",
        "create-toast": "Create goal drawer — coming in a follow-up slice",
        "checkin-toast": "Check-in drawer for {id} — coming in a follow-up slice",
        "edit-toast": "Edit drawer for {id} — coming in a follow-up slice",
        "adjust-toast": "Mid-cycle adjust drawer for {id} — coming in a follow-up slice",
        "complete": "complete",
        "result-count": "{n} goals match",
        "kpi": {
          "active": "Active goals",
          "active-sub": "{smart} SMART · {okr} OKR",
          "on-track": "On-track or achieved",
          "on-track-sub": "{achieved} achieved",
          "at-risk": "At risk or off-track",
          "at-risk-sub": "{low} low confidence",
          "avg-progress": "Avg. progress",
          "avg-progress-sub": "across all goals",
          "alignment": "Alignment coverage",
          "alignment-sub": "{aligned} cascaded"
        },
        "filter": {
          "type": {
            "label": "Type",
            "all": "All types",
            "smart": "SMART KPI only",
            "okr": "OKR only"
          },
          "status": {
            "label": "Status",
            "all": "All statuses"
          },
          "dept": {
            "label": "Dept",
            "all": "All depts"
          }
        },
        "status": {
          "not_started": "Not started",
          "on_track": "On track",
          "at_risk": "At risk",
          "off_track": "Off track",
          "achieved": "Achieved",
          "missed": "Missed"
        },
        "type-desc": {
          "smart": "Specific, Measurable, Achievable, Relevant, Time-bound. Weighted contribution to evaluation.",
          "okr": "Objective + 3-5 Key Results. Aspirational scoring (0.0-1.0 per KR, averaged)."
        },
        "col": {
          "goal": "Goal",
          "type": "Type",
          "owner": "Owner",
          "lifecycle": "Lifecycle",
          "source": "Source",
          "weight": "Weight",
          "progress": "Progress",
          "status": "Status",
          "confidence": "Confidence",
          "last-checkin": "Last check-in",
          "actions": "Actions"
        },
        "action": {
          "view": "View",
          "checkin": "Log check-in",
          "edit": "Edit",
          "adjust": "Mid-cycle adjust"
        },
        "empty": {
          "title": "No goals match your filters",
          "sub": "Try clearing one of the filters above.",
          "clear": "Clear filters"
        },
        "drawer": {
          "close": "Close drawer",
          "close-cta": "Close",
          "lifecycle": "Lifecycle",
          "step": "step {n}/10",
          "progress": "Progress",
          "status": "Status",
          "confidence": "Confidence",
          "weight": "Weight",
          "owner": "Owner",
          "source": "Source",
          "parent": "parent",
          "cycle": "Cycle",
          "last-checkin": "Last check-in",
          "alignment": "Alignment",
          "description": "Description"
        }
      },
      "reviews": {
        "title": "Review Pipeline",
        "subtitle": "H1 2026 cycle · org-wide manager review status · {total} reviews across {managers} managers · {pct}% submitted or beyond",
        "nudge": "Nudge pending managers",
        "nudge-toast": "Bulk reminder sent to all pending managers (demo)",
        "go-calibration": "Go to calibration",
        "state": {
          "not_started": "Not started",
          "self_in_progress": "Self draft",
          "self_submitted": "Self submitted",
          "manager_in_progress": "Manager review",
          "manager_submitted": "Manager submitted",
          "pending_calibration": "Pending calibration",
          "calibrated": "Calibrated",
          "acknowledged": "Acknowledged"
        },
        "filter": {
          "all": "All states",
          "pending": "Pending (manager not yet submitted)",
          "submitted": "Manager submitted",
          "complete": "Calibrated / Acknowledged"
        },
        "mgr": {
          "summary": "{dept} · {total} direct reports · {submitted} submitted",
          "submitted-pct": "{pct}% submitted",
          "nudge-toast": "Reminder sent to {name} (demo)",
          "expand": "Expand {name}",
          "collapse": "Collapse {name}",
          "nudge-aria": "Nudge {name}"
        },
        "row": {
          "employee": "Employee",
          "self-submitted": "Self submitted",
          "manager-submitted": "Manager submitted",
          "state": "State",
          "rating-self": "Self rating",
          "rating-manager": "Manager rating",
          "open": "Open",
          "open-aria": "Open review workspace for {name}",
          "open-toast": "Review workspace for {name} — coming in a follow-up slice"
        },
        "empty-filter": "No managers match this filter."
      },
      "calibration": {
        "title": "Calibration Workshop",
        "subtitle-pill": "H1 2026 · {pending} pending sign-off",
        "subtitle": "Performance × Potential · drag employees between cells or use the ⋮ menu · sign off to lock ratings and transition reviews to {calibrated}",
        "calibrated-bold": "Calibrated",
        "export-csv": "Export CSV",
        "export-pdf": "Export PDF",
        "sign-off-lock-n": "Sign off & lock ({count})",
        "sign-off-lock": "Sign off & lock ratings",
        "nudge": "Nudge flagged managers",
        "open": "Open session",
        "open-toast": "Calibration session UI — coming in a follow-up slice",
        "export-csv-toast": "Calibration CSV exported (demo)",
        "export-pdf-toast": "Calibration PDF exported (demo)",
        "sign-off-toast": "Sign-off & lock — coming in a follow-up slice",
        "nudge-toast": "Reminder sent to managers with variance flags (demo)",
        "axis": {
          "perf-low": "← Lower performance",
          "perf-solid": "Solid performance",
          "perf-high": "Higher performance →",
          "pot-high": "↑ Higher potential",
          "pot-solid": "Solid potential",
          "pot-low": "↓ Limited potential"
        },
        "cell": {
          "empty": "— empty —",
          "1A": "Diamond in the Rough",
          "2A": "Future Star",
          "3A": "Star",
          "1B": "Inconsistent Player",
          "2B": "Core Player",
          "3B": "Key Contributor",
          "1C": "Concern",
          "2C": "Solid Performer",
          "3C": "Specialist",
          "1A-desc": "Strong potential but performance not yet there. Coach hard.",
          "2A-desc": "Solid performance with high potential. One step from Star.",
          "3A-desc": "High performance and high potential. Top talent.",
          "1B-desc": "Solid potential, low performance. Investigate.",
          "2B-desc": "Reliable solid contributor. The backbone.",
          "3B-desc": "High performer in current role. Solid potential.",
          "1C-desc": "Low performance and limited potential. Difficult.",
          "2C-desc": "Meets bar reliably. Limited room to grow.",
          "3C-desc": "High performance, niche expert. Limited mobility."
        },
        "legend": {
          "variance": "Self ≠ Manager rating (variance)",
          "promo": "Promotion recommended",
          "menu": "Click for move menu"
        },
        "card-menu": {
          "title": "Move \"{name}\" to",
          "current": "(current)",
          "detail": "Calibration detail (notes · history)",
          "open-workspace": "Open review workspace"
        },
        "side": {
          "session": {
            "title": "Session overview",
            "in-matrix": "In matrix",
            "pending": "Pending sign-off",
            "locked": "Already locked",
            "variance": "Variance flags"
          },
          "dist": {
            "title": "Distribution health",
            "sub": "Target vs Actual",
            "lede": "Black tick marks the target. Wide variance = forced distribution drift.",
            "foot": "Target = recommended forced distribution. ±8% is within healthy range; beyond that, calibration drift is likely."
          },
          "variance": {
            "title": "Variance resolution",
            "flagged": "{count} flagged",
            "empty": "No managers exceed the ±0.50 variance threshold. Distribution is healthy.",
            "over": "Over-rates",
            "under": "Under-rates",
            "row": "{dir} by {amount} (avg {avg} vs org 3.55) · {n} reviews submitted"
          },
          "lock": {
            "title": "Sign-off lock",
            "body": "When you sign off, the rating_manager becomes the final rating for all pending reviews, the template version used is frozen, and employees are notified to acknowledge. Future template edits will not retroactively change these reviews."
          }
        },
        "footer": {
          "summary": "{reviews-bold} ready for sign-off · {flags-bold} to resolve · once locked, ratings are final",
          "reviews-one": "1 review",
          "reviews-other": "{count} reviews",
          "flags-one": "1 variance flag",
          "flags-other": "{count} variance flags"
        }
      },
      "devplans": {
        "title": "Development Plans",
        "subtitle": "{total} active plans · {pending} pending approval · {approved} approved",
        "push": "Push approved to L&D",
        "push-toast": "L&D module integration coming · push to L&D will activate when L&D is built",
        "bulk": "Bulk approve",
        "bulk-toast": "Bulk approve workflow (demo)",
        "approve-toast": "Plan {id} approved (demo)",
        "lnd-toast": "Sent to L&D module (demo · L&D not yet built)",
        "col": {
          "id": "Plan ID",
          "employee": "Employee",
          "dept": "Dept",
          "area": "Growth area",
          "action": "Recommended action",
          "status": "Status",
          "owner": "Owner",
          "actions": "Actions"
        },
        "action": {
          "view": "View",
          "approve": "Approve",
          "lnd": "L&D"
        },
        "status": {
          "Active": "Active",
          "In review": "In review",
          "Approved": "Approved",
          "Pending": "Pending"
        },
        "drawer": {
          "title": "{id} — {emp}",
          "sub": "{dept} · plan owner: {owner} · status: {status}",
          "close-label": "Close drawer",
          "employee": "Employee",
          "department": "Department",
          "area": "Growth area",
          "action": "Recommended action",
          "owner": "Owner (LM)",
          "status": "Status",
          "milestones": "Milestones (demo)",
          "milestone-1": "Q2 2026 · Complete foundational training course (4 weeks)",
          "milestone-2": "Q3 2026 · First check-in with HR Director · review measurable signs of improvement",
          "milestone-3": "Q4 2026 · Mid-year evaluation reassessment · adjust plan if needed",
          "lnd-linkage": "L&D linkage",
          "lnd-body": "When this plan is approved and pushed to L&D, the recommended courses become enrolment items for the employee in the L&D module. Completion data flows back into the Performance evidence base for next cycle.",
          "close-cta": "Close",
          "send-cta": "Send to L&D",
          "send-toast": "Sent to L&D (demo)",
          "approve-cta": "Approve plan",
          "approve-toast": "Plan approved (demo)"
        }
      },
      "reports": {
        "title": "Reports & Analytics",
        "subtitle": "{count} standard reports · click any card for a preview",
        "custom": "Custom report",
        "custom-toast": "Custom report builder — enterprise capabilities",
        "export": "Export all",
        "export-toast": "Export all to Excel (demo)",
        "preview": "Preview →",
        "preview-toast": "Report drawer — coming in a follow-up slice",
        "items": {
          "R1": {
            "title": "Performance Summary Report",
            "desc": "Org-wide rating distribution, cycle progress, completion rate, average scores by template.",
            "period": "Auto-refresh from current cycle"
          },
          "R2": {
            "title": "Rating Distribution Report",
            "desc": "Bell-curve by department · manager · grade. Year-over-year shift. Detect grading drift.",
            "period": "Latest closed cycle"
          },
          "R3": {
            "title": "Department Performance Report",
            "desc": "Rank departments by average rating, KPI achievement, goal completion, attendance score.",
            "period": "Current cycle"
          },
          "R4": {
            "title": "Calibration Summary",
            "desc": "Pre vs post calibration shifts, adjustments by HR, departments with most variance.",
            "period": "After calibration closes"
          },
          "R5": {
            "title": "Top Talent Report",
            "desc": "Employees rated Outstanding for 2+ consecutive cycles. Promotion candidates with succession data.",
            "period": "Rolling 3 cycles"
          },
          "R6": {
            "title": "Low Performer Tracking",
            "desc": "Below-expectation employees, root cause, development plan status, time-to-improve, exit risk score.",
            "period": "Rolling 2 cycles"
          },
          "R7": {
            "title": "Development Plan Tracking",
            "desc": "All active plans, completion %, training assigned, follow-up date, manager comments.",
            "period": "Cycle to date"
          }
        }
      },
      "settings": {
        "title": "Performance module settings",
        "subtitle": "Configure rating scale · workflow · reminders · approval · integration toggles",
        "edit": "Edit",
        "restore": "Restore defaults",
        "save": "Save all",
        "restore-toast": "Restore defaults (demo)",
        "save-toast": "Settings saved (demo)",
        "edit-toast": "Editor drawer — coming in a follow-up slice",
        "toggle-toast": "Toggled (demo) — persists in a follow-up slice",
        "groups": {
          "workflow": "Rating & Workflow",
          "calibration": "Calibration",
          "reminders": "Reminders & Notifications",
          "integrations": "Integrations"
        },
        "items": {
          "rating-scale": {
            "title": "Rating scale",
            "desc": "Levels used across all evaluation forms",
            "value": "5-level (Outstanding → Unsatisfactory)"
          },
          "cycle-cadence": {
            "title": "Default cycle cadence",
            "desc": "How often new performance cycles open",
            "value": "Half-yearly (H1 / H2)"
          },
          "self-review": {
            "title": "Require self-review",
            "desc": "Employees must submit before manager opens",
            "value": "On"
          },
          "peer-360": {
            "title": "Enable 360 feedback",
            "desc": "Optional peer/subordinate feedback",
            "value": "Off"
          },
          "calib-required": {
            "title": "Calibration required",
            "desc": "HR calibration before final rating is locked",
            "value": "On"
          },
          "forced-dist": {
            "title": "Forced distribution",
            "desc": "Cap % of Outstanding/Exceeds per department",
            "value": "Off (recommended)"
          },
          "calib-quorum": {
            "title": "Calibration quorum",
            "desc": "Min participants for a department to calibrate",
            "value": "5 employees"
          },
          "reminder-self": {
            "title": "Self-review reminders",
            "desc": "Email/in-app reminders before deadline",
            "value": "7 days · 2 days · same day"
          },
          "reminder-mgr": {
            "title": "Manager review reminders",
            "desc": "Sent to LMs with pending reviews",
            "value": "5 days · 1 day · daily after due"
          },
          "escalate-overdue": {
            "title": "Escalate overdue reviews",
            "desc": "Notify next manager up after deadline",
            "value": "+3 days"
          },
          "pull-wm": {
            "title": "Pull from Work Mgmt",
            "desc": "Auto-attach operational evidence to forms",
            "value": "On"
          },
          "pull-hrops": {
            "title": "Pull from HR Ops",
            "desc": "Attendance, leave, OT context in forms",
            "value": "On"
          },
          "push-payroll": {
            "title": "Push reward to Payroll",
            "desc": "Send approved bonus/increment to Payroll",
            "value": "On (advisory; Payroll Admin confirms)"
          },
          "push-lnd": {
            "title": "Push to L&D",
            "desc": "Send approved dev plans/training to L&D",
            "value": "Off (L&D module not yet active)"
          }
        }
      },
      "subtitle-suffix": "performance"
    },
    "billing": {
      "title": "Billing",
      "subtitle": "{company} · provider recharge",
      "period-label": "Billing period",
      "no-access": "You do not have access to Billing.",
      "not-recharged": "not recharged",
      "reconciled": "Reconciled",
      "direct-notice": "Direct workforce is internal company cost and is {strong}. Switch to a Client or Project scope to view recharge.",
      "dashboard-empty": "No recharge runs for this scope + period yet.",
      "runs-direct-notice": "Direct workforce is internal company cost and is {strong}.",
      "runs-empty": "No recharge runs for this scope + period.",
      "recon-direct-notice": "Direct workforce is not recharged — nothing to reconcile.",
      "tabs": {
        "dashboard": "Dashboard",
        "runs": "Recharge Runs",
        "recon": "Reconciliation",
        "agreements": "Agreements"
      },
      "kpi": {
        "total-recharge": "Total Recharge",
        "cost-base": "Cost Base",
        "margin-fee": "Margin / Fee",
        "runs": "Recharge Runs",
        "employees-billed": "Employees Billed",
        "reconciled": "Reconciled",
        "with-variance": "With Variance",
        "period": "Period"
      },
      "runs": {
        "col-run-id": "Run ID",
        "col-client-project": "Client › Project",
        "col-method": "Method",
        "col-emp": "Emp",
        "col-cost-base": "Cost Base",
        "col-margin": "Margin",
        "col-total": "Total Recharge",
        "col-recon": "Reconciliation",
        "heading": "Recharge Runs",
        "count": "{n} run(s)"
      },
      "recon": {
        "runs-reconciled": "Runs Reconciled",
        "total-variance": "Total Variance",
        "col-run": "Run",
        "col-project": "Project",
        "col-payroll-cost": "PayrollRun Cost",
        "col-billed-base": "Billed Base",
        "col-variance": "Variance",
        "col-status": "Status",
        "heading": "Reconciliation"
      },
      "detail": {
        "back": "Back",
        "back-to-runs": "Back to Runs",
        "not-found": "Run not found.",
        "service-fee": "Service Fee",
        "pass-through": "Pass-Through",
        "margin": "Margin",
        "lines-heading": "Recharge lines",
        "no-lines": "No recharge lines.",
        "col-employee": "Employee",
        "col-cost": "Cost",
        "col-fee": "Fee",
        "col-pass-through": "Pass-Through",
        "col-line-total": "Line Total",
        "recon-heading": "Reconciliation",
        "payroll-employer-cost": "PayrollRun employerCost",
        "billed-cost-base": "Billed cost base",
        "variance": "Variance",
        "sources-heading": "Source PayrollRuns",
        "sources-note": "RechargeRun originates from PayrollRun · ADV excluded from cost · FIN = full-month cost.",
        "advance-excluded": "advance (excluded from cost)",
        "cost-amount": "{amount} cost"
      },
      "loading": "Loading billing…",
      "load-error": "Billing data could not be loaded.",
      "retry": "Retry",
      "dashboard-empty-owner": "Use {strong} above.",
      "dashboard-empty-readonly": "Recharge is generated by the commercial owner at the provider company root — this scope is a collaborative, read-only view.",
      "scope": {
        "all": "All Scopes",
        "direct": "{company} (Direct)"
      },
      "method": {
        "cost": "Cost + Fee",
        "lump": "Lump Sum"
      },
      "status": {
        "reconciled": "reconciled",
        "issued": "Issued",
        "handed": "Handed to Finance"
      },
      "gen": {
        "button": "Generate Recharge",
        "disabled-title": "Generated by the commercial owner at the provider company root"
      },
      "dashboard": {
        "heading": "Billing Dashboard",
        "view-runs": "View Recharge Runs"
      },
      "panel": {
        "heading": "Commercial owner · operate",
        "project": "Project",
        "agreements": "Commercial Agreements",
        "note": "Single commercial owner: recharge is generated here at the provider company root for the selected billing period. Client and project scopes review the results."
      },
      "lifecycle": {
        "issue": "Issue Invoice",
        "handoff": "Hand to Finance",
        "invoice-chip": "Invoice {no}",
        "issued-line": "Issued {at} by {by} · Billing terminal state (PO D2)",
        "locked": "Locked",
        "handed-line": "{no} · {at} by {by}",
        "handoff-note": "Formal domain handoff: the billing record is locked, the commercial agreement and payroll source are frozen as snapshots, and responsibility is transferred to Finance. Billing does not manage accounts receivable or collections.",
        "agreement-snapshot": "Agreement snapshot: {id} · effective {date}",
        "payroll-snapshot": "Payroll snapshot: {ids} · checksum {checksum}"
      },
      "agreements": {
        "heading": "Commercial Agreements",
        "sub": "Effective-dated pricing & recharge rules per client project · versions are immutable so Billing can always reproduce a historical invoice (PO D1)",
        "form-heading": "New agreement version",
        "form-hint": "(versions are immutable — a change = a new effective-dated version; PO D1)",
        "project": "Project",
        "effective": "Effective from",
        "method": "Method",
        "fee-type": "Fee type (Cost+Fee)",
        "fee-percentage": "Percentage of cost",
        "fee-per-head": "Per head",
        "fee-flat": "Flat per period",
        "fee-value": "Fee value",
        "fee-placeholder": "e.g. 15",
        "currency": "Currency",
        "lump-basis": "Lump-sum basis",
        "lump-per-head": "Per head",
        "lump-flat": "Flat",
        "lump-amount": "Lump-sum amount",
        "pass-through": "Pass-through components",
        "pass-through-hint": "(from the Payroll component catalog — no duplicated payroll logic)",
        "catalog-unavailable": "Payroll component catalog unavailable",
        "save": "Save new version",
        "read-only": "Commercial agreements are authored by the commercial owner at the provider company root — read-only here.",
        "empty": "No commercial agreements yet.",
        "current": "current",
        "col-version": "Version",
        "col-effective": "Effective from",
        "col-method": "Method",
        "col-pricing": "Pricing",
        "col-pass-through": "Pass-through",
        "col-cur": "Cur"
      },
      "toast": {
        "generated": "Recharge generated for {client} › {project}",
        "issued": "Invoice {no} issued for {id} — Billing terminal state. Use “Hand to Finance” to transfer ownership.",
        "handed": "{no} handed to Finance — record locked; agreement + payroll snapshots frozen.",
        "agreement-saved": "Agreement version saved · {project} effective {date}"
      },
      "error": {
        "refused-generate": "Recharge is generated by the commercial owner at the provider company root — client and project scopes are collaborative, read-only views.",
        "refused-issue": "Invoice issuance belong to the commercial owner at the provider company root — this scope is a collaborative, read-only view.",
        "refused-handoff": "The Finance handoff belong to the commercial owner at the provider company root — this scope is a collaborative, read-only view.",
        "refused-agreement": "Commercial agreements belong to the commercial owner at the provider company root — this scope is a collaborative, read-only view.",
        "pick-project": "Pick a project in the Generate panel",
        "already-exists": "Recharge already exists for this project + period",
        "no-payroll": "No payroll data to recharge for this project + period",
        "no-agreement": "No commercial agreement is effective for {projectId} in this period — save an agreement version in Commercial Agreements first.",
        "run-not-found": "Run not found",
        "locked": "This run was handed to Finance — it is locked and immutable.",
        "not-reconciled": "Only reconciled runs can be issued (current status: {status}).",
        "variance": "Resolve the reconciliation variance before issuing this invoice.",
        "already-handed": "Already handed to Finance.",
        "not-issued": "Only issued invoices can be handed to Finance (current status: {status}).",
        "project-required": "Project is required",
        "effective-required": "Effective-from date is required",
        "duplicate-version": "An agreement version for this project already starts on {date} — pick a different effective date.",
        "generic": "Something went wrong — please try again."
      }
    },
    "insights": {
      "title": "Insights",
      "subtitle": "Reports & Analytics · across all modules",
      "toast-open": "Open {name}",
      "tiles": {
        "headcount": {
          "title": "Headcount",
          "desc": "Direct · Outsourced · External"
        },
        "turnover": {
          "title": "Turnover",
          "desc": "Voluntary, involuntary, per project"
        },
        "attendance": {
          "title": "Attendance",
          "desc": "Present, late, absent, OT"
        },
        "payroll-cost": {
          "title": "Payroll cost",
          "desc": "Gross, net, taxes, allowances"
        },
        "project-profitability": {
          "title": "Project profitability",
          "desc": "Bill rate vs cost, margin"
        },
        "compliance": {
          "title": "Compliance",
          "desc": "Contracts expiring, NSSF, TOS filings"
        }
      }
    },
    "ownKit": {
      "crumb": {
        "label": "Drill-down path"
      },
      "filter": {
        "period": "Pay period",
        "all-periods": "All periods",
        "type": "Type",
        "all-types": "All types",
        "type-adv": "Advance",
        "type-fin": "Final",
        "type-off": "Off-cycle",
        "published-only": "Published runs only"
      },
      "quick": {
        "label": "Quick filters",
        "all": "All",
        "attention": "Needs Attention",
        "payroll-ready": "Payroll Ready",
        "locked": "Locked",
        "ready": "Ready",
        "inflight": "In-flight"
      },
      "portfolio": {
        "label": "Oversight portfolio",
        "lead": "Oversight view · counts only.",
        "banner": "Operations happen at the owning scope; published records are record-level below; in-flight work rolls up as counts.",
        "empty": "No published records in this scope yet."
      }
    },
    "moreapps": {
      "title": "More Apps",
      "subtitle": "Ecosystem launcher · workforce platform expansion",
      "section-live": "Available now",
      "section-future": "Coming to the platform",
      "tag-live": "Live",
      "tag-soon": "Soon",
      "title-open": "Open {name}",
      "toasts": {
        "coming-soon": "{name} — coming soon"
      },
      "live": {
        "stock": {
          "label": "Stock Mgmt",
          "desc": "FMCG inventory · multi-warehouse · batch/expiry · replenishment"
        },
        "lnd": {
          "label": "L&D",
          "desc": "Learning & Development · courses · capability matrix · certifications"
        },
        "admin": {
          "label": "Admin",
          "desc": "Tenant configuration · users · roles · master data · policies · platform"
        }
      },
      "future": {
        "recruitment": "Recruitment",
        "benefits": "Benefits",
        "ai-assistant": "AI Assistant",
        "survey": "Survey",
        "asset-mgmt": "Asset Mgmt",
        "compliance-center": "Compliance Center"
      }
    },
    "fieldops": {
      "shared": {
        "status": {
          "completed": "Completed",
          "missed": "Missed",
          "inprogress": "In Progress",
          "scheduled": "Scheduled",
          "planned": "Planned",
          "cancelled": "Cancelled"
        },
        "flag": {
          "flagged": "⚑ Flagged",
          "critical": " · critical"
        },
        "pager": {
          "summary": "{n} row · page {page} / {pages} | {n} rows · page {page} / {pages}",
          "prev": "‹ Prev",
          "next": "Next ›",
          "label": "Pagination"
        },
        "breadcrumb": {
          "label": "Breadcrumb"
        },
        "lifecycle": {
          "label": "Lifecycle progress"
        }
      },
      "title": "Field Ops",
      "kind": {
        "sup": "Field Operations",
        "oversight": "Management Oversight",
        "admin": "Configuration & Audit"
      },
      "subtitle": "{project} · {kind}",
      "portfolio": {
        "company": "{name} · Portfolio (by client)",
        "client": "{name} · Portfolio (by project)",
        "scope-company": "Company scope",
        "scope-client": "Client scope",
        "mode": "Aggregate portfolio view — counts only",
        "hint-company": "Grouped by client; select a client to drill into its projects. Record-level visits live at project scope under the existing access model.",
        "hint-client": "Grouped by this client's projects; each project's information stays separated. Open a project for the operational experience.",
        "kind-company": "Company portfolio",
        "kind-client": "Client portfolio",
        "period-label": "Portfolio period",
        "all-periods": "All periods",
        "reset": "Reset",
        "col": {
          "client": "Client",
          "projects": "Projects",
          "active": "Active PJPs",
          "inpr": "In progress",
          "done": "Completed",
          "miss": "Missed",
          "flag": "Flagged",
          "completion": "Completion",
          "coverage": "Coverage",
          "project": "Project",
          "pjp-status": "PJP status",
          "planned": "Planned",
          "outcomes": "Close outcomes",
          "actions": "Actions"
        },
        "open-client": "Open client →",
        "open-client-aria": "Open client {name}",
        "view": "View",
        "view-aria": "View client {name}",
        "open-project": "Open project →",
        "open-project-aria": "Open project {name}",
        "no-activity": "No Field Ops activity yet",
        "status-none": "no PJPs",
        "status-active": "{n} active",
        "status-pending": "{n} pending approval",
        "outcomes": "{met} met plan · {part} partially",
        "empty-company": "No active clients.",
        "empty-client": "No projects under this client.",
        "unav": "Operating Calendar (aggregated, read-only): {n} upcoming outlet-unavailability period across the portfolio — details live at project scope. | Operating Calendar (aggregated, read-only): {n} upcoming outlet-unavailability periods across the portfolio — details live at project scope.",
        "own-ops": "Own operations (direct sites): {n} field visits — switch the scope selector to {scope} for the record-level view.",
        "direct-workforce": "Direct Workforce",
        "isolation-company": "Data isolation follows the existing ownership framework — a client's records are never mixed into another client's view.",
        "isolation-client": "Record-level PJP and visit information belongs at project scope, under the acting user's approved role and access."
      },
      "today-label": "{date} · {tz}",
      "tabs-label": "Field Ops sections",
      "subtabs-label": "{tab} views",
      "tabs": {
        "cc": "Command Center",
        "plan": "Plan",
        "exec": "Execute",
        "actions": "Actions",
        "insights": "Execution Insights",
        "config": "Configuration",
        "vtpl": "Visit Templates",
        "cal": "Operating Calendar",
        "audit": "Audit"
      },
      "subtabs": {
        "sup": {
          "exec": {
            "today": "Today",
            "week": "Week",
            "history": "History"
          },
          "plan": {
            "detail": "Plan Detail"
          }
        },
        "rsm": {
          "plan": {
            "queue": "Approval Queue",
            "reg": "Regional PJP Register",
            "ready": "Planning Readiness"
          },
          "exec": {
            "cov": "Regional Execution",
            "exc": "Exceptions",
            "recs": "Visit Records",
            "md": "Manager-Directed",
            "load": "Supervisor Workload"
          }
        },
        "hrbp": {
          "plan": {
            "comp": "Planning Compliance",
            "work": "Supervisor Workload",
            "ready": "Overdue Planning"
          },
          "exec": {
            "cov": "Coverage",
            "exc": "Exception Indicators",
            "load": "Supervisor Workload"
          }
        },
        "gov": {
          "exec": {
            "cov": "Coverage",
            "exc": "Exceptions"
          }
        }
      },
      "actor": {
        "tag": "ACTING AS · DEMO",
        "aria": "Acting as {name}, {sub}. Change the demo persona.",
        "menu-label": "Demo personas",
        "groups": {
          "system": "System access",
          "governance": "Governance & oversight",
          "regional": "Regional operations"
        },
        "unassigned": "Unassigned line",
        "note": "Acting-as is a demo stand-in for SSO — the actor list and every permission are derived from live reporting relationships, never fixed codes. Grouping and indentation are for demo comprehension only. System Administrator is a system-access role, not the organizational manager of the roles below; governance roles sit outside the RSM reporting tree.",
        "sub": {
          "sup": "Sales Supervisor · {region}",
          "rsm": "RSM (external) · {region}",
          "hrbp": "HRBP · Optimal P oversight",
          "champion": "Project Champion (external, read-only)",
          "leader": "Project Leader (external, read-only)",
          "admin": "HR admin · configuration + audit"
        },
        "switch-failed": "The demo persona could not be changed."
      },
      "reset": {
        "button": "Reset Field Ops demo data",
        "title": "Restore the deterministic Field Ops demo baseline",
        "ask": "Reset all Field Ops demo data to the baseline?",
        "keep": "Keep",
        "go": "Reset demo data",
        "flash": "Field Ops demo data reset to the deterministic baseline.",
        "failed": "The Field Ops demo data could not be reset."
      },
      "panel": {
        "placeholder-title": "{view}",
        "placeholder-body": "This view is being built — it arrives in a following Field Ops release.",
        "portfolio-company": "Company portfolio",
        "portfolio-client": "Client portfolio",
        "legacy": "This project has no outlets yet, so the Field Ops operational workspace does not apply. Add outlets to the project in Site Master to plan journey plans and visits."
      },
      "state": {
        "loading": "Loading Field Ops…",
        "error": "Field Ops data could not be loaded.",
        "retry": "Retry",
        "not-found": "This project was not found."
      },
      "exec": {
        "mode": {
          "label": "Display mode",
          "list": "List",
          "map": "Map",
          "my-route": "My route · {date}",
          "regional": "Regional execution",
          "coverage": "Coverage",
          "map-title": "Route map"
        },
        "origin": {
          "label": "Manager-Directed",
          "title": "Origin: Manager-Directed/Ad Hoc — directed by the line manager; not part of the monthly PJP"
        },
        "kpi": {
          "today-stops": "Today's stops",
          "planned-route": "planned route",
          "completed-today": "Completed today",
          "of": "of {n}",
          "month-completion": "Month completion",
          "due-sub": "{done} / {due} due",
          "open-fu": "Open follow-ups",
          "overdue-sub": "{n} overdue",
          "coverage": "Coverage",
          "outlets-sub": "{visited} / {total} outlets",
          "completion": "Completion",
          "missed": "Missed",
          "count": "count",
          "flagged": "Flagged",
          "critical-sub": "{n} critical",
          "in-population": "in filtered population",
          "flagged-completed": "Flagged (completed)"
        },
        "today": {
          "open-field": "Open field mode (mobile)",
          "check-in": "Check in",
          "continue": "Continue checklist →",
          "empty": "No visits on today's route. Check the weekly calendar or generate this week from your published PJP.",
          "promoter": "Promoter: {name}",
          "combined": "Combined",
          "combined-title": "One physical visit fulfils the Manager-Directed requirement AND the eligible PJP occurrence ({id})",
          "linked": "linked to Combined Visit {id}",
          "linked-title": "A Combined Visit ({id}) covers this PJP occurrence — completing it there fulfils this obligation once; no duplicate credit",
          "overlap": "{n} overlapping task deduplicated | {n} overlapping tasks deduplicated"
        },
        "cycle": {
          "title": "Visit Cycle progress · {period}",
          "sub": "live execution status of your approved PJP — planning changes stay in the builder / amendments",
          "in-progress": "Visit Cycle {k} in progress · {done}/{elig}",
          "all-complete": "All Visit Cycles complete",
          "name": "Visit Cycle {k}",
          "outlets": "{done}/{elig} outlet | {done}/{elig} outlets",
          "complete": " · complete",
          "remaining": " · {n} remaining",
          "not-due": " · not due yet",
          "next": "Next required visit:",
          "due": "due {date}"
        },
        "week": {
          "label": "Week",
          "w": "W{n}",
          "generate": "Generate week {n} from PJP",
          "report": "Report outlet unavailability",
          "today": " · today",
          "schedule": "Schedule",
          "reschedule": "Reschedule",
          "reschedule-of": "Reschedule {name}",
          "new-date": "New date",
          "reason": "Reason",
          "move": "Move",
          "cancel": "Cancel reschedule",
          "empty": "No visits generated for week {n} yet",
          "empty-gen": " — use “Generate week”.",
          "empty-nopjp": " (PJP not approved yet).",
          "generated": "{n} visit generated for week {w} | {n} visits generated for week {w}"
        },
        "filter": {
          "search": "Search outlet / person / id",
          "all-regions": "All regions",
          "all-rsms": "All RSMs",
          "all-sups": "All supervisors",
          "all-provinces": "All provinces",
          "all-outlets": "All outlets",
          "all-statuses": "All statuses",
          "from": "From date",
          "to": "To date",
          "clear": "Clear",
          "clear-one": "Clear {field}",
          "field": {
            "q": "search",
            "region": "region",
            "rsm": "RSM",
            "sup": "supervisor",
            "province": "province",
            "outlet": "outlet",
            "status": "status",
            "from": "from",
            "to": "to"
          }
        },
        "status": {
          "planned": "Planned",
          "scheduled": "Scheduled",
          "inprogress": "In Progress",
          "completed": "Completed",
          "flagged": "Completed — Flagged",
          "missed": "Missed",
          "cancelled": "Cancelled"
        },
        "cols": {
          "id": "ID",
          "outlet": "Outlet",
          "supervisor": "Supervisor",
          "promoter": "Promoter",
          "planned": "Planned",
          "status": "Status",
          "score": "Score"
        },
        "table": {
          "empty": "No visits match."
        },
        "mgmt": {
          "period": "Period",
          "execution": " · execution",
          "planning": " · planning",
          "all-periods": "All periods",
          "all": "{label} (all)",
          "locked": "Locked to your authorized scope",
          "all-exc": "All exception types",
          "exc": {
            "missed": "Missed",
            "flagged": "Flagged (completed)",
            "critical": "Critical flags",
            "overdue": "Overdue follow-ups"
          },
          "chip": {
            "period": "period",
            "region": "region",
            "rsm": "rsm",
            "sup": "sup",
            "province": "province",
            "dt": "dt",
            "exc": "exc"
          },
          "clear": "Clear",
          "reset": "Reset Filters",
          "dim": {
            "region": "Region",
            "rsm": "RSM",
            "sup": "Supervisor",
            "province": "Province",
            "dt": "DT"
          },
          "by": "By {dim}",
          "by-dt": "By DT",
          "drill-hint": "click a row to drill down",
          "drill-row": "{name} — drill down",
          "no-data": "No data in the filtered population.",
          "col": {
            "outlets": "Outlets",
            "visited": "Visited",
            "coverage": "Coverage",
            "completion": "Completion",
            "missed": "Missed",
            "flagged": "Flagged",
            "critical": "Critical",
            "open-fu": "Open FU",
            "overdue-fu": "Overdue FU"
          },
          "hrbp-note": "Workforce & supervisor coverage — drill through project → region → RSM → supervisor → province/DT. Aggregates only; no visit transactions."
        },
        "exc": {
          "missed-title": "Missed visits — record level (your region)",
          "flagged-title": "Completed — Flagged (published records)",
          "overdue-title": "Overdue follow-ups",
          "overdue-row": "· owner {owner} · due {due}",
          "none": "None."
        },
        "recs": {
          "note": "Authorized record-level visits across your region (D2-107 publication rules unchanged)."
        },
        "load": {
          "note": "Supervisor workload vs plan capacity — current period {period}.",
          "col": {
            "supervisor": "Supervisor",
            "region": "Region",
            "outlets": "Outlets",
            "planned": "Planned visits",
            "capacity": "Capacity",
            "utilisation": "Utilisation",
            "peak": "Peak day"
          },
          "no-plan": "no approved plan this period",
          "empty": "No supervisors in scope."
        },
        "months": {
          "1": "January",
          "2": "February",
          "3": "March",
          "4": "April",
          "5": "May",
          "6": "June",
          "7": "July",
          "8": "August",
          "9": "September",
          "10": "October",
          "11": "November",
          "12": "December"
        }
      },
      "rsm": {
        "more": "more",
        "cycle": "Cycle {k}",
        "weekly": "Weekly workload:",
        "clustering": "Geographic clustering:",
        "state": {
          "loading": "Loading the approval queue…",
          "error": "The approval queue could not be loaded.",
          "loading-review": "Loading the plan review…",
          "error-review": "The plan review could not be loaded."
        },
        "queue": {
          "note": "You approve the {plan}, not individual visits. Approval publishes the plan atomically — it becomes operational at once; future visit dates are kept. Your access covers your regional supervisors only.",
          "plan": "plan",
          "meta": "{id} · rev {rev} · {outlets} outlets · est. {est} calendar-based visits · submitted {at}",
          "review": "Review Plan",
          "hide": "Hide review",
          "empty": "No submitted plans awaiting your approval.",
          "amendments": "Amendment requests"
        },
        "sla": {
          "approval": "Approval",
          "decision": "Decision",
          "state": {
            "ok": "On track",
            "reminder": "Due soon",
            "urgent": "Urgent — due today",
            "breached": "Overdue",
            "escalated": "Escalated",
            "met": "Met",
            "met-late": "Met late",
            "met-offline": "Met · offline synced"
          },
          "wd": "{n} WD",
          "by": "by {date}",
          "sync": "sync pending",
          "paused": "paused (approved leave)",
          "policy": "policy {ref}",
          "capped": "target capped",
          "legacy": "legacy record"
        },
        "life": {
          "draft": "Draft",
          "submitted": "Submitted",
          "approved": "Approved & Published",
          "owner-rsm": "RSM · {name}",
          "owner-sup": "Supervisor · {name}",
          "next": {
            "draft": "Submit to RSM",
            "returned": "Revise & resubmit (rev {rev})",
            "submitted": "RSM decision — Approve & Publish or Return for Revision",
            "approved-published": "Generate weeks & execute · changes via Amendment Request",
            "cancelled": "None — plan cancelled",
            "archived": "None — archived"
          },
          "returned": "Returned for Revision · rev {rev}",
          "cancelled": "Cancelled",
          "amendment": "Amendment {status} · {id}",
          "amend-status": {
            "requested": "requested",
            "approved": "approved",
            "rejected": "rejected"
          },
          "stage": "Stage:",
          "rev": "rev {rev}",
          "owner": "Owner:",
          "next-label": "Next action:",
          "history": "Lifecycle & revision history ({n} events)"
        },
        "review": {
          "period": "planning period",
          "rev": "rev {rev}",
          "sup-note": "Supervisor note:",
          "no-note": "No submission note provided.",
          "kpi": {
            "planned": "Planned visits",
            "coverage": "Outlet coverage",
            "gaps": "Coverage gaps",
            "remaining": "Remaining capacity"
          },
          "target": "target {n}",
          "below": "{n} below target",
          "above": "{n} above target",
          "target-met": "target met",
          "balanced": "balanced across {n} working days",
          "coverage-sub": "{n} of {of} assigned outlets",
          "gaps-some": "outlets NOT in this plan",
          "gaps-none": "all assigned outlets planned",
          "slots": "of {n} summed slots across {days} visit days",
          "date-overrides": "{n} date override | {n} date overrides",
          "shortfall": "Monthly target shortfall: {n} visit. | Monthly target shortfall: {n} visits.",
          "sup-explanation": "Supervisor explanation: “{reason}”",
          "no-explanation": "No explanation was recorded — return this plan for revision.",
          "overload": "Overload:",
          "overload-rest": "exceed the applicable date capacity.",
          "unsched": "Not schedulable within capacity ({n}):",
          "override": "Supervisor capacity override on record",
          "override-weigh": "Weigh this before deciding.",
          "gaps-title": "Coverage gaps:",
          "views": "Review submitted PJP",
          "view": {
            "summary": "Summary",
            "calendar": "Calendar",
            "map": "Map"
          },
          "readonly": "Visual review is read-only; approval rules are unchanged.",
          "daily": "Daily workload — default capacity",
          "per-day": "visits/day",
          "date-specific": "date-specific override | date-specific overrides",
          "tip": "{n} of {cap}",
          "tip-override": "date override",
          "tip-over": "OVERLOAD +{n}",
          "tip-left": "{n} remaining",
          "daycap": "Date-specific capacity:",
          "per-day-n": "{n}/day",
          "daycap-star": "(* in the workload strip)",
          "clustering": "same province · DT outlets share days where capacity allows (hover a day for its mix).",
          "commit": "Visit-cycle commitment:",
          "commit-body": "the table below is the supervisor's exact submitted cycle membership and proposed dates. Planned/month is calculated from the cycles containing each outlet — it is not a separate frequency setting.",
          "col": {
            "outlet": "Outlet",
            "promoter": "Promoter",
            "province": "Province",
            "dt": "DT",
            "planned": "Planned / month",
            "cycles": "Visit Cycle assignments",
            "visits": "Visits"
          }
        },
        "decide": {
          "approve": "Approve & Publish…",
          "return": "Return for Revision…",
          "approve-label": "Confirm approval",
          "approve-title": "Confirm approval.",
          "approve-body": "Approve & Publish is atomic — the plan becomes operational at once and this month's visit schedule is generated as reviewed above",
          "approve-override": "; note the supervisor's capacity override on record",
          "approve-ph": "Approval note (optional)",
          "confirm-approve": "Confirm — Approve & Publish",
          "cancel": "Cancel",
          "return-label": "Return for revision",
          "return-title": "Return this plan for revision.",
          "return-body": "A reason is required — it is shown to the supervisor and recorded in the plan audit trail.",
          "return-ph": "Return reason (required)",
          "confirm-return": "Confirm — Return for Revision",
          "err-reason": "A return reason is required — the supervisor must know what to revise.",
          "flash-approved": "Plan {id} approved & published — it is now operational for {period}.",
          "flash-returned": "Plan {id} returned for revision — the supervisor sees your reason.",
          "toast-approved": "✓ PJP approved & published",
          "toast-returned": "PJP returned for revision",
          "failed": "The decision could not be saved."
        },
        "amend": {
          "rev": "Revision {from} → {to}",
          "effective": "effective {date}",
          "requested": "requested {at}",
          "reason": "Reason:",
          "changes": "Requested changes ({n}):",
          "add": "add to plan",
          "at": "at {freq}",
          "remove": "remove from plan",
          "current": "(current {freq})",
          "impact": "Schedule impact (balanced generator):",
          "before": "before",
          "after": "after",
          "visits": "visits",
          "within": "within",
          "capacity": "capacity.",
          "exceeded": "CAPACITY EXCEEDED after amendment — {n} visit(s) unplaceable:",
          "feasible": "Feasible after amendment · peak day {peak} / {cap}.",
          "forward": "Past and in-progress visits stay untouched; only FUTURE visits regenerate (forward-only).",
          "approve": "Approve revision",
          "reject": "Reject",
          "reject-ph": "Reject reason",
          "reject-label": "Reject reason for {id}",
          "toast-approved": "Amendment approved — future visits regenerated"
        },
        "cal": {
          "conflict-title": "Capacity conflict — this plan cannot be scheduled as configured.",
          "required": "Required",
          "vs-available": "visits vs available",
          "conflict": "total slots across {days} visit days (default {cap}/day; date overrides included).",
          "conflict-unplaced": "{n} visit could not be placed: | {n} visits could not be placed:",
          "conflict-revise": "Revise Visit Cycle membership, proposed dates or capacity.",
          "feasible": "Feasible:",
          "feasible-fit": "visits fit within",
          "feasible-rest": "total slots across {days} visit days · peak {n} / {cap} on {date} · remaining {rem}.",
          "override-title": "Capacity override recorded",
          "override-rsm": "The RSM sees this before approval.",
          "title": "Operational calendar · {period} — default {cap}/day",
          "overrides": "{n} date-specific override | {n} date-specific overrides",
          "views-label": "Schedule view",
          "calendar": "Calendar",
          "itinerary": "Itinerary · date order",
          "all-cycles": "All cycles",
          "cycle-hint": "Cycle filter highlights its generated dates without removing the monthly context.",
          "dow": {
            "mon": "Mon",
            "tue": "Tue",
            "wed": "Wed",
            "thu": "Thu",
            "fri": "Fri",
            "sat": "Sat",
            "sun": "Sun"
          },
          "dow-long": {
            "sun": "Sunday",
            "mon": "Monday",
            "tue": "Tuesday",
            "wed": "Wednesday",
            "thu": "Thursday",
            "fri": "Friday",
            "sat": "Saturday"
          },
          "company-calendar": "Company Calendar",
          "included-override": "included by audited override",
          "non-working": "non-working",
          "override": "override",
          "source-title": "From the published person calendar",
          "not-available": "Not an available Visit Day",
          "unavailable": "unavailable",
          "of-cap": "{n} of {cap}",
          "override-suffix": " · override",
          "capacity": "capacity",
          "overloaded": "overloaded",
          "day-full": "day full",
          "tip": "{n} of {cap} capacity",
          "tip-over": "OVERLOAD +{n}",
          "tip-free": "{n} free",
          "visits": "{n} visit | {n} visits",
          "in-cycle": "{n} in C{k}",
          "nonvisit-title": "No PJP visit scheduled · planned non-visit activity",
          "legend": {
            "planned": "Planned visits",
            "nonvisit": "Default non-visit work",
            "unavailable": "Outlet unavailable",
            "holiday": "Public holiday / non-working",
            "sunday": "Sunday",
            "click": "Click a working day for its generated route or planned non-visit activity"
          },
          "date-override": "date override",
          "sunday-nonworking": "Sunday · non-working",
          "outlets-unavailable": "{n} outlet unavailable | {n} outlets unavailable",
          "close-day": "Close day detail",
          "sequence": "Generated sequence for this date (base outlet order):",
          "min": "min",
          "window": "window {w}",
          "resolve": "outlet unavailable — resolve before execution",
          "no-located": "No located outlets on this date — the generated sequence above is the visit order.",
          "route": "Generated route · {date}",
          "route-note": "— this selected date only; later Visit Cycles may use different routes because membership, capacity, working dates and exceptions can differ.",
          "no-visits": "No PJP visits scheduled.",
          "choose-work": "Choose the planned non-visit activity for this date:",
          "nonvisit-label": "Planned non-visit activity for {date}",
          "other-ph": "Describe other activity",
          "step1-default": "Step 1 remains the default; this changes only {date}.",
          "regen": "This is the authoritative dated monthly schedule. It regenerates from the current Visit Cycle membership, cycle order, proposed dates, outlet work, capacity and calendar exceptions; Step 2 changes flow here directly.",
          "itin-empty": "No planned visits yet — add outlets first.",
          "visit-of": "visit {i} of {n}",
          "clustering": "same province · DT outlets share days where capacity allows (hover a day). Sundays, public holidays and recorded closures are excluded automatically.",
          "closure": {
            "title": "Operating Calendar impact — {n} unavailability period: | Operating Calendar impact — {n} unavailability periods:",
            "unavailable": "unavailable",
            "unscheduled": "could NOT be rescheduled within capacity (listed above)",
            "avoided": "the generator avoided these dates; visits sit on other working days",
            "review": "review required"
          }
        },
        "map": {
          "legacy": "No submitted Visit Cycle route is available for this legacy plan.",
          "by-cycle": "Submitted route by Visit Cycle",
          "cycle-stops": "Cycle {k} · {n} stops",
          "readonly": "Read-only LM review",
          "no-geo": "Assigned outlet coordinates are unavailable; use the included-outlet list below.",
          "mode-label": "Route display",
          "map": "Map",
          "list": "List",
          "title": "Visit Cycle {k} · proposed first-to-last sequence · {n} included of {assigned} assigned",
          "title-note": "— read-only submitted route review · Step 3 remains the authoritative dated monthly calendar",
          "distance": "estimated outlet-to-outlet distance",
          "navigate": "Navigate from your location ↗",
          "nav-unavailable": "External navigation unavailable — the internal route view and List mode remain fully usable",
          "nav-notice": "Opens Google Maps. Outlet coordinates are shared for navigation. Optimal HR does not collect or store your live location for route preview.",
          "list-mode": "Map hidden. Use the included-outlet list below to review order, visit work and proposed dates.",
          "legend-on": "● Included + routed",
          "legend-off": "○ Assigned, not included",
          "legend-google": "Google Maps provides live driving time and road distance from your current location",
          "missing": "{n} outlet has no coordinates and remain in the list controls | {n} outlets have no coordinates and remain in the list controls",
          "svg-label": "Visit Cycle {k} route map",
          "included": "Included",
          "not-included": "Not included",
          "rank": "Cycle {k} route rank",
          "stops": "{n} stops",
          "range": "Select dates within",
          "dates-pending": "dates pending",
          "empty-route": "Include an outlet from the map to create the route.",
          "no-date": "No date",
          "start": "START"
        }
      },
      "cc": {
        "hero": {
          "title": "What needs attention now",
          "continue": "Continue Current Visit — {site}",
          "continue-sub": "Checked in · finish tasks and check out",
          "start": "Start Today’s Route ({n} stop) | Start Today’s Route ({n} stops)",
          "start-sub": "{done} of {total} done today",
          "plan": "{action} — {period}",
          "plan-sub": "Planning deadline {date}",
          "review": "Review This Month’s Execution",
          "review-sub": "No visit needs action right now"
        },
        "attn": {
          "missed": "{n} missed this month",
          "critical": "{n} critical flags",
          "overdue": "{n} overdue action | {n} overdue actions",
          "not-started": "{period} PJP not started · deadline {date}"
        },
        "action": {
          "create": "Create PJP",
          "create-next": "Create Next PJP",
          "continue": "Continue Draft",
          "revise": "Revise & Resubmit",
          "view-submitted": "View Submitted",
          "view-approved": "View Approved",
          "view-pjp": "View PJP",
          "amend": "Request Amendment"
        },
        "status": {
          "none": "No plan yet for {period}",
          "draft": "{id} · rev {rev}",
          "returned": "{id} · returned by RSM",
          "submitted": "{id} · awaiting RSM approval",
          "approved": "{id} · operational"
        },
        "chip": {
          "none": "not created",
          "draft": "draft",
          "returned": "returned",
          "submitted": "submitted",
          "approved": "approved · published"
        },
        "exec": {
          "title": "Current-month execution · {period}",
          "line": "Coverage {coverage} ({visited}/{outlets}) · Completed {completed} · Missed {missed} · Flagged {flagged}",
          "bar": "Completion {n}%"
        },
        "plan": {
          "title": "Next-month planning · {period}",
          "deadline": "Planning deadline: {date}",
          "passed": "passed",
          "empty": "Plan next month's outlet routes before the deadline."
        },
        "life": {
          "draft": "Draft",
          "submitted": "Submitted",
          "approved": "Approved & Published",
          "returned": "Returned for Revision · rev {rev}",
          "cancelled": "Cancelled",
          "amendment": "Amendment {status} · {id}",
          "stage": "Stage:",
          "rev": "rev {rev}",
          "owner": "Owner:",
          "owner-rsm": "RSM · {name}",
          "owner-sup": "Supervisor · {name}",
          "next": "Next action:",
          "history": "Lifecycle & revision history ({n} events)",
          "next-action": {
            "draft": "Submit to RSM",
            "returned": "Revise & resubmit (rev {rev})",
            "submitted": "RSM decision — Approve & Publish or Return for Revision",
            "approved-published": "Generate weeks & execute · changes via Amendment Request",
            "cancelled": "None — plan cancelled",
            "archived": "None — archived"
          }
        },
        "kpi": {
          "today": "Today's route",
          "today-sub": "{done} done · {inprogress} in progress",
          "week": "This week (W{n})",
          "week-sub": "{n} completed",
          "coverage": "Outlet coverage",
          "coverage-sub": "{visited} / {outlets} outlets this month",
          "cmf": "Completed · Missed · Flagged",
          "clean-rate": "clean rate {n}%",
          "followups": "Follow-ups",
          "open": "{n} open",
          "overdue": "{n} overdue"
        },
        "route": {
          "title": "Today's route · {date}",
          "empty": "No stops today.",
          "open": "Open Execute · Today →"
        },
        "upcoming": {
          "title": "Upcoming visits",
          "empty": "Nothing scheduled ahead — generate the next week from your PJP.",
          "open": "Open Execute · Week →"
        },
        "recent": {
          "title": "Recent activity"
        },
        "rsm": {
          "banner": "Regional line management · PJP approvals",
          "pending": "{n} plan awaiting your approval | {n} plans awaiting your approval",
          "amends": "{n} amendment request | {n} amendment requests",
          "open-queue": "Open Approval Queue →",
          "queue-clear": "queue clear",
          "exec-title": "Current-month execution · {period}",
          "coverage": "Regional coverage",
          "coverage-sub": "{visited} / {outlets} outlets",
          "completion": "Completion",
          "completion-sub": "{completed} / {due} due",
          "missed": "Missed",
          "missed-sub": "record-level in Exceptions",
          "flagged": "Flagged (completed)",
          "critical-sub": "{n} critical",
          "followups": "Follow-ups",
          "readiness": "Next-month PJP readiness · {period}",
          "deadline": "(deadline {date})",
          "ready": "Plans ready",
          "ready-sub": "approved & published for {period}",
          "awaiting": "Awaiting approval",
          "awaiting-sub": "in your queue",
          "not-started": "Not started / draft",
          "not-started-sub": "chase before deadline",
          "table-title": "PJP status by supervisor · both periods",
          "th-supervisor": "Supervisor",
          "th-exec": "{period} (execution)",
          "th-coverage": "Coverage",
          "th-adherence": "Adherence",
          "th-plan": "{period} (planning)",
          "note": "Analysis with filters & drill-down lives under {coverage}, {exceptions} and {performance}; record-level missed & flagged under Exceptions.",
          "note-coverage": "Coverage",
          "note-exceptions": "Exceptions",
          "note-performance": "Performance"
        },
        "hrbp": {
          "note-lead": "Outsourcing governance overlay.",
          "note": "You oversee the outsourced workforce on this project — coverage, exceptions, risks and compliance. Routine PJP approvals and visit execution stay with the supervisor / RSM workflow; routine visit records are not listed here. Vacant supervisor seats are covered via Execute Oversight (audited).",
          "supervisors": "Supervisors",
          "supervisors-sub": "{n} promoters avg / supervisor",
          "coverage": "Project coverage · {period}",
          "coverage-sub": "{visited} / {outlets} outlets (execution)",
          "exceptions": "Unresolved exceptions",
          "exceptions-sub": "{n} overdue — escalation risk",
          "missed-rate": "Missed rate",
          "missed-rate-sub": "{n} missed (counts)",
          "readiness": "Next-month PJP readiness",
          "readiness-sub": "{period} approved · {n} awaiting RSM",
          "workload-title": "Supervisor workload & risk (aggregates)",
          "th-supervisor": "Supervisor",
          "th-region": "Region",
          "th-promoters": "Promoters",
          "th-outlets": "Outlets",
          "th-completion": "Completion",
          "th-missed": "Missed",
          "th-flag-rate": "Flag rate",
          "th-pjp": "PJP {period}",
          "not-created": "not created",
          "exceptions-title": "Unresolved operational exceptions (open follow-ups)",
          "exception-meta": "· owner {owner} · due {due}",
          "overdue": "overdue",
          "open": "open",
          "no-exceptions": "No unresolved exceptions."
        },
        "gov": {
          "lead-leader": "Executive project oversight",
          "lead-champion": "Project performance oversight",
          "aggregate-only": "— aggregate only.",
          "note": "This surface shows totals, rates, scores, trends and major-exception counts. Person-level visit records — in any status, including completed — are not available to this role (D2-107 is a publication ceiling, not a role entitlement).",
          "exec-title": "Current-month execution · {period}",
          "coverage": "Coverage",
          "coverage-sub": "{visited} / {outlets} outlets",
          "completion": "Completion",
          "completion-sub": "{completed} completed / {due} due",
          "clean": "Clean completion",
          "clean-sub": "flag rate {n}% of completed",
          "avg-score": "Avg score",
          "avg-score-sub": "across completed visits",
          "critical": "Critical issues",
          "critical-sub": "major exceptions (counts)",
          "missed": "Missed",
          "missed-sub": "count · follow-ups open {open} ({overdue} overdue)",
          "readiness": "Next-month planning readiness · {period}",
          "aggregate": "(aggregate)",
          "approved": "Plans approved",
          "approved-sub": "of {n} supervisors",
          "awaiting": "Awaiting approval",
          "awaiting-sub": "with regional RSMs",
          "not-started": "Not started / draft",
          "not-started-sub": "deadline {date}",
          "by-region": "By region",
          "by-rsm": "By RSM",
          "th-region": "Region",
          "th-rsm": "RSM",
          "th-due": "Due",
          "th-completed": "Completed",
          "th-completion": "Completion",
          "th-clean": "Clean",
          "th-flag-rate": "Flag rate",
          "th-critical": "Critical",
          "th-missed": "Missed",
          "th-avg-score": "Avg score",
          "majors-title": "Major exceptions (summary — no promoter-level records)",
          "major-critical": "{n} critical issue in {region} | {n} critical issues in {region}",
          "major-missed": "{n} missed visits in {region}",
          "no-majors": "No major exceptions above thresholds."
        },
        "state": {
          "loading": "Loading the Command Center…",
          "error": "The Command Center could not be loaded.",
          "retry": "Retry"
        }
      },
      "plans": {
        "per": "{month} {year}",
        "day-short": "{day} {month}",
        "months": {
          "m1": "January",
          "m2": "February",
          "m3": "March",
          "m4": "April",
          "m5": "May",
          "m6": "June",
          "m7": "July",
          "m8": "August",
          "m9": "September",
          "m10": "October",
          "m11": "November",
          "m12": "December"
        },
        "months-short": {
          "m1": "Jan",
          "m2": "Feb",
          "m3": "Mar",
          "m4": "Apr",
          "m5": "May",
          "m6": "Jun",
          "m7": "Jul",
          "m8": "Aug",
          "m9": "Sep",
          "m10": "Oct",
          "m11": "Nov",
          "m12": "Dec"
        },
        "appr": {
          "draft": "Draft",
          "submitted": "Pending Approval",
          "returned": "Returned for Revision",
          "approved-published": "Approved & Published",
          "archived": "Approved & Published",
          "cancelled": "Cancelled"
        },
        "exec": {
          "inprogress": "In Progress · {done} / {total}",
          "closed": "Closed · {done} / {total}",
          "upcoming": "Upcoming",
          "upcoming-n": "Upcoming · {n} visits"
        },
        "outcome": {
          "open": "Open",
          "closed": "Closed · {outcome}",
          "met": "Met Plan",
          "partial": "Partially Achieved",
          "below": "Below Plan",
          "not-assessed": "Not Assessed",
          "cancelled": "Cancelled"
        },
        "sla": {
          "ok": "On track",
          "reminder": "Due soon",
          "urgent": "Urgent — due today",
          "breached": "Overdue",
          "escalated": "Escalated",
          "met": "Met",
          "met-late": "Met late",
          "met-offline": "Met · offline synced",
          "wd": "{n} WD",
          "by": " · by {date}",
          "sync": " · sync pending",
          "paused": " · paused (approved leave)",
          "policy": "policy {ref}",
          "capped": " · target capped",
          "legacy": " · legacy record"
        },
        "reg": {
          "hrbp-title": "Project compliance & workload register.",
          "hrbp-text": "Read-only oversight: approvals stay with the regional RSMs; visit execution stays with supervisors.",
          "filter-period": "Filter by period",
          "filter-status": "Filter by approval status",
          "filter-sup": "Filter by supervisor",
          "all-periods": "All periods",
          "all-statuses": "All approval statuses",
          "all-sups": "All supervisors",
          "reset": "Reset",
          "new": "+ New PJP",
          "col": {
            "period": "Period",
            "supervisor": "Supervisor",
            "region": "Region",
            "approval": "Approval",
            "execution": "Execution",
            "planned": "Planned",
            "completion": "Completion",
            "coverage": "Coverage",
            "capacity": "Capacity use",
            "outcome": "Outcome",
            "actions": "Actions"
          },
          "id-rev": "{id} · rev {rev}",
          "fix": "Fix",
          "empty": "No plans match the current filters.",
          "footnote": "Approval, execution and close are INDEPENDENT: “Closed” means the period elapsed — the outcome chip grades what was achieved (e.g. an 80%-completed elapsed plan reads Closed · Partially Achieved).",
          "action": {
            "continue": "Continue Draft",
            "revise": "Revise & Resubmit",
            "view-submission": "View Submission",
            "results": "View Results",
            "open-current": "Open Current Plan",
            "view": "View Plan",
            "review": "Review Plan"
          },
          "more": "More actions",
          "delete-draft": "Delete draft",
          "cancel-submission": "Cancel submission",
          "delete-title": "Delete this draft permanently?",
          "cancel-title": "Cancel submission before RSM approval?",
          "cancel-text": "The plan returns to Draft and can be edited and submitted again.",
          "delete-impact": "Removes this draft ({outlets}), its {visits} and {followups}. Other plans in {period} keep their visits and follow-ups. An audited deletion record is retained.",
          "n-outlets": "{n} outlet | {n} outlets",
          "n-visits": "{n} planned visit | {n} planned visits",
          "n-followups": "{n} linked follow-up | {n} linked follow-ups",
          "keep": "Keep",
          "confirm": "Confirm",
          "deleted": "Draft {id} deleted · {visits} and {followups} removed. Other plans in {period} are unaffected.",
          "n-planned-visits": "{n} planned visit | {n} planned visits",
          "n-followups-short": "{n} follow-up | {n} follow-ups",
          "cancelled": "Submission cancelled — the plan is back in Draft."
        },
        "agg": {
          "title": "PJP plans — aggregate register (read-only).",
          "text": "Plan-level records, approvals and amendments stay with the operational workflow; this view reports counts and outcomes only.",
          "kpi": {
            "plans": "Plans (all periods)",
            "plans-sub": "project-wide",
            "approved": "Approved & published",
            "approved-sub": "operational plans",
            "closed": "Closed periods",
            "closed-sub": "{met} met plan · {partial} partially achieved",
            "pending": "Pending Approval",
            "pending-sub": "in RSM queues"
          },
          "col": {
            "region": "Region",
            "plans": "Plans",
            "draft": "Draft",
            "pending": "Pending",
            "returned": "Returned",
            "approved": "Approved",
            "met": "Closed · Met Plan",
            "partial": "Closed · Partially"
          },
          "empty": "No plans yet — counts appear as supervisors create PJPs."
        },
        "ready": {
          "lead": "Planning readiness for",
          "deadline": "— deadline {date} (last working day of the execution month).",
          "col": {
            "supervisor": "Supervisor",
            "region": "Region",
            "next": "Next-period plan",
            "approval": "Approval",
            "current": "Current-period plan"
          },
          "awaiting": "awaiting your review",
          "ready": "ready",
          "with-sup": "with supervisor",
          "not-started": "not started",
          "none": "none"
        },
        "pd": {
          "back": "← Back to PJP Register",
          "period": "Period",
          "new-for": "+ New PJP for {period}",
          "none": "No PJP for {period}.",
          "none-use": "Use",
          "new": "+ New PJP",
          "none-builder": "— a guided builder (setup → outlets & visit work → schedule preview → review & submit).",
          "none-elapsed": "Elapsed periods cannot receive a new plan.",
          "last": "last: {event} {ts}",
          "note-ph": "Note to your RSM (optional)",
          "submit": "Submit to RSM",
          "continue-amend": "Continue amendment · rev {rev}",
          "request-amend": "Request amendment",
          "awaiting": "Awaiting RSM decision",
          "sections": "Plan sections",
          "submitted": "PJP submitted for RSM approval",
          "sec": {
            "ov": "Overview",
            "out": "Outlets & Tasks",
            "sch": "Schedule",
            "hist": "Approval & History",
            "amend": "Amendments",
            "amend-n": "Amendments ({n})"
          },
          "ov": {
            "outlets": "Outlets",
            "outlets-sub": "{pct}% of assigned",
            "planned": "Planned visits",
            "planned-sub": "from the balanced schedule",
            "available": "Available capacity",
            "slots": "{n} slots",
            "available-sub": "{days} working days × {cap} visits/day · {pct}% used",
            "daily": "Daily capacity",
            "daily-sub": "visits/day (plan setting) — dailyCapacity",
            "execution": "Execution",
            "period-active": "period active",
            "period-upcoming": "period upcoming",
            "src": {
              "label": "Starting source:",
              "template": {
                "t": "Route Template: full assigned outlet list",
                "d": "Created from your complete assigned outlet list with standard defaults; adjusted afterwards in this plan."
              },
              "blank": {
                "t": "Start Blank",
                "d": "Created without copying another plan — outlets and planning settings were added manually."
              },
              "copied": {
                "t": "Copied from {from}",
                "d": "Started as a copy of that approved plan; every edit after creation belongs to this draft."
              },
              "copy-none": {
                "t": "Copied · no earlier approved plan",
                "d": "Copy was chosen at creation but no earlier approved plan existed — standard defaults were applied instead."
              }
            },
            "conflict": "Capacity conflict",
            "conflict-text": "— required {required} vs available {available}. Open",
            "conflict-tail": "to resolve or record an audited override.",
            "feasible": "Feasible — {required} visits within {available} capacity.",
            "plan-note": "Planning note: {note}",
            "override": "Capacity override on record — {reason}"
          },
          "hist": {
            "step": {
              "draft": "Draft",
              "submitted": "Submitted",
              "approved": "Approved & Published"
            },
            "owner-rsm": "RSM · {name}",
            "owner-sup": "Supervisor · {name}",
            "next": {
              "draft": "Submit to RSM",
              "returned": "Revise & resubmit (rev {rev})",
              "submitted": "RSM decision — Approve & Publish or Return for Revision",
              "approved-published": "Generate weeks & execute · changes via Amendment Request",
              "cancelled": "None — plan cancelled",
              "archived": "None — archived"
            },
            "returned-chip": "Returned for Revision · rev {rev}",
            "amend-chip": "Amendment {status} · {id}",
            "stage": "Stage:",
            "owner": "Owner:",
            "next-label": "Next action:",
            "history": "Lifecycle & revision history ({n} events)",
            "submit-note": "Submission note: {note}"
          },
          "amend": {
            "working": "Working Amendment · Revision {rev}",
            "working-text": "Approved Revision {rev} remains active. Continue the familiar planning flow; only your proposed revision will be sent to the RSM.",
            "continue": "Continue amendment",
            "request": "Request amendment",
            "revision": "Revision {from} → {to}",
            "effective": "effective {date}",
            "reason": "Reason:",
            "none": "No amendments on this plan.",
            "add": "add to plan",
            "at": "at {freq}",
            "remove": "remove from plan",
            "current": "(current {freq})"
          }
        },
        "out": {
          "title": "Plan by Visit Cycle",
          "lead": "A Visit Cycle is one planned pass through its selected outlets. Each cycle may have its own membership, order and proposed dates.",
          "count": "{cycles} · {visits} visits",
          "n-cycles": "{n} cycle | {n} cycles",
          "cycles-label": "Visit Cycles",
          "cycle": "Visit Cycle {k}",
          "partial": "partial",
          "dates-pending": "dates pending",
          "calc": "Calculated visits/month:",
          "calc-text": "an outlet’s value is the number of Visit Cycles containing it. Minimum {min} ·",
          "below-min": "{n} below minimum — warning/explanation remains required",
          "all-meet": "all outlets meet the minimum",
          "overlap-block": "Visit Cycle dates overlap by more than the handoff day — submission blocked.",
          "overlap-block-text": "{b} starts {start} before {a} finishes {finish}. Adjust the cycle dates so the next cycle starts on or after the prior cycle finish.",
          "overlap-warn": "Same-day cycle handoff.",
          "overlap-warn-text": "{b} starts {start} as {a} finishes. This is allowed when the combined visits remain within that date’s capacity.",
          "editing": "Editing Visit Cycle {k}",
          "editing-text": "All route, outlet and bulk changes below apply to this selected cycle.",
          "guard": "Planning guardrail review.",
          "guard-below": "{n} outlet is below the stated minimum. | {n} outlets are below the stated minimum.",
          "guard-target": "{n} planned visit is below the monthly target. | {n} planned visits are below the monthly target.",
          "guard-tail": "The plan remains editable; an explanation is required before submission.",
          "why-min": "Reason for outlets below minimum",
          "why-target": "Reason for monthly target shortfall",
          "zero": "{n} outlet is planned for 0 visits this month. | {n} outlets are planned for 0 visits this month.",
          "zero-text": "It remains in the monthly plan but belongs to no Visit Cycle, so it is below the minimum of {min}. Add to a Visit Cycle, or explain the shortfall before submission. | They remain in the monthly plan but belong to no Visit Cycle, so they are below the minimum of {min}. Add to a Visit Cycle, or explain the shortfall before submission.",
          "per-month": "visits/month",
          "chk-1": "The selected",
          "chk-purpose": "Visit Purpose",
          "chk-2": "applies its standard checklist from the",
          "chk-lib": "Work Management Master Task Library",
          "chk-3": ". Step 3 remains the authoritative full monthly calendar.",
          "no-geo": "Assigned outlet coordinates are unavailable; use the included-outlet list below.",
          "route-head": "Visit Cycle {k} · proposed first-to-last sequence · {included} included of {assigned} assigned",
          "route-edit": "— click any pin to include or exclude it · Step 3 remains the authoritative dated monthly calendar",
          "route-read": "— read-only submitted route review · Step 3 remains the authoritative dated monthly calendar",
          "route-km": "estimated outlet-to-outlet distance",
          "nav": "Navigate from your location ↗",
          "nav-unavailable": "External navigation unavailable — the internal route view and List mode remain fully usable",
          "nav-notice": "Opens Google Maps. Outlet coordinates are shared for navigation. Optimal HR does not collect or store your live location for route preview.",
          "list-mode": "Map hidden. Use the included-outlet list below to review order, visit work and proposed dates.",
          "col": {
            "order": "Order",
            "outlet": "Outlet",
            "promoter": "Promoter",
            "priority": "Priority",
            "purpose": "Visit purpose",
            "date-scheduled": "Scheduled visit date",
            "date-proposed": "Proposed visit date",
            "capacity": "Capacity",
            "window": "Window",
            "min": "Min",
            "planned": "Planned / month"
          },
          "start": "Start",
          "carry": "Carry-forward priority",
          "not-scheduled": "Not scheduled",
          "slots-left": "{n} slot left | {n} slots left",
          "est": "est {n} min",
          "suggest": "suggest {n}",
          "unresolved": "unresolved task version — {text}",
          "legacy": "legacy · {why} — kept as recorded",
          "review": "task set changed —",
          "keep": "Keep {v}",
          "use": "Use {v}",
          "use-suggestion": "Use suggestion",
          "below": "below the {n}-min estimate —",
          "below-reason": "reason recorded by {by} on {at}: {reason}",
          "below-required": "an explanation is required",
          "below-ph": "Why is the planned duration below the estimate?",
          "minimum": "minimum {n}",
          "empty": "This Visit Cycle has no outlets. Add one below or copy the structure from an earlier cycle.",
          "table-label": "Visit Cycle {k} outlets"
        },
        "sch": {
          "conflict": "Capacity conflict — this plan cannot be scheduled as configured.",
          "conflict-text": "Required {required} visits vs available {available} total slots across {days} visit days (default {cap}/day; date overrides included).",
          "unplaced": "{n} visit could not be placed: | {n} visits could not be placed:",
          "more": "more",
          "revise": "Revise Visit Cycle membership, proposed dates or capacity —",
          "or-override": "or record an explicit override:",
          "override-ph": "Override reason (required, audited)",
          "record-override": "Record override",
          "feasible": "Feasible:",
          "fit": "visits fit within",
          "feasible-tail": "total slots across {days} visit days · peak {peak} / {cap} on {date} · remaining {rem}.",
          "override-recorded": "Capacity override recorded",
          "override-rsm": "The RSM sees this before approval.",
          "op-cal": "Operational calendar · {period} — default {cap}/day",
          "date-overrides": "{n} date-specific override | {n} date-specific overrides",
          "views": "Schedule view",
          "calendar": "Calendar",
          "itinerary": "Itinerary · date order",
          "cycle-filter": "Cycle filter",
          "all-cycles": "All cycles",
          "cycle": "Cycle {k}",
          "cycle-hint": "Cycle filter highlights its generated dates without removing the monthly context.",
          "wd": {
            "mon": "Mon",
            "tue": "Tue",
            "wed": "Wed",
            "thu": "Thu",
            "fri": "Fri",
            "sat": "Sat",
            "sun": "Sun"
          },
          "wdl": {
            "mon": "Monday",
            "tue": "Tuesday",
            "wed": "Wednesday",
            "thu": "Thursday",
            "fri": "Friday",
            "sat": "Saturday",
            "sun": "Sunday"
          },
          "company-cal": "Company Calendar",
          "included": "included by audited override",
          "non-working": "non-working",
          "override": "override",
          "from-person-cal": "From the published person calendar",
          "not-visit-day": "Not an available Visit Day",
          "names-unavailable": "{names} unavailable",
          "n-unavailable": "{n} unavailable",
          "of-cap": "{n} of {cap} capacity",
          "overload": "OVERLOAD +{n}",
          "free": "{n} free",
          "n-of": "{n} of {cap}",
          "capacity": "capacity",
          "overloaded": "overloaded",
          "full": "day full",
          "n-visits": "{n} visit | {n} visits",
          "in-cycle": "{n} in C{k}",
          "nonvisit-tip": "No PJP visit scheduled · planned non-visit activity",
          "lg": {
            "planned": "Planned visits",
            "nonvisit": "Default non-visit work",
            "unavailable": "Outlet unavailable",
            "holiday": "Public holiday / non-working",
            "sunday": "Sunday",
            "click": "Click a working day for its generated route or planned non-visit activity"
          },
          "date-override": "date override",
          "sunday-nw": "Sunday · non-working",
          "outlets-unavailable": "{n} outlet unavailable | {n} outlets unavailable",
          "close-day": "Close day detail",
          "sequence": "Generated sequence for this date (base outlet order):",
          "window": "window {w}",
          "resolve": "outlet unavailable — resolve before execution",
          "no-visits": "No PJP visits scheduled.",
          "choose-activity": "Choose the planned non-visit activity for this date:",
          "activity": "Planned non-visit activity",
          "other-ph": "Describe other activity",
          "step1-default": "Step 1 remains the default; this changes only {date}.",
          "regen": "This is the authoritative dated monthly schedule. It regenerates from the current Visit Cycle membership, cycle order, proposed dates, outlet work, capacity and calendar exceptions; Step 2 changes flow here directly.",
          "no-planned": "No planned visits yet — add outlets first.",
          "visit-of": "visit {n} of {total}",
          "weekly": "Weekly workload:",
          "cluster": "Geographic clustering:",
          "cluster-text": "same province · DT outlets share days where capacity allows (hover a day). Sundays, public holidays and recorded closures are excluded automatically.",
          "closures": "Operating Calendar impact — {n} unavailability period: | Operating Calendar impact — {n} unavailability periods:",
          "closure": "{name} unavailable {range} ({type}) — {outcome}",
          "closure-unscheduled": "could NOT be rescheduled within capacity (listed above)",
          "closure-avoided": "the generator avoided these dates; visits sit on other working days",
          "closure-review": "review required",
          "drag-hint": "Drag an outlet onto another working day to move that visit — drafts only; an Approved & Published plan changes through {amend}.",
          "drag-amend": "Request Amendment",
          "drag-tip": "drag to another working day",
          "moved": "Visit moved to {date} — draft adjustment, audited; capacity and unavailability re-checked",
          "move-picked": "{name} ({date}) picked up — move to a working day and press Enter to drop it, or Escape to cancel.",
          "move-cancel": "Move cancelled.",
          "move-label": "{name} on {date} — press Enter to pick up and move this visit",
          "route": "Generated route · {date}",
          "route-note": "— this selected date only; later Visit Cycles may use different routes because membership, capacity, working dates and exceptions can differ.",
          "route-none": "No located outlets on this date — the generated sequence above is the visit order."
        }
      },
      "wizard": {
        "title-new": "+ New PJP · {period}",
        "title-amend": "Amend PJP · {period} · Revision {rev}",
        "sub-new": "{name} · monthly guided plan",
        "sub-amend": "{name} · approved-plan revision",
        "status-ready": "Ready",
        "status-updating": "Updating…",
        "close": "Close",
        "stepper-label": "Plan builder steps",
        "steps": {
          "1": "Plan Setup",
          "2": "Outlets & Visit Work",
          "3": "Schedule Preview",
          "4": "Review & Submit"
        },
        "amend-banner-title": "Working Amendment · Revision {rev}",
        "amend-banner": " — Approved Revision {base} remains locked and operational until the RSM approves this proposed revision.",
        "open-existing": "Open the existing plan",
        "month": {
          "10": "October",
          "11": "November",
          "12": "December",
          "01": "January",
          "02": "February",
          "03": "March",
          "04": "April",
          "05": "May",
          "06": "June",
          "07": "July",
          "08": "August",
          "09": "September"
        },
        "month-short": {
          "10": "Oct",
          "11": "Nov",
          "12": "Dec",
          "01": "Jan",
          "02": "Feb",
          "03": "Mar",
          "04": "Apr",
          "05": "May",
          "06": "Jun",
          "07": "Jul",
          "08": "Aug",
          "09": "Sep"
        },
        "foot": {
          "cancel": "Cancel",
          "back": "‹ Back",
          "save": "Save Draft",
          "save-amend": "Save amendment draft",
          "create": "Create draft & continue ›",
          "continue": "Continue ›",
          "submit": "Submit to RSM",
          "submit-amend": "Submit amendment",
          "confirm": "Discard this unsaved plan setup?",
          "keep": "Keep editing",
          "discard": "Discard",
          "missing": "{n} visit date is still required across all Visit Cycles. | {n} visit dates are still required across all Visit Cycles."
        },
        "err": {
          "min-reason": "Explain why the minimum is below the project recommendation before continuing.",
          "alt-work": "Choose the default work classification for working days with no PJP visit. “Other” requires a description.",
          "source": "Choose a Starting Source: Continue from previous approved PJP, or Route Template. Start Blank is no longer available for new plans.",
          "dup": "A PJP for {period} already exists — one plan per supervisor × period. Open it from the register instead.",
          "period": "Pick a planning period.",
          "future": "New PJPs are for FUTURE periods only — the active month and elapsed periods cannot receive a new plan.",
          "amend-reason": "Explain why the approved plan must change before continuing.",
          "amend-reason-submit": "Explain why this approved plan must change before submitting.",
          "amend-effective": "Choose a valid effective date from the approved working calendar. Past dates are never available.",
          "missing-dates": "Select a visit date for every ranked outlet before Schedule Preview. {n} date is still required. | Select a visit date for every ranked outlet before Schedule Preview. {n} dates are still required.",
          "day-work": "Describe the “Other” non-visit activity for {date} before continuing.",
          "month-draft-only": "Only a draft (or returned) plan can change its planning month.",
          "only-sup": "Only a supervisor creates their PJP."
        },
        "flash": {
          "draft-saved": "Draft saved — everything you entered is kept. Continue any time from the register.",
          "draft-kept": "Draft kept — continue any time from the register.",
          "amend-saved": "Working Amendment Revision {rev} saved — the approved plan remains active.",
          "submitted": "Plan {id} submitted — Pending Approval with your RSM.",
          "amend-submitted": "Amendment {id} submitted — Revision {rev} is awaiting RSM approval; Revision {base} remains active."
        },
        "toast": {
          "created": "Draft {id} created"
        },
        "impact": {
          "applied": "✓ Applied: {list}{outlets}. Est/month, planned visits, workload and capacity recalculated; the Schedule Preview regenerates from the updated plan. Nothing else in your draft was changed.",
          "outlets": "{updated} outlet(s) updated, {preserved} individually adjusted outlet(s) kept their overrides, {kept} untouched",
          "title": "Apply updated planning defaults?",
          "changed": "{label} changed from {from} to {to}.",
          "k": {
            "period": "Planning Month",
            "capacity": "Daily Capacity",
            "purpose": "Default Visit Purpose",
            "minfreq": "Minimum Visits / Outlet",
            "target": "Target Planned Visits",
            "altwork": "Default Non-Visit Work",
            "dur": "Default Visit Duration"
          },
          "v": {
            "capacity": "{n} visits/day",
            "minfreq": "{n}/month",
            "dur": "{n} minutes",
            "not-set": "not set"
          },
          "count": "{n} outlet already exists in this draft | {n} outlets already exist in this draft",
          "count-adj": ", including {n} individually adjusted outlet | , including {n} individually adjusted outlets",
          "count-tail": ". The Schedule Preview regenerates after any applied change.",
          "prev": "Update outlets still using the previous defaults",
          "prev-hint": "— recommended · individually adjusted outlets keep their settings",
          "all": "Update all existing outlets",
          "all-hint": "— individual adjustments will be overwritten",
          "later": "Keep existing outlet settings",
          "later-hint": "— apply the new defaults only to outlets added later",
          "apply": "Apply the updated plan settings",
          "apply-hint": "— outlet configuration preserved; schedule, workload and feasibility recalculate",
          "cancel": "Cancel and return to Plan Setup"
        },
        "sec": {
          "amend-request": "Amendment request",
          "amend-request-hint": "Required before editing the approved plan",
          "identity": "Planning identity",
          "identity-hint": "One Supervisor × month · future periods only",
          "baseline": "Revision baseline",
          "baseline-hint": "Approved plan copied into this working revision",
          "source": "Starting source",
          "source-hint": "Choose how this new monthly plan begins",
          "defaults": "Planning defaults",
          "defaults-hint": "Capacity and target create a suggestion · Step 2 owns the actual cycles",
          "calendar": "Visit days & capacity",
          "note": "Planning note",
          "note-hint": "(optional)"
        },
        "setup": {
          "intro-new-b": "+ New PJP",
          "intro-new": "one MONTHLY plan per Supervisor × Planning Month (future months only; your active approved plan is never modified).",
          "intro-amend-b": "Amend approved PJP",
          "intro-amend": "revise the locked plan through the same guided planning flow; the approved revision is never edited directly.",
          "pending": "{n} Plan Setup change staged — press {continue} to review the impact on your {outlets} before anything is applied. | {n} Plan Setup changes staged — press {continue} to review the impact on your {outlets} before anything is applied.",
          "pending-continue": "Continue",
          "pending-outlets": "{n} existing outlet | {n} existing outlets",
          "amend-reason": "Reason for amendment",
          "amend-reason-ph": "Explain what changed and why the approved plan must be revised",
          "amend-effective": "Effective date",
          "choose-date": "Choose date…",
          "today-sameday": "TODAY (same-day)",
          "amend-effective-hint": "An available visit day only; past dates are never offered and completed or elapsed work stays locked.",
          "sameday-notice": "Same-day amendment — approval must be completed before any field execution begins.",
          "month": "Planning month",
          "month-hint": "Future months only",
          "owner": "Plan owner",
          "route": "Approval route",
          "target": "Approval target",
          "target-hint": "Project planning policy · last working day before the plan month",
          "workcal": "Working calendar",
          "workcal-value": "Person calendar · Scheduling",
          "workcal-hint": "Published roster, approved leave and project holidays",
          "baseline-b": "Approved Revision {rev}",
          "baseline": "is the locked operational baseline.",
          "baseline-copy": "Its outlets, Visit Cycles, route order, proposed dates, working calendar and visit work are copied into {rev}. Edit only what needs to change; the approved plan remains active until RSM approval.",
          "baseline-working": "Working Revision {rev}",
          "src-copy": "Continue from previous approved PJP",
          "recommended": "Recommended",
          "src-copy-d": "Copy approved outlet settings and prioritize under-covered outlets early.",
          "src-template": "Start from Route Template",
          "src-template-d": "Use all {n} assigned outlets with current project defaults.",
          "capacity": "Daily visit capacity",
          "capacity-hint": "Maximum visits on a visit day; not a daily quota",
          "target-visits": "Target planned visits",
          "target-visits-hint": "Monthly target; the system suggests full + partial cycles",
          "purpose": "Default visit purpose",
          "purpose-title": "The business objective pre-filled for every outlet added in step 2 — editable per outlet while the plan is Draft/Returned; the approved checklist resolves from the purpose automatically",
          "purpose-hint": "Pre-fills each outlet · checklist follows the purpose",
          "min": "Minimum visits / outlet",
          "min-hint": "Project recommendation: {n}/month · over is allowed; below needs a reason",
          "min-why": "Reason below project recommendation",
          "dur": "Default visit duration",
          "dur-title": "Pre-fills the estimated duration (minutes) for every outlet added in step 2 — adjustable per outlet",
          "minutes": "{n} minutes",
          "alt": "Default work when no PJP visit is scheduled",
          "choose-activity": "Choose activity…",
          "alt-other": "Specify other work",
          "alt-hint": "Keeps non-visit working dates visible to the LM; specific dates can be overridden.",
          "note-ph": "Context, constraints or instructions for your RSM"
        },
        "src": {
          "template": "Route Template: full assigned outlet list",
          "blank": "Start Blank",
          "blank-d": "Created without copying another plan — outlets and planning settings were added manually.",
          "legacy": "Recorded at creation and kept unchanged; this starting source is no longer offered for new plans.",
          "copied": "Copied from {from}",
          "copied-none": "Copied · no earlier approved plan"
        },
        "ins": {
          "config": "Configuration source",
          "config-v": "{period} approved PJP",
          "config-none": "no earlier approved plan — defaults apply",
          "latest": "Latest execution insight",
          "latest-v": "{period} · as of {date}",
          "latest-none": "no execution data yet",
          "signal": "Coverage signal",
          "signal-v": "{n} outlet currently under-covered | {n} outlets currently under-covered",
          "suggest": "Suggested starting outlet",
          "reason": "Reason: {done} of {req} required {month} visits completed{high}{geo}.",
          "high": "high priority",
          "geo": "geographically feasible",
          "shortfall": "The previous shortfall remains in {period}. The new month does not duplicate that obligation automatically; it can prioritize those outlets within the explicit target.",
          "on-track": "Coverage is on track — the new target is distributed into full and partial cycles, then remains editable in Step 2.",
          "prioritize": "Prioritize under-covered outlets in the new schedule",
          "prioritized": "Under-covered outlets were prioritized when this draft was created (ordering + route start only)."
        },
        "sum": {
          "source": "Starting Source",
          "outlets": "Selected outlets",
          "days": "Available visit days",
          "slots": "Maximum visit slots",
          "target": "Target planned visits",
          "remain": "Remaining capacity",
          "min": "Minimum required visits",
          "met": "met",
          "warning": "warning",
          "avg": "Estimated average / outlet",
          "cycles": "Suggested Visit Cycles",
          "cycles-wait": "Waiting for outlet selection",
          "cycles-full": "Cycle 1–{full} full cycles",
          "cycles-partial": "Cycle 1–{full} + {partial} outlets in Cycle {next}",
          "time": "Estimated visit time",
          "hours": "{n} hour | {n} hours",
          "util": "{pct}% utilization. Daily capacity is a ceiling, not an instruction to fill every day. Step 2 decides the actual cycle membership and per-outlet frequency."
        },
        "cal": {
          "multi": "Multi-select",
          "multi-finish": "Finish multi-select",
          "selected-n": "{n} selected",
          "include": "Include",
          "exclude": "Exclude",
          "reset": "Reset to person calendar",
          "dow": {
            "1": "Mon",
            "2": "Tue",
            "3": "Wed",
            "4": "Thu",
            "5": "Fri",
            "6": "Sat",
            "7": "Sun"
          },
          "state": {
            "work": "Available visit day",
            "rest": "Configured rest day",
            "exception": "Visit exception",
            "nonvisit": "Non-visit work",
            "comprest": "Compensatory rest"
          },
          "pending-rsm": "pending RSM",
          "tip": {
            "off": "Manual non-visit classification — {type}",
            "other-work": "other work",
            "comp-off": "Linked compensatory rest for field work on {date}",
            "on": "Controlled visit-day exception · {status}",
            "leave": "{label} — hard block from Leave",
            "comp": "{label} — managed from the linked field-work exception",
            "exception": "{label} — reason and compensation choice required",
            "work": "Available visit day — click to classify another activity or change capacity"
          },
          "cap": "cap {n}",
          "cap-title": "Date capacity {n}",
          "legend": {
            "work": "Available visit day",
            "rest": "Rest / non-working",
            "holiday": "Public holiday",
            "leave": "Approved leave",
            "other": "Other work / excluded",
            "exception": "Visit exception / compensatory rest",
            "selected": "Selected"
          },
          "hint": "Select a date to change availability or its capacity. Exception dates require a reason.",
          "chip": {
            "on": "Visit exception · {status}",
            "comp-off": "Compensatory rest · linked to {date}"
          },
          "sel": {
            "leave": "Hard block from Leave. Change or cancel the leave in HR Ops; Field Ops cannot override it.",
            "comp": "Linked calendar transaction. Change the original rest/holiday field-work exception; do not replace it with a remark.",
            "why": "Reason for field work (required)",
            "comp-choice": "Compensation choice…",
            "comp-repl": "Replacement day off",
            "comp-none": "No replacement day",
            "repl-title": "Linked compensatory-rest date · must be a rostered working day after this field-work date",
            "from": "Authorized start",
            "to": "Authorized end",
            "request": "Request visit-day exception",
            "repl-note": "Replacement rest is linked automatically and may fall in the next month within the {days}-day policy window.",
            "linked": "Linked compensatory rest: {date} · one approval transaction",
            "restore": "Restore person calendar",
            "activity": "Non-visit activity…",
            "other": "Describe if Other",
            "use-other": "Use for other work",
            "comp-hint": "For compensatory rest, start from the original holiday/rest field-work date and choose Replacement day off; the system creates this date as a linked transaction.",
            "cap": "Capacity for this date",
            "cap-why": "Reason if different from {n}",
            "cap-apply": "Apply capacity",
            "foot": "Plan capacity is a ceiling, not a requirement to fill every day. Leave is source-owned; holiday/rest work becomes attendance-authorized only after RSM approval."
          },
          "msg": {
            "blocked": "Apply the staged month change first (press Continue) — then adjust the new month’s calendar.",
            "leave-hard": "{label} is a hard block from Leave. Change or cancel the leave at its source before planning field work.",
            "comp-linked": "{label} is linked to the original rest/holiday field-work request. Change that linked transaction instead of overriding it here.",
            "already-unavailable": "{label} is already unavailable in the person calendar.",
            "alt-required": "Choose the work classification for this non-visit day. “Other” also requires a description.",
            "reason-required": "{label} — a reason is required before requesting field work.",
            "comp-choice": "Choose whether this exception receives a replacement day off.",
            "repl-required": "Choose the replacement day off before requesting this visit-day exception.",
            "repl-window": "Choose a replacement working date after the field-work date and within {days} days.",
            "repl-unavailable": "Choose an available rostered working date for the replacement day off.",
            "repl-taken": "That replacement date already has a planning adjustment. Choose another working date.",
            "done-off": "{date} classified as non-visit work and removed from visit-day capacity.",
            "done-on": "{date} exception requested — RSM approval will authorize attendance.",
            "done-clear": "{date} restored to the person calendar.",
            "click-leave": "{label} — hard-blocked by Leave; Field Ops cannot override it.",
            "click-comp": "{label} — this date is controlled by its linked field-work exception, not a free-text calendar remark.",
            "click-exception": "{label} — a reason and compensation choice are required before requesting field work.",
            "click-selected": "Date selected — review availability and capacity below.",
            "multi-on": "Multi-select on — pick dates, then Include or Exclude. Exceptions still require a reason individually.",
            "multi-none": "Nothing selected yet — pick dates first.",
            "multi-included": "{n} date included | {n} dates included",
            "multi-excluded": "{n} date classified as non-visit work | {n} dates classified as non-visit work",
            "multi-skip-tail": "{n} date skipped — exception details or a default non-visit activity are required | {n} dates skipped — exception details or a default non-visit activity are required",
            "multi-tail": "capacity updated in place.",
            "multi-skipped": "{n} selected date needs exception details or a default non-visit activity. | {n} selected dates need exception details or a default non-visit activity.",
            "reset": "Visit days restored from the Person Calendar (Scheduling).",
            "cap-range": "Capacity must be between 1 and 30 visits for the selected date.",
            "cap-reason": "A reason is required for a date-specific capacity change.",
            "cap-done": "{date} capacity set to {n} visits · schedule recalculated.",
            "cap-restored": "{date} capacity restored to the plan default · schedule recalculated."
          }
        },
        "rev": {
          "loading": "Preparing the review…",
          "intro": "Confirm the monthly plan before sending it to {rsm} for approval · rev {rev}",
          "intro-amend": "Confirm proposed {rev} before sending only its changes to {rsm}. Approved Revision {base} remains active while review is pending.",
          "revision": "Revision {rev}",
          "amend-request": "Amendment request",
          "reason": "Reason:",
          "effective": "Effective:",
          "not-selected": "Not selected",
          "changes": "Changes from Approved Revision {base}",
          "no-change": "No planning change detected yet.",
          "kpi-outlets": "Planned outlets",
          "kpi-outlets-s": "{pct}% of assigned outlets",
          "kpi-visits": "Generated visits",
          "kpi-visits-s": "across {n} visit cycle · from the balanced schedule | across {n} visit cycles · from the balanced schedule",
          "kpi-peak": "Peak daily load",
          "kpi-peak-ok": "capacity is feasible",
          "kpi-peak-no": "CONFLICTS — see readiness",
          "kpi-util": "Utilization",
          "kpi-util-s": "of {slots} total visit slots across {days} visit days",
          "summary": "Plan summary",
          "period": "Planning period",
          "baseline": "Revision baseline",
          "source": "Starting source",
          "baseline-v": "Approved Revision {base} → Proposed Revision {rev}",
          "target": "Visit target",
          "target-v": "{n} generated / {target} targeted",
          "target-above": "{n} above target",
          "target-gap": "{n} visit is below target — explain for the RSM or revise Step 2. | {n} visits are below target — explain for the RSM or revise Step 2.",
          "target-why": "Reason for target shortfall",
          "min-v": "{n}/month",
          "min-below": "{n} outlet below minimum | {n} outlets below minimum",
          "min-met": "minimum met for all outlets",
          "min-why": "Below-minimum explanation",
          "min-why-missing": "Missing — submission blocked",
          "nonvisit": "Non-visit working days",
          "not-classified": "Not classified",
          "dur-policy-l": "Visit-duration policy",
          "dur-policy": "minimum {min} · maximum {max} · {inc}-minute increments",
          "dur-none": "NOT CONFIGURED — planning is blocked",
          "dur-below": "Below-estimate durations ({n})",
          "dur-below-row": "{site} · {sel} min vs {est} min estimate —",
          "dur-below-missing": "explanation missing",
          "cal-days": "{n} visit days",
          "cal-adj": "{n} manual adjustment | {n} manual adjustments",
          "cal-cap": "{n} date-capacity override | {n} date-capacity overrides",
          "checklist": "Applied checklist:",
          "mix-n": "({n} outlet) | ({n} outlets)",
          "checklist-tail": "— tasks come from the Work Management Master Task Library.",
          "readiness": "Submission readiness",
          "ok": "Ready",
          "not-ok": "Needs attention",
          "override": "Capacity override on record — {reason} (visible to the RSM).",
          "review-again": "Review schedule again"
        },
        "ready": {
          "out": "Outlet work is complete",
          "out-ok": "{n} of {n} outlets have purpose, Visit Cycle membership, proposed dates, window and duration.",
          "out-no": "Add at least one outlet in Step 2.",
          "sched": "Schedule is generated",
          "sched-ok": "{n} visits are distributed across {dates} working dates and {cycles} cycle. | {n} visits are distributed across {dates} working dates and {cycles} cycles.",
          "sched-no": "No visits generated yet — add outlets in Step 2.",
          "overlap": "Visit Cycle handoff is valid",
          "overlap-ok": "No cycle date ranges overlap.",
          "overlap-warn": "Adjacent cycles share one handoff date; this is allowed within that date’s capacity.",
          "overlap-no": "A later cycle starts before the prior cycle finishes — revise Step 2 before submission.",
          "target": "Monthly visit target is met or explained",
          "target-explained": "{n}-visit shortfall has an RSM-visible explanation.",
          "target-over": "Schedule is {n} visit above target and remains within capacity. | Schedule is {n} visits above target and remains within capacity.",
          "target-ok": "Generated schedule matches the monthly target.",
          "target-no": "{n} visit is below target — explain the variance or revise Step 2. | {n} visits are below target — explain the variance or revise Step 2.",
          "cap": "Capacity is feasible",
          "cap-ok": "Peak load is {peak} against the applicable limit of {cap} on {date}.",
          "cap-busiest": "the busiest date",
          "cap-no": "{n} visit cannot be placed — choose another proposed date, add visit days, or record a reasoned date-capacity exception. | {n} visits cannot be placed — choose another proposed date, add visit days, or record a reasoned date-capacity exception.",
          "work": "Non-visit working days are classified",
          "work-ok": "Days without a planned outlet visit default to {type}.",
          "work-no": "Choose what work is expected when no PJP visit is scheduled; Other requires a description.",
          "min": "Minimum coverage is explained",
          "min-explained": "{n} outlet is below the planning minimum with an RSM-visible explanation. | {n} outlets are below the planning minimum with an RSM-visible explanation.",
          "min-ok": "Every outlet meets or exceeds the planning minimum.",
          "min-no": "{n} outlet is below the minimum — add an RSM-visible reason before submission. | {n} outlets are below the minimum — add an RSM-visible reason before submission.",
          "exc": "Calendar exceptions are handled",
          "exc-ok": "Project non-working days and public holidays are avoided unless included with a reasoned override; outlet unavailability is respected",
          "exc-adj": "manual calendar adjustments recorded and audited",
          "exc-tail": "no unresolved conflicts remain.",
          "exc-no": "Unresolved conflicts remain — open Schedule Preview."
        },
        "life": {
          "title": "Approval handoff",
          "note": "Submission does not publish the plan; RSM approval is still required.",
          "note-amend": "Submission does not replace the approved plan; RSM approval is still required.",
          "draft": "Draft",
          "working": "Working Revision",
          "pending": "Pending Approval",
          "pending-amend": "Amendment Pending",
          "published": "Approved & Published",
          "active": "Revision Active",
          "appr": "Submitting sends this revision to {rsm} for review — Approve & Publish happen together on the RSM side; you cannot silently change the plan while approval is pending.",
          "appr-amend": "Submitting sends the proposed change set to {rsm} for review. Approved Revision {base} stays operational until Revision {rev} is approved; completed and elapsed work is never rewritten.",
          "subnote": "Note to your RSM (optional)"
        },
        "lane": {
          "empty": "No planned visits yet — add outlets to see the coverage progression.",
          "title": "Monthly coverage commitment",
          "hint": "Actual dated routes remain visible in Schedule Preview.",
          "cycles": "{n} cycle | {n} cycles",
          "cycle": "Visit Cycle {k}",
          "outlets": "{n} outlet | {n} outlets",
          "visits": "{n} visit | {n} visits",
          "finish": "planned finish {d}",
          "rule": "Next-cycle rule:",
          "rule-text": "each outlet enters its next Visit Cycle only after its own earlier visit and required minimum spacing — respecting working dates, capacity, holidays and outlet unavailability.",
          "overlap": "Visit Cycle windows overlap across different outlets.",
          "overlap-text": "Visit Cycle {b} starts {start} while Visit Cycle {a} finishes {finish}. This is expected when cycle membership differs; every outlet’s own sequence and spacing remain protected. Use Step 3 for the actual dated routes."
        },
        "plan": {
          "banner-title": "Build the monthly plan by Visit Cycle.",
          "banner": "Review each cycle, then adjust its outlets, first-to-last order and proposed dates. Purpose, preferred window and duration remain editable; the checklist follows the purpose automatically.",
          "fits": "Visit Cycle plan fits the available calendar.",
          "fits-text": "{n} planned visits across {days} visit days · peak {peak} / {cap} on {date} · {rem} visit slots remain.",
          "fits-tail": "Cycle membership and proposed dates remain explicit and editable.",
          "unplaced": "{n} planned visit cannot be placed. | {n} planned visits cannot be placed.",
          "unplaced-actions": "Recommended actions: {a}, {b}, or {c}. The system never removes an outlet from a Visit Cycle automatically.",
          "unplaced-a": "choose another proposed date",
          "unplaced-b": "add a visit day",
          "unplaced-c": "raise capacity for the selected date with an audited reason",
          "title": "Plan by Visit Cycle",
          "title-hint": "A Visit Cycle is one planned pass through its selected outlets. Each cycle may have its own membership, order and proposed dates.",
          "cycles-chip": "{n} cycle · {visits} visits | {n} cycles · {visits} visits",
          "tabs-label": "Visit Cycles",
          "cycle": "Visit Cycle {k}",
          "partial": "partial",
          "dates-pending": "dates pending",
          "copy-next": "Apply to next cycle",
          "copy-rest": "Apply to all remaining cycles",
          "reset-all": "Reset system suggestion",
          "calc": "Calculated visits/month:",
          "calc-text": "an outlet’s value is the number of Visit Cycles containing it. Minimum {n} ·",
          "calc-below": "{n} below minimum — warning/explanation remains required | {n} below minimum — warning/explanation remains required",
          "calc-met": "all outlets meet the minimum",
          "overlap-block": "Visit Cycle dates overlap by more than the handoff day — submission blocked.",
          "overlap-block-text": "Visit Cycle {b} starts {start} before Visit Cycle {a} finishes {finish}. Adjust the cycle dates so the next cycle starts on or after the prior cycle finish.",
          "overlap-warn": "Same-day cycle handoff.",
          "overlap-warn-text": "Visit Cycle {b} starts {start} as Visit Cycle {a} finishes. This is allowed when the combined visits remain within that date’s capacity.",
          "editing": "Editing Visit Cycle {k}",
          "editing-hint": "All route, outlet and bulk changes below apply to this selected cycle.",
          "window": "Suggested cycle window",
          "window-end": "Last available visit day for Cycle {k}",
          "window-note": "Cycle {k} starts on the next available visit day. Shortening gives it days; extending takes days from it.",
          "window-final": "Final cycle uses the remaining available visit days.",
          "window-reset": "Reset suggested windows",
          "guardrail": "Planning guardrail review.",
          "guardrail-below": "{n} outlet is below the stated minimum. | {n} outlets are below the stated minimum.",
          "guardrail-target": "{n} planned visit is below the monthly target. | {n} planned visits are below the monthly target.",
          "guardrail-tail": "The plan remains editable; an explanation is required before submission.",
          "min-why": "Reason for outlets below minimum",
          "target-why": "Reason for monthly target shortfall",
          "zero": "{n} outlet is planned for 0 visits this month. | {n} outlets are planned for 0 visits this month.",
          "zero-text": "It remains in the monthly plan but belongs to no Visit Cycle, so it is below the minimum of {min}. Add to a Visit Cycle, or explain the shortfall before submission. | They remain in the monthly plan but belong to no Visit Cycle, so they are below the minimum of {min}. Add to a Visit Cycle, or explain the shortfall before submission.",
          "visits-month": "visits/month",
          "chk": "The selected {purpose} applies its standard checklist from the {library}. Step 3 remains the authoritative full monthly calendar.",
          "chk-purpose": "Visit Purpose",
          "chk-library": "Work Management Master Task Library",
          "bulk-select": "Select cycle",
          "bulk-clear": "Clear",
          "bulk-count": "{n} selected",
          "bulk-priority": "Priority…",
          "bulk-purpose": "Purpose…",
          "bulk-window": "Window…",
          "bulk-min": "Min",
          "bulk-dur": "Estimated duration (minutes) for the selected outlets",
          "bulk-remove": "Remove from this cycle",
          "bulk-field": {
            "priority": "Priority",
            "purpose": "Visit purpose (checklist follows automatically)",
            "window": "Preferred window",
            "dur": "Estimated duration"
          },
          "bulk-confirm": "Remove {n} selected outlet from Visit Cycle {k}? | Remove {n} selected outlets from Visit Cycle {k}?",
          "bulk-confirm-text": "Other Visit Cycles and the monthly outlet assignment remain unchanged.",
          "keep": "Keep",
          "cancel": "Cancel",
          "close": "Close",
          "conflict": "{date} is full ({used} / {cap}).",
          "conflict-text": "Choose another date, or record a date-specific capacity exception with an audited reason.",
          "conflict-why": "Exception reason",
          "conflict-apply": "Increase this date by 1",
          "add": "Add to Visit Cycle {k}",
          "add-label": "Outlet to add to Visit Cycle {k}",
          "add-none": "Every outlet in this monthly plan is already in Visit Cycle {k}.",
          "note": {
            "copied-next": "✓ Visit Cycle {from} outlets, starting outlet and visit order applied to Visit Cycle {to}. New dates were suggested from each destination cycle’s available Visit Days and capacity.",
            "copied-all": "✓ Visit Cycle {from} outlets, starting outlet and visit order applied to {n} remaining cycle. New dates were suggested from each destination cycle’s available Visit Days and capacity. | ✓ Visit Cycle {from} outlets, starting outlet and visit order applied to {n} remaining cycles. New dates were suggested from each destination cycle’s available Visit Days and capacity.",
            "reset-all": "✓ Visit Cycles reset to the original system suggestion.",
            "select-first": "Select outlets first — bulk changes apply only to selected outlets.",
            "remove-first": "Select outlets first — removal applies only to the active Visit Cycle.",
            "bulk-set": "✓ {field} updated for {n} selected outlet — estimates, workload and capacity recalculated. Unselected outlets kept their values. | ✓ {field} updated for {n} selected outlets — estimates, workload and capacity recalculated. Unselected outlets kept their values.",
            "bulk-removed": "✓ {n} selected outlet removed from Visit Cycle {k} only. Other cycles are unchanged. | ✓ {n} selected outlets removed from Visit Cycle {k} only. Other cycles are unchanged.",
            "cand-first": "Select one or more assigned outlets first.",
            "cand-added": "✓ {n} assigned outlet added. The first selected outlet is the initial route start; use the order controls to change it later. | ✓ {n} assigned outlets added. The first selected outlet is the initial route start; use the order controls to change it later.",
            "cand-added-map": "✓ {n} assigned outlet added from the map. The first selected outlet is the initial route start; use the order controls to change it later. | ✓ {n} assigned outlets added from the map. The first selected outlet is the initial route start; use the order controls to change it later.",
            "reset-part-order": "✓ Visit Cycle {k} outlet order reset. All outlets remain in this cycle.",
            "reset-part-dates": "✓ Visit Cycle {k} dates reset. All outlets remain in this cycle.",
            "reset-part-both": "✓ Visit Cycle {k} outlet order and dates reset. All outlets remain in this cycle."
          },
          "cand-title": "Available assigned outlets",
          "cand-hint": "All assigned outlets not yet selected remain candidates.",
          "cand-n": "{n} available",
          "cand-assigned": "Assigned outlet",
          "cand-add": "Add selected ({n})",
          "cand-add-hint": "Select one for a single add, or select several to add them together.",
          "cand-nogeo": "Assigned outlet coordinates are unavailable; use the candidate list.",
          "cand-map": "Add from map",
          "cand-map-hint": "Select assigned outlet pins, then add them to this plan.",
          "cand-map-add": "Add selected from map",
          "select": "Select",
          "deselect": "Deselect",
          "include": "Include",
          "exclude": "Exclude",
          "map-note-edit": "— click any pin to include or exclude it · Step 3 remains the authoritative dated monthly calendar",
          "map-note-read": "— read-only submitted route review · Step 3 remains the authoritative dated monthly calendar",
          "spill": "next available after window",
          "why": {
            "step1": "not a Visit Day in Step 1",
            "step1-off": "other work in Step 1",
            "step1-comp": "compensatory rest",
            "unavailable": "outlet unavailable",
            "before-prev": "before previous route stop",
            "after-next": "after next route stop",
            "too-close": "too close to Cycle {k}",
            "too-soon": "too soon after Cycle {k}",
            "full": "daily capacity full",
            "before-window": "before cycle window",
            "outside-window": "outside cycle window",
            "other": "unavailable"
          },
          "reset-cycle": "Reset cycle",
          "reset-cycle-title": "Reset Visit Cycle {k}",
          "reset-cycle-text": "Choose what to reset. All outlets stay in this cycle.",
          "reset-order": "Outlet order",
          "reset-dates": "Dates",
          "reset-both": "Outlet order & dates",
          "selected": "selected",
          "date-for": "Visit date for {name}",
          "pick-date": "Pick date",
          "picker-title": "Choose date · {name}",
          "picker-hint": "Only dates available from Step 1 can be selected. Route order and daily capacity also apply.",
          "pick": {
            "ok": "Available visit date",
            "step1": "Unavailable in Step 1",
            "outlet": "Outlet unavailable",
            "before-prev": "Before the previous route stop",
            "after-next": "After the next route stop",
            "before-next-cycle": "Before the outlet’s next seven-day cycle period",
            "overlaps-next": "Overlaps the outlet’s selected next cycle period",
            "full": "Daily capacity full"
          },
          "tbl": {
            "label": "Visit Cycle {k} outlets",
            "select": "Select",
            "select-row": "Select {name}",
            "order": "Order",
            "outlet": "Outlet",
            "promoter": "Promoter",
            "priority": "Priority",
            "purpose": "Visit purpose",
            "date-proposed": "Proposed visit date",
            "date-scheduled": "Scheduled visit date",
            "capacity": "Capacity",
            "window": "Window",
            "min": "Min",
            "planned": "Planned / month",
            "actions": "Row actions",
            "start": "Start",
            "carry": "Carry-forward priority",
            "tasks": "tasks",
            "not-scheduled": "Not scheduled",
            "slots-left": "{n} slot left | {n} slots left",
            "dur": "Duration (minutes)",
            "est": "est {n} min",
            "suggest": "suggest {n}",
            "unresolved": "unresolved task version — {text}",
            "legacy": "legacy · {why} — kept as recorded",
            "review": "task set changed —",
            "keep": "Keep {v}",
            "use": "Use {v}",
            "use-suggestion": "Use suggestion",
            "below-recorded": "below the {n}-min estimate — reason recorded by {by} on {at}: {reason}",
            "below-required": "below the {n}-min estimate — an explanation is required",
            "below-why": "Why is the planned duration below the estimate?",
            "minimum": "minimum {n}",
            "earlier": "Move earlier",
            "later": "Move later",
            "remove": "Remove from this Visit Cycle only",
            "tasks-from": "{n} tasks from Work Management Master Task Library",
            "empty": "This Visit Cycle has no outlets. Add one below or copy the structure from an earlier cycle."
          },
          "regen-title": "✓ Schedule Preview regenerated",
          "regen": "— the calendar below re-derives from the current Visit Cycles, proposed dates, outlet work, capacity and approved calendar exceptions."
        }
      },
      "phone": {
        "label": "Field mode",
        "tag": "PROTOTYPE · field mode",
        "close": "Close field mode",
        "today": "Today · {date}",
        "promoter": "Promoter {name}",
        "no-stops": "No stops today.",
        "back": "‹ Route",
        "check-in": "Check in at outlet",
        "combined": "Combined Visit",
        "combined-union": "approved task union ({n} duplicate removed) | approved task union ({n} duplicates removed)",
        "dur": "~{n} min",
        "window": "window {w}",
        "feed-label": "Work Management feed:",
        "feed": "{n} planned task | {n} planned tasks",
        "feed-added": " + {n} added in field",
        "flow": {
          "label": "Field execution steps",
          "checkin": "✓ Check in",
          "review": "2 Review {a}/{b}",
          "tasks": "3 Tasks {a}/{b}",
          "followup": "4 Follow-up",
          "clockout": "5 Clock out"
        },
        "sec": {
          "prior": "2. Previous follow-ups · {a}/{b} reviewed",
          "planned": "3. Today's planned tasks · {a}/{b} completed",
          "added": "Additional tasks · {a}/{b} completed",
          "followup": "4. Add follow-up or improvement point"
        },
        "prior-empty": "No unresolved follow-up from an earlier visit at this outlet.",
        "added-empty": "Add only when extra work is needed during this visit.",
        "add-task": "＋ Add task from Work Management…",
        "add-action": "＋ Add Work Management action",
        "created": "Created this visit:",
        "notes": "Visit notes / coaching topic",
        "wm-hint": "A finding or commitment can create a {wm} at check-out (flagged findings do this automatically). Coaching notes stay observation evidence — never an automatic performance rating.",
        "wm-hint-action": "Work Management action",
        "ready": "Ready to complete",
        "ready-tail": " · checklist and mandatory evidence are complete.",
        "incomplete": "Visit remains incomplete",
        "complete": "Check out & complete",
        "complete-title": "Complete the checklist and required evidence first",
        "flag-placeholder": "Issue observed (manual flag reason)",
        "complete-flag": "Complete + flag",
        "closed": "Visit is {status}{flag}. Score {score}.",
        "closed-flag": " — flagged: {reasons}",
        "vstatus": {
          "planned": "planned",
          "scheduled": "scheduled",
          "inprogress": "inprogress",
          "completed": "completed",
          "cancelled": "cancelled"
        },
        "task": {
          "min": "{n} min",
          "evidence": {
            "photo": "photo required",
            "note": "note required",
            "none": "no attachment required"
          },
          "source": {
            "planned": " · planned",
            "additional": " · added in field"
          },
          "remove": "Remove added task",
          "complete": "Complete",
          "issue": "Issue found",
          "note-issue": "Describe the issue and next action",
          "note-required": "Required task note",
          "add-photo": "📷 Add photo evidence"
        },
        "photo": {
          "remove": "Remove photo evidence",
          "source": {
            "camera": "Taken with camera",
            "library": "Selected from library"
          },
          "status": {
            "active": "active",
            "superseded": "superseded",
            "failed": "failed",
            "purged": "purged"
          }
        },
        "retention": {
          "pending-config": "Retention pending configuration",
          "held": "Retention on legal hold — original date {date}",
          "pending": "pending",
          "pending-anchor": "Retention starts when this record closes",
          "set": "Retention until {date}"
        },
        "fu": {
          "meta": "{id} · from {from} · due {due}",
          "previous-visit": "previous visit",
          "overdue": "overdue",
          "evidence-required": "evidence required",
          "outcome": {
            "placeholder": "Record today's update…",
            "completed": "Completed today — send for LM verification",
            "progress": "Progress made — keep open",
            "blocked": "Blocked — keep open",
            "not-applicable": "Not applicable during this visit"
          },
          "note": "Required update: what was done, remains, or blocked",
          "add-evidence": "📷 Add completion evidence"
        },
        "fu-status": {
          "open": "Open",
          "inprogress": "In Progress",
          "submitted": "Submitted for Verification",
          "reopened": "Returned for Correction",
          "resolved": "Verified"
        },
        "form": {
          "kind-label": "Action type",
          "kind": {
            "follow-up": "Follow-up",
            "improvement": "Improvement",
            "issue": "Issue"
          },
          "kind-hint": "Structured type (PO-D19) — “escalation” is a workflow condition, not a type.",
          "desc": "What needs to happen next?",
          "task-label": "Linked task",
          "no-task": "No task link (source context recorded as missing)",
          "critical": "Source finding is critical",
          "due-title": "Leave empty for the policy default due date (High +3 · Normal +5 working days — PO-D20)",
          "create": "Create action",
          "cancel": "Cancel"
        },
        "sheet": {
          "title": "Add evidence photo",
          "evidence": "Evidence",
          "cancel": "Cancel photo capture",
          "camera": "📷 Take photo",
          "library": "▧ Choose from photo library",
          "lib-reason": "Required if you choose the library: why is this not a camera photo?",
          "help": "{camera} is preferred for live proof. A library image is allowed {reason}, is clearly labelled in the audit record, and then fully satisfies the requirement. Without the reason the task simply stays incomplete — the visit is not failed.",
          "help-camera": "Camera",
          "help-reason": "with a one-line reason"
        },
        "toast": {
          "done": "✓ Visit completed",
          "flagged": "Visit completed — Flagged ({sev}) · follow-up required",
          "synced": "Synced {n} location record | Synced {n} location records",
          "nothing": "Nothing pending — already synchronised."
        },
        "issues": {
          "tasks": "{n} Work Management checklist item incomplete | {n} Work Management checklist items incomplete",
          "photos": "{n} required visit photo missing | {n} required visit photo missings",
          "photos-lib": "{n} required visit photo missing ({lib} awaiting a library-selection reason) | {n} required visit photo missings ({lib} awaiting a library-selection reason)",
          "notes": "{n} required task note missing | {n} required task notes missing",
          "unreviewed": "{n} previous follow-up not reviewed | {n} previous follow-ups not reviewed",
          "update-notes": "{n} follow-up update note missing | {n} follow-up update notes missing",
          "update-evidence": "{n} completed follow-up evidence item missing | {n} completed follow-up evidence items missing"
        },
        "sim": {
          "title": "Prototype location simulator — no real GPS in V6",
          "inside": "At outlet",
          "edge": "Near boundary",
          "far": "Away from outlet",
          "weak": "Weak signal",
          "denied": "Permission denied",
          "none": "No fix",
          "offline": "Simulate offline device — captures stay Pending sync"
        },
        "geo": {
          "state": {
            "unconfigured": "Unconfigured",
            "permission-denied": "Permission denied",
            "no-fix": "No fix",
            "low-confidence": "Low confidence",
            "inside": "Inside",
            "outside": "Outside",
            "boundary-uncertainty": "Boundary uncertainty",
            "not-captured": "Not captured / N-A"
          },
          "source": {
            "site": "site",
            "project": "project"
          },
          "nums": {
            "distance": "distance {n} m",
            "accuracy": "accuracy ±{n} m",
            "radius": "radius {n} m",
            "none": "No distance, accuracy or radius is recorded for this state — nothing is assumed."
          },
          "reason": "Reason required — the action is then allowed and flagged",
          "foot": "Simulated location · V6 soft control only, never a block · not an attendance record.",
          "why": {
            "no-coords": "no outlet coordinates in Site/Outlet Master",
            "no-radius": "no outlet geofence radius, and no project fallback radius has been explicitly configured",
            "no-threshold": "no project accuracy threshold has been explicitly configured",
            "denied": "location permission denied on the device",
            "no-fix": "no location reading is available",
            "no-distance": "distance to the outlet could not be calculated",
            "inside": "the reported position and its accuracy circle sit wholly inside the outlet geofence",
            "outside": "the reported position and its accuracy circle sit wholly outside the outlet geofence",
            "boundary": "the accuracy circle overlaps the geofence boundary — presence can be neither confirmed nor excluded",
            "low": "reported accuracy ±{acc} m exceeds the configured threshold of {thr} m"
          },
          "rec": {
            "checkin": "Check-in location",
            "checkout": "Check-out location",
            "pending": "Pending sync",
            "synced": "Synced",
            "flagged": "Flagged",
            "captured": "captured {at}",
            "synced-at": "synced {at}",
            "reason": "Reason: {r}",
            "sync-now": "Sync now",
            "none-title": "Location: {label}",
            "none-body": "This record predates geofence capture or was created by the system — no evaluation exists. That is provenance, not an exception."
          }
        }
      },
      "sla": {
        "state": {
          "ok": "On track",
          "reminder": "Due soon",
          "urgent": "Urgent — due today",
          "breached": "Overdue",
          "escalated": "Escalated",
          "met": "Met",
          "met-late": "Met late",
          "met-offline": "Met · offline synced"
        },
        "wd": "{n} WD",
        "by": "by {date}",
        "sync-pending": "sync pending",
        "paused": "paused (approved leave)",
        "policy": "policy {ref}",
        "capped": "target capped",
        "legacy": "legacy record",
        "label": {
          "due": "Due",
          "resp": "Resp",
          "verify": "Verify",
          "response": "First response",
          "delivery": "Delivery",
          "verification": "Verification",
          "acknowledge": "Acknowledge"
        }
      },
      "actions": {
        "note": {
          "lead": "Visit complete ≠ issue resolved.",
          "a": "Corrective actions are owned and tracked in",
          "wm": "Work Management",
          "b": ". The supervisor submits the action taken and evidence; the LM verifies or returns it. The original visit finding is never overwritten."
        },
        "empty": "No actions. Flagged visit findings create one automatically.",
        "status": {
          "open": "Open",
          "inprogress": "In Progress",
          "submitted": "Submitted for Verification",
          "reopened": "Returned for Correction",
          "resolved": "Verified"
        },
        "cols": {
          "action": "Action",
          "source": "Source visit · outlet",
          "owner": "Owner · due",
          "risk": "Risk",
          "sla": "SLA",
          "status": "Status",
          "evidence": "Evidence",
          "verification": "Verification",
          "open": "Open the action"
        },
        "kind": {
          "follow-up": "Follow-up",
          "improvement": "Improvement",
          "issue": "Issue"
        },
        "risk": {
          "High": "High",
          "Normal": "Normal"
        },
        "overdue": "overdue",
        "evidence": {
          "required": "Required",
          "supporting": "Supporting",
          "attached": "{n} attached",
          "photo": "📷 Correction photo",
          "receipt": "＋ Delivery receipt",
          "ack": "＋ Outlet acknowledgement",
          "revisit": "＋ Revisit evidence",
          "remove": "Remove",
          "none": "No correction evidence added yet."
        },
        "verification": {
          "pending": "Verification pending",
          "verified": "Verified {at}",
          "returned": "Returned · {reason}",
          "returned-default": "Returned · correction required",
          "not-submitted": "Not submitted"
        },
        "button": {
          "work": "Work on issue",
          "continue": "Continue work",
          "correct": "Correct & resubmit",
          "view-submission": "View submission",
          "view-record": "View record",
          "review": "Review",
          "view": "View"
        },
        "method": {
          "choose": "Choose resolution method…",
          "replenished": "Replacement / replenishment completed",
          "revisit": "Corrected during a revisit",
          "remote": "Corrected remotely with outlet",
          "late_evidence": "Required evidence supplied after visit",
          "exception": "Request evidence exception",
          "none": "—"
        },
        "basis": {
          "pinned-evidence": "pinned task requires evidence",
          "critical": "source finding marked critical",
          "issue": "action type is Issue",
          "unavailable": "structured source unavailable — defaulted to Normal",
          "none-met": "no High criterion met"
        },
        "missing-item": {
          "pinned-task": "pinned task",
          "pinned-unresolved": "pinned task version unresolved",
          "severity": "finding severity",
          "type": "action type"
        },
        "drawer": {
          "aria": "Corrective action {id}",
          "eyebrow": "CORRECTIVE ACTION · {id}",
          "meta": "{type} · owner {owner} · due {due}",
          "close": "Close",
          "separate-lead": "Visit completion and issue resolution are separate.",
          "separate-body": "The original visit finding remains immutable. This action closes only after corrective work is submitted with the required evidence and verified by the LM.",
          "source-title": "ORIGINAL SOURCE FINDING",
          "visit": "Visit",
          "outlet": "Outlet",
          "visit-date": "Visit date",
          "type": "Type (structured)",
          "risk": "Risk (structured)",
          "pin": "Pinned task version",
          "severity": "Source finding severity",
          "critical": "Critical",
          "not-critical": "Not critical",
          "executor": "Actual visit executor",
          "executor-none": "not recorded (pre-PO-D19 visit)",
          "sla-title": "SLA · PO-D20 (soft control — a breach warns, escalates and is audited; it never blocks or auto-decides)",
          "missing": "Structured source context missing at creation: {list} — risk was derived from the available structure only, never from free text (PO-D19).",
          "submissions": "{n} submissions preserved — a Return for Correction never erases earlier submissions or evidence (PO-D19).",
          "returned": "Returned for Correction:",
          "step1": "1 · HOW WAS THE ISSUE HANDLED?",
          "step2": "2 · ACTION PERFORMED",
          "step2-ph": "What was actually done (e.g. replenished 2 SKUs, rebuilt facing)",
          "step3": "3 · RESOLUTION NOTE",
          "step3-ph": "Describe what was corrected, quantity/result and who confirmed it.",
          "step4": "4 · CORRECTION COMPLETED ON",
          "step5": "5 · EVIDENCE",
          "required-pinned": "REQUIRED — pinned task version {pin} (not reducible)",
          "required": "REQUIRED",
          "supporting": "(supporting evidence)",
          "exception-lead": "Exception does not auto-close the issue.",
          "exception-body": "Explain why evidence cannot be obtained. The LM can accept the exception or require a revisit.",
          "cannot-submit": "Cannot submit:",
          "submitted-title": "SUBMITTED CORRECTIVE ACTION",
          "action-performed": "Action performed:",
          "completed": "Completed {on} · submitted {at}",
          "submitted-evidence": "SUBMITTED EVIDENCE",
          "no-file": "No file evidence — evidence exception requested.",
          "verified-lead": "Verified",
          "verified-body": "— final business state · {at} · by {by}{via}{note}",
          "via": {
            "direct-line": "direct-line",
            "designated": "designated"
          },
          "reopen-rule": "Reopening requires a new linked corrective action (PO-D19).",
          "linked": "Linked follow-on: {ids}",
          "follow-on": "Raise linked follow-on action",
          "foot": "Work Management owns the corrective action; Field Ops preserves the source visit and delivery audit.",
          "start": "Start action",
          "submit": "Submit for Verification",
          "verify-ph": "Verifier note (required)",
          "return": "Return for Correction",
          "verify": "Verify"
        },
        "err": {
          "method": "Choose how the issue was handled.",
          "action": "Record the action performed — what was actually done (PO-D19).",
          "note": "Describe the corrective action taken (at least 10 characters).",
          "date": "Record the date the corrective action was completed.",
          "pinned": "The pinned task version requires evidence — this floor cannot be reduced or waived, including by exception (PO-D19).",
          "evidence": "Evidence is required. Add a correction photo, receipt, acknowledgement or revisit evidence.",
          "exception": "An evidence exception needs a clear reason for the LM to assess.",
          "source": "Record whether this evidence came from the camera or the photo library.",
          "remove-reason": "A reason is required to remove evidence. The original is retained as superseded; nothing is deleted.",
          "return-note": "Explain what evidence or correction is still required.",
          "verify-note": "A verifier note is required to Verify (PO-D19, AUTH-018).",
          "scope": "This corrective action is outside your authorized scope."
        },
        "toast": {
          "submitted": "Corrective action submitted for verification",
          "verified": "Corrective action Verified",
          "returned": "Returned for Correction — the owner sees your reason"
        },
        "mgmt": {
          "line": "· owner {owner} · {site} · due {due}",
          "empty": "No follow-ups in the filtered population."
        }
      },
      "md": {
        "title": "Manager-Directed Visits",
        "purpose-title": "Business Visit Purpose — Ad Hoc is the origin, never a purpose",
        "channel": {
          "in-app": "in-app",
          "verbal": "verbal"
        },
        "vstatus": {
          "inprogress": "in progress",
          "scheduled": "scheduled",
          "planned": "planned",
          "completed": "completed",
          "cancelled": "cancelled"
        },
        "aria": {
          "supervisor": "Supervisor",
          "outlet": "Outlet",
          "purpose": "Visit Purpose"
        },
        "sup": {
          "sub": "origin “Manager-Directed/Ad Hoc” — same visit form & WM checklist; never a separate plan",
          "counts": "{done} fulfilled · {open} open",
          "record": "Record verbal LM instruction",
          "awaiting": "awaiting acknowledgement",
          "acknowledged": "acknowledged",
          "requested-by": "requested by",
          "meta": "recorded by {rec} · {channel} · purpose: {purpose}",
          "ack": "Acknowledge",
          "inroute-a": "Visit",
          "combined-with": "(Combined with {id})",
          "inroute-b": "is on today’s route — {status}. Execute it from the route below or field mode.",
          "elig-a": "This outlet has an eligible future PJP occurrence —",
          "elig-b": "planned {date}. A Combined Visit is ONE check-in, checkout, duration and physical record; overlapping tasks are deduplicated; the PJP occurrence completes early only when ALL mandatory PJP work is done.",
          "no-elig": "No eligible future PJP occurrence for this outlet — execute as Manager-Directed only.",
          "combine": "Start Combined Visit ({id})",
          "only-elig": "Manager-Directed only",
          "only": "Start Manager-Directed visit",
          "route-note": "Your planned PJP route is never silently changed: displaced stops stay scheduled — reorder or reschedule them explicitly (Week tab ↻), or request an amendment.",
          "empty": "No open directions. In-app directions from your RSM appear here for acknowledgement."
        },
        "form": {
          "lead": "Record a verbal / external LM instruction.",
          "body": "Requested By and Recorded By stay separate: requested by your LM/RSM, recorded by you.",
          "requested-by": "Requested by",
          "recorded-by": "Recorded by",
          "rsm": "{name} (RSM)",
          "supervisor": "{name} (Supervisor)",
          "note-ph": "Instruction / context (optional)",
          "go": "Record & acknowledge",
          "cancel": "Cancel"
        },
        "toast": {
          "combined": "Combined Visit created — one physical visit, both obligations tracked",
          "only": "Manager-Directed visit added to today’s route"
        },
        "kpi": {
          "issued": "Directions issued",
          "issued-sub": "your region",
          "awaiting": "Awaiting acknowledgement",
          "awaiting-sub": "supervisor action",
          "acknowledged": "Acknowledged",
          "acknowledged-sub": "not yet executed",
          "fulfilled": "Fulfilled",
          "fulfilled-sub": "{n} via Combined Visit"
        },
        "rsm": {
          "note": "— direct a supervisor in your region to an outlet in their assigned scope. The direction is an origin record (“Manager-Directed/Ad Hoc”), never a separate plan; the supervisor acknowledges and executes it with the standard visit form and WM checklist. PJP completion and Manager-Directed completion always report separately.",
          "flash": "Direction issued — the supervisor sees it on Execute · Today and must acknowledge before executing.",
          "direct": "Direct a visit",
          "note-ph": "Direction / context (optional)",
          "issue": "Issue direction",
          "scope": "Regional scope enforced: only your supervisors, only outlets in their assigned scope. Ad Hoc is an origin — the Visit Purpose stays a business purpose.",
          "fulfil-combined": "{id} · Combined — one physical visit; also completed PJP occurrence {pjp}",
          "fulfil-only": "{id} · Manager-Directed only",
          "empty": "No Manager-Directed Visits yet.",
          "report-note": "Reporting stays separate: PJP completion (Regional Execution) never counts Manager-Directed physical records, and a Combined Visit is ONE physical visit that fulfils one Manager-Directed requirement and one PJP obligation — no duplicate credit."
        },
        "cols": {
          "id": "ID",
          "outlet": "Outlet",
          "supervisor": "Supervisor",
          "requested": "Requested by",
          "recorded": "Recorded by",
          "channel": "Channel",
          "purpose": "Purpose",
          "status": "Status",
          "fulfilment": "Fulfilment"
        },
        "status": {
          "completed": "Fulfilled",
          "acknowledged": "Acknowledged",
          "cancelled": "Cancelled",
          "issued": "Issued"
        }
      },
      "map": {
        "truth": "Planned route execution view · not continuous employee GPS tracking. Route lines follow the planned outlet sequence (no turn-by-turn navigation); coordinates come from Site/Outlet Master.",
        "no-geo": "No outlet coordinates available from Site/Outlet Master — use List mode.",
        "canvas-label": "Planned route map. Arrow keys move the map, + and − zoom, 0 returns to the full route view.",
        "bg": {
          "river": "river",
          "north": "north district",
          "south": "south district",
          "caption": "Schematic background · illustrative (not survey cartography)"
        },
        "nav": {
          "up": "Move up",
          "down": "Move down",
          "left": "Move left",
          "right": "Move right",
          "reset": "Back to the full route view",
          "zoom-in": "Zoom in",
          "zoom-out": "Zoom out"
        },
        "status": {
          "done": "Completed",
          "flagged": "Flagged · Completed",
          "inpr": "In Progress",
          "up": "Upcoming",
          "missed": "Missed",
          "unav": "Outlet Unavailable"
        },
        "range": {
          "label": "Route period",
          "pjp": "PJP Period",
          "week": "Week",
          "day": "Day",
          "custom": "Custom Range",
          "month": "Approved PJP month",
          "week-date": "Any date inside the week",
          "day-date": "Day",
          "today": "Today",
          "from": "From",
          "to": "To",
          "invalid": "Invalid range — {to} must be on or after {from}. Adjust the dates to continue.",
          "pjp-label": "PJP period · {month}",
          "week-label": "week {wk} · {month}"
        },
        "stat": {
          "all": "All route status",
          "up": "Upcoming",
          "inpr": "In Progress",
          "done": "Completed",
          "missed": "Missed",
          "flagged": "Flagged",
          "unav": "Unavailable"
        },
        "updated": "Updated just now",
        "refresh": "Refresh",
        "kpi": {
          "routes": "Active routes",
          "routes-sub": {
            "pjp": "planned this PJP period",
            "week": "planned this week",
            "day": "planned for the day",
            "custom": "planned in the selected range"
          },
          "completed": "Completed",
          "flagged-sub": "{n} flagged",
          "inpr": "In progress",
          "inpr-sub": "checked in now",
          "up": "Upcoming",
          "unav-sub": "{n} outlet(s) unavailable",
          "exc": "Exceptions",
          "exc-sub": "{m} missed · {f} flagged"
        },
        "empty": "No planned routes in {range} under the current scope/filters.",
        "my-route": "My route",
        "sup-routes": "Supervisor routes",
        "show-route": "Show {name}'s route on the map",
        "stops": "{done} / {total} stops",
        "legend": {
          "owner": "Route owner:",
          "status": "Visit status:"
        },
        "detail": {
          "none": "No routes for this period.",
          "progress": "{name} · route progress",
          "summary": "{done} of {total} completed",
          "n-flagged": "{n} flagged",
          "n-inpr": "{n} in progress",
          "n-up": "{n} upcoming",
          "n-missed": "{n} missed",
          "n-unav": "{n} unavailable",
          "estimated": "Estimated",
          "distance": "distance {km}",
          "time": "time {t}",
          "hm": "{h}h {m}m",
          "current": "current:",
          "current-chip": "current",
          "timeline": "{name} · planned route milestones",
          "stop-label": "{n} {name}, {status}",
          "window": "window {w}",
          "visit": "Visit",
          "loc-unavailable": "location unavailable",
          "tasks": "Tasks {n} / {total} recorded",
          "score": "score {n}",
          "photos": "{n} evidence photo | {n} evidence photos",
          "exception": "exception recorded",
          "open-visit": "Open visit",
          "view-visit": "View visit",
          "nogeo-title": "Location unavailable ({n}):",
          "nogeo-text": "— no coordinates in Site/Outlet Master; records stay accessible in List mode."
        },
        "agg": {
          "truth": "Planned route execution view · not continuous employee GPS tracking. Aggregate coverage by geography — individual routes, outlet sequences and person-level records are outside this role's information ceiling.",
          "empty": "No execution data in the current scope/filters.",
          "svg-label": "Aggregate coverage by province",
          "done": "{done} / {n} done",
          "col": {
            "province": "Province",
            "planned": "Planned",
            "completed": "Completed",
            "missed": "Missed",
            "flagged": "Flagged",
            "completion": "Completion"
          }
        },
        "cycle": {
          "label": "Visit Cycle {k} route map",
          "start": "START",
          "include": "Include {name}",
          "exclude": "Exclude {name}",
          "legend-in": "● Included + routed",
          "legend-out": "○ Assigned, not included",
          "legend-google": "Google Maps provides live driving time and road distance from your current location",
          "missing": "{n} outlet has no coordinates and remains in the list controls | {n} outlets have no coordinates and remain in the list controls",
          "no-geo": "Assigned outlet coordinates are unavailable; use the included-outlet list below.",
          "rank": "Cycle {k} route rank",
          "n-stops": "{n} stops",
          "within": "Select dates within {range}",
          "pending": "dates pending",
          "no-date": "No date",
          "selected": "selected",
          "empty": "Include an outlet from the map to create the route.",
          "view": "Route view",
          "map": "Map",
          "list": "List",
          "start-badge": "S"
        }
      },
      "ins": {
        "note-title": "Execution Insights",
        "note": "outlet & route execution results. This is NOT employee appraisal: formal evaluation lives in Performance Management with its own templates, evaluators and review cycles.",
        "reporting-period": "Reporting period",
        "all-periods": "All periods",
        "period-select": "Reporting period",
        "period-hint": "Period is set in the filter bar below",
        "refreshed": "Last refreshed {ts}",
        "scope": {
          "owner": "Plan owner: {name}",
          "rsm": "Authorized scope: {sub}",
          "rsm-default": "regional line management",
          "hrbp": "Authorized scope: Optimal P oversight (project-wide)",
          "gov": "Authorized scope: aggregate governance view (counts only)"
        },
        "exec": {
          "inprogress": "In Progress · {done} / {total}",
          "closed": "Closed · {done} / {total}",
          "upcoming": "Upcoming",
          "upcoming-n": "Upcoming · {n} visits"
        },
        "close": {
          "met": "Closed · Met Plan",
          "partial": "Closed · Partially Achieved",
          "below": "Closed · Below Plan",
          "not-assessed": "Closed · Not Assessed",
          "cancelled": "Cancelled"
        },
        "sla": {
          "title": "SLA MEASURES · PO-D20 (policy {ref})",
          "sub-own": "Working-day clocks · Asia/Phnom_Penh · your actions. A breach warns, escalates and is audited — it never auto-decides anything.",
          "sub-agg": "Working-day clocks · Asia/Phnom_Penh · project aggregate — counts only, record access unchanged. A breach warns, escalates and is audited — it never auto-decides anything.",
          "col": {
            "measure": "Measure",
            "on-time": "On time",
            "open": "Open in target",
            "overdue": "Overdue open",
            "met-late": "Met late"
          },
          "row": {
            "response": "First response",
            "delivery": "Delivery (due date)",
            "verify": "Verification"
          }
        },
        "sup": {
          "coverage": "Outlet coverage",
          "outlets-sub": "{visited} / {total} outlets",
          "completion": "Completion",
          "due-sub": "{done} / {due} due",
          "clean": "Clean completion",
          "flag-rate": "flag rate {n}%",
          "avg": "Avg outlet score",
          "completed-visits": "completed visits",
          "empty": "No visits in this period.",
          "col": {
            "outlet": "Outlet",
            "visits": "Visits",
            "completed": "Completed",
            "missed": "Missed",
            "flagged": "Flagged",
            "avg": "Avg outlet score"
          }
        },
        "perf": {
          "clean": "Clean completion",
          "flag-rate": "flag rate {n}%",
          "avg": "Avg score",
          "completed-visits": "completed visits",
          "adherence": "Adherence",
          "on-planned-date": "on planned date",
          "col": {
            "clean": "Clean",
            "avg-score": "Avg score",
            "flag-rate": "Flag rate",
            "adherence": "Adherence"
          }
        }
      },
      "admin": {
        "config": {
          "note-title": "Configuration.",
          "note": "Checklist items and weights are configuration data — score and auto-flags derive from them. Visit Templates and the Operating Calendar have their own destinations. No operational entitlement is implied by administrative access.",
          "template": "Checklist template · {name}",
          "col": {
            "group": "Group",
            "item": "Item",
            "weight": "Weight",
            "critical": "Critical auto-flag"
          },
          "critical": "critical",
          "toggle-aria": "Critical auto-flag for item {n}: {item}"
        },
        "sla": {
          "title": "SLA POLICY · PO-D20 (AUTH-019)",
          "published": "Published system default v{v}",
          "override-active": "project override v{v} active",
          "no-override": "no project override — system default applies (evaluation never suspends)",
          "resolved": "resolved: {ref}",
          "wd": "WD",
          "reason": "Reason (required)",
          "set-project": "Set project override",
          "publish": "Publish new system default",
          "remove": "Remove override",
          "err-whole": "SLA values must be whole numbers of working days.",
          "coverage": "Coverage: {n} verification clock overdue | Coverage: {n} verification clocks overdue",
          "designated": "designated verifiers active: {n}",
          "coverage-suggest": " — consider designating LM/RSM coverage (AUTH-017). This panel grants no record-level access to action content.",
          "coverage-tail": " · This panel grants no record-level access to action content.",
          "audit": "POLICY AUDIT (latest)"
        },
        "vtpl": {
          "own-label": "Ownership:",
          "own-a": "the",
          "library": "Work Management Master Task Library",
          "own-b": "owns every reusable task definition ({n} published tasks). Field Ops Visit Templates only COMPOSE and reference approved library tasks per visit purpose — there is no second task library.",
          "intro-label": "Visit Task Templates",
          "intro-a": "compose approved tasks from the",
          "intro-b": "— Field Ops references the library, it never forks a second one. Route Template = your full assigned outlet list with standard defaults (a + New PJP starting source).",
          "unresolved": "unresolved task version",
          "minutes": "~{n} min",
          "tasks": "{n} library task | {n} library tasks"
        },
        "audit": {
          "note-title": "Audit.",
          "note": "Full read-only visibility for audit purposes; every status change, override, approval, amendment and resolution is event-logged on its record."
        }
      },
      "cal": {
        "note-title": "Operating Calendar.",
        "note": "Outlet unavailability = a TEMPORARY inability to visit (never permanent closure, program removal, resignation or leave — those stay with Site/Outlet Master and HR/People). Confirmed unavailable dates are avoided by the balanced scheduler and excuse Missed. Public holidays are company-calendar owned — read-only here.",
        "prev": "Previous month",
        "next": "Next month",
        "today": "Today",
        "today-lower": "today",
        "view": {
          "month": "Month",
          "list": "List"
        },
        "filter-label": "Event filter",
        "filter": {
          "all": "All events",
          "pjp": "PJP visits",
          "unav": "Outlet unavailability",
          "hol": "Public holidays / non-working",
          "exc": "Missed & exceptions"
        },
        "record": "+ Record unavailability",
        "grid-label": "Operating calendar, {month}",
        "dow": {
          "mon": "Mon",
          "tue": "Tue",
          "wed": "Wed",
          "thu": "Thu",
          "fri": "Fri",
          "sat": "Sat",
          "sun": "Sun"
        },
        "chip": {
          "visits": "{n} visit | {n} visits",
          "unav": "{n} unavailable",
          "missed": "{n} missed",
          "flagged": "{n} flagged"
        },
        "hol-title": "{name} · Company Calendar · non-working",
        "legend": {
          "pjp": "PJP visits",
          "unav": "Outlet unavailable",
          "hol": "Public holiday / non-working",
          "done": "Completed",
          "flagged": "Completed · flagged"
        },
        "list": {
          "visits": "{n} visits",
          "empty": "No events match this filter in {month}."
        },
        "day": {
          "planned": "Planned",
          "completed": "Completed",
          "inprogress": "In Progress",
          "upcoming": "Upcoming",
          "missed": "Missed",
          "flagged": "Flagged",
          "unavailable": "Unavailable",
          "by-sup": "Visits by supervisor ({n})",
          "visits": "visits",
          "n-done": "{n} done",
          "n-inprogress": "{n} in progress",
          "n-upcoming": "{n} upcoming",
          "visit": "Visit",
          "window": "window {w}",
          "empty": "No events on this date.",
          "impact-title": "Schedule impact:",
          "impact": "outlets marked unavailable are excluded by the balanced scheduler and their planned visits are excused — they never count as Missed. Approved future visits on an affected date surface as conflicts for reschedule/amendment."
        },
        "hist": {
          "title": "Unavailability history · {month}",
          "outlet": "Outlet",
          "status": "Status",
          "all-outlets": "All outlets",
          "all-statuses": "All statuses",
          "reset": "Reset",
          "empty": "No unavailability records in {month}."
        },
        "status": {
          "active": "Active",
          "scheduled": "Scheduled",
          "past": "Past",
          "cancelled": "Cancelled"
        },
        "col": {
          "outlet": "Outlet",
          "from": "From",
          "to": "To",
          "type": "Type",
          "reason": "Reason",
          "status": "Status",
          "recorded-by": "Recorded by",
          "actions": "Actions"
        },
        "upcoming": {
          "title": "Upcoming outlet unavailability · {month}",
          "reopen": "reopen {d}",
          "cancel": "Cancel",
          "cancel-aria": "Cancel the unavailability of {outlet}",
          "empty": "No upcoming unavailability in {month}. Full history lives in List mode."
        },
        "hol": {
          "title": "Public Holidays / Non-working Days · {month}",
          "col": {
            "dates": "Date(s)",
            "holiday": "Holiday",
            "source": "Source",
            "impact": "Schedule impact"
          },
          "source": "Company Calendar",
          "non-working": "Non-working",
          "impact": "The balanced scheduler never plans visits on this date; it is read-only here — holidays are maintained in the Company Calendar.",
          "impact-range": "The balanced scheduler never plans visits on this date range; it is read-only here — holidays are maintained in the Company Calendar.",
          "empty": "No public holidays in {month} on the Company Calendar."
        },
        "cancelled": "Unavailability cancelled — the dates are schedulable again"
      },
      "unav": {
        "title": "Record outlet unavailability",
        "close": "Close",
        "sub": "Temporary inability to visit — permanent deactivation stays with Site/Outlet Master; resignations stay with HR/People.",
        "f": {
          "site": "Outlet *",
          "type": "Type *",
          "from": "Start date *",
          "to": "End date *",
          "reason": "Reason *",
          "reopen": "Expected reopening date",
          "notes": "Notes (optional)"
        },
        "select-outlet": "— select outlet —",
        "reason-ph": "e.g. Inventory count",
        "reopen-hint": "Defaults to the day after the end date; editable — reopening is an expectation.",
        "notes-ph": "Add any additional details…",
        "by-a": "Recorded by",
        "by-b": "{ts} · every record and cancellation is audited.",
        "cancel": "Cancel",
        "submit": "Record unavailability",
        "recorded": "Unavailability recorded — planned visits on those dates are excused, not Missed",
        "recorded-conflicts": "Unavailability recorded — planned visits on those dates are excused, not Missed · {n} approved future visit(s) affected — use amendment/reschedule",
        "types": {
          "0": "Temporary business closure",
          "1": "Renovation",
          "2": "Inventory / stock count",
          "3": "Owner-requested no-visit period",
          "4": "Emergency",
          "5": "Access restriction",
          "6": "Local event",
          "7": "Other"
        },
        "err": {
          "pick-outlet": "Pick an outlet.",
          "start-required": "A start date is required.",
          "end-before-start": "End date must be on or after the start date.",
          "reason-required": "A reason is required.",
          "reopen-after-end": "Expected reopening must be later than the end date.",
          "end-before-new-start": "End date is now before the new start date — adjust the end date."
        }
      }
    },
    "admin-settings": {
      "title": "Admin",
      "subtitle": "Tenant configuration · master data · policies · platform",
      "toast-open": "Open {name}",
      "title-open": "Open {name}",
      "groups": {
        "company": {
          "label": "Company",
          "tiles": {
            "profile": {
              "title": "Company Profile",
              "desc": "Tenant overview · Locations · Policies"
            },
            "users-roles": {
              "title": "Users & Roles",
              "desc": "Permissions matrix"
            },
            "modules": {
              "title": "Modules",
              "desc": "Enable/disable per tenant"
            }
          }
        },
        "setup": {
          "label": "Setup · master data",
          "tiles": {
            "employment-types": {
              "title": "Employment Types",
              "desc": "Full-time, Part-time, Intern, Casual"
            },
            "contract-types": {
              "title": "Contract Types",
              "desc": "UDC, FDC, Consultant, Probation"
            },
            "cost-centers": {
              "title": "Cost Centers",
              "desc": "Financial allocation across modules"
            },
            "approval-workflows": {
              "title": "Approval Workflows",
              "desc": "Routing rules cross-module"
            }
          }
        },
        "policies": {
          "label": "Policies"
        },
        "platform": {
          "label": "Platform",
          "tiles": {
            "localization": {
              "title": "Localization",
              "desc": "English + Khmer · date format · time zones"
            },
            "audit-log": {
              "title": "Audit Log",
              "desc": "Every change tracked"
            },
            "data-privacy": {
              "title": "Data & Privacy",
              "desc": "Retention, PDPA, export, deletion"
            }
          }
        }
      },
      "workspace": {
        "title": "Workspace & Tenant Settings",
        "desc": "Business type · billing · address · subscription · contacts"
      }
    },
    "admin-policies": {
      "title": "Policies",
      "subtitle": "Review and tailor this company's HR module policies and settings. Changes take effect across the relevant workflows.",
      "back": "Back to Admin",
      "back-to-cards": "Back to Policies",
      "areas": {
        "attendance": {
          "title": "Attendance",
          "desc": "Clock rules, grace periods, breaks and location enforcement"
        },
        "employment": {
          "title": "Employment",
          "desc": "FDC and UDC notice periods and contract reminders"
        },
        "leave": {
          "title": "Leave",
          "desc": "Leave accrual, entitlements and request rules"
        },
        "schedule": {
          "title": "Schedule",
          "desc": "Working-hours, shift and labour-law settings"
        },
        "localization": {
          "title": "Localization",
          "desc": "Locale, currency and regional formatting"
        },
        "overtime": {
          "title": "Overtime",
          "desc": "OT request limits, rates, multipliers and calculation basis"
        }
      },
      "groups": {
        "attendance": {
          "clock-settings": "Clock Settings",
          "overtime-grace": "Overtime & Grace Periods",
          "breaks-reminders": "Breaks & Reminders",
          "location-enforcement": "Location Enforcement"
        },
        "employment": {
          "fdc": "Fixed-Duration Contract (FDC)",
          "udc": "Undetermined-Duration Contract (UDC)"
        },
        "other": "Other"
      },
      "row": {
        "value": "Value:",
        "edit-value": "Edit {name}",
        "errors": {
          "min": "Value must be at least {min}.",
          "max": "Value must be at most {max}.",
          "required": "A value is required.",
          "not-a-number": "Enter a number.",
          "range-numbers": "Enter both a minimum and a maximum, as numbers.",
          "range-min-max": "The minimum must not be more than the maximum.",
          "range-bounds-min": "Both values must be at least {min}.",
          "range-bounds-max": "Both values must be at most {max}.",
          "time-format": "Enter a start and an end time.",
          "time-order": "The end time must be after the start time."
        },
        "changed": "Changed",
        "default": "Default: {value}",
        "reset": "Reset {name} to the default ({value})",
        "read-only": "Set by the platform",
        "start-time": "{name} — start time",
        "end-time": "{name} — end time",
        "range-min": "{name} — minimum",
        "range-max": "{name} — maximum",
        "hint-range": "Allowed {min} to {max}",
        "hint-step": "in steps of {step}",
        "hint-waived": "Any range — the labour-law cap is turned off"
      },
      "error": {
        "title": "Couldn't load policies",
        "desc": "Something went wrong loading this company's policies. Try again."
      },
      "no-company": {
        "title": "No active company",
        "desc": "Select a company from the switcher to manage its policies."
      },
      "empty": {
        "title": "No configurable settings",
        "desc": "This area has no configurable policies or settings yet."
      },
      "unknown": {
        "title": "Unknown policy area",
        "desc": "That policy area doesn't exist. Pick one of the available areas."
      },
      "pending-note": "Takes effect when {module} moves to V2. Your changes are saved now and will be used then.",
      "no-id": "This company's settings for this area have no saved record on the server yet, so they can't be changed here. They show the platform defaults.",
      "zones-link": "Manage work zones",
      "save-errors": {
        "forbidden": "You don't have permission to change this company's policies.",
        "conflict": "This setting was changed by someone else. Reload the page and try again.",
        "generic": "The change couldn't be saved. Try again."
      },
      "history": {
        "button": "Edit history",
        "title": "{area} — edit history",
        "overrides": "Changed values"
      },
      "orphans": {
        "title": "Retired keys",
        "empty": "No retired keys. Every saved value belongs to a current setting.",
        "error": "Couldn't load the retired keys."
      }
    },
    "pay": {
      "center": {
        "title": "Payroll Center",
        "subtitle-upcoming": "Prepare upcoming payroll runs before cut-off and pay date",
        "subtitle-in-progress": "Continue processing an active payroll run (work-in-progress)",
        "subtitle-completed": "Review approved and locked payroll results",
        "subtitle-error": "Couldn't load payroll schedule",
        "error": "Couldn't load payroll schedule — {message}",
        "off-cycle": {
          "button": "Off-Cycle Payroll",
          "types": {
            "bonus": "Bonus",
            "incentive": "Incentive",
            "adjustment": "Adjustment",
            "final-pay": "Final Pay",
            "special": "Special Payroll"
          }
        },
        "filters": {
          "all": "All",
          "upcoming": "Upcoming",
          "in-progress": "In-Progress",
          "off-cycle": "Off-Cycle",
          "completed": "Completed",
          "label": "Schedule filters"
        },
        "schedule": {
          "title": "Schedule",
          "subtitle": "Browse payroll runs across statuses",
          "scroll-left": "Scroll schedule left",
          "scroll-right": "Scroll schedule right"
        },
        "status": {
          "upcoming": "Upcoming",
          "in-progress": "In progress",
          "off-cycle": "Off-cycle",
          "completed": "Completed"
        },
        "empty": {
          "description": "No payroll runs match this filter."
        },
        "retry": "Retry",
        "yes": "Yes",
        "result-count": "{n} payroll runs in this filter",
        "card": {
          "paid": "Paid",
          "est": "Est.",
          "opens": "Opens {date}",
          "later": "later",
          "approved": "Approved: {date}",
          "paid-date": "Paid Date: {date}",
          "cut-off": "Cut off: {date}",
          "pay-date": "Pay Date: {date}",
          "pay-period": "Pay Period: {period}",
          "net-pay": "Net Pay",
          "progress": "Progress",
          "step-of": "Step {n} of {total}"
        },
        "ip": {
          "current": "Current Payroll Run",
          "validate": "Validate",
          "resume": "Resume Run",
          "emps": "Employees in run",
          "emps-sub-first": "all eligible for advance",
          "emps-sub-second": "{n} ready for full reconciliation",
          "net-first": "Est. Net Pay (advance)",
          "net-second": "Est. Net Pay",
          "net-sub-first": "50% basic · tax/NSSF on 2nd",
          "net-sub-second": "after TOS / NSSF / FBT / advance",
          "warn": {
            "bank-account": "1 bank account",
            "count-blockers": "{n} blocker | {n} blockers",
            "count-warnings": "{n} warning | {n} warnings",
            "label-blockers": "Blockers",
            "label-warnings": "Warnings",
            "label-issues": "Issues",
            "sub-blockers": "must resolve before next step",
            "sub-acknowledged": "non-blocking · acknowledged at Step 1, awaiting resolution",
            "sub-eligibility": "non-blocking · eligibility",
            "sub-clear": "all clear"
          },
          "steps-title": "Payroll Run Steps",
          "steps-sub": "Track progress across the run lifecycle",
          "step": {
            "1": "Eligibility",
            "2": "Pay Input Review",
            "3": "Calculation",
            "4": "Approval",
            "5": "Payment & Payslips"
          },
          "step-state": {
            "done": "Done",
            "active": "In progress",
            "pending": "Pending"
          },
          "first-note-title": "First Payroll — 50% basic salary advance",
          "first-note": "Tax (TOS) and NSSF do not apply on the First Payroll. They are computed on the Second Payroll (Feb 27) when full-month earnings are known. The advance paid here is automatically deducted from the Second Payroll net.",
          "hc": "HC In Run",
          "hc-sub": "+1 new joiner vs prior",
          "adv": "Advance Net Pay",
          "adv-sub": "50% of basic salary (advance).",
          "issues": "Validation Issues",
          "issues-sub": "Warning — non-blocking, can proceed to calculation.",
          "quick-title": "Quick checks",
          "quick-tax": "Tax profiles valid",
          "quick-bank": "Bank accounts valid",
          "quick-att": "Attendance locked",
          "quick-note": "Finalize validations to unlock the approval step.",
          "validate-ok": "Validation passed — ready to advance to Calculation",
          "validate-issues": "{blockers} blocker(s) · {warnings} warning(s) — opening Issues Center"
        },
        "dept": {
          "mode-label": "Distribution basis",
          "amount": "Amount",
          "share": "% Share",
          "draft-title": "Draft distribution by department",
          "draft-sub": "Preview (draft) — consistent with Past Payroll analytics",
          "completed-title": "Salary Distribution by Department",
          "completed-sub": "Past payroll insights — completed payroll only"
        },
        "done": {
          "summary": "Final Payroll Summary",
          "run-id": "Run ID",
          "locked": "Approved & Locked",
          "approved": "Approved {date}",
          "paid": "Paid {date}",
          "employees": "{n} employees",
          "view": "View Payroll Details",
          "kpi-hc": "Total HC Paid",
          "kpi-net": "Total Net Pay",
          "kpi-net-sub": "Final settlement after 1st-payroll advance",
          "kpi-gross": "Total Gross Pay",
          "kpi-gross-sub": "Basic + OT + bonuses + incentives + paid leave",
          "kpi-ded": "Total Deductions",
          "kpi-ded-sub": "Tax + NSSF + unpaid leave + advance offset + others",
          "earnings": "Earnings Breakdown",
          "final": "Final",
          "basic": "Basic Salary",
          "ot": "Overtime",
          "bonus": "Bonuses",
          "incentive": "Incentives",
          "leave": "Paid Leave",
          "deductions": "Deductions Breakdown",
          "unpaid": "Unpaid Leave",
          "tax": "Tax (TOS)",
          "nssf": "NSSF (Employee)",
          "advance": "1st-Payroll Advance Offset",
          "other": "Other Deductions",
          "unpaid-note": "is a salary deduction from basic pay (not a tax or penalty).",
          "bonuses-title": "Bonuses & Incentives",
          "total-bonuses": "Total Bonuses",
          "total-incentives": "Total Incentives",
          "rewarded": "Employees Rewarded",
          "rewarded-note": "For full employee list, open View Payroll Details.",
          "compliance": "Payroll Compliance Snapshot",
          "compliance-sub": "Audit-friendly summary for approved payrolls",
          "compliant": "Compliant",
          "c-cycle": "Payroll Cycle",
          "c-cycle-v": "Bi-monthly",
          "c-tax": "Tax Applied",
          "c-nssf": "NSSF Applied",
          "c-currency": "Currency",
          "c-offset": "First Payroll Offset",
          "c-offset-v": "Applied (2nd)",
          "c-rounding": "Rounding",
          "c-rounding-v": "2 decimals",
          "c-by": "Finalized By",
          "c-by-v": "HR & Finance",
          "c-trail": "Approval Trail",
          "c-trail-v": "Available"
        },
        "export": {
          "button": "Export Reports",
          "failed": "Couldn't export the report — {message}",
          "payroll-detail": "Payroll Detail",
          "tax-report": "Tax (TOS) Report",
          "nssf-report": "NSSF Report"
        },
        "up": {
          "next": "Next Payroll",
          "off-badge": "Off-Cycle · {kind}",
          "start": "Start Payroll",
          "est": "Est. Employees",
          "required": "Required Inputs",
          "status": "Status",
          "off-demo": "Off-cycle · demo only",
          "status-blockers": "{n} blocker | {n} blockers",
          "status-pending": "{n} input pending | {n} inputs pending",
          "status-ready": "Ready to start",
          "checklist": "Preparation Checklist",
          "checklist-sub": "Track readiness before the cut-off date",
          "open-items": "{n} open items",
          "ready-of": "{ready} of {total} ready",
          "card": {
            "att": "Attendance cut-off",
            "ota": "OT & allowances",
            "roster": "New hires / exits",
            "tax": "Tax/NSSF updates"
          },
          "card-state": {
            "ready": "Ready",
            "in-progress": "In progress",
            "not-started": "Not started",
            "pending": "{n} pending",
            "review": "Review",
            "blocker": "Blocker"
          },
          "start-note": "When you click Start Payroll, the system will lock inputs and begin validations.",
          "off-inputs": {
            "final-pay": "Termination notice · accrued leave · final tax/NSSF stop-out",
            "bonus": "Pre-approved bonus list",
            "incentive": "Pre-approved incentive list",
            "adjustment": "Manual adjustments",
            "special": "Custom inputs",
            "other": "Off-cycle inputs"
          },
          "all-collected": "All collected",
          "input": {
            "attendance": "Attendance",
            "ot": "Overtime records",
            "allowance": "Allowances",
            "bonus": "Bonus / Variable"
          },
          "locked-title": "Pay period has not started yet",
          "off-title": "Off-cycle {kind} — demo via the regular In-Progress / Upcoming cards",
          "locked-toast": "This payroll opens once its pay period begins. No data to review yet."
        },
        "prep": {
          "collect": "Collect Inputs",
          "precheck": "Pre-check",
          "open-collect": "Open Collect Inputs",
          "open-precheck": "Open Pre-check",
          "ci-sub": "Pay period {period} · cut-off {cutOff}",
          "ci-received": "{collected} of {total} sources received",
          "due": "Due {date}",
          "ci-lifecycle": "Each source advances: not started → requested → partial → received. Mark received once the data is in the system.",
          "mark-all": "Mark all received",
          "mark-all-toast": "All inputs marked received",
          "cols": {
            "source": "Input source",
            "owner": "Owner",
            "method": "Method",
            "status": "Status",
            "updated": "Last updated",
            "actions": "Actions"
          },
          "records": "{n} record | {n} records",
          "just-now": "Just now",
          "send-request": "Send request",
          "send-reminder": "Send reminder",
          "mark-received": "Mark received",
          "reopen": "Reopen",
          "ci-foot": "Closing this dialog returns you to the Upcoming Payroll view.",
          "close": "Close",
          "status": {
            "received": "Received",
            "partial": "Partial",
            "requested": "Requested",
            "not-required": "Not required",
            "not-started": "Not started"
          },
          "status-toast": "{source} → {status}",
          "input": {
            "attendance": {
              "label": "Attendance",
              "owner": "HR Officer",
              "source": "TMS / Manual upload"
            },
            "ot": {
              "label": "Overtime records",
              "owner": "Dept Heads",
              "source": "Manager submission"
            },
            "allowance": {
              "label": "Allowances",
              "owner": "HR Officer",
              "source": "Standing + manual"
            },
            "bonus": {
              "label": "Bonus / Variable",
              "owner": "Managers",
              "source": "Manager submission"
            }
          },
          "pc-sub": "Lightweight readiness validation · nothing is committed",
          "passed": "{n} passed",
          "warnings": "{n} warnings",
          "blockers": "{n} blockers",
          "last-run": "Last run {when}",
          "check": {
            "roster": {
              "title": "Roster snapshot",
              "detail": "32 active · 1 new hire · 1 termination this period"
            },
            "bank": {
              "title": "Bank account on file",
              "detail": "All 33 employees have bank account configured"
            },
            "tax": {
              "title": "Tax IDs verified",
              "detail": "2 employees with unverified tax records (E0007, E0011)",
              "fix": "Open People · Tax"
            },
            "nssf": {
              "title": "NSSF IDs assigned",
              "detail": "All 33 employees have NSSF IDs"
            },
            "carry": {
              "title": "Carryover from prior run",
              "detail": "0 held employees carrying into this run"
            },
            "rates": {
              "title": "FX rates current",
              "detail": "NSSF 4080 KHR/USD · NBC 4085 KHR/USD (Feb 2026)"
            },
            "holidays": {
              "title": "Public holidays loaded",
              "detail": "Khmer New Year (Apr 14–16) confirmed for next period"
            }
          },
          "resolved-was": "Resolved · was: {detail}",
          "fix-toast": "Routed to fix — marked resolved for prototype",
          "rerun": "Re-run pre-check",
          "rerun-toast": "Pre-check re-ran · {pass} of {total} passed",
          "start-blocked": "Resolve {n} blocker before starting | Resolve {n} blockers before starting",
          "start-confirm": "Pre-check has {n} blocker. Start anyway? | Pre-check has {n} blockers. Start anyway?",
          "started-pending": "Started — some inputs still pending. You can resolve them in Step 1."
        }
      },
      "detail": {
        "back": "Back to Payroll Center",
        "meta": "Pay period {start} – {end} · {cycle} cycle · Run ID {runId} · Generated {generatedAt}",
        "badges": {
          "locked": "Approved & Locked",
          "approved": "Approved {date} by {actor}",
          "paid": "Paid {date}",
          "employees": "{count} employees",
          "off-cycle": "Off-Cycle: {type}"
        },
        "totals": {
          "title": "Run Totals",
          "headcount-paid": {
            "label": "Total HC Paid",
            "help": "Headcount that received payment"
          },
          "gross": {
            "label": "Total Gross Pay",
            "help": "Basic + OT + bonuses + incentives + paid leave"
          },
          "deductions": {
            "label": "Total Deductions",
            "help": "Tax (TOS) + NSSF + unpaid leave + advance offset + others"
          },
          "net": {
            "label": "Total Net Pay",
            "help": "Final settlement paid to {count} employees"
          }
        },
        "earnings": {
          "title": "Earnings",
          "total": "Total Gross"
        },
        "deductions": {
          "title": "Deductions",
          "total": "Total Deductions"
        },
        "employees": {
          "title": "Employee Detail (sample of {n} of {total})",
          "columns": {
            "employee": "Employee",
            "dept": "Dept",
            "pay-method": "Pay Method",
            "bank": "Bank",
            "gross": "Gross",
            "tax": "Tax",
            "nssf": "NSSF",
            "other": "Deductions",
            "net": "Net"
          },
          "demo-note": "Showing demo records — production renders all {total}"
        },
        "compliance": {
          "title": "Compliance"
        },
        "audit": {
          "title": "Audit Trail"
        },
        "export": {
          "csv": "CSV",
          "excel": "Excel",
          "pdf": "Download PDF"
        },
        "loading": "Loading the payroll record…",
        "error": "Couldn't load the payroll record.",
        "retry": "Retry",
        "footer": "Generated by Optimal HR — Payroll Module · This document reflects the locked payroll snapshot.",
        "footer-run-id": "Run ID: {id}"
      },
      "run": {
        "untitled": "Payroll run",
        "save-exit": "Save & Exit",
        "save-exit-hint": "Run stays In-Progress · resume any time",
        "save-exit-title": "Run stays In-Progress — you can resume any time from Payroll Center",
        "identity": {
          "run-id": "Run",
          "pending": "Pending — generated in Step 3",
          "pay-date": "Pay Date:",
          "pay-period": "Pay Period:"
        },
        "step-title": "Step {n} of {total} — {label}",
        "steps": {
          "eligibility": "Eligibility",
          "pay-inputs": "Pay Input Review",
          "calculation": "Calculation",
          "approval": "Approval",
          "payment-distribution": "Payment & Payslips"
        },
        "subtitles": {
          "eligibility": "Review who will be included in this payroll run and resolve employee-level issues before pay input.",
          "pay-inputs": "Validate readiness of pay inputs. Resolve blockers, then confirm to unlock calculation.",
          "calculation": "Run the engine on validated inputs, compare against prior runs, submit for approval.",
          "approval": "Inspect the submitted payroll package. Approve or return for correction.",
          "payment-distribution": "Per bank: Generate file → Settle → Generate Payslips → Distribute. Close the run when every employee is settled and distributed."
        },
        "stepper": {
          "label": "Payroll run steps",
          "locked-tooltip": "Complete the previous step first"
        },
        "summary-strip": {
          "in-this-run": "In this run",
          "eligible": "eligible",
          "excluded": "excluded",
          "warnings": "warning(s)"
        },
        "warning-banner": {
          "title": "employee profile warning(s) — non-blocking",
          "subtitle": "Resolve before Step 5 (Payment) so bank export and NSSF report come out clean.",
          "show": "Show details",
          "hide": "Hide details"
        },
        "loading": "Loading the payroll run…",
        "error": "Couldn't load the payroll run — {message}",
        "retry": "Retry",
        "confirm-error": "Couldn't confirm — {message}",
        "back-to-center": "Back to Payroll Center",
        "back-to": "Back to {step}",
        "confirm-continue-dot": "Confirm · Continue to {step}",
        "confirm-continue-to": "Confirm & Continue to {step}",
        "confirm-passthrough": "Confirm pass-through · Continue to {step}",
        "resolve": {
          "issue": "Issue",
          "blocker": "Blocker",
          "warning": "Warning",
          "choose": "Choose how to resolve:",
          "resolve": "Resolve",
          "close": "Close",
          "cancel": "Cancel",
          "apply": "Apply",
          "select": "Select...",
          "missing": "Missing: {fields}",
          "audit": "Resolution is audited (actor, timestamp, before/after) and updates the central employee record.",
          "forms": {
            "add-bank": "Add bank account",
            "add-nssf": "Add NSSF ID",
            "adjust": "Adjust amount within cap",
            "edit": "Edit OT hours"
          },
          "fields": {
            "bank": "Bank",
            "bankAccount": "Account number",
            "nssfId": "NSSF ID",
            "newAmount": "New amount (USD)",
            "weekday": "Weekday hours",
            "dayOff": "Day-off hours"
          },
          "actions": {
            "add-bank": "Add bank account here",
            "cash": "Pay in Cash",
            "cheque": "Pay by Cheque",
            "hold": "Hold to next run",
            "exclude": "Exclude from this run",
            "verify-tax": "Verify tax profile (Resident)",
            "add-nssf": "Add NSSF ID"
          }
        },
        "step1": {
          "loading": "Loading eligibility…",
          "error": "Couldn't load eligibility.",
          "kpi": {
            "total": {
              "label": "Total Employees",
              "help": "Reviewed in this run"
            },
            "ready": {
              "label": "Eligible & Ready",
              "help": "${amount} gross basic"
            },
            "action": {
              "label": "Warnings",
              "help": "Non-blocking · resolve when ready"
            },
            "excluded": {
              "label": "Ineligible / Excluded",
              "sub-newhires": "{n} new hire deferred to next run | {n} new hires deferred to next run",
              "sub-manual": "manually excluded · not paid this run",
              "sub-none": "$0 held back"
            }
          },
          "list": {
            "label": {
              "all": "Showing · All employees in run",
              "ready": "Showing · Eligible & Ready",
              "action": "Showing · Warnings",
              "excluded": "Showing · Held / Excluded"
            },
            "help": {
              "all": "Full roster across all buckets. Use the filters above to focus.",
              "ready": "Select rows to Hold (carry to next run as back-pay).",
              "action": "Resolve individually, or bulk Exclude (definitive) / Hold per row.",
              "excluded": "Held = will carry to next run · Excluded = definitive. Click Include to bring back."
            },
            "bulk": {
              "all": "Apply",
              "ready": "Hold selected",
              "action": "Exclude selected",
              "excluded": "Include selected"
            },
            "in-list": "in list",
            "total-basic": "Total Basic",
            "search": "Search by ID, name, department or position…",
            "clear-search": "Clear search",
            "matching": "of {total} · matching “{q}”",
            "in-filter": "{n} employee in this filter | {n} employees in this filter",
            "sort-hint": "Click column headers to sort",
            "sort-by": "Sort by {col}",
            "sel-none": "Select rows to apply a bulk action.",
            "sel-all-tab": "Pick a filter (Eligible / Action / Excluded) to apply actions.",
            "selected": "{n} selected",
            "select-all": "Select all rows",
            "select-row": "Select {name}",
            "no-match": "No employees match “{q}” in this filter.",
            "empty": "No employees in this filter.",
            "columns": {
              "code": "ID",
              "name": "Employee",
              "dept": "Department",
              "position": "Position",
              "basic": "Basic",
              "bank": "Bank",
              "action": "Action",
              "issues": "Issue(s)",
              "reason": "Reason",
              "bucket": "Bucket",
              "status": "Status / Reason"
            },
            "actions": {
              "hold": "Hold",
              "hold-title": "Hold this employee — will carry to next run as back-pay",
              "defer-title": "Defer to next run as back-pay",
              "exclude": "Exclude",
              "exclude-title": "Definitive exclusion — no auto carryover",
              "fix": "Fix",
              "include": "Include",
              "read-only": "Read-only",
              "filter-to-act": "Filter to act"
            },
            "status": {
              "held": "Held (calc skipped)",
              "excluded": "Excluded",
              "final-pay": "Final Pay",
              "deferred": "Deferred",
              "active": "Active"
            },
            "bucket": {
              "ready": "Ready",
              "action": "Action",
              "excluded": "Excluded"
            }
          },
          "movements": {
            "title": "Staff movements in this period",
            "body": "These are not blockers — the calculation will prorate or treat each case automatically. Review here so you know what to expect on Step 3.",
            "type": {
              "new-hire": "New Hire",
              "termination": "Termination"
            },
            "new-hire-first": "Joined {date} · deferred to Second Payroll",
            "new-hire-second": "Joined {date} · prorated basic by working days",
            "termination-detail": "Last day {date} · excluded — awaiting final pay run"
          },
          "rules": {
            "title-first": "Eligibility rules — First Payroll",
            "title-second": "Eligibility rules — Second Payroll",
            "defaults": "Defaults — change in Company Settings",
            "active": "Active status from first working day through last day of pay period",
            "leavers": "Exclude any employee who resigned or terminated during the period — awaiting final pay run",
            "new-hires-first": "New hires only included if they started on the first working day — otherwise deferred to Second Payroll",
            "profile-first": "Required profile (bank, tax, NSSF) is informational only — cash advance is acceptable",
            "new-hires-second": "Include all new hires who started during the pay period — prorated by working days",
            "profile-second": "Required profile (bank, NSSF, tax) generates warnings but does not block — resolve before Step 5 (Payment)"
          },
          "gate-banner": {
            "strong": "action-required",
            "text": "item(s) must be resolved before Step 2 unlocks."
          },
          "gate-hint": "Resolve all action-required items first",
          "toast": {
            "confirmed": "Step 1 confirmed — eligibility snapshot saved",
            "held-one": "{name} held — components carry to next run · {reason}",
            "held-many": "{n} employee(s) held — components carry to next run · {reason}",
            "excluded-one": "{name} excluded from this run · {reason}",
            "excluded-many": "{n} employee(s) excluded from this run · {reason}",
            "included-one": "{name} included back into this run.",
            "included-many": "{n} employee(s) included back into this run.",
            "cannot-exclude": "{code} has no warning to exclude on — use Hold instead."
          },
          "move-modal": {
            "supra": "Step 1",
            "title": {
              "hold": "Hold (calc skipped)",
              "exclude": "Exclude from this run"
            },
            "hint": {
              "hold": "components carry to next run as back-pay",
              "exclude": "definitive — no auto carryover"
            },
            "selected": "{n} selected employee(s)",
            "reason": "Reason (visible in audit trail) *",
            "default": {
              "hold": "Held this period — components will carry to next run as back-pay",
              "exclude": "Admin decision — do not pay this period"
            },
            "required": {
              "hold": "Hold reason is required",
              "exclude": "Exclude reason is required"
            },
            "audit": "Saved to the audit trail with the actor and timestamp.",
            "cancel": "Cancel",
            "submit": {
              "hold": "Hold",
              "exclude": "Exclude"
            }
          }
        },
        "step2": {
          "loading": "Loading pay inputs…",
          "error": "Couldn't load the pay-input review.",
          "open-pi": "Open Pay Input",
          "cross-component": "Cross-component view",
          "gate-hint": "Resolve all blockers first",
          "passthrough": {
            "title": "No pay input applies — First Payroll advance",
            "body-1": "First Payroll runs as a fixed",
            "body-advance": "50% basic salary advance",
            "body-2": ". Pay-input components (OT, Allowance, Bonus, Incentive, Seniority, Back Pay, Leave, Adjustments) are",
            "body-scheduled": "scheduled for the Second Payroll",
            "body-3": "at the end of the month, when full earnings are known. Nothing to validate here — review the message and confirm to continue.",
            "hint-1": "If a particular component must be included on First Payroll (rare), push it explicitly from",
            "hint-pic": "Pay Input Center",
            "hint-2": "before confirming.",
            "kpi": {
              "components": "Components Pushed",
              "components-sub": "none on this run",
              "records": "Validated Records",
              "records-sub": "no input components",
              "issues": "Issues Found",
              "issues-sub": "nothing to validate"
            },
            "ack-1": "Step 2 is a",
            "ack-pass": "pass-through",
            "ack-2": "for this run — no pay-input review is required. Click",
            "ack-confirm": "Confirm & Continue",
            "ack-3": "below to advance to Step 3 (Calculation)."
          },
          "kpi": {
            "val-amount": "Validated Amount",
            "val-records": "Validated Records",
            "pass-rate": "100% pass rate",
            "emps": "Employees Affected",
            "emps-sub": "{n} of {of} in run",
            "issues": "Issues Found",
            "blockers": "{n} blocker | {n} blockers",
            "movements": "Movements",
            "mv-new-hire": "{n} new hire",
            "mv-term": "{n} term",
            "mv-unpaid": "{n} unpaid leave",
            "mv-none": "no movements"
          },
          "components": {
            "title": "Pay Components",
            "subtitle": "Validation status per component — resolve blockers to unlock Step 3"
          },
          "comp": {
            "OT": "Overtime",
            "ALLOW": "Allowance",
            "BONUS": "Bonus",
            "INCENT": "Incentive",
            "SENIOR": "Seniority",
            "BACKPAY": "Back Pay",
            "UNPAID": "Unpaid Leave",
            "ANNUAL": "Annual Leave"
          },
          "card": {
            "blockers": "{r} records · {n} blocker | {r} records · {n} blockers",
            "warnings": "{r} records · {n} warning | {r} records · {n} warnings",
            "hours": "{r} records · {n} hrs",
            "days": "{r} records · {n} days",
            "amount": "{r} records · ${amount}"
          },
          "gate-banner": {
            "title": "blocker(s) prevent Step 3 unlock"
          },
          "issues": {
            "title": "Issues to resolve",
            "subtitle": "Resolve every blocker. Warnings can pass.",
            "blockers": "blockers",
            "warnings": "warnings",
            "all-resolved": "All pay-input issues resolved."
          },
          "toast": {
            "passed": "Step 2 passed — no pay input applies; advancing to Calculation",
            "confirmed": "Step 2 confirmed — pay input package locked for calculation"
          },
          "issues-center": {
            "supra": "Pay Input",
            "title": "Issues Center",
            "subtitle": "All warnings and blockers across components. Blockers must be resolved before validation.",
            "kpi": {
              "total": "Total Issues",
              "blockers": "Blockers",
              "warnings": "Warnings"
            },
            "cols": {
              "severity": "Severity",
              "component": "Component",
              "code": "Code",
              "message": "Message",
              "employees": "Employees"
            },
            "blocker": "Blocker",
            "warning": "Warning",
            "empty": "No issues found."
          }
        },
        "step3": {
          "loading": "Loading the calculation…",
          "error": "Couldn't load the calculation.",
          "submit-hint": "Click Calculate first to generate the Run ID",
          "compare": {
            "title": "Comparison Gate",
            "subtitle": "Compare against a previous run to catch unusual variance before calculation",
            "options": {
              "dec-second": "vs. Dec 31, 2025 — Second Payroll",
              "jan-first": "vs. Jan 15, 2026 — First Payroll",
              "none": "No comparison"
            },
            "headcount": "Headcount",
            "gross": "Gross total",
            "ot": "OT total",
            "tax": "Tax total",
            "advance": "Advance total",
            "within-range": "{v} (within range)",
            "normal": "{v} (normal)",
            "review": "{v} (review)",
            "no-prior": "No prior",
            "advance-value": "+3 employees (50% basic)"
          },
          "calc": {
            "title": "Calculation",
            "subtitle": "Run the payroll engine on validated inputs. Result is read-only and can be submitted for approval.",
            "completed": "Completed"
          },
          "log": {
            "loaded": "Loaded {n} eligible employees",
            "applied": "Applied {records} pay-input records (OT {hours} hrs)",
            "tos": "Computed TOS (5-bracket schedule, KHR ÷ NBC rate {tos})",
            "nssf": "Computed NSSF — 4 schemes (Injury, Health, Pension Er+Ee), capped 1.2M KHR {'@'} {nssf}",
            "fbt": "Computed FBT 20% on allowance (employee/employer split)",
            "net": "Computed net pay & locked snapshot"
          },
          "totals": {
            "title": "Calculated Totals",
            "subtitle": "Read-only snapshot. Submit to unlock Step 4.",
            "note-pending-1": "No payroll calculation has been run yet. Click",
            "note-pending-2": "to generate the run ID and the calculated totals.",
            "note-first-strong": "First Payroll convention:",
            "note-first": "50% basic salary advance only. Tax, NSSF, FBT, and other components reconcile on the Second Payroll.",
            "note-second": "Calculated in KHR with NSSF rate {nssf} · TOS rate {tos}. Displayed in USD.",
            "pending-1": "Calculation pending. Click",
            "pending-2": "to compute the payroll snapshot and generate the Run ID.",
            "cols": {
              "component": "Component",
              "amount": "Amount",
              "records": "Records",
              "method": "Method"
            }
          },
          "rows": {
            "basic-advance": "Basic Salary (50% advance)",
            "gross-advance": "Gross (Advance)",
            "tos": "Tax on Salary (TOS)",
            "nssf-pension": "NSSF (Pension Employee)",
            "fbt": "FBT (Employee)",
            "net-advance": "Net Pay (Advance)",
            "basic": "Basic Salary (effective)",
            "ot": "Overtime (OT)",
            "allowance": "Allowance (variable)",
            "incentive": "Incentive / Commission",
            "bonus": "Bonus",
            "seniority": "Seniority",
            "back-pay": "Back Pay / Deduction",
            "leave-encash": "Leave Encashment",
            "adjustment": "Adjustment",
            "unpaid-leave": "Unpaid Leave (deduction)",
            "gross": "Gross Pay",
            "nssf-employee": "NSSF (Pension Employee 2%)",
            "fbt-employee": "FBT (Employee share)",
            "advance": "First-Payroll Advance",
            "net": "Net Pay",
            "employer-nssf": "(Employer) NSSF Total",
            "employer-fbt": "(Employer) FBT"
          },
          "methods": {
            "first": "Cambodia 1st-payroll convention",
            "second-only": "Not applicable — Second Payroll only",
            "basic": "Prorated for new hires / terminations / unpaid leave",
            "ot": "{hours} hrs total · weekday 1.5×, day-off 2×",
            "allowance": "Excluded from NSSF/TOS base — see FBT",
            "pay-input": "Pay Input",
            "auto": "Auto-computed",
            "manual-correction": "Manual correction",
            "leave-encash": "Avg gross 12 mo ÷ 22 × unused AL",
            "manual": "Manual",
            "unpaid": "Reduces basic",
            "tos": "{khr} KHR {'@'} {rate}",
            "nssf": "{khr} KHR {'@'} {rate} (capped 1.2M)",
            "fbt": "20% × allowance × employee rate",
            "advance": "Deducted from advance paid mid-month",
            "employer-nssf": "Injury + Health + Pension Employer — paid to NSSF",
            "employer-fbt": "Reported on FBT return"
          },
          "flags": {
            "title": "Variance Flags",
            "subtitle": "Acknowledge variances before submitting (warnings only — not blocking).",
            "all-ack": "All variance flags acknowledged."
          },
          "actions": {
            "calculate": "Calculate",
            "recalculate": "Re-calculate",
            "submit": "Submit for Approval"
          },
          "toast": {
            "calculated": "Payroll calculated — Run ID: {id}",
            "recalculated": "Recalculated — Run ID: {id} · ready to re-submit",
            "submitted": "Submitted for approval — routed to Approver",
            "not-calculated": "Calculation not complete"
          }
        },
        "step4": {
          "loading": "Loading Step 4 (approval)…",
          "error": "Couldn't load Step 4 — {message}",
          "retry": "Retry",
          "close": "Close",
          "cancel": "Cancel",
          "back": "Back to Calculation",
          "approve-continue": "Approve & Continue to Payment & Payslips",
          "continue": "Continue to Payment & Payslips",
          "confirm-error": "Couldn't approve the payroll — {message}",
          "locked": "Approved & locked — Step 5 unlocked.",
          "workspace": "Review Workspace",
          "resolve": "Resolve",
          "view": "View",
          "decision": {
            "pending": "Pending",
            "approved": "Approved",
            "deferred": "Deferred",
            "returned": "Returned"
          },
          "kpi": {
            "employees": "Employees",
            "advance": "Basic Advance (Gross)",
            "advance-sub": "50% of basic salary · tax/NSSF deferred to Second Payroll",
            "net-advance": "Net Pay (Advance)",
            "exceptions": "Exceptions",
            "exceptions-sub": "movements + variance",
            "gross": "Gross Pay",
            "tos": "TOS",
            "nssf": "NSSF (emp)",
            "nssf-sub": "Pension 2% · employer side in report",
            "fbt": "FBT (emp)",
            "fbt-sub": "20% × allowance · employee share",
            "advance-offset": "Advance offset",
            "net": "Net Pay"
          },
          "bucket": {
            "ready": "Ready",
            "ready-first": "All employees clean for advance",
            "ready-second": "All checks passed",
            "review": "Needs Review",
            "review-first": "No exceptions on advance pay",
            "review-second": "Movements / variance",
            "hold": "On Hold",
            "hold-first": "No corrections pending",
            "hold-second": "Action-required (not yet resolved)"
          },
          "ws-filter": {
            "all": "All",
            "totals": "Totals",
            "exceptions": "Exceptions",
            "review": "Needs Review"
          },
          "col": {
            "type": "Type",
            "item": "Item",
            "current": "Current",
            "previous": "Previous",
            "variance": "Variance",
            "status": "Status"
          },
          "row": {
            "total": "Total",
            "movement": "Movement",
            "basic-advance": "Basic Advance",
            "gross": "Gross Pay",
            "net": "Net Pay",
            "first-run": "first run",
            "snapshot": "snapshot",
            "first-note": "OT, allowances, tax, NSSF, and FBT reconcile in the Second Payroll — nothing to review here.",
            "none": "No rows in this view."
          },
          "status": {
            "review": "Review",
            "blocked": "Blocked",
            "acknowledged": "Acknowledged",
            "elsewhere": "Final Pay handled elsewhere",
            "held": "Held to next run"
          },
          "panel": {
            "kicker": "Approval Decision",
            "title": "Finance · HR Director",
            "submitted": "Submitted",
            "reviewer": "Reviewer",
            "approve": "Approve Payroll",
            "return": "Return for Correction"
          },
          "movement": {
            "kicker": "{type} review",
            "new-hire": "New hire",
            "termination": "Termination",
            "unpaid-leave": "Unpaid leave",
            "leave-dates": "Approved leave dates",
            "unpaid-days": "Unpaid days",
            "unpaid-days-value": "{n} of 22 working days",
            "daily-rate": "Daily rate",
            "daily-rate-value": "${amount} · basic/22",
            "deduction": "Deduction applied",
            "net": "Resulting net pay",
            "leave-note": "Source: Leave module · already approved upstream. This row only confirms the payroll deduction is right.",
            "hire-date": "Hire date",
            "basic-full": "Basic (full month)",
            "prorated": "Prorated basic",
            "tax-nssf": "Tax / NSSF",
            "tax-nssf-value": "Calculated on prorated earnings",
            "net-period": "Net pay this period",
            "hire-note": "Verify hire date and that all standing allowances were applied correctly for the partial period.",
            "effective": "Effective date",
            "reason": "Reason",
            "status-run": "Status this run",
            "status-run-value": "Excluded · awaiting Final Pay (off-cycle)",
            "term-title": "Cambodia practice: terminations need a separate Final Pay run.",
            "term-body": "Final Pay typically includes: notice period pay, accrued annual leave encashment, severance (if applicable), final tax withholding, and NSSF stop-out.",
            "note": "Approver note (required to return)",
            "note-placeholder": "e.g. Verified against leave module ref LEAVE-2026-014",
            "reason-required": "A note is required to return this movement for correction.",
            "return": "Return for correction",
            "acknowledge": "Acknowledge",
            "elsewhere": "Handled elsewhere",
            "final-pay": "Launch Final Pay run"
          },
          "override": {
            "title": "Approve with unacknowledged movements?",
            "body": "{n} movement(s) still need approver acknowledgment. Approve anyway? (Override will be logged.)",
            "approve": "Approve anyway"
          },
          "return": {
            "kicker": "Step 4",
            "title": "Return Payroll for Correction",
            "sub": "Reason is required and saved to the audit trail.",
            "reason": "Reason for return *",
            "placeholder": "Describe what needs correction (e.g., OT total looks too high — please re-verify Sales team)",
            "required": "Reason is required to return",
            "target": "Send back to",
            "target-3": "Step 3 — Calculation"
          },
          "toast": {
            "approved": "Payroll approved & locked — Step 5 unlocked",
            "returned": "Returned for correction — routed to Step 3",
            "movement-acknowledged": "Movement acknowledged",
            "movement-elsewhere": "Movement marked as handled elsewhere",
            "movement-returned": "Returned for correction — movement flagged, the run reopens at Step 3"
          }
        },
        "step5": {
          "loading": "Loading Step 5 (payment & payslips)…",
          "error": "Couldn't load Step 5 — {message}",
          "retry": "Retry",
          "close": "Close",
          "cancel": "Cancel",
          "resolve": "Resolve",
          "resolved": "Resolved",
          "page": {
            "back": "Back to run",
            "heading": "Step 5 of 5 — Payment & Payslips",
            "subtitle": "Per bank: Generate file → Settle → Generate Payslips → Distribute. Close the run when every employee is settled and distributed."
          },
          "kpi": {
            "employees": "Employees to Pay",
            "total-net": "Total Net Pay",
            "pending": "Pending Settlement",
            "settled": "Settled",
            "distributed": "Payslips Distributed"
          },
          "how": {
            "title": "Each card runs its own pipeline:",
            "body": "Generate Excel → Settle (after bank confirms payment) → Generate Payslips → Distribute. Per-bank cards advance independently. Manual card releases payslips only when every employee on the manual card is settled — employees rerouted via \"Update bank account\" automatically appear in their new bank's card as a fresh batch."
          },
          "held": {
            "title": "{n} employee(s) on Step 5 hold — net ${amount}",
            "materiality": "Re-approval recommended ({pct}% of run net)",
            "body": "Held payments are listed inside the Manual / Exception resolution. Open it to Release · Defer · or Cancel & adjust each one.",
            "open": "Open Manual modal",
            "open-title": "Resolve held payments inside the Manual / Exception modal"
          },
          "pipeline": {
            "title": "Payment Pipeline",
            "subtitle": "Per-bank batches advance independently. Click a card to drill in, or review the full payroll on the right.",
            "pending": "Pending",
            "pending-file": "Pending file",
            "settled": "Settled",
            "distributed": "Distributed",
            "held": "Payment held"
          },
          "card": {
            "manual": "Manual / Exception",
            "employees": "Employees",
            "amount": "Amount",
            "pending": "Pending",
            "settled": "Settled",
            "distrib": "Distrib",
            "view": "View {n} employee | View {n} employees",
            "empty": "No employees routed here",
            "generate": "Generate Excel · {n} emp | Generate Excel · {n} emps",
            "resolve-manually": "Resolve Manually",
            "resolve-first": "Resolve {n} exception first | Resolve {n} exceptions first",
            "resolve-first-hint": "Open Resolve Manually and pick a payment method for each exception",
            "release": "Generate & Distribute Payslips",
            "release-manual": "Generate & Distribute",
            "distribute": "Distribute Payslips",
            "done": "All {n} employee settled & distributed | All {n} employees settled & distributed",
            "locked": "Locked · {n} employee | Locked · {n} employees",
            "settle": "Settle batch",
            "mark-settled": "Mark all settled",
            "regenerate": "Re-generate"
          },
          "reports": {
            "title": "Final Payroll Reports",
            "subtitle": "Locked and exportable for filing / archive",
            "all-ready": "All 4 reports ready",
            "ready": "Ready",
            "preview": "Preview & Download",
            "download": "Download CSV",
            "gate-pre": "Reports unlock once",
            "gate-strong": "all payslips have been distributed",
            "gate-post": ". They reflect the locked snapshot of this run.",
            "summary": {
              "label": "Summary Report",
              "help": "Totals · breakdowns · compliance · audit"
            },
            "detail": {
              "label": "Detail Report",
              "help": "Per-employee register · landscape A4"
            },
            "tos": {
              "label": "Tax (TOS) Report",
              "help": "GDT-compliant · EN ↔ ខ្មែរ"
            },
            "nssf": {
              "label": "NSSF Report",
              "help": "4-scheme contributions · EN ↔ ខ្មែរ"
            }
          },
          "close-gate": {
            "blocked": "Run cannot be closed yet",
            "blocked-hint": "Settle all bank batches and distribute every payslip first.",
            "holds-hint": "Resolve {n} held payment (Release / Defer / Cancel & Adjust) before closing. | Resolve {n} held payments (Release / Defer / Cancel & Adjust) before closing.",
            "ready": "Ready to close run",
            "ready-hint": "All employees settled and payslips distributed. Click Close Run to lock the snapshot.",
            "closed": "Run closed",
            "closed-hint": "Locked snapshot saved — see Payroll Record.",
            "summary-emps": "{n} employees · ${amount} net",
            "summary-reports": "{n} of 4 reports ready",
            "summary-holds": "{n} unresolved hold | {n} unresolved holds",
            "title": "Lock the run snapshot — reports become final and the schedule moves to Completed",
            "btn": "Close Run",
            "closed-btn": "Run closed"
          },
          "col": {
            "id": "ID",
            "employee": "Employee",
            "department": "Department",
            "net-pay": "Net pay",
            "account": "Account",
            "pipeline": "Pipeline",
            "action": "Action",
            "reason": "Reason",
            "amount": "Amount",
            "status": "Status",
            "bank": "Bank"
          },
          "bank-list": {
            "kicker": "Bank batch · {tag}",
            "employees": "employees",
            "total": "Total",
            "pending": "pending",
            "settled": "settled",
            "distributed": "distributed",
            "empty": "No employees routed to this bank.",
            "footer": "Pipeline updates as you advance the bank card actions on Step 5.",
            "payslip": "Payslip",
            "payslip-title": "View official payslip",
            "hold-title": "Pull this employee from the batch — pending investigation"
          },
          "full": {
            "open": "Review full payroll detail",
            "open-title": "See every employee's full pay record across all banks",
            "kicker": "Full payroll detail",
            "sub": "Read-only snapshot of every paid employee · mirrors the Detail Report download",
            "gross": "Gross",
            "tax": "Tax",
            "net": "Net",
            "search": "Search by ID, name, department, or bank…",
            "count": "{n} employees in this run",
            "showing": "Showing {n} of {total} · matching “{q}”",
            "no-match": "No employees match “{q}”",
            "none": "No payroll records.",
            "tip": "Tip: use the search to filter; click a per-bank card on Step 5 to act on that batch."
          },
          "hold": {
            "kicker": "Hold payment · pending investigation",
            "title": "Hold payment — {name}",
            "net": "net",
            "next": "What happens next",
            "next-1": "Employee is removed from {bank}'s pending batch (count and amount go down).",
            "next-2": "{bank}'s Excel must be generated again for the remaining employees.",
            "next-3": "Their payslip is locked — never generated, never distributed — until you resolve the hold.",
            "next-4": "Resolve later from the Manual / Exception resolution: Release · Defer to next run · Cancel & adjust.",
            "reason": "Reason (required, recorded in audit trail)",
            "reason-placeholder": "e.g. Line manager called — staff did not show up for work this morning. Pending investigation.",
            "reason-required": "Reason is required.",
            "action": "Hold payment",
            "held": "Held — pending investigation",
            "deferred": "Deferred to next run",
            "cancelled": "Cancelled — Adjustment created",
            "cancelled-short": "Cancelled — Adjustment"
          },
          "hold-resolve": {
            "kicker": "Resolve hold",
            "title": "Resolve hold — {name}",
            "subtitle": "{code} · originated from {bank} · reason: {reason}",
            "release": "Release for payment",
            "release-desc": "Investigation cleared (e.g., medical certificate received). Employee re-enters their original bank's pending batch — that bank's Excel will need re-generation.",
            "defer": "Defer to next run",
            "defer-desc": "Investigation will outlast the close window. Net pay carries forward to the next Second Payroll as an opening line. Tax and NSSF stay filed this period.",
            "cancel": "Cancel & adjust",
            "cancel-desc": "No-show confirmed (e.g., absent without leave). Payment cancelled this run; an Off-Cycle Adjustment follows so Finance/HR can deduct AWOL days and claw back the First Payroll advance.",
            "note": "Resolution note (optional)",
            "note-placeholder": "e.g. Spoke with line manager — staff returned with medical certificate."
          },
          "manual": {
            "kicker": "Step 5 · Payment",
            "title": "Manual / Exception Resolution",
            "pending-of": "of {total} pending. Each exception needs an action before Payslips can finalize.",
            "empty": "No manual exceptions in this run.",
            "error": "Couldn't save the manual outcome — {message}",
            "reason-held": "Held · from {bank} — {reason}",
            "reason-investigation": "pending investigation",
            "reason-no-bank": "No bank account on file",
            "reason-routed": "Routed to manual",
            "ref": "Ref",
            "change": "Change",
            "undo": "Undo",
            "choose": "Choose resolution",
            "apply": "Apply",
            "save-reroute": "Save & Reroute",
            "bank": "Bank",
            "bank-placeholder": "Select a bank…",
            "bank-required": "Choose the new bank.",
            "ref-required": "Reference is required for {option}",
            "legend": {
              "settled": "Settled",
              "settled-desc": "paid out, exception cleared",
              "updated": "Updated",
              "updated-desc": "new bank info, retried automatically",
              "deferred": "Deferred",
              "deferred-desc": "carried to next run as back-pay",
              "held": "Held",
              "held-desc": "in-flight pause; resolve via Release / Defer / Cancel & Adjust",
              "pending": "Pending",
              "pending-desc": "acknowledged, blocks Payslips"
            },
            "opt": {
              "cash": "Pay by Cash",
              "cheque": "Pay by Cheque",
              "transfer": "Pay by Transfer",
              "update": "Update Bank Account",
              "hold": "Hold payment to next run",
              "pending": "Keep Pending"
            },
            "opt-desc": {
              "cash": "Cash handover. Records receipt for audit.",
              "cheque": "Manual cheque issued. Captures cheque number.",
              "transfer": "Wire / manual transfer. Captures reference.",
              "update": "Capture new bank info — system retries on next batch.",
              "hold": "Defer cash payment to next run. Tax/NSSF already filed this period — next run combines NET only.",
              "pending": "Acknowledge but take no action yet (will block Payslips)."
            },
            "prompt": {
              "cash": "Receipt # (optional)",
              "cheque": "Cheque # (required)",
              "transfer": "Transfer reference (required)",
              "update": "New account # (required)",
              "hold": "Reason for deferral (calc already done; only cash deferred)"
            },
            "status": {
              "cash": "Paid (Cash)",
              "cheque": "Paid (Cheque)",
              "transfer": "Paid (Transfer)",
              "update": "Updated"
            }
          },
          "toast": {
            "generated": "{bank} batch generated — {file} ({n} emps)",
            "generate-error": "Couldn't generate the {bank} file — {message}",
            "distributed": "{bank} payslips generated & distributed — {n} emps",
            "held": "{name} held — {bank} batch updated",
            "released": "{name} released back to original bank — file re-generation required",
            "deferred": "{name} deferred — net carries to next run",
            "cancelled": "{name} cancelled — Off-Cycle Adjustment to follow",
            "closed": "Run closed · marked as completed · returning to Payroll Center",
            "manual-cash": "Pay by Cash recorded",
            "manual-cheque": "Pay by Cheque recorded",
            "manual-transfer": "Pay by Transfer recorded",
            "manual-update": "Bank account updated — employee moved to the new bank's card as a new batch",
            "manual-hold": "Payment held to next run",
            "manual-pending": "Kept pending",
            "settled": "{bank} batch settled — {n} emp(s) · ref {ref}"
          }
        }
      },
      "input-center": {
        "title": "Pay Input",
        "subtitle": "Review & validate pay components for the active run",
        "subtitle-editing": "Editing {component} — changes update the Run Health header",
        "subtitle-readonly": "Read-only history view — {period}",
        "past-period": "past period",
        "period-label": "Pay Period:",
        "period-group": {
          "current": "Current",
          "past": "Past (paid)"
        },
        "period-current": "{label} (current)",
        "period-none": "Current period (no active run)",
        "read-only": "Read-only",
        "no-components": "No pay components are configured for this run yet.",
        "error": "Couldn't load pay inputs — {message}",
        "retry": "Retry",
        "empty": "No entries match the current filters.",
        "close": "Close",
        "cancel": "Cancel",
        "run-context": {
          "heading": "Correcting for {id}",
          "subtitle": "Period locked to this run. Make corrections here, then return to the run flow.",
          "return": "Return to Run"
        },
        "issues-center": {
          "btn": "Issues Center"
        },
        "validate": {
          "btn": "Validate All"
        },
        "bulk-import": {
          "btn": "Batch Import"
        },
        "header-actions": {
          "settings": "Settings",
          "add-entry": "Add Entry",
          "verify": "Verify"
        },
        "next": {
          "blockers": "Resolve {n} blocker in {component} before calculation can run. | Resolve {n} blockers in {component} before calculation can run.",
          "warnings": "{n} warning in {component} — review before validating. | {n} warnings in {component} — review before validating.",
          "clean": "All components clean. Ready to validate.",
          "open": "Open {component} →",
          "validate": "Validate All →"
        },
        "health": {
          "total-records": "Total Records",
          "validated-suffix": "validated",
          "validated-amount": "Validated Amount",
          "employees": "{n} employee | {n} employees",
          "warnings": "Warnings",
          "warnings-sub": "non-blocking",
          "blockers": "Blockers",
          "blockers-sub": "resolve before calc",
          "progress": "Validation progress",
          "progress-of": "{done} of {total}"
        },
        "sidebar": {
          "title": "Components",
          "count-suffix": "total",
          "sort-label": "Sort components",
          "sort-urgency": "Sort: Urgency",
          "sort-group": "Sort: Group",
          "sort-name": "Sort: Name",
          "group-system": "System Job · auto from Work",
          "group-variable": "Variable Pay · manual",
          "paid": "{n} paid · locked",
          "add-component": "Add component",
          "catalog-toast": "Component catalog managed by Admin"
        },
        "pulse": {
          "title": "Run Cycle Pulse",
          "cut-off": "Cut-off",
          "passed": "Cut-off has passed",
          "today": "Today is cut-off",
          "left": "{n} working day left | {n} working days left",
          "anomaly": "Anomaly",
          "vs-prior": "vs prior run",
          "now-was": "${now} now · was ${was}",
          "activity": "Activity",
          "view-all": "View all",
          "view-all-toast": "Full activity log coming next",
          "who": {
            "sarah": "Sarah",
            "system": "System",
            "visal": "Visal"
          },
          "what": {
            "sarah": "verified 4 OT entries",
            "system": "imported 5 bonus rows",
            "visal": "flagged Adjustment blocker"
          },
          "when": {
            "sarah": "12 min ago",
            "system": "1 hr ago",
            "visal": "2 hrs ago"
          }
        },
        "groups": {
          "system": "System Job",
          "variable": "Variable Pay"
        },
        "components": {
          "ot": "Overtime (OT)",
          "seniority": "Seniority",
          "unpaid": "Unpaid Leave",
          "annual": "Annual Leave",
          "allow": "Allowance",
          "incentive": "Incentive / Commission",
          "bonus": "Bonus",
          "other": "Other Custom",
          "backpay": "Back Pay / Deduction",
          "adjust": "Adjustment / Deduction"
        },
        "component-desc": {
          "ot": "Fed from attendance",
          "seniority": "Auto-computed from tenure",
          "unpaid": "Fed from leave system",
          "annual": "Fed from leave system",
          "allow": "One-time only — fixed/recurring allowances are configured in C&B",
          "incentive": "Manual or imported per period",
          "bonus": "Manual or imported per period",
          "other": "Custom per-period components",
          "backpay": "Manual correction for a prior period",
          "adjust": "Manual per-period adjustment"
        },
        "workspaces": {
          "ot": "Overtime (OT)",
          "allow": "Allowance",
          "variable": "Variable Pay",
          "system": "System & Post-cycle"
        },
        "ws": {
          "period": "Period: {period}",
          "cut-off": "Cut-off: {date}"
        },
        "settings": {
          "tolerance": "Tolerance (claimed vs. computed)",
          "tol-0": "±0 min (strict)",
          "min": "±{n} min",
          "rounding": "Rounding",
          "none": "None",
          "round": "{n} min",
          "note": "Once-per-run settings. Applies to verification only."
        },
        "kpis": {
          "records": "Records",
          "total-amount": "Total Amount",
          "employees": "Employees",
          "warnings": "Warnings",
          "blockers": "Blockers"
        },
        "subtypes": {
          "all": "All",
          "label": "Sub-components"
        },
        "filters": {
          "search-placeholder": "Search employee, memo, reference…",
          "search-label": "Search entries",
          "clear-search": "Clear search",
          "status-label": "Filter by status",
          "source-label": "Filter by source",
          "remove": "Remove filter: {filter}",
          "all": "All",
          "valid": "Valid",
          "warning": "Warning",
          "blocker": "Blocker",
          "paid": "Paid",
          "source-all": "All Sources",
          "source-attendance": "Attendance",
          "source-import": "Import",
          "source-manual": "Manual",
          "source-system": "System / API"
        },
        "columns": {
          "emp": "Employee",
          "date": "OT Date",
          "time": "Time",
          "claimed": "Claimed (h)",
          "computed": "Computed (h)",
          "amount": "Amount",
          "otType": "OT Type",
          "source": "Source",
          "status": "Status",
          "subtype": "Subtype",
          "effective": "Earning Period",
          "applyTo": "Apply to"
        },
        "cb-readonly": "Configured in C&B · read-only",
        "from-cb": "From C&B",
        "paid-title": "Locked — paid via {run}",
        "resolve": "Resolve",
        "resolve-for": "Resolve {emp}",
        "mark-valid": "Mark valid",
        "resolved": "Resolved — {emp} marked valid",
        "rows-of": "{shown} of {total} entries",
        "export": "Export",
        "exported": "Exported {n} entries",
        "verify-done": "{component} verified — {warnings} warning(s), {blockers} blocker(s) remain",
        "issues": {
          "employee": "Employee",
          "memo": "Memo",
          "amount": "Amount",
          "action": "Action",
          "open": "Open in workspace",
          "open-for": "Open {emp} in the workspace",
          "empty": "No issues — all entries are valid."
        },
        "va": {
          "title": "Validate All Components",
          "blocked": "Resolve {n} blocker before validating. Open Issues Center to review. | Resolve {n} blockers before validating. Open Issues Center to review.",
          "warn": "{n} warning will be flagged for reviewer attention but will not block validation. | {n} warnings will be flagged for reviewer attention but will not block validation.",
          "ok": "All entries pass validation. Lock inputs and move to Review.",
          "confirm": "Validate & Lock",
          "done": "All components validated and locked. Run moves to Review.",
          "error": "Validation failed — {message}"
        },
        "form": {
          "period": "Pay Period",
          "emp": "Employee",
          "date": "Date",
          "otType": "OT Type",
          "claimed": "Hours Claimed",
          "subtype": "Type",
          "allowance-type": "Allowance Type",
          "effective": "Earning Period",
          "applyTo": "Reason / Reference",
          "amount": "Amount (USD)",
          "memo": "Memo",
          "optional": "(optional)",
          "select-period": "Select pay period…",
          "select": "Select {field}…",
          "helper": {
            "when-paid": "When this will be paid",
            "when-earned": "When this was earned",
            "negative": "Use negative for deductions"
          },
          "placeholder": {
            "optional": "Optional note",
            "effective-allow": "e.g., Jan 2026, Current",
            "effective-variable": "e.g., Q4 2025, Jan 2026, Current",
            "effective-system": "e.g., Dec 2025, Current",
            "apply-allow": "e.g., Client visit Jan 18, Team dinner",
            "apply-variable": "e.g., Sales target, Performance, Retention",
            "apply-system": "e.g., Loan repayment, Missed allowance"
          }
        },
        "add": {
          "title": "Add Entry — {component}",
          "submit": "Add Entry",
          "drift": "You’re adding to {target} while viewing {current}. On submit the entry lands in {target}’s workspace, not the current one.",
          "duplicate": "This employee already has a paid {component} entry (locked via {run}). Add another anyway?",
          "done": "Entry added — {emp} ({component})",
          "elsewhere": " · not in current view"
        },
        "batch": {
          "title": "Batch Import — {component}",
          "effective-placeholder": "e.g., Q4 2025 / Jan 2026 / Current",
          "file": "Upload File",
          "click": "Click to upload",
          "drag": "or drag & drop",
          "hint": "CSV or XLSX up to 10 MB",
          "selected": "Selected: {name}",
          "note": "Batch Note",
          "note-placeholder": "e.g., Q4 incentive batch — late approval, pushed from Jan to Feb pay",
          "note-hint": "Prefixed to every imported entry’s memo for context.",
          "columns": "Expected columns",
          "template": "Download template",
          "template-done": "Template downloaded — {name}",
          "import": "Import",
          "done": "Imported {n} entries from {file}",
          "note-attached": " (batch note attached)"
        }
      },
      "reportsCenter": {
        "types": {
          "summary": "Payroll Summary",
          "detail": "Payroll Detail",
          "tos": "Tax (TOS) Report",
          "nssf": "NSSF Report"
        },
        "statuses": {
          "idle": "Idle",
          "generating": "Generating…",
          "ready": "Ready",
          "failed": "Failed"
        }
      },
      "offCycle": {
        "back": "Back to Payroll Center",
        "title": "Off-Cycle Payroll",
        "subtitle": "Bonus, incentive, adjustment, final pay and special runs outside the regular cycle. Off-cycle runs are inserted into the Payroll Center based on their pay date.",
        "loading": "Loading off-cycle drafts…",
        "error": "Couldn't load off-cycle drafts — {message}",
        "retry": "Retry",
        "list-title": "Off-cycle drafts",
        "count": "{n} in list",
        "empty": {
          "title": "No off-cycle drafts yet",
          "subtitle": "Choose a type from Off-Cycle Payroll to start one. Drafts persist for 7 days."
        },
        "menu": {
          "button": "Off-Cycle Payroll"
        },
        "kind": {
          "bonus": "Bonus",
          "incentive": "Incentive",
          "adjustment": "Adjustment",
          "final-pay": "Final Pay",
          "special": "Special Payroll"
        },
        "filter": {
          "label": "Status"
        },
        "status": {
          "all": "All",
          "DRAFT": "Draft",
          "COMMITTED": "Committed",
          "ABANDONED": "Abandoned"
        },
        "type": {
          "FINAL_PAY": "Final Pay",
          "BONUS": "Bonus",
          "BACK_PAY": "Back Pay",
          "ADVANCE": "Advance",
          "INCENTIVE": "Incentive",
          "ADJUSTMENT": "Adjustment",
          "SPECIAL": "Special Payroll",
          "unspecified": "Type not set"
        },
        "cols": {
          "draft": "Draft",
          "type": "Type",
          "status": "Status",
          "pay-date": "Pay Date",
          "employees": "Employees",
          "updated": "Updated",
          "action": "Actions"
        },
        "row": {
          "open": "Open",
          "open-label": "Open draft {name}",
          "untitled": "Untitled draft"
        },
        "create": {
          "eyebrow": "Off-Cycle Payroll",
          "title": "Create {kind} schedule",
          "subtitle": "Off-cycle runs are inserted into the Payroll Center based on their pay date.",
          "type-label": "Off-Cycle Type",
          "cancel": "Cancel",
          "close": "Close",
          "submit": "Create Draft",
          "submitting": "Creating draft…",
          "error": "Couldn't create the draft — {message}"
        },
        "advance": {
          "title": "{kind} is treated as advance",
          "body": "Paid out now in this off-cycle run, then included in the next regular Final Payroll as gross earnings. Tax + NSSF are computed on the full gross there, and this advance is automatically deducted from the net pay."
        },
        "flow": {
          "title": "How this run will work",
          "badge-pass": "{n} steps · Step 2 pass-through",
          "badge-full": "{n} steps · full review",
          "steps": {
            "bonus": {
              "s1": "Eligibility (auto from approved list)",
              "s2": "Pay Input Review (pass-through)",
              "s3": "Calculation",
              "s4": "Approval",
              "s5": "Payment & Payslips"
            },
            "incentive": {
              "s1": "Eligibility (auto from approved list)",
              "s2": "Pay Input Review (pass-through)",
              "s3": "Calculation",
              "s4": "Approval",
              "s5": "Payment & Payslips"
            },
            "adjustment": {
              "s1": "Eligibility (pick → unpick employees)",
              "s2": "Pay Input Review (pass-through)",
              "s3": "Calculation",
              "s4": "Approval",
              "s5": "Payment & Payslips"
            },
            "final-pay": {
              "s1": "Eligibility (auto-resign list)",
              "s2": "Pay Input Review",
              "s3": "Calculation",
              "s4": "Approval",
              "s5": "Payment & Payslips"
            },
            "special": {
              "s1": "Eligibility (all eligible)",
              "s2": "Pay Input Review",
              "s3": "Calculation",
              "s4": "Approval",
              "s5": "Payment & Payslips"
            }
          },
          "note": {
            "bonus": "Step 2 is a pass-through — entries come pre-approved from the approved-bonus list. Treated as advance: tax + NSSF reconciled in next regular Final Payroll.",
            "incentive": "Step 2 is a pass-through — entries come pre-approved from the approved-incentive list. Treated as advance: tax + NSSF reconciled in next regular Final Payroll.",
            "adjustment": "Step 2 is a pass-through — adjustment values are entered with employee selection in Step 1. No tax/NSSF re-computed (correction only).",
            "final-pay": "Full review at Step 2. Final Pay reconciles severance, leave encashment, prorated salary, gratuity — all reviewed in Pay Input before calculation.",
            "special": "Full review at Step 2 — special payrolls (e.g., 13th-month, one-off retroactive) follow the same review path as a regular run."
          }
        },
        "wizard": {
          "back": "Back to Off-Cycle drafts",
          "loading": "Loading draft…",
          "error": "Couldn't load the draft — {message}",
          "not-found": "Draft not found or expired. Off-cycle drafts persist for 7 days.",
          "steps-label": "Draft steps",
          "steps": {
            "employees": "Employees",
            "amounts": "Amounts",
            "dates": "Dates",
            "review": "Review"
          },
          "back-step": "Back",
          "next": "Save & Continue",
          "saving": "Saving…",
          "save-error": "Couldn't save — {message}",
          "committed": "This draft was committed as schedule {id}.",
          "abandoned": "This draft was abandoned.",
          "employees": {
            "batch-label": "Approved {kind} Batch",
            "batch-placeholder": "Select an approved {kind} batch…",
            "batch-option": "{title} · {count} employees · ${total} · approved {date}",
            "batch-hint": "Imported from Pay Input · employee count auto-populates.",
            "batch-picked": "{title} · {count} employees · total ${total} · approved {date}",
            "batch-empty-1": "No approved {kind} list available. Go to",
            "batch-empty-link": "Pay Input",
            "batch-empty-2": "to import a batch and get it approved first.",
            "est-label": "Est. Employees",
            "est-auto-batch": "· auto from batch",
            "est-auto-selection": "· auto from selection",
            "run-label": "Original Run ID",
            "run-placeholder": "Select a closed payroll run…",
            "run-hint": "Pick the closed run that has the wrong amount you need to correct.",
            "run-picked": "· paid {paid} · period {period} · {n} employees in run",
            "select-label": "Select Employees",
            "select-resigning-label": "Select Resigning Employees",
            "select-eligible-label": "Select Eligible Employees",
            "no-run": "No run selected yet",
            "pick-run-first": "Pick an Original Run ID first to load its employees.",
            "selected": "{n} of {total} selected",
            "select-all": "Select all",
            "deselect-all": "Deselect all",
            "resigning": "Resigning {date}",
            "resigning-hint": "Auto-detected from People module · employees with resignation date inside the pay period.",
            "resigning-empty-label": "Resigning Employees",
            "resigning-empty": "No resigning employees found in the roster. Final Pay runs require at least one resignation in scope.",
            "eligible-hint": "{n} active employees in roster · pick those to include in this special payroll.",
            "eligible-empty-label": "Eligible Employees",
            "eligible-empty": "No active employees in the roster."
          },
          "amounts": {
            "title": "{component} amounts",
            "hint": "Per-employee amounts paid in this run — pre-filled from the approved list where one exists.",
            "currency": "Currency",
            "cols": {
              "code": "ID",
              "employee": "Employee",
              "dept": "Department",
              "amount": "Amount",
              "reason": "Reason"
            },
            "total": "Total",
            "empty": "Select employees first.",
            "amount-label": "Amount for {name}",
            "reason-label": "Reason for {name}",
            "reason-placeholder": "Optional"
          },
          "dates": {
            "pay-date": "Pay Date",
            "pay-date-hint": "Cut-off auto = 2 working days before pay date",
            "cut-off": "Cut-off (auto)",
            "period": "Pay Period",
            "period-placeholder": "Select an existing pay period…",
            "period-hint": "Proposed from existing payroll periods to avoid date-selection errors.",
            "period-inherited": "Inherited from the Original Run ID picked in the Employees step.",
            "reason": "Reason / Description",
            "placeholder": {
              "bonus": "e.g., Year-end performance bonus payout for FY2025",
              "incentive": "e.g., Q4 sales target incentive — Sales team",
              "adjustment": "e.g., Correction for missed December allowance — 4 employees",
              "final-pay": "e.g., Final settlement for resignations effective in Feb 2026",
              "special": "e.g., 13th-month payout aligned with Khmer New Year"
            }
          },
          "review": {
            "title": "Review",
            "valid": "Validation passed",
            "invalid": "Validation issues found",
            "employees": "Employees",
            "cut-off": "Cut-off",
            "cycle": "Parent cycle",
            "totals-title": "Totals by component",
            "grand-total": "Grand total"
          },
          "commit": {
            "action": "Create Schedule",
            "submitting": "Creating schedule…",
            "error": "Couldn't create the schedule — {message}",
            "success": "{kind} schedule created — {date}"
          },
          "abandon": {
            "action": "Discard draft",
            "title": "Discard this draft?",
            "body": "The draft is abandoned and no schedule is created. This cannot be undone.",
            "confirm": "Discard draft",
            "cancel": "Keep draft",
            "error": "Couldn't discard the draft — {message}"
          }
        }
      },
      "templates": {
        "title": "Templates",
        "subtitle": "Reusable payroll configurations for regular cycles, off-cycle runs, and special payrolls.",
        "loading": "Loading templates…",
        "error": "Couldn't load templates — {message}",
        "empty": "No templates have been created for this employer yet.",
        "untitled": "Untitled template",
        "default-badge": "Default",
        "code": {
          "1ST_PAY": "First Payroll",
          "2ND_PAY": "Second Payroll",
          "FINAL_PAY": "Final Payroll"
        },
        "versions": {
          "btn": "Version history",
          "heading": "Version History",
          "loading": "Loading versions…",
          "error": "Couldn't load versions — {message}",
          "empty": "No version history available.",
          "version-label": "Version {n}",
          "latest": "Latest",
          "attributes": "{n} attributes",
          "btn-for": "Version history of {name}"
        },
        "clone": {
          "btn": "Clone",
          "title": "Clone Template",
          "description": "Create a new template based on an existing one.",
          "name-label": "New template name",
          "default-name": "{name} (Copy)",
          "name-required": "Template name is required.",
          "cancel": "Cancel",
          "confirm": "Clone",
          "cloning": "Cloning…",
          "success": "Template \"{name}\" created successfully.",
          "btn-for": "Duplicate {name}"
        },
        "import": {
          "btn": "Import",
          "coming-soon": "Template import is on the roadmap — coming in a follow-up release."
        },
        "new": {
          "btn": "New Template",
          "coming-soon": "Template authoring is on the roadmap — coming in a follow-up release."
        },
        "use": {
          "btn": "Use"
        },
        "computation": {
          "title": "Computation Rules",
          "subtitle": "Global payroll calculation settings (applied across templates)",
          "edit": "Edit",
          "ot-weekday-label": "OT Multiplier (Weekday)",
          "ot-weekday-value": "1.5× basic hourly",
          "ot-weekend-label": "OT Multiplier (Weekend / Holiday)",
          "ot-weekend-value": "2.0× basic hourly",
          "daily-rate-label": "Daily Rate Formula",
          "daily-rate-value": "Basic ÷ 22 working days · Hourly: Basic ÷ 198 (22 d × 9 h)",
          "workweek-label": "Workweek",
          "workweek-value": "5 days × 9 hours = 45 hours / week",
          "rounding-label": "Rounding",
          "rounding-value": "2 decimals, half-up",
          "currency-label": "Default Currency",
          "currency-value": "USD (KHR for TOS filing)",
          "first-payroll-offset-label": "First Payroll Offset",
          "first-payroll-offset-value": "Tax & NSSF applied on 2nd payroll only"
        },
        "retry": "Retry",
        "used-in": "Used In",
        "last-used": "Last Used",
        "runs": "{n} runs",
        "edit": "Edit",
        "edit-for": "Edit {name}",
        "kind": {
          "Regular": "Regular",
          "Off-Cycle Bonus": "Off-Cycle Bonus",
          "Off-Cycle Adjustment": "Off-Cycle Adjustment",
          "Off-Cycle Final Pay": "Off-Cycle Final Pay",
          "Off-Cycle Special": "Off-Cycle Special",
          "Draft": "Draft"
        }
      },
      "payslip": {
        "unnamed": "Unnamed employee",
        "list": {
          "back": "Back to run",
          "title": "Payslips",
          "subtitle": "Per-employee payslips for this payroll run.",
          "loading": "Loading payslips…",
          "error": "Couldn't load payslips — {message}",
          "empty": "No payslips for this run yet.",
          "filtered-empty": "No payslips match the current filters.",
          "retry": "Retry",
          "employees": "{n} employees",
          "total-net": "Total net",
          "held": "{n} on hold",
          "showing": "{n} of {total} payslips"
        },
        "view": {
          "back": "Back to payslip list",
          "title": "Payslip",
          "subtitle": "Frozen snapshot of the locked Step 3 calculation.",
          "loading": "Loading payslip…",
          "error": "Couldn't load payslip — {message}",
          "empty": "Payslip not available for this employee.",
          "kicker": "Official Payslip",
          "pdf": "Download PDF (full detail)",
          "pdf-hint": "Auto-expands all groups, then opens browser print dialog → Save as PDF",
          "lang": "Payslip language"
        },
        "kpi": {
          "total": "Total",
          "ready": "Ready to Generate",
          "generated": "Generated",
          "on-hold": "On Hold",
          "distributed": "Distributed"
        },
        "lock": {
          "locked": "Run locked",
          "unlocked": "Run unlocked"
        },
        "filter": {
          "all": "All statuses",
          "search-label": "Search by name or code",
          "search-placeholder": "Search by employee name or code…",
          "clear": "Clear search"
        },
        "status": {
          "ready-to-generate": "Ready to generate",
          "generated": "Generated",
          "on-hold": "On hold",
          "distributed": "Distributed"
        },
        "hold-reason": {
          "MISSING_DELIVERY_METHOD": "Missing delivery method",
          "MISSING_EMAIL": "Missing email address",
          "PORTAL_NOT_ACTIVATED": "Employee portal not activated"
        },
        "delivery": {
          "MANUAL_DOWNLOAD": "Manual download",
          "EMAIL": "Email",
          "PORTAL": "Employee portal"
        },
        "cols": {
          "employee": "Employee",
          "status": "Status",
          "gross": "Gross",
          "net": "Net",
          "delivery": "Delivery",
          "actions": "Actions",
          "item": "Item",
          "amount": "Amount",
          "id": "ID"
        },
        "actions": {
          "view": "Payslip",
          "view-for": "Open the payslip of {name}"
        },
        "doc": {
          "title": "Payslip",
          "tagline": "Official statement of monthly compensation",
          "run-id": "Run ID: {id}"
        },
        "meta": {
          "employee-name": "Employee Name",
          "employee-id": "Employee ID",
          "template": "Payroll Type",
          "pay-method": "Payment Method",
          "delivery-contact": "Delivery Contact"
        },
        "summary": {
          "gross": "Gross Pay",
          "deductions": "Total Deductions",
          "net": "Net Pay"
        },
        "section": {
          "earnings": "Earnings",
          "deductions": "Deductions",
          "empty-earnings": "No earnings recorded for this payslip.",
          "empty-deductions": "No deductions recorded for this payslip."
        },
        "totals": {
          "earnings": "Total Earnings",
          "deductions": "Total Deductions"
        },
        "hold-banner": {
          "title": "Payslip on hold",
          "hint": "Resolve the hold before generating or distributing this payslip."
        },
        "note": {
          "label": "Important Note",
          "body": "This is a system-generated payslip. No signature is required. The figures shown are a frozen snapshot of the locked Step 3 calculation.",
          "generated-at": "Generated: {date}",
          "file": "File: {name}"
        },
        "distribute": {
          "action": "Distribute",
          "title": "Distribute payslips",
          "body": "Send the generated payslips through one delivery channel. Rows on hold or not yet generated are skipped automatically.",
          "method-label": "Delivery channel",
          "methods": {
            "manual": "Manual download",
            "manual-hint": "Mark all generated payslips as distributed; the actor downloads the files locally.",
            "email": "Email",
            "email-hint": "Send each payslip to the employee's registered email address.",
            "portal": "Self-service portal",
            "portal-hint": "Publish each payslip to the employee's self-service portal."
          },
          "submit": "Distribute now",
          "submitting": "Distributing…",
          "cancel": "Cancel",
          "success": "Distributed {count} payslip(s).",
          "skipped": "{count} row(s) skipped (on hold, wrong delivery method, or not generated).",
          "error": "Couldn't distribute the payslips — {message}",
          "kicker": "Payslips"
        },
        "hold-resolve": {
          "action": "Resolve hold",
          "empty": "Open an on-hold payslip to resolve it.",
          "reason-title": "Hold reason",
          "method-label": "Pick a delivery method",
          "methods": {
            "manual": "Manual download",
            "email": "Email",
            "portal": "Self-service portal"
          },
          "email-label": "Employee email",
          "email-placeholder": "Enter the employee's email address",
          "email-required-error": "An email address is required for EMAIL delivery.",
          "portal-label": "Activate the employee's self-service portal",
          "portal-hint": "Required for PORTAL delivery so the employee can sign in.",
          "portal-required-error": "Activation is required for PORTAL delivery.",
          "required-marker": "(required)",
          "submit": "Resolve hold",
          "submitting": "Resolving…",
          "cancel": "Cancel",
          "error": "Couldn't resolve the hold — {message}",
          "subtitle": "Pick a delivery method. The resolution is recorded in the audit trail."
        },
        "generate": {
          "action": "Generate Payslips",
          "done": "{n} payslip(s) generated."
        },
        "hold": {
          "action": "Hold payment",
          "kicker": "Hold payment · pending investigation",
          "title": "Hold payment — {name}",
          "subtitle": "{code} · net {net}",
          "next-title": "What happens next",
          "next-1": "Employee is removed from their bank's pending batch (count and amount go down).",
          "next-2": "Their payslip is locked — never generated, never distributed — until you resolve the hold.",
          "next-3": "Release puts them back in their bank's batch.",
          "reason-label": "Reason (required, recorded in audit trail)",
          "reason-placeholder": "e.g. Line manager called — staff did not show up for work this morning. Pending investigation.",
          "reason-required": "Reason is required.",
          "cancel": "Cancel",
          "badge": "Held — pending investigation",
          "release": "Release",
          "done": "{name} held — excluded from payslip distribution.",
          "released": "{name} released for payment.",
          "title-hint": "Pull this employee from the batch — pending investigation"
        },
        "verify": {
          "open": "Open verification",
          "qr": "Verification QR code",
          "title": "Payslip verification",
          "verified": "VERIFIED",
          "issued-by": "This document is verified and issued by",
          "generated-at": "Generated at:",
          "hash": "Document Hash:",
          "run-id": "Run ID:",
          "employee": "Employee:",
          "contact": "For further verification, please contact:",
          "phone": "Phone:",
          "email": "Email:",
          "warning": "Any modification to this document will invalidate its authenticity.",
          "close": "Close"
        }
      },
      "shell": {
        "title": "Payroll",
        "owning-suffix": "payroll-owning scope (processing)",
        "client-suffix": "published payrolls · read-only",
        "company-suffix": "published payroll hierarchy · read-only (processing lives at owning scopes)",
        "tenant-subtitle": "All Scopes · executive portfolio · published payrolls only · read-only",
        "operations": "Payroll operations",
        "tabs-label": "Payroll sections",
        "tabs": {
          "payroll-center": "Payroll Center",
          "pay-input": "Pay Input",
          "reports": "Reports",
          "templates": "Templates"
        },
        "module-name": "Payroll",
        "portfolio-label": "Payroll oversight",
        "portfolio-lead": "Payroll oversight is read-only at this scope."
      },
      "portfolio": {
        "all-scopes": "All Scopes",
        "direct": "Direct Workforce",
        "direct-sub": "Payroll owner · company-owned staff",
        "client-rollup": "Client rollup · read-only",
        "project-sub": "{id} · payroll owner",
        "months": {
          "m1": "Jan",
          "m2": "Feb",
          "m3": "Mar",
          "m4": "Apr",
          "m5": "May",
          "m6": "Jun",
          "m7": "Jul",
          "m8": "Aug",
          "m9": "Sep",
          "m10": "Oct",
          "m11": "Nov",
          "m12": "Dec"
        },
        "kpi": {
          "count": "Published payrolls",
          "emp": "Employees paid",
          "gross": "Total gross payroll",
          "last": "Last published"
        },
        "col": {
          "workspace": "Workspace",
          "projects": "Projects",
          "published": "Published payrolls",
          "emp": "Employees paid",
          "gross": "Gross payroll",
          "last": "Last published",
          "status": "Status",
          "scope": "Scope",
          "latest": "Latest published",
          "period": "Pay period",
          "type": "Type",
          "employees": "Employees",
          "gross-short": "Gross",
          "net": "Net",
          "published-on": "Published on"
        },
        "status-published": "Published",
        "status-none": "None",
        "demo": "demo",
        "demo-title": "Seeded demo history (PAY-PORT-97) — removable by migration",
        "search": "Search workspace…",
        "search-clear": "Clear search",
        "open-row": "Open {name}",
        "open-company": "Open company payroll workspace",
        "view-latest": "View latest published payroll (read-only)",
        "open-owning": "Open payroll workspace — owning scope (processing)",
        "empty-l1": "No published payrolls found for the selected filters.",
        "empty-l3": "No published payrolls found for this scope in the selected period.",
        "foot-l1": "Real workspaces only (ARCH-2) — click one to drill into Direct / Client / Project · Read-only portfolio",
        "foot-l2": "Click a row for its published periods · the eye opens the latest record · the arrow switches to the owning workspace",
        "foot-l3": "Click a pay period to open the published payroll record (read-only)",
        "l2-banner-lead": "The Payroll Center is a workspace, not a report.",
        "l2-banner": "Processing lives only at payroll-owning scopes (Direct Workforce / Project) — this level reviews published history and navigates the hierarchy. Client rows are consolidated rollups (read-only).",
        "l4-banner-lead": "Published payroll record — read-only snapshot.",
        "l4-banner": "This is the payroll module's own Payroll Record page fed the locked published run. No payroll operations exist at All Scopes; CSV/Excel/PDF export remain available (read-only actions).",
        "loading": "Loading published payrolls…",
        "error": "Couldn't load the published payrolls.",
        "retry": "Retry",
        "run-missing": "Published run not found.",
        "record": {
          "back": "Back to published periods",
          "pdf": "Download PDF",
          "title": "{period} — {type} Payroll",
          "window": "Pay period {window}",
          "run-id": "Run ID",
          "published": "Published {at}",
          "locked": "Approved & Locked",
          "published-by": "Published {at} by {by}",
          "employees": "{n} employees",
          "totals": "Run Totals",
          "hc": "Total HC Paid",
          "hc-sub": "Headcount that received payment",
          "gross": "Total Gross Pay",
          "gross-sub": "Basic + allowances + OT + back pay + seniority",
          "ded": "Total Deductions",
          "ded-sub": "Tax (TOS) + NSSF + unpaid leave + advance offset + others",
          "net": "Total Net Pay",
          "net-sub": "Final settlement paid to {n} employees",
          "earnings": "Earnings",
          "basic": "Basic Salary",
          "advance": "Salary Advance (50% basic)",
          "allowances": "Allowances",
          "overtime": "Overtime",
          "back-pay": "Back Pay",
          "seniority": "Seniority",
          "total-gross": "Total Gross",
          "deductions": "Deductions",
          "unpaid": "Unpaid Leave",
          "tax": "Tax (TOS)",
          "nssf": "NSSF (Employee)",
          "offset": "1st-Payroll Advance Offset",
          "other": "Other Deductions",
          "total-ded": "Total Deductions",
          "detail": "Employee Detail ({n})",
          "col": {
            "employee": "Employee",
            "dept": "Dept",
            "pay-method": "Pay Method",
            "bank": "Bank",
            "gross": "Gross",
            "tax": "Tax",
            "nssf": "NSSF",
            "deductions": "Deductions",
            "net": "Net"
          },
          "loading": "Loading employee lines…",
          "error": "Couldn't load the employee lines.",
          "no-lines": "No employee lines in this run.",
          "compliance": "Compliance",
          "cycle": "Payroll Cycle",
          "bimonthly": "Bi-monthly",
          "tax-applied": "Tax Applied",
          "nssf-applied": "NSSF Applied",
          "currency": "Currency",
          "rounding": "Rounding",
          "two-dec": "2 decimals",
          "offset-row": "First Payroll Offset",
          "applied": "Applied (2nd)",
          "yes": "Yes",
          "no": "No",
          "audit": "Audit Trail",
          "audit-published": "Payroll Published",
          "audit-locked": "Snapshot Locked",
          "audit-locked-sub": "Read-only after {at}",
          "footer": "Generated by Optimal HR — Payroll Module · This document reflects the locked payroll snapshot.",
          "footer-run": "Run ID: {id}"
        }
      },
      "bridge": {
        "label": "Pay Inputs — Collect",
        "kpi": {
          "employees": "Employees",
          "basic": "Total basic",
          "allowances": "Allowances",
          "ot": "OT hours (approved)",
          "attention": "Needs attention"
        },
        "info-lead": "System-fed, editable before run.",
        "info": "Basic (rate basis × locked attendance for Daily/Hourly), itemized allowances (compensation records), approved OT classified by day type, approved unpaid/AL days and movement flags are pre-filled from live modules. Source-owned values (basic, allowances, seniority, leave, OT) are read-only here — edit them in their owning module. Only Payroll-owned inputs (bonus, incentive, adjustment, one-time components) are editable.",
        "src": {
          "ec": "Effective Compensation · Employment Record",
          "att": "Attendance",
          "lv": "Leave",
          "man": "Payroll Manual Input"
        },
        "col": {
          "employee": "Employee",
          "basis": "Basis",
          "basic": "Basic $",
          "allowances": "Allowances",
          "seniority": "Seniority $",
          "ot": "OT h",
          "unpaid": "Unpaid d",
          "al": "AL d",
          "bonus": "Bonus $",
          "incentive": "Incentive $",
          "adjust": "Adjust $",
          "flags": "Flags"
        },
        "est": "est.",
        "locked": "locked",
        "lock": {
          "basic": "Basic Salary — managed in Effective Compensation (Employment Records). Read-only in Payroll.",
          "seniority": "Seniority entitlement — managed in Effective Compensation. Read-only in Payroll.",
          "unpaid": "Unpaid leave days — fed from approved Leave requests. Read-only in Payroll.",
          "al": "Annual leave days — fed from approved Leave requests. Read-only in Payroll."
        },
        "ot-tip": "Weekday {weekday}h · Day-off {dayOff}h · Hol-work {holWork}h · Hol-off {holOff}h",
        "ot-none": "No approved OT in period",
        "ot-src": "fed from Attendance (approved OT). Read-only in Payroll.",
        "src-manual": "Source: Payroll Manual Input (this run only)",
        "src-ec": "Source: Effective Compensation · maintained in Employment Records · effective {eff}",
        "add": "+ add",
        "add-from": "Add component from catalog:",
        "add-amount": "Amount (USD)",
        "add-btn": "Add",
        "add-hint": "Deductions: use a negative Adjustment",
        "add-nonzero": "Enter a non-zero amount",
        "remove": "Remove {code}",
        "edit": {
          "bonus": "Bonus for {name}",
          "incentive": "Incentive for {name}",
          "adjustment": "Adjustment for {name}"
        },
        "warn": {
          "no-bank": "No bank account",
          "estimated": "No locked attendance — standard-month estimate",
          "zero-basic": "Zero basic"
        },
        "move": {
          "termination": "Termination",
          "new-hire": "New hire",
          "unpaid-leave": "Unpaid leave"
        },
        "empty": "No payroll-eligible employees in this scope.",
        "loading": "Loading pay inputs…",
        "error": "Couldn't load the pay inputs.",
        "reset": "Reset edits"
      },
      "reports": {
        "title": "Reports",
        "subtitle": "Generated reports for completed payroll runs — preview, download PDF, or export Excel.",
        "year-label": "Filter by year",
        "all-years": "All years",
        "all": "All",
        "export-all": "Export All (ZIP)",
        "export-all-start": "Exporting {n} runs · 4 reports each — watch your downloads",
        "export-none": "No completed runs to export",
        "exported": "{tab} exported — {name}",
        "popup-blocked": "Allow pop-ups to print the PDF.",
        "tabs-label": "Report type",
        "tabs": {
          "summary": "Payroll Summary",
          "detail": "Payroll Detail",
          "tos": "Tax (TOS) Report",
          "nssf": "NSSF Report"
        },
        "kpi": {
          "reports": "Reports",
          "hc": "Total HC Paid",
          "net": "Total Net Paid",
          "gross": "Total Gross Paid",
          "tax": "Total Tax (TOS)",
          "avg-tax": "Avg Tax / Run",
          "nssf": "Total NSSF (Employee)",
          "avg-nssf": "Avg NSSF / Run",
          "hc-filed": "Headcount Filed"
        },
        "kpi-sub": {
          "reports": "completed runs",
          "hc": "employee-records",
          "net": "filtered period",
          "gross": "before deductions",
          "tax": "filed in period",
          "avg-tax": "running average",
          "nssf": "pension 2%",
          "avg-nssf": "running average",
          "hc-filed": "employee-records"
        },
        "search-placeholder": "Search by run ID, period, or approver…",
        "search-label": "Search reports",
        "clear-search": "Clear search",
        "result-count": "{n} run | {n} runs",
        "remove-filter": "Remove filter: {filter}",
        "error": "Couldn't load reports — {message}",
        "retry": "Retry",
        "empty": "No completed payrolls yet. Reports appear here once a run is closed.",
        "empty-filtered": "No reports match your filters. Try clearing the search or year filter.",
        "runs": "{n} run | {n} runs",
        "total-prefix": "Total:",
        "across": "across",
        "employee-records": "employee-records",
        "cols": {
          "run": "Run",
          "type": "Type",
          "period": "Pay Period",
          "pay-date": "Pay Date",
          "employees": "Employees",
          "net": "Net Pay",
          "status": "Status",
          "approver": "Approver",
          "actions": "Actions"
        },
        "type": {
          "regular": "Regular",
          "other": "Off-cycle"
        },
        "completed": "Completed",
        "view": "View {tab}",
        "view-for": "View {tab} for {run}",
        "pdf": "Download PDF",
        "pdf-for": "Download PDF for {run}",
        "excel": "Download Excel",
        "excel-for": "Download Excel for {run}"
      }
    },
    "people": {
      "title": "People",
      "subtitle": "{total} employees",
      "page-subtitle": "{direct} internal · {outsourced} outsourced",
      "tab-coming-soon": "Coming in a follow-up slice",
      "tabs": {
        "directory": "Directory",
        "outsourced": "Outsourced Workforce",
        "clients": "Clients",
        "external": "External Approvers",
        "emp-records": "Employment Records",
        "sites": "Sites",
        "org-units": "Org Units",
        "org-chart": "Org Chart",
        "workforce-plan": "Workforce Plan",
        "positions": "Positions",
        "onboarding": "Onboarding",
        "offboarding": "Offboarding",
        "compliance": "Compliance",
        "configuration": "Configuration"
      },
      "clients": {
        "subtitle": "Outsourcing customers · group projects · external approvers",
        "add-client": "Add Client",
        "search-placeholder": "Search clients, contacts, industry…",
        "status-unknown": "Unknown",
        "yes": "Yes",
        "no": "No",
        "banner": {
          "title": "Clients",
          "lead": "A client groups one or more outsourcing projects (e.g. Unilever → APSARA · NAO). Projects carry the employees; external approvers are scoped to the client."
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "archived": "Archived",
          "all-platform": "All platforms",
          "on-platform": "On platform",
          "off-platform": "Off platform",
          "label-status": "Status",
          "label-platform": "Platform",
          "label-search": "Search"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "cancel": "Cancel",
          "create": "Create client",
          "save": "Save changes"
        },
        "table": {
          "name": "Client",
          "industry": "Industry",
          "contact": "Primary contact",
          "platform": "Platform",
          "status": "Status",
          "on-platform-tag": "On platform",
          "showing": "Showing {filtered} of {total} clients",
          "click-hint": "Click a row to open the client profile"
        },
        "empty": {
          "title": "No clients match the current filters."
        },
        "error": "Failed to load clients.",
        "error-403": "You don't have access to this client list.",
        "retry": "Retry",
        "fields": {
          "name": "Display name",
          "name-placeholder": "e.g. Unilever",
          "legal-name": "Legal name",
          "industry": "Industry",
          "on-platform": "Client is also on OptimalHR (cross-tenant)",
          "counterparty": "Counterparty tenant",
          "primary-contact": "Primary contact",
          "contact-name": "Contact name",
          "contact-email": "Contact email",
          "contact-phone": "Contact phone",
          "email-invalid": "Enter a valid email address.",
          "address": "Address",
          "notes": "Notes"
        },
        "engagement": {
          "provider-managed": "Provider-managed",
          "vendor-lite": "Vendor lite",
          "service": "Service",
          "unknown": "Unknown"
        },
        "create": {
          "title": "Add client",
          "subtitle": "Create a new outsourcing customer."
        },
        "edit": {
          "title": "Edit client"
        },
        "profile": {
          "back": "Back to Clients",
          "edit": "Edit",
          "error": "Failed to load this client.",
          "sections": {
            "profile": "Profile",
            "projects": "Projects",
            "approvers": "External Approvers",
            "staff": "Staff"
          }
        },
        "projects": {
          "add": "Add Project",
          "edit": "Edit",
          "create-title": "Add project",
          "edit-title": "Edit project",
          "empty": "No projects under this client yet.",
          "error": "Failed to load projects.",
          "contract-count": "{n} contracts",
          "fields": {
            "name": "Project name",
            "engagement": "Engagement type",
            "org-full": "Organisation full name",
            "org-short": "Organisation short name",
            "id-format": "Employee ID format",
            "id-format-hint": "Optional pattern for auto-generated employee codes."
          }
        },
        "approvers": {
          "placeholder": "External approvers for this client are managed in the External Approvers tab.",
          "go-to-tab": "Open External Approvers",
          "error": "Couldn’t load approvers.",
          "empty": "No external approvers for this client yet.",
          "count": "{active} active approvers · {covered}/{total} projects covered"
        },
        "staff": {
          "placeholder": "Staff roster by client is coming in a later slice. For now, see contract counts under each project."
        },
        "toasts": {
          "created": "Client \"{name}\" created.",
          "create-failed": "Could not create the client. Try again.",
          "saved": "Client saved.",
          "save-failed": "Could not save the client. Try again.",
          "project-created": "Project \"{name}\" created.",
          "project-saved": "Project saved.",
          "project-failed": "Could not save the project. Try again."
        }
      },
      "emp-records": {
        "title": "Employment Records",
        "subtitle": "Offers · Contracts · Employment Actions · Compensation · Benefits — single hub for the employee's employment story",
        "actions": {
          "new-record": "New Record",
          "view": "View",
          "clear-filters": "Clear filters",
          "cancel": "Cancel",
          "close": "Close",
          "edit": "Edit"
        },
        "sub-tabs": {
          "offers": "Offers",
          "contracts": "Contracts",
          "actions": "Employment Actions",
          "compensation": "Compensation",
          "benefits": "Benefits"
        },
        "dispatch": {
          "title": "Create employment record",
          "lede": "Pick the record type you want to create — we'll route the rest.",
          "form-title": "New {kind}",
          "form-lede": "Fill in the basics — the team will be notified once you submit.",
          "back": "Back",
          "cancel": "Cancel",
          "submit": "Create",
          "created-toast": "{kind} draft created for {employee}",
          "fields": {
            "employee": "Employee or candidate",
            "detail": "Notes / detail"
          },
          "placeholders": {
            "employee": "Search by name or employee code…",
            "detail": "Add context — effective date, amount, terms, etc."
          },
          "errors": {
            "no-kind": "Please pick a record type first.",
            "employee-required": "Employee or candidate is required."
          },
          "offer": {
            "title": "Offer",
            "desc": "Draft an offer letter for a candidate."
          },
          "contract": {
            "title": "Contract",
            "desc": "Issue a new employment contract."
          },
          "action": {
            "title": "Employment Action",
            "desc": "Promotion, transfer, salary or allowance change."
          },
          "benefit": {
            "title": "Benefit",
            "desc": "Enrol an employee into a benefit programme."
          },
          "compensation": {
            "title": "Compensation Event",
            "desc": "Record a salary, bonus, or allowance change."
          }
        },
        "offers": {
          "banner": "Offer Letters are pre-contract employment offers issued to candidates before Add Person. Lifecycle: Draft → Issued → Accepted (or Declined / Withdrawn / Expired). After issue but before acceptance, edits create a new version (Revise & Re-issue). On Accept, downstream creation of Person + Contract + Compensation is wired in CT-4.",
          "search-placeholder": "Candidate, position, offer ID…",
          "showing": "Showing {filtered} of {total}",
          "footer-note": "{shown} of {total} offers shown · Per-offer override always allowed — packages from the Allowance & Benefits library are starting points, not constraints.",
          "new-offer": "New Offer",
          "filters": {
            "status": "Status",
            "workforce": "Workforce",
            "search": "Search"
          },
          "status-filter": {
            "open": "Open (Draft + Issued)",
            "all": "All statuses"
          },
          "statuses": {
            "Draft": "Draft",
            "Issued": "Issued",
            "Distributed": "Distributed",
            "Accepted": "Accepted",
            "Declined": "Declined",
            "Withdrawn": "Withdrawn",
            "Expired": "Expired"
          },
          "workforce": {
            "all": "All",
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "kpi": {
            "all": "All",
            "draft": "Draft",
            "issued-not-sent": "Issued · not sent",
            "distributed": "Distributed · awaiting response",
            "accepted": "Accepted",
            "declined": "Declined"
          },
          "cols": {
            "code": "Offer ID",
            "candidate": "Candidate",
            "position": "Position",
            "scope": "Scope",
            "salary": "Salary",
            "type-on-accept": "Type → on Accept",
            "issued": "Issued",
            "status": "Status",
            "actions": "Actions"
          },
          "scope": {
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "drawer": {
            "candidate-email": "Email",
            "candidate-phone": "Phone",
            "scope": "Scope",
            "position": "Position",
            "job-grade": "Job grade",
            "contract-type": "Contract type on accept",
            "salary": "Gross salary (monthly)",
            "start": "Proposed start",
            "valid-until": "Valid until",
            "end": "Proposed end",
            "probation-end": "Probation ends",
            "allowances": "Allowances",
            "notes": "Internal notes",
            "issued": "Issued",
            "distributed": "Distributed",
            "accepted": "Accepted",
            "declined-reason": "Decline reason"
          },
          "empty": {
            "title": "No offers match",
            "lede": "Try clearing a filter or adjusting your search."
          },
          "form": {
            "new-title": "New Offer Letter",
            "new-sub": "Draft · pick position, package will auto-fill",
            "no-name": "(no name)",
            "no-position": "(no position)",
            "close": "Close",
            "view-mode": "View mode.",
            "edit": "Edit",
            "chain": "Version {version} · revised offer chain.",
            "candidate": "Candidate",
            "latin-name": "Latin Name *",
            "khmer-name": "Khmer Name",
            "email": "Email",
            "phone": "Phone",
            "position-contract": "Position & Contract Type",
            "workforce-type": "Workforce Type *",
            "job-grade": "Job Grade *",
            "grade-hint": "(filters vacancies below)",
            "client": "Client",
            "project": "Project",
            "select": "— select —",
            "any-project": "— Any project —",
            "position": "Position *",
            "position-hint": "(from Vacancy list)",
            "select-position": "— Select a vacant position{grade} —",
            "position-other": "— Other (free-text, no vacancy) —",
            "position-other-ph": "Free-text position title (e.g. for a new role not yet in vacancy list)",
            "no-vacancies": "No vacant positions at {grade} for this workforce. Switch grade or pick Other (free-text).",
            "selected": "Selected",
            "contract-type": "Contract Type on Accept *",
            "start-date": "Proposed Start Date *",
            "valid-until": "Offer Valid Until *",
            "end-date": "Proposed End Date *",
            "fdc-max": "(max 24 months per LL)",
            "prob-end": "(= probation end)",
            "fdc-warn": "FDC max is 24 months per Cambodia LL ({months} months specified)",
            "include-probation": "Include probation period",
            "probation-end-date": "Probation End Date *",
            "probation": "Probation",
            "probation-ends": "Yes · ends {date}",
            "no": "No",
            "compensation": "Compensation Package",
            "override": "· per-offer override",
            "template": "· template: {ref}",
            "gross-salary": "Gross Salary (Monthly) *",
            "gross-salary-short": "Gross Salary",
            "salary-ph": "e.g. 1500",
            "salary-band-warn": "Outside {code} band (${min}-${max})",
            "allowance-package": "Allowance Package",
            "allowance-package-hint": "(choose a template or pick Custom to define your own)",
            "choose-template": "— Choose template or Custom —",
            "custom": "Custom (define manually)",
            "no-allowance-template": "No matching template — pick Custom and add lines below.",
            "allowance": "Allowance",
            "monthly": "Monthly",
            "no-allowances": "No allowances",
            "add-one": "add one",
            "total-allowances": "Total allowances + base",
            "add-allowance": "Add allowance line",
            "remove": "Remove",
            "benefits": "Benefits",
            "benefits-package": "Benefits Package",
            "benefits-package-hint": "(choose a template or pick Custom)",
            "no-benefits-template": "No matching template — pick Custom.",
            "pick-benefits": "Pick a template above or switch to",
            "no-benefits": "No benefits defined.",
            "note-optional": "Note (optional)",
            "conditions-notes": "Conditions & Notes",
            "conditions": "Conditions before joining",
            "conditions-hint": "(one per line — things candidate must satisfy before start date)",
            "conditions-ll": "Cambodia LL compulsory: medical clearance from Labor Department doctor. Other conditions (background check, references) are company policy.",
            "no-conditions": "No conditions specified.",
            "internal-notes": "Internal Notes",
            "notes-hint": "(not visible on offer letter)",
            "notes-label": "Notes",
            "letter-preview": "Letter Preview",
            "download-pdf": "Download as PDF",
            "all-filled": "All required fields filled",
            "cancel": "Cancel",
            "cancel-edit": "Cancel edit",
            "save-draft": "Save Draft",
            "save-issue": "Save & Issue",
            "status": "Status",
            "toast-draft": "Offer {id} saved as Draft",
            "toast-issued": "Offer {id} issued"
          }
        },
        "contracts": {
          "banner": "Contracts hold the agreed legal terms of employment. Each type drives its own lifecycle: Probation converts to FDC/UDC via a new contract · FDC extends or converts to UDC · UDC changes go through Employment Change (the contract persists) · any contract can be Terminated. Click a row to view its full chain history.",
          "search-placeholder": "Search by code, employee, position, or type…",
          "showing": "Showing {filtered} of {total}",
          "footer-note": "{shown} of {total} contracts shown · Lifecycle actions (Convert · Extend · Issue Employment Change · Terminate) are available in the detail drawer when contract status is Active",
          "kpi": {
            "active": "Active contracts",
            "expiring-30": "Expiring ≤30 days",
            "expiring-31-60": "Expiring 31-60 days",
            "probation-ending-30": "Probation ending ≤30d",
            "unsigned": "Unsigned"
          },
          "filters": {
            "status": "Status",
            "type": "Contract Type",
            "workforce": "Workforce",
            "client": "Client",
            "search": "Search"
          },
          "status-opts": {
            "active": "Active only",
            "all": "All statuses",
            "Active": "Active",
            "history": "History (Superseded/Expired/Terminated)",
            "pending": "Pending Signature"
          },
          "type-opts": {
            "all": "All types"
          },
          "workforce": {
            "all": "All",
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "client-opts": {
            "all": "All clients"
          },
          "cols": {
            "code": "Contract ID",
            "employee": "Employee",
            "type": "Type",
            "position": "Position",
            "scope": "Scope",
            "start": "Start",
            "end": "End",
            "status": "Status",
            "actions": "Actions"
          },
          "scope": {
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "exp-chip": {
            "le30": "≤30d",
            "le60": "≤60d",
            "expired": "Expired"
          },
          "empty": {
            "no-match": "No contracts match the current filters.",
            "title": "No contracts match",
            "lede": "Try clearing a filter or adjusting your search."
          },
          "detail": {
            "close": "Close",
            "close-btn": "Close",
            "no-position": "No position",
            "header": "Header",
            "employee": "Employee",
            "position": "Position",
            "type": "Type",
            "status": "Status",
            "scope": "Scope",
            "reports-to": "Reports To",
            "start": "Start Date",
            "end": "End Date",
            "indefinite": "Indefinite",
            "probation-end": "Probation End",
            "notice-period": "Notice Period",
            "work-location": "Working Location",
            "working-hours": "Working Hours",
            "remuneration": "Remuneration",
            "remuneration-note": "(initial values from contract · live values in Compensation)",
            "gross-salary": "Gross Salary",
            "pay-frequency": "Pay Frequency",
            "pay-method": "Pay Method",
            "extensions": "Extensions ({count})",
            "ext-addendum": "Addendum",
            "ext-old-end": "Old End",
            "ext-new-end": "New End",
            "ext-signed": "Signed",
            "ext-reason": "Reason",
            "amendments": "Amendments / Employment Changes ({count})",
            "amd-eff": "eff. {date}",
            "amd-reason": "Reason: {reason}",
            "amd-by": "by {by}",
            "chain": "Contract Chain ({count})",
            "chain-viewing": "← viewing",
            "chain-open": "open",
            "signed-copy": "Signed Copy",
            "signed-by": "Signed by:",
            "document": "Document:",
            "not-attached": "Not attached",
            "not-signed": "Contract not yet signed.",
            "footer-id": "Contract",
            "action-convert": "Convert to UDC…",
            "action-extend": "Extend…",
            "action-amend": "Issue Employment Change…",
            "action-terminate": "Terminate…",
            "action-stub": "{action} — coming soon. Contracts are created from accepted offers in this build."
          },
          "chips": {
            "all": "All",
            "active": "Active",
            "probation": "Probation",
            "expiring": "Expiring ≤30d",
            "unsigned": "Unsigned",
            "expired": "Expired"
          },
          "drawer": {
            "position": "Position",
            "employee-code": "Employee Code",
            "start": "Start",
            "end": "End",
            "notes": "Notes"
          }
        },
        "actions-tab": {
          "title": "Employment Actions",
          "subtitle": "Cross-employee operational workspace · Phase 1 recording · status derived from effective date · no approval queue",
          "new-action": "New Employment Action",
          "search-placeholder": "Search by code, employee, type, or detail…",
          "showing": "Showing {filtered} of {total}",
          "banner-title": "Phase 1 · Recording only.",
          "banner-lede": "HR records EAs that were approved offline (memo / letter / LM sign-off). Status: Scheduled (future effective date) → Effective (today / past). Approval workflow comes in Phase 2.",
          "phase2": "Phase 2",
          "kpi": {
            "all-eas": "All EAs",
            "scheduled": "Scheduled",
            "effective-this-week": "Effective this week",
            "by-detected-label": "By Detected Label",
            "cancelled": "Cancelled",
            "cancelled-delta": "{n} cancelled",
            "future-dated": "future-dated",
            "last-7-days": "in the last 7 days",
            "retained": "retained for audit"
          },
          "filters": {
            "all-types": "All action types",
            "all-labels": "All detected labels",
            "all-statuses": "All statuses"
          },
          "status": {
            "scheduled": "Scheduled",
            "effective": "Effective",
            "cancelled": "Cancelled"
          },
          "cols": {
            "effective": "Effective Date",
            "employee": "Employee",
            "type": "Action Type",
            "detail": "Detail",
            "detected-label": "Detected Label",
            "status": "Status",
            "comp": "Comp",
            "actions": "Actions",
            "code": "Code"
          },
          "empty": {
            "title": "No employment actions match",
            "lede": "Try clearing a filter or adjusting your search.",
            "lede-none": "Click New Employment Action to record the first one."
          },
          "modal": {
            "aria": "Employment Action",
            "title": "New Employment Action",
            "step1": "Step 1 of 3 · choose the Employment Event Classification",
            "step2": "Step 2 of 3 · choose the employee this classification applies to",
            "step3": "Step 3 of 3 · fill in the form · Phase 1 recording",
            "what-change": "What kind of change?",
            "what-change-lede": "Pick the business classification first. Each classification has its own form. Next you'll pick the employee, then fill in the form.",
            "classification": "Classification",
            "change-classification": "Change classification",
            "pick-employee": "Pick Employee",
            "employee": "Employee",
            "employee-search": "Search by ID · name · position · department…",
            "employee-hint": "Excludes inactive employees. Click a row to continue to the {label} form.",
            "employee-empty": "No active employees match your search.",
            "upcoming": "{label} — Upcoming Feature · planned for a later phase",
            "upcoming-tag": "⏸ UPCOMING FEATURE",
            "detail-title": "Detail",
            "recorded": "Recorded {date}",
            "toast-saved": "{label} recorded · status: {status}"
          },
          "form": {
            "effective-date": "Effective Date",
            "effective-hint": "Back-date window: {days} days · Today (demo): {today}",
            "reason": "Reason",
            "reason-placeholder": "Why is this change being recorded?",
            "document": "Document Reference",
            "document-placeholder": "Filename or reference (e.g. PromotionLetter-2026-014.pdf · filed in personnel file)",
            "dropzone": "Drag & drop or browse to attach the offline memo / letter",
            "offline-label": "Offline approval completed",
            "offline-desc": "LM / HR / Employee have agreed and signed off offline (memo, letter, or verbal). Tick when the paper trail is in place.",
            "offline-notes": "Notes — e.g. Approved by LM Sopheap, memo signed 2026-06-28",
            "companion-label": "Companion: also record a Salary Adjustment",
            "companion-desc": "Position Assignment often carries a salary change. Records two distinct entries (one Employment Action + one Compensation Event) sharing this effective date and reason.",
            "base-salary": "Base Salary",
            "new-base-salary": "New Base Salary",
            "routing-template": "Routing template (stored, not executed)",
            "position-placeholder": "Pick a target Position…",
            "position-search": "Search Title · Department · Site · Grade…",
            "position-empty": "No assignable Positions match · all matching seats are currently occupied.",
            "vacant": "Vacant",
            "manager-placeholder": "Pick a manager…",
            "pick": "Pick…",
            "value": "value",
            "detected-action": "Detected Action (derived from delta)",
            "delta-attribute": "Attribute",
            "delta-current": "Current",
            "delta-target": "Target",
            "no-change": " (No Change)",
            "ready": "Ready to save · status will be {status}",
            "missing": "{n} required field(s) missing or invalid",
            "cancel": "Cancel",
            "save": "Save Record"
          },
          "detail": {
            "record-id": "Record ID",
            "employee": "Employee",
            "effective": "Effective Date",
            "status": "Status",
            "detected": "Detected Action",
            "document": "Document ref",
            "offline": "Offline approval",
            "offline-yes": "Completed",
            "offline-no": "Not marked completed",
            "change-summary": "Change Summary",
            "position-delta": "Position Delta (at record)",
            "routing": "Approval Routing Reference",
            "routing-template": "Routing template (stored, not executed)",
            "cancel-record": "Cancel Record",
            "close": "Close"
          },
          "chips": {
            "all": "All",
            "pending": "Pending",
            "approved": "Approved",
            "effective": "Effective"
          },
          "drawer": {
            "effective": "Effective Date",
            "approver": "Approver",
            "detail": "Detail"
          }
        },
        "benefits": {
          "title": "Benefits",
          "subtitle": "Cross-employee enrollment workspace · {employees} employees · {entries} catalog entries · monthly cost rollup",
          "new-benefit": "New Benefit",
          "bulk-enroll": "Bulk Enroll",
          "edit-catalog": "Edit catalog",
          "search-placeholder": "Search by benefit, provider, kind…",
          "showing": "Showing {filtered} of {total}",
          "footer-note": "New Benefit adds a catalog entry company-wide · Bulk Enroll enrolls many eligible employees at once · click the pencil on any row to edit. For individual enrollment, go to the employee's Profile → Benefits.",
          "kpi": {
            "active-enrollments": "Active enrollments",
            "employees-enrolled": "Employees enrolled",
            "monthly-cost-employer": "Monthly cost (employer)",
            "renewing-90": "Renewing ≤90 days",
            "across-all": "across all benefits",
            "coverage": "{pct}% coverage",
            "annualized": "USD {amount} annualized",
            "action-needed": "action needed",
            "all-clear": "all clear"
          },
          "chips": {
            "all": "All",
            "active": "Active",
            "renewing": "Renewing",
            "ended": "Ended"
          },
          "cols": {
            "benefit": "Benefit",
            "enrolled": "Enrolled",
            "eligible": "Eligible",
            "takeup": "Take-up",
            "monthly-cost": "Monthly Cost",
            "renewal": "Renewal",
            "actions": "Actions"
          },
          "kinds": {
            "Insurance": "Insurance",
            "Statutory": "Statutory",
            "Wellness": "Wellness",
            "Allowance In-kind": "Allowance In-kind",
            "Other": "Other"
          },
          "statuses": {
            "Active": "Active",
            "Renewing": "Renewing",
            "Ended": "Ended"
          },
          "workforce": {
            "Direct": "Direct",
            "Outsourced": "Outsourced"
          },
          "eligibility-types": {
            "all": "All employees",
            "grade": "Grade-based (minimum)",
            "workforce_type": "Workforce type (Direct / Outsourced)",
            "tenure": "Tenure (minimum months)",
            "department": "Specific Department"
          },
          "catalog": {
            "new-title": "New Benefit",
            "edit-title": "Edit Benefit",
            "subtitle": "Master catalog entry",
            "kind": "Kind",
            "status": "Status",
            "name": "Benefit Name",
            "name-ph": "e.g., Infinity Group Health · Plan A",
            "provider": "Provider",
            "provider-ph": "e.g., Infinity General Insurance",
            "scheme": "Scheme / Coverage Tier",
            "scheme-ph": "e.g., Accident + Health",
            "coverage": "Coverage Items (comma-separated)",
            "coverage-ph": "e.g., Health, Hospitalization, OPD",
            "eligibility": "Eligibility",
            "min-grade": "Min Grade Number",
            "workforce-type": "Workforce Type",
            "min-months": "Min Months",
            "department": "Department",
            "department-ph": "e.g., Sales",
            "label": "Label",
            "cost-employee": "Cost / employee / mo (USD)",
            "cost-family": "Cost / family / mo (USD)",
            "renewal": "Next Renewal",
            "policy-pattern": "Policy ID Pattern",
            "policy-pattern-opt": "(optional · use {code} placeholder)",
            "policy-pattern-ph": "e.g., P/01/GPA/24/{code}",
            "create": "Create Benefit",
            "save-changes": "Save Changes",
            "toast-created": "Created {name}",
            "toast-updated": "Updated {name}"
          },
          "bulk": {
            "title": "Bulk Enroll in Benefit",
            "step1": "Step 1 · Pick the benefit to bulk-enroll",
            "step1-eyebrow": "Step 1 · pick benefit",
            "step2": "Step 2 · Pick employees to enroll",
            "selected-benefit": "SELECTED BENEFIT",
            "selected-count": "{count} selected",
            "currently-enrolled": "{count} currently enrolled",
            "eligible-not-enrolled": "{count} eligible · not enrolled",
            "pick-different": "← Pick a different benefit",
            "select-all": "Select all",
            "clear": "Clear",
            "all-enrolled": "All eligible employees are already enrolled.",
            "submit": "Enroll {count} employee(s)",
            "toast": "{count} employee(s) enrolled in {name}"
          },
          "drawer": {
            "provider": "Provider",
            "eligibility": "Eligibility",
            "cost-per-employee": "Cost per Employee",
            "renewal": "Renewal",
            "description": "Description"
          },
          "empty": {
            "title": "No benefits match",
            "lede": "Try clearing a filter or adjusting your search."
          }
        },
        "compensation": {
          "title": "Compensation Center",
          "subtitle": "Components · packages · assignments · events · reports — workforce-wide · Phase 1 record-only",
          "tabs": {
            "overview": "Overview",
            "components": "Components",
            "packages": "Packages",
            "assignments": "Assignments",
            "events": "Events",
            "reports": "Reports"
          },
          "phase-banner": {
            "title": "Phase 1 · Record-only.",
            "body": "Compensation Events save directly to the Compensation Timeline and Contract Salary Adjustment history. Approvals happen offline. The workflow engine lands in Phase 2."
          },
          "kpi": {
            "active-employees": "Active Employees",
            "total-monthly-comp": "Total Monthly Comp",
            "components": "Components",
            "packages": "Packages",
            "salary-adj-ytd": "Salary Adj {year}",
            "bonuses-ytd": "Bonuses {year}",
            "in-scope": "in scope",
            "recurring-wide": "recurring package · workforce-wide",
            "active-catalog": "active in catalog",
            "pkg-breakdown": "{allowance} allowance · {benefits} benefits",
            "recorded": "recorded",
            "total": "total"
          },
          "actions": {
            "manage-components": "Manage Components",
            "manage-components-desc": "Add or edit Pay Component Catalog",
            "build-packages": "Build Packages",
            "build-packages-desc": "Bundle components by scope",
            "bulk-assign": "Bulk Assign",
            "bulk-assign-desc": "By department + grade",
            "record-event": "Record Event",
            "record-event-desc": "Salary · bonus · allowance change"
          },
          "top-depts": {
            "title": "Top Departments by Monthly Comp",
            "view-report": "View full report →",
            "empty": "No data."
          },
          "recent-events": {
            "title": "Recent Events",
            "view-ledger": "Open full ledger →",
            "empty": "No Compensation Events recorded yet."
          },
          "stub": {
            "lede": "This panel ships with the Phase B compensation backend (components, packages, assignments, events ledger, reports). For now use Overview to land on the workforce-wide picture.",
            "back": "Back to Overview"
          },
          "phase2": "PHASE 2",
          "filters": {
            "category": "Category",
            "status": "Status",
            "dept": "Department",
            "grade": "Job Grade",
            "contract": "Contract",
            "all": "All",
            "all-depts": "All depts",
            "all-grades": "All grades",
            "all-contracts": "All contracts"
          },
          "components": {
            "title": "Pay Component Catalog",
            "subtitle": "Master list of components used across packages and per-employee assignments. Edits cascade to all employees on next save.",
            "new": "New Component",
            "search-placeholder": "Search by code or name…",
            "empty": "No matching components.",
            "status-active": "Active",
            "status-inactive": "Inactive",
            "cat": {
              "all": "All categories",
              "base": "Base Pay",
              "allowance": "Allowance",
              "var": "Variable Pay"
            },
            "status": {
              "active": "Active only",
              "all": "All",
              "inactive": "Inactive only"
            },
            "cols": {
              "code": "Code",
              "name": "Name",
              "category": "Category",
              "recurring": "Recurring",
              "tax": "Tax Treatment",
              "nssf": "NSSF Base",
              "funded": "Funded",
              "status": "Status"
            },
            "legend": {
              "none": "Excluded from tax",
              "tos": "Progressive tier per salary band (Cambodia LL)",
              "fringe": "20% flat-rate Fringe Benefit Tax"
            }
          },
          "packages": {
            "title": "Allowance & Benefits Packages",
            "subtitle": "Bundle components into reusable packages scoped by Workforce Type · Client · Project · Job Grade. Cascade: Project → Client → Tenant-generic. Used by Offer Letters and Add Person pre-fill.",
            "allowance-title": "Allowance Packages",
            "benefits-title": "Benefits Packages",
            "cols": {
              "name": "Package",
              "scope": "Scope",
              "components": "Components",
              "monthly": "Monthly",
              "enabled": "Enabled",
              "items": "Items",
              "contract": "Contract"
            },
            "kpi": {
              "active": "Active in section",
              "direct": "Direct templates",
              "outsourced": "Outsourced templates",
              "shown": "Shown after filters"
            },
            "filters": {
              "workforce": "Workforce",
              "client": "Client",
              "project": "Project",
              "all-clients": "All clients",
              "all-projects": "All projects"
            },
            "workforce-direct": "Direct only",
            "workforce-outsourced": "Outsourced only",
            "show-inactive": "Show inactive",
            "empty": "No packages match the current filters.",
            "footnote": "Templates are foundation only in this release — consumed by the Offer Letter flow and the Add Person pre-fill in upcoming slices. Per-offer override remains available regardless of template selection.",
            "on": "on",
            "off": "off",
            "detail": {
              "scope": "Scope",
              "notes": "Notes",
              "line-items": "Line Items",
              "allowance": "Allowance",
              "amount": "Monthly Amount",
              "total": "Total per month"
            }
          },
          "assignments": {
            "title": "Employee Compensation Assignments",
            "subtitle": "Who's on which package · base + allowance components per employee. Use Bulk Assign for group changes.",
            "bulk": "Bulk Assign by Group",
            "search-placeholder": "Search name, code, title…",
            "showing": "Showing {shown} of {total} employees",
            "empty": "No employees match.",
            "cols": {
              "employee": "Employee",
              "title": "Title",
              "base": "Base / mo",
              "allowances": "Allowance Components",
              "allowance-total": "Allowances / mo",
              "total": "Total / mo"
            },
            "open-profile": "Open {name} profile"
          },
          "events": {
            "title": "Compensation Events Ledger",
            "subtitle": "Every recorded Salary Adjustment, Bonus, Variable Pay change, and Allowance event across the workforce.",
            "export": "Export CSV",
            "export-soon": "Cross-employee export — coming soon",
            "record": "Record Event",
            "search-placeholder": "Search employee, event type, or reason…",
            "event-type": "Event type",
            "date-range": "Date range",
            "types": {
              "all": "All event types",
              "salary": "Salary Adjustment",
              "bonus": "Bonus Awarded",
              "varpay": "Variable Pay Eligibility",
              "allowance": "Allowance (Add / Change / End)"
            },
            "ranges": {
              "30": "Last 30 days",
              "90": "Last 90 days",
              "180": "Last 6 months",
              "365": "Last 12 months",
              "all": "All time"
            },
            "ledger-title": "Compensation Events Ledger",
            "ledger-count": "{groups} entries · {filtered} of {total} events (bulk actions grouped)",
            "empty": "No Compensation Events match the current filters.",
            "cols": {
              "effective": "Effective",
              "employee": "Employee",
              "event": "Event",
              "detail": "Detail",
              "reason": "Reason",
              "status": "Status"
            },
            "effective": "Effective",
            "scheduled": "Scheduled",
            "employees": "employees",
            "bulk": "BULK",
            "same-to": "same amount to {count} employees",
            "show": "Show {count}",
            "hide": "Hide {count}",
            "open-profile": "Open employee profile"
          },
          "cost-alloc": {
            "title": "Cost Allocation Overview",
            "manage": "Manage (Phase 2)",
            "body": "Cross-employee project allocation editing comes in Phase 2. Per-employee read-only view available on each Profile → Compensation tab."
          },
          "reports": {
            "title": "Compensation Reports",
            "subtitle": "Lightweight analytics across the workforce.",
            "by-component": "By Component",
            "by-dept": "By Department",
            "by-grade": "By Job Grade",
            "top-earners": "Top Earners",
            "dept-total": "Total · {count} depts",
            "footnote": "Phase 1 reports use the current effective package. Charts, period comparisons, and CSV export land in Phase 2.",
            "cols": {
              "component": "Component",
              "assignments": "Assignments",
              "monthly-total": "Monthly Total",
              "distribution": "Distribution",
              "department": "Department",
              "headcount": "Headcount",
              "base-total": "Base Total",
              "allowances-total": "Allowances Total",
              "grade": "Job Grade",
              "avg-monthly": "Avg Monthly",
              "employee": "Employee",
              "title-dept": "Title · Dept",
              "base": "Base",
              "allowances": "Allowances",
              "total-monthly": "Total Monthly"
            }
          },
          "picker": {
            "title": "Record Compensation Event",
            "sub": "Pick the employee first · then choose the event type",
            "search": "Search",
            "search-placeholder": "Name, code, or title…",
            "helper": "Showing first 30 matches. Refine search to narrow.",
            "empty": "No matching employees.",
            "toast": "Opening Compensation for {name} — Phase 2 records the event."
          },
          "bulk": {
            "title": "Bulk Assign Compensation Component",
            "sub": "Phase 1 record-only · creates one Compensation Event per matched employee",
            "info-title": "Bulk Assign by Group.",
            "info-body": "Pick a Department + Grade combination, then a component and amount. One Compensation Event is recorded per matched employee. The Contract Base Salary is never overwritten.",
            "matched": "Matched Employees",
            "will-receive": "employees will receive this assignment",
            "component": "Component",
            "select-component": "Select an allowance component…",
            "component-helper": "Only allowance components are bulk-assignable in Phase 1. Salary adjustments must be recorded per-employee.",
            "amount": "Amount (USD)",
            "amount-helper": "Same amount applied to every matched employee.",
            "funded": "Funded by",
            "funded-optimal": "Optimal-funded",
            "funded-client": "Client-funded",
            "effective": "Effective Date",
            "reason": "Reason",
            "reason-placeholder": "e.g. Department-wide phone allowance roll-out",
            "submit": "Record {count} Events",
            "toast": "{count} Compensation Events recorded · see Events ledger"
          },
          "component": {
            "new-title": "New Component",
            "edit-title": "Edit Component — {name}",
            "sub": "Master Pay Component · cascades to all packages and assignments",
            "code": "Code",
            "code-helper": "Short uppercase identifier · cannot be changed later.",
            "code-immutable": "Code is immutable once created.",
            "name-en": "Name (English)",
            "name-km": "Name (Khmer)",
            "tax": "Tax Treatment",
            "flags": "Other Flags",
            "recurring": "Recurring (paid every period)",
            "nssf": "Counts toward NSSF base",
            "seniority": "Counts toward Seniority base",
            "funding": "Default Funding",
            "funded-optimal": "Optimal-funded",
            "funded-client": "Client-funded",
            "funded-policy": "Policy-driven (per assignment)",
            "save": "Save Changes",
            "create": "Create Component",
            "toast-created": "Component \"{name}\" created",
            "toast-updated": "Component \"{name}\" updated",
            "tax-help": {
              "none": "Excluded from both Tax on Salary (TOS) and Fringe Benefit Tax. E.g. transport, meal allowances within statutory limits.",
              "tos": "Tax on Salary · progressive tier per Cambodia LL. Applies to cash compensation paid directly to the employee (base, housing, position, etc.).",
              "fringe": "Fringe Benefit Tax · 20% flat-rate on benefit value. Applies to non-cash benefits (company car, employer-provided accommodation, in-kind allowances, etc.)."
            }
          }
        }
      },
      "sites": {
        "subtitle": "Workplace locations · company-owned and EOR client placements · single source of truth for where employees work",
        "add-site": "Add Site",
        "search-placeholder": "Site name, code, address…",
        "footnote": "{shown} of {total} sites shown · Click any row to view details · Edit, disable, or delete a site from the row actions",
        "banner": {
          "title": "Sites",
          "lead": "— manage workplace locations used as employee Base Locations.",
          "detail": "Sites unifies company-owned offices and EOR client placement sites under a single model. The Main Office is the primary base location; additional Sub Offices can be enabled or disabled as needed."
        },
        "type": {
          "main": "Main Office",
          "sub": "Sub Office",
          "unknown": "Unknown"
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "inactive": "Inactive",
          "all-types": "All types",
          "label-type": "Type",
          "label-status": "Status",
          "label-search": "Search",
          "label-country": "Country",
          "label-province": "Province",
          "label-district": "District",
          "all-countries": "All countries",
          "all-provinces": "All provinces",
          "all-districts": "All districts",
          "clear-one": "Clear filter {name}"
        },
        "table": {
          "code": "Site Code",
          "name": "Site Name",
          "type": "Type",
          "owner": "Site Owner",
          "status": "Status",
          "enabled": "Enabled",
          "actions": "Actions",
          "always-on": "Always on",
          "showing": "Showing {filtered} of {total}",
          "click-hint": "Click any row to open the site detail",
          "area": "Area",
          "no-coordinates": "No coordinates"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "edit": "Edit {name}",
          "edit-short": "Edit",
          "delete": "Delete {name}",
          "delete-short": "Delete",
          "view-map": "View {name} on map",
          "view-map-short": "View on map",
          "toggle": "Enable or disable {name}",
          "export": "Export",
          "export-empty": "Nothing to export — no rows match the filters",
          "history": "History"
        },
        "empty": {
          "title": "No sites match the current filters."
        },
        "error": {
          "title": "Couldn't load sites."
        },
        "drawer": {
          "close": "Close site detail",
          "section": {
            "address": "Address & GPS",
            "roster": "Details"
          },
          "fields": {
            "gps-lat": "GPS Lat",
            "gps-lon": "GPS Lon",
            "owner": "Site owner"
          },
          "no-value": "—"
        },
        "map": {
          "label": "Site location map",
          "coordinates": "Location coordinates",
          "coordinates-hint": "Click or drag the pin on the map, or type \"latitude, longitude\"."
        },
        "modal": {
          "title": "Create new site",
          "edit-title": "Edit site",
          "subtitle": "Workplace location used as an employee Base Location. Fields marked * are required.",
          "cancel": "Cancel",
          "submit": "Create site",
          "update": "Update site",
          "footnote": "A site needs a name. Add a map pin (coordinates) if the site will be used as a work zone. Only Sub Offices can be added; the Main Office comes with the company.",
          "fields": {
            "name": "Site name",
            "name-placeholder": "e.g. Head Office",
            "code": "Site code",
            "code-placeholder": "Optional company code",
            "type": "Type",
            "location": "Location on map",
            "address": "Address details",
            "address-placeholder": "Street, sangkat, khan",
            "status": "Status",
            "country-placeholder": "Select a country",
            "province-placeholder": "Select a province",
            "district-placeholder": "Select a district",
            "area-loading": "Loading…",
            "area-none": "No matches",
            "area-error": "Couldn't load the location list. You can still save the site; try the list again later."
          }
        },
        "delete": {
          "title": "Delete site?",
          "body": "Are you sure you want to delete \"{name}\"? This cannot be undone.",
          "confirm": "Delete"
        },
        "disable": {
          "title": "Disable site?",
          "body": "Are you sure you want to disable \"{name}\"? Employees can no longer use it as a base location until it is re-enabled.",
          "confirm": "Disable"
        },
        "toasts": {
          "created": "Site \"{name}\" created",
          "updated": "Site \"{name}\" updated",
          "deleted": "Site \"{name}\" deleted",
          "enabled": "Site \"{name}\" enabled",
          "disabled": "Site \"{name}\" disabled"
        },
        "export": {
          "code": "Code",
          "name": "Name",
          "type": "Type",
          "status": "Status",
          "country": "Country",
          "province": "Province",
          "district": "District",
          "address": "Address",
          "lat": "Lat",
          "lng": "Lng",
          "radius": "Zone radius (m)"
        },
        "history-title": "Edit history · {name}",
        "history-fields": {
          "Name": "Name",
          "Code": "Code",
          "Status": "Status",
          "Type": "Type",
          "IsPrimary": "Main Office",
          "Location": "Coordinates",
          "DetailedAddress": "Address",
          "Country": "Country",
          "Province": "Province",
          "District": "District",
          "WorkZone": "Work zone"
        },
        "errors": {
          "save": "Couldn't save the site. Please try again.",
          "delete": "Couldn't delete the site. Please try again.",
          "status": "Couldn't change the site's status. Please try again."
        }
      },
      "workZones": {
        "title": "Work Zones",
        "section-aria": "Sites and Work Zones",
        "add-zone": "Add Zone",
        "convert-all": "Convert all",
        "search-placeholder": "Search work zones by name, code, or address",
        "no-match": "No work zones match \"{q}\".",
        "status": {
          "active": "Active"
        },
        "table": {
          "location": "Location",
          "address": "Address",
          "employees": "Employees",
          "radius": "Radius",
          "status": "Status",
          "actions": "Actions",
          "no-value": "—"
        },
        "actions": {
          "edit": "Edit work zone {name}",
          "deactivate": "Deactivate work zone {name}",
          "view-employees": "View employees assigned to {name}"
        },
        "empty": {
          "title": "No work zones configured",
          "detail": "Convert an existing base location to a work zone to start enforcing clock in/out boundaries."
        },
        "error": {
          "title": "Couldn't load work zones."
        },
        "form": {
          "add-title": "Add Work Zone",
          "edit-title": "Edit Work Zone",
          "location": "Work location",
          "center-point": "Center point",
          "no-coords": "This location has no coordinates. Set them on the Sites tab before assigning a work zone.",
          "no-locations": "No base locations available.",
          "all-converted": "All base locations are already active work zones.",
          "radius": "Enforcement radius",
          "radius-meters": "Enforcement radius in meters",
          "meters": "meters",
          "cancel": "Cancel",
          "add": "Add zone",
          "save": "Save changes"
        },
        "employees": {
          "title": "Zone employees",
          "subtitle": "{name} · {count} assigned",
          "name": "Full name",
          "code": "Code",
          "position": "Job title",
          "orgUnit": "Org. unit",
          "empty": "No employees assigned to this zone.",
          "close": "Close"
        },
        "deactivate": {
          "title": "Deactivate Work Zone",
          "body": "Deactivate the work zone for \"{name}\"? Employees assigned to this location will no longer be geofence-restricted here. The base location itself stays intact.",
          "confirm": "Deactivate"
        },
        "batch": {
          "convert-all": "Convert all",
          "cancel": "Cancel",
          "dismiss": "Dismiss",
          "staleHint": "This batch hasn't reported progress in over 5 minutes — the worker likely failed before starting. Cancel it to clear the banner and submit a new one.",
          "processed": "{processed} of {total} processed",
          "succeeded": "{count} succeeded",
          "skipped": "{count} location(s) skipped (excluded, already a work zone, or no coordinates).",
          "banner": {
            "title": "Batch conversion",
            "queued": "Batch conversion queued…",
            "processing": "Converting base locations to work zones…",
            "completed": "Batch conversion completed",
            "failed": "Batch conversion failed"
          },
          "error": {
            "invokeWorker": "Could not start the background worker. Try again in a moment.",
            "generic": "The operation failed before finishing. Check the logs."
          },
          "toast": {
            "completed": "{count} location(s) converted.",
            "conflict": "A batch is already in progress. Resuming the existing operation.",
            "cancelled": "Batch cancelled. You can submit a new batch operation now.",
            "submitFailed": "Could not start batch conversion."
          },
          "dialog": {
            "title": "Convert base locations to work zones",
            "lead": "Every active base location with valid coordinates that isn't already a work zone will be activated with the radius below. Locations missing coordinates are skipped automatically.",
            "willConvert": "Will be converted",
            "missingCoords": "Missing coordinates",
            "excluded": "Excluded",
            "exclude": "Exclude specific locations (optional)",
            "excludeHint": "Already-active work zones and locations missing coordinates are skipped automatically.",
            "alreadyZoned": "{count} already a work zone — skipped, radius unchanged.",
            "start": "Start conversion"
          },
          "skipped-download": "Download skipped rows",
          "skipped-truncated": "The list shows the first 500 skipped locations only."
        },
        "errors": {
          "save": "Couldn't save the work zone. Please try again."
        }
      },
      "org-units": {
        "title": "Org Units",
        "subtitle": "Structural backbone of the company · organized by configurable layers",
        "add-unit": "Add Unit",
        "search-placeholder": "Search by name or head…",
        "kpi": {
          "total": "Total Org Units",
          "with-head": "With head assigned",
          "vacant-heads": "Vacant heads",
          "with-budget": "With HC budget set"
        },
        "filters": {
          "all-types": "All types",
          "all-parents": "All parents",
          "no-parent": "No parent (top-level)",
          "show-inactive": "Show inactive"
        },
        "view": {
          "tree": "Tree",
          "table": "Table"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "define-levels": "Define Levels",
          "edit": "Edit",
          "delete": "Delete",
          "deactivate": "Deactivate",
          "reactivate": "Reactivate",
          "export": "Export",
          "export-empty": "Nothing to export — no rows match the filters",
          "history": "History"
        },
        "table": {
          "name": "NAME",
          "parent": "PARENT",
          "layer": "LAYER",
          "type": "TYPE",
          "head": "POSITION IN-CHARGE",
          "roles": "LINKED ROLES",
          "vacant-head": "Vacant",
          "showing": "Showing {filtered} of {total} units",
          "sorted-by": "sorted by {col} {dir}",
          "click-hint": "Click any row to open the unit details",
          "code": "CODE",
          "head-col": "HEAD",
          "hc-budget": "HC BUDGET",
          "hc-budget-hint": "Approved headcount for this unit including all descendants",
          "sub-alloc": "SUB-UNIT ALLOC",
          "sub-alloc-hint": "Sum of the immediate sub-units' budgets",
          "filled": "FILLED",
          "open": "OPEN",
          "total": "TOTAL",
          "status": "STATUS",
          "leaf": "leaf",
          "escalated": "via parent unit",
          "inactive": "Inactive",
          "budget-note": "Top-down budget: the sum of a unit's immediate sub-unit budgets may not exceed its own. Sub-unit alloc shows how much is already given out; Status flags over-allocation."
        },
        "tree": {
          "showing": "Showing {n} units across {d} layers",
          "expand-all": "Expand all",
          "collapse-all": "Collapse all",
          "click-hint": "Click any node to open the unit · use the chevron to expand/collapse",
          "no-children": "Leaf",
          "counts": "{filled} filled · {open} open · {total} total",
          "budget": "HC budget {n}"
        },
        "empty": {
          "title": "No matches",
          "lede": "No units match these filters. Try clearing one to widen the search."
        },
        "error": {
          "title": "Couldn't load org units",
          "desc": "Something went wrong while loading the org unit list. Try again."
        },
        "levels-empty": {
          "title": "No layers defined yet",
          "lede": "Define the company's hierarchy layers (e.g. Management, Department, Section) before adding org units.",
          "cta": "Define Levels"
        },
        "drawer": {
          "fields": {
            "name": "Name",
            "type": "Type",
            "parent": "Parent",
            "ancestor-path": "Ancestor path",
            "head": "Position In-Charge",
            "created": "Created",
            "leadership": "Leadership & roles",
            "roles": "Linked roles",
            "child-units": "Child units",
            "code": "Code",
            "name-km": "Name (Khmer)",
            "status": "Status",
            "location": "Location",
            "effective-date": "Effective date",
            "description": "Description",
            "hc-budget": "HC budget",
            "sub-alloc": "Sub-unit allocation",
            "seats": "Seats (filled · open · total)",
            "head-name": "Head"
          },
          "no-value": "—",
          "no-children": "No child units yet.",
          "ancestor-root": "Top of company",
          "history": "History",
          "history-title": "Edit history · {name}",
          "close": "Close"
        },
        "edit-modal": {
          "subtitle-new": "A unit is a structural node in the company hierarchy.",
          "title-new": "Add Org Unit",
          "title-edit": "Edit {name}",
          "name-label": "Name",
          "name-placeholder": "e.g. Customer Success",
          "name-required": "Name is required",
          "type-label": "Type",
          "layer-required": "Select a layer",
          "parent-label": "Parent unit",
          "parent-note": "Choose a Layer {n} unit as the parent",
          "parent-required": "Parent unit is required",
          "no-levels-note": "No layers are defined yet. Use \"Define Levels\" first, then add units.",
          "head-label": "In-Charge Position",
          "head-placeholder": "Vacant — no position assigned",
          "info-note": "You can assign an In-Charge Position now or leave it vacant and fill it later.",
          "cancel": "Cancel",
          "create": "Create",
          "save": "Save",
          "error-save": "Couldn't save the org unit. Please try again.",
          "error-delete": "Couldn't delete the org unit. Please try again.",
          "delete": {
            "title": "Delete org unit",
            "warning": "This permanently deletes the org unit. This cannot be undone.",
            "cannot-children": "Cannot delete — {n} child unit(s) must be moved or deleted first.",
            "cannot-roles": "Cannot delete — {n} role(s) are still linked to this unit.",
            "reassign": "Resolve the blockers above, then try again.",
            "confirm": "Delete unit"
          },
          "section-identity": "Identity",
          "section-hierarchy": "Hierarchy",
          "section-leadership": "Leadership",
          "section-budget": "Headcount & dates",
          "name-km-label": "Name (Khmer)",
          "name-km-placeholder": "e.g. ផ្នែកសេវាអតិថិជន",
          "name-too-long": "Name must be 200 characters or fewer",
          "code-label": "Code",
          "code-hint": "Assigned by the system (UNIT-NNN) and cannot be changed.",
          "code-pending": "Assigned when you save",
          "head-seat-label": "Head of unit (seat)",
          "head-seat-placeholder": "Vacant — no seat assigned",
          "head-seat-hint": "Pick the seat that heads this unit. If it is left vacant, direct-manager routing escalates to the parent unit's head.",
          "seat-vacant": "Vacant",
          "head-current": "Current head: {name}",
          "location-label": "Location",
          "location-placeholder": "No location",
          "budget-label": "HC budget (people)",
          "budget-placeholder": "— not set —",
          "budget-hint": "Approved headcount for this unit and everything under it. Leave blank for not set. Sub-unit budgets must add up to no more than this.",
          "budget-not-integer": "HC budget must be a whole number",
          "budget-negative": "HC budget cannot be negative",
          "budget-too-large": "HC budget must be 999,999 or less",
          "effective-date-label": "Effective date",
          "description-label": "Description",
          "description-placeholder": "What this unit is for",
          "inactive-banner": "This org unit is inactive. Its history is kept. Use Reactivate below to bring it back.",
          "server-refused": "The server refused the change: {reason}",
          "created": "Org unit \"{name}\" created",
          "updated": "\"{name}\" updated",
          "deactivate": {
            "title": "Deactivate org unit",
            "warning": "Deactivated units are hidden from pickers and new assignments but kept for history and reports. This is reversible — you can reactivate the unit later.",
            "blockers-title": "The server will refuse while this unit still has:",
            "blocker-sub-units": "{n} active sub-unit(s): {names}",
            "blocker-filled": "{n} filled position(s) (employees attached)",
            "blocker-open": "{n} open position(s)",
            "blockers-hint": "Move or close those first. The server re-checks when you confirm.",
            "button": "Deactivate",
            "confirm-question": "Deactivate \"{name}\"? You can reactivate it later.",
            "confirm": "Yes, deactivate",
            "cancel-confirm": "Keep active",
            "done": "\"{name}\" deactivated"
          },
          "reactivate": {
            "title": "Reactivate org unit",
            "warning": "Reactivating returns the unit to Active. It shows in pickers again. A unit cannot be reactivated while its parent is inactive.",
            "parent-inactive": "The parent unit \"{name}\" is inactive — reactivate it first.",
            "button": "Reactivate",
            "done": "\"{name}\" reactivated"
          }
        },
        "define-levels-modal": {
          "title": "Define Levels",
          "subtitle": "Set up the company's hierarchy layers.",
          "layers-question": "How many layers does your hierarchy have?",
          "layers-label": "Number of layers",
          "layers-range": "Choose between 1 and 5 layers",
          "names-question": "Name each layer (up to {max})",
          "layer-name-required": "Layer {n} name",
          "layer-name-optional": "Layer {n} name (optional)",
          "live-preview": "Live preview",
          "preview-note": "This preview updates as you type — nothing is saved until you click Save.",
          "cancel": "Cancel",
          "save": "Save",
          "error-save": "Couldn't save the layer configuration. Please try again.",
          "server-refused": "Not saved — {reason}",
          "duplicate-names": "Each layer needs its own name — \"{name}\" is used twice.",
          "name-required": "Give layer {n} a name."
        },
        "budget-status": {
          "unset": "— not set —",
          "sub-unit-over": "Sub-unit over: {alloc}/{budget}",
          "hc-over": "HC over by {n}",
          "at-cap": "At cap",
          "headroom": "{n} headroom",
          "unknown": "Unknown status ({raw})"
        },
        "status": {
          "active": "Active",
          "inactive": "Inactive"
        },
        "history-fields": {
          "Name": "Name",
          "NameKm": "Name (Khmer)",
          "Code": "Code",
          "Description": "Description",
          "ParentId": "Parent",
          "ParentName": "Parent name",
          "Layer": "Layer",
          "Type": "Type",
          "LocationId": "Location",
          "HeadPositionId": "Head seat",
          "HeadcountBudget": "HC budget",
          "EffectiveDate": "Effective date",
          "Status": "Status",
          "SubUnitAllocation": "Sub-unit allocation",
          "FilledCount": "Filled",
          "OpenCount": "Open"
        }
      },
      "org-chart": {
        "subtitle": "Visualisation of your Org. Unit structure with people assigned",
        "export": "Export",
        "export-toast": "Org-chart PDF export — coming in a subsequent slice",
        "edit-lines": "Edit Reporting Lines",
        "info-banner": "shows the people hierarchy built from Reports-to relationships. Click any node to focus that sub-tree. Vacant positions appear under their resolved manager.",
        "canvas-title": "Org. Chart of Optimal P",
        "layer-1": "Layer 1",
        "status": {
          "active": "Active",
          "pending": "Pending",
          "probation": "Probation",
          "on-leave": "On leave",
          "inactive-vacant": "Inactive / Vacant"
        },
        "nav": {
          "title": "Role Navigation",
          "hint": "Toggle to expand · click to focus",
          "hide": "Hide navigation",
          "show": "Show navigation",
          "short": "Nav",
          "empty": "No matches"
        },
        "toolbar": {
          "show-vacancies": "Show vacancies",
          "default-view": "Default view (Level 1+2 visible, Level 3+ collapsed)",
          "expand-all": "Expand all branches",
          "collapse-all": "Collapse all branches",
          "zoom-out": "Zoom out",
          "zoom-in": "Zoom in",
          "zoom-fit": "Fit to 100%",
          "export": "Export",
          "reset-focus": "Reset focus",
          "back-to-root": "Back to root"
        },
        "search-placeholder": "Search name or role…",
        "chart": {
          "focus-reset": "Show full chart",
          "showing-focused": "Focused on {name} — showing ancestors + descendants only",
          "vacancy-pill": "Vacancy"
        },
        "drawer": {
          "title": "Employee profile",
          "section-contact": "Contact",
          "section-reporting": "Reporting line",
          "section-directs": "Direct reports",
          "section-meta": "Org info",
          "field-code": "Employee code",
          "field-title": "Title",
          "field-dept": "Department",
          "field-manager": "Reports to",
          "field-email": "Email",
          "field-phone": "Phone",
          "field-join": "Joined",
          "field-type": "Employment type",
          "field-breadcrumb": "Org breadcrumb",
          "no-directs": "No direct reports",
          "no-manager": "Top of company — no manager",
          "directs-more": "+{count} more"
        },
        "edit-modal": {
          "title": "Edit Reporting Lines",
          "lede": "Reassign an employee's manager. Submitting toasts a confirmation — the real backend wires up in a subsequent slice.",
          "employee-label": "Employee",
          "manager-label": "New manager",
          "employee-placeholder": "Select an employee…",
          "manager-placeholder": "Select a manager…",
          "submit": "Save reporting line",
          "cancel": "Cancel",
          "toast": "Reporting line for {employee} updated to report to {manager}"
        },
        "empty": {
          "title": "No employees in the org chart yet"
        }
      },
      "workforce-plan": {
        "title": "Workforce Plan",
        "subtitle": "{open} open positions · click Fill to start the Add Person wizard pre-selected",
        "banner": "<b>Position-first hiring.</b> Each Position is a unique seat. Positions sharing the same Job Title are grouped — click any group to expand. Off-plan creations are audit-logged.",
        "kpi": {
          "open-positions": "Open positions",
          "high-priority": "High priority",
          "filled-total": "Filled total",
          "off-plan": "Off-plan exceptions",
          "budgeted": "Budgeted Headcount",
          "filled-positions": "Filled Positions",
          "vacant-positions": "Vacant Positions",
          "vacancy-rate": "Vacancy Rate",
          "hiring-demand": "Hiring Demand"
        },
        "budget": {
          "summary": "Org Unit headcount budget ({count} units)",
          "table": {
            "org-unit": "Org Unit",
            "filled": "Filled",
            "open": "Open",
            "total": "Total",
            "hc-budget": "HC Budget",
            "status": "Status",
            "frozen": "Frozen",
            "off-plan": "Off-plan"
          },
          "status": {
            "over-by": "Over by {n}",
            "at-cap": "At cap",
            "headroom": "{n} headroom",
            "unset": "No budget set"
          },
          "region-label": "Org Unit headcount budget"
        },
        "table": {
          "showing": "Showing {groups} Job Title {label} · {open} open positions total",
          "groups-one": "group",
          "groups-many": "groups",
          "hint": "Grouped by Job Title · click to expand",
          "region-label": "Open positions grouped by Job Title"
        },
        "group": {
          "summary-filled": "{filled} filled",
          "summary-open": "{open} open",
          "summary-high": "{high} High",
          "summary-specifiers": "specifiers: {names}",
          "bulk-fill": "Bulk Fill",
          "bulk-fill-title": "Open Add Person wizard for the first vacancy in this group",
          "create": "New position",
          "create-aria": "New position for {title}",
          "view-open": "View open seats"
        },
        "row": {
          "off-plan": "Off-plan",
          "optimal-internal": "Optimal Internal",
          "days-suffix": "({days}d)",
          "fill": "Fill",
          "reports-to": "↳ reports to {label}",
          "fill-aria": "Fill {code} — {title}"
        },
        "priority": {
          "low": "Low",
          "medium": "Medium",
          "high": "High",
          "urgent": "Urgent"
        },
        "empty": {
          "title": "All positions filled",
          "lede": "No open seats right now. Use <b>New Position</b> above to plan ahead."
        },
        "recently-filled": {
          "summary": "Recently filled ({count})",
          "table": {
            "position": "Position",
            "job-title": "Job title",
            "filled-by": "Filled by",
            "filled-on": "Filled on"
          },
          "none": "No seats filled in the last 90 days.",
          "region-label": "Recently filled positions"
        },
        "actions": {
          "new-position": "New Position",
          "fill-toast": "Add Person wizard pre-selected for {code} — coming next",
          "bulk-fill-toast": "Bulk Fill {group} — coming next",
          "created-toast": "Vacancy created · {title}"
        },
        "drawer": {
          "title": "Vacancy details",
          "fields": {
            "code": "Vacancy code",
            "title": "Job title",
            "grade": "Grade",
            "dept": "Department",
            "org-unit": "Org Unit",
            "approver": "Approver",
            "hiring-manager": "Hiring manager",
            "created": "Created",
            "target-start": "Target start",
            "candidates": "Candidates",
            "timeline": "Status timeline",
            "budget": "Budget",
            "activity": "Activity",
            "project": "Project",
            "filled-by": "Filled by",
            "filled-on": "Filled on"
          },
          "no-value": "—",
          "budget-line": "{amount} USD",
          "close": "Close"
        },
        "modal": {
          "title": "Create vacancy",
          "lede": "A vacancy reserves an approved seat for a planned hire.",
          "fields": {
            "title": "Title",
            "grade": "Grade",
            "dept": "Department",
            "org-unit": "Org Unit",
            "headcount": "Headcount",
            "justification": "Justification",
            "budget": "Annual budget (USD)"
          },
          "placeholders": {
            "title": "e.g. Senior Backend Engineer",
            "dept": "e.g. Engineering",
            "org-unit": "e.g. OU-ENG-PLATFORM",
            "headcount": "1",
            "justification": "Why this seat now? Headcount plan reference…",
            "budget": "0"
          },
          "validation": {
            "title-required": "Title is required",
            "dept-required": "Department is required",
            "org-unit-required": "Org Unit is required",
            "headcount-positive": "Headcount must be a positive whole number",
            "budget-non-negative": "Budget cannot be negative"
          },
          "cancel": "Cancel",
          "submit": "Create"
        },
        "live-subtitle": "{open} open positions · grouped by Job Title",
        "banner-lead": "Position-first hiring.",
        "banner-live": "{lead} Each Position is a unique seat. Positions sharing the same Job Title are grouped — click any group to expand. Off-plan creations are audit-logged.",
        "empty-live": "No open seats right now. Use New Position above to plan ahead."
      },
      "positions": {
        "title": "Positions",
        "subtitle": "Master register of every approved seat — open, filled, frozen, off-plan",
        "add-position": "New Position",
        "banner": {
          "body": "{position} is one unique seat (e.g. P0150 = the 1st Plant Operator slot on Acme Line A). {jobTitle} is the role template that can be referenced by many Positions. One Job Title → many Positions; one Position → at most one Employee.",
          "position-term": "Position",
          "job-title-term": "Job Title"
        },
        "actions": {
          "new-position": "New Position",
          "clear-filters": "Clear filters",
          "edit-toast": "Edit Position {id} — coming in a follow-up slice",
          "export": "Export",
          "edit": "Edit",
          "freeze": "Freeze",
          "unfreeze": "Unfreeze",
          "cancel": "Cancel position",
          "restore": "Restore",
          "history": "Edit history"
        },
        "kpi": {
          "all-positions": "All positions",
          "open-vacant": "Open (vacant)",
          "filled": "Filled",
          "off-plan": "Off-plan"
        },
        "chips": {
          "all": "All",
          "open": "Open",
          "filled": "Filled",
          "frozen": "Frozen",
          "offplan": "Off-plan",
          "cancelled": "Cancelled"
        },
        "filters": {
          "all-job-titles": "All Job Titles",
          "all-org-units": "All Org Units",
          "all-projects": "All Projects",
          "optimal-internal": "Optimal Internal"
        },
        "toggles": {
          "group-by-job-title": "Group by Job Title",
          "show-cancelled": "Show cancelled"
        },
        "priority": {
          "high": "High",
          "medium": "Medium",
          "low": "Low"
        },
        "search-placeholder": "Search by P-ID, title, employee…",
        "row": {
          "off-plan": "Off-plan",
          "edit-action": "Edit Position"
        },
        "table": {
          "showing": "Showing {filtered} of {total} positions",
          "click-hint": "Click any row to open the position details",
          "group-summary": "{count} positions · {filled} filled · {open} open",
          "position-id": "POSITION ID",
          "job-title": "JOB TITLE",
          "org-unit": "ORG UNIT",
          "specifiers": "SPECIFIERS",
          "project": "PROJECT",
          "grade": "GRADE",
          "status": "STATUS",
          "filled-by": "FILLED BY",
          "open-since": "OPEN SINCE",
          "edit": "EDIT",
          "reports-to": "REPORTS TO",
          "remove-filter": "Remove filter: {name}"
        },
        "empty": {
          "title": "No positions match these filters",
          "lede": "Try clearing one or more filters to widen the search."
        },
        "drawer": {
          "fields": {
            "job-title": "Job Title",
            "org-unit": "Org Unit",
            "project": "Project",
            "open-since": "Open since",
            "specifiers": "Specifiers",
            "filled-by": "Filled by",
            "status": "Status"
          },
          "no-value": "—",
          "foot-note": "Edit, fill or freeze actions arrive in a follow-up slice — this drawer is the read-only view for now.",
          "close": "Close",
          "timeline": "Status timeline",
          "filled-on": "Filled on",
          "cancelled-on": "Cancelled on",
          "filled-note": "Someone sits in this seat, so it can't be frozen or cancelled. Vacate it first through a transfer or a termination.",
          "reports-note": "{n} position(s) report to this one — move them before cancelling it.",
          "fill-hint": "To fill this seat, add the person from People › Add Person and choose {id} as their position."
        },
        "modal": {
          "title": "New Position",
          "lede": "A Position is a unique seat — its name is derived from Job Title + Specifiers (no free-text name needed).",
          "fields": {
            "job-title": "Job Title",
            "org-unit": "Org Unit",
            "project": "Project",
            "priority": "Priority"
          },
          "placeholders": {
            "job-title": "Pick a Job Title…",
            "org-unit": "e.g. Operations"
          },
          "validation": {
            "job-title-required": "Job Title is required",
            "org-unit-required": "Org Unit is required"
          },
          "cancel": "Cancel",
          "submit": "Create position",
          "created-toast": "Position created · {id}"
        },
        "status-unknown": "Unknown",
        "unknown-title": "No job title",
        "load-error": {
          "title": "Couldn't load positions",
          "lede": "Something went wrong reading the org chart. Try again."
        },
        "none": {
          "title": "No positions yet",
          "lede": "This company has no seats on its org chart. Open the first one with New Position."
        },
        "toasts": {
          "updated": "Position {id} saved",
          "frozen": "Position {id} frozen",
          "unfrozen": "Position {id} unfrozen",
          "cancelled": "Position {id} cancelled",
          "restored": "Position {id} restored"
        },
        "confirm": {
          "freeze-title": "Freeze {id}?",
          "freeze-body": "A frozen seat stays on the register but cannot be filled until you unfreeze it.",
          "cancel-title": "Cancel {id}?",
          "cancel-body": "The seat leaves the open headcount and the org chart. It stays on the register (Show cancelled) and can be restored later.",
          "keep": "Keep it"
        },
        "form": {
          "edit-title": "Edit position {code}",
          "none": "None",
          "reports-to": "Reports to",
          "reports-to-top": "Top of the chart",
          "reports-to-hint": "Leave at the top if this seat reports to no one.",
          "reports-to-search": "Search positions…",
          "no-results": "No matching positions",
          "base-location": "Base location",
          "target-start": "Target start date",
          "off-plan": "Off-plan (outside the Workforce Plan)",
          "off-plan-hint": "Off-plan seats are audit-flagged and need a justification.",
          "justification": "Justification",
          "justification-placeholder": "Why is this seat needed now?",
          "specifier-placeholder": "Value",
          "title-change-warning": "Changing the job title clears this position's specifier values when you save.",
          "org-unit-placeholder": "Pick an Org Unit…",
          "save": "Save changes",
          "validation": {
            "job-title-required": "Job Title is required",
            "org-unit-required": "Org Unit is required",
            "justification-required": "A justification is required for an off-plan position"
          }
        },
        "errors": {
          "forbidden": "You don't have permission to change positions.",
          "not-found": "This position no longer exists. Reload the page.",
          "conflict": "The server refused this change. Reload the page and try again.",
          "invalid": "Some details were not accepted. Check the form and try again.",
          "network": "Couldn't reach the server. Check your connection and try again.",
          "generic": "Something went wrong saving the position. Try again."
        }
      },
      "onboarding": {
        "title": "Onboarding",
        "subtitle": "Track readiness from accepted offer to probation completion — physical · documents · system · payroll · manager · probation.",
        "add-person": "Add Person",
        "add-toast": "Add-Person wizard — coming in a subsequent slice",
        "actions": {
          "start-onboarding": "Start Onboarding",
          "clear-filters": "Clear filters",
          "view": "View"
        },
        "banner": {
          "title": "Phase 1 · Record-only.",
          "body": "Onboarding tracks readiness — approvals happen offline. Task execution, notifications and integrations run in the owner modules (see link chips). Phase 2 adds workflow automation."
        },
        "kpi": {
          "new-hires": "New hires (30d)",
          "pending-docs": "Pending docs",
          "in-probation": "In probation",
          "probation-due": "Probation due",
          "new-joiners": "New Joiners",
          "preboarding": "Preboarding",
          "day1": "Day 1 Ready",
          "probation-window": "Probation Window",
          "attention": "Attention Needed",
          "open-view": "open this view →"
        },
        "sub-tabs": {
          "dashboard": "Dashboard",
          "new-joiners": "New Joiners",
          "preboarding": "Preboarding",
          "day1": "Day 1 Readiness",
          "probation": "Probation",
          "templates": "Templates",
          "reports": "Reports"
        },
        "dispatch": {
          "title": "Start Onboarding",
          "lede": "Pick the joiner whose onboarding you want to start.",
          "form-title": "Onboarding setup",
          "form-lede": "Confirm template, owner and start date — readiness tracking begins immediately.",
          "empty": "No eligible joiners. Create the person first with Add Person.",
          "fields": {
            "template": "Template",
            "owner": "Assigned owner",
            "start-date": "Start date"
          },
          "placeholders": {
            "template": "Select a template…",
            "owner": "e.g. Sokunthea Pen"
          },
          "errors": {
            "no-joiner": "Pick a joiner first",
            "template-required": "Template is required",
            "owner-required": "Owner is required",
            "start-date-required": "Start date is required"
          },
          "cancel": "Cancel",
          "back": "Back",
          "submit": "Start onboarding",
          "created-toast": "Onboarding started · {employee}"
        },
        "dashboard": {
          "toolbar": {
            "title": "Readiness Dashboard",
            "lede": "Track readiness from accepted offer to probation completion — physical · documents · system access · payroll · manager/team · probation."
          },
          "kpi": {
            "open-view": "open this view →"
          },
          "stages": {
            "draft": "Offer Accepted",
            "preboarding": "Preboarding",
            "day1": "Day 1 Activation",
            "active": "Orientation",
            "probation": "Probation",
            "completed": "Completed"
          },
          "journey": {
            "title": "Onboarding Journey"
          },
          "current": {
            "title": "Current Onboardings",
            "empty": "No active onboardings. Add people from the New Joiners tab."
          },
          "card": {
            "ready": "{pct}% ready",
            "starts-in": "in {days}d",
            "starts-today": "today",
            "started-ago": "{days}d ago"
          },
          "attention": {
            "title": "Attention Needed",
            "empty": "All clear — no readiness blockers right now."
          },
          "flags": {
            "contract": "Contract not signed",
            "bank": "Missing bank account",
            "laptop": "Laptop not assigned",
            "ess": "ESS invite not sent",
            "payroll": "Payroll setup pending",
            "probation": "Probation review due"
          },
          "owners": {
            "title": "Module Ownership — Onboarding monitors readiness; execution lives in the owner module",
            "people": "source of truth",
            "contract": "employment agreement record",
            "work": "task execution",
            "docs": "document storage",
            "asset": "issued company property",
            "hrops": "schedule / attendance setup",
            "payroll": "payroll readiness",
            "perf": "probation review / check-in",
            "people-name": "People Profile",
            "contract-name": "Contract",
            "work-name": "Work Mgmt",
            "docs-name": "Documents",
            "asset-name": "Asset",
            "hrops-name": "HR Ops",
            "payroll-name": "Payroll",
            "perf-name": "Performance"
          }
        },
        "new-joiners": {
          "toolbar": {
            "title": "New Joiners",
            "lede": "Only this tab starts onboarding. Use <strong>+ Add Person</strong> when the employee profile does not exist yet."
          },
          "fresh": {
            "title": "Fresh Employees",
            "lede": "Contract signed · not yet started work · onboarding not started",
            "empty": "No one in this group right now."
          },
          "catchup": {
            "title": "Catch-up Onboarding",
            "lede": "Already active or migrated employee · still inside probation · onboarding missing",
            "empty": "No one in this group right now."
          },
          "start": "Start",
          "cols": {
            "joined": "Start / Joined",
            "probation-end": "Probation End",
            "contract": "Contract",
            "reason": "Reason"
          },
          "drawer": {
            "title": "Title",
            "dept": "Department",
            "joined": "Start date",
            "contract": "Contract type",
            "client": "Client / Project",
            "reason": "Reason"
          }
        },
        "preboarding": {
          "toolbar": {
            "title": "Preboarding",
            "lede": "Everything that must be ready <strong>before</strong> Day 1 — readiness matrix by group. Click a row to open the full checklist."
          },
          "cols": {
            "employee": "Employee",
            "start": "Start",
            "profile": "Profile",
            "contract": "Contract",
            "physical": "Physical",
            "system": "System",
            "payroll": "Payroll",
            "manager": "Manager",
            "probation": "Probation",
            "overall": "OVERALL"
          },
          "empty": {
            "title": "No one in preboarding."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "start": "Start date",
            "progress": "Progress",
            "owner": "Assigned owner",
            "probation-end": "Probation end",
            "notes": "Notes"
          }
        },
        "day1": {
          "search-placeholder": "Search Day-1 records…",
          "chips": {
            "all": "All",
            "ready": "Ready",
            "not-ready": "Not Ready",
            "activated": "Activated"
          },
          "cols": {
            "employee": "Employee",
            "role": "Role",
            "start": "Start",
            "gates": "Gates",
            "owner": "Owner",
            "status": "Status"
          },
          "gates": {
            "contract": "Contract signed & stored",
            "physical": "Workspace · equipment · access card",
            "system": "ESS · email · attendance · schedule",
            "manager": "Manager · buddy · Day 1 plan"
          },
          "showing": "Showing {filtered} of {total} Day-1 records",
          "empty": {
            "title": "No Day 1 candidates yet — add joiners from the New Joiners tab.",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "gates-title": "Day-1 Gates",
            "start": "Start date",
            "owner": "Owner",
            "notes": "Notes"
          },
          "starts": "Starts",
          "toolbar": {
            "title": "Day 1 Readiness",
            "lede": "Candidates approaching Day 1 — each shows the four readiness gates plus the activation CTA."
          },
          "status": {
            "ready": "READY",
            "not-ready": "NOT READY"
          },
          "activate": "Activate · Day 1 Done"
        },
        "probation": {
          "search-placeholder": "Search probation records…",
          "chips": {
            "all": "All",
            "in-probation": "In Probation",
            "due-soon": "Due ≤14d",
            "confirmed": "Confirmed"
          },
          "cols": {
            "employee": "Employee",
            "role": "Role",
            "start": "Start",
            "probation-end": "Probation End",
            "days-left": "Days Left",
            "owner": "Owner",
            "status": "Status",
            "role-client": "Role · Client",
            "case": "Case",
            "days": "Days",
            "cycle-stage": "Cycle Stage",
            "lm-recommendation": "LM Recommendation",
            "lm-recommendation-tooltip": "The Line Manager's recommendation from their review — status only, not an action",
            "action": "Action"
          },
          "showing": "Showing {filtered} of {total} probation records",
          "empty": {
            "title": "No probation records",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "start": "Start date",
            "probation-end": "Probation end",
            "owner": "Owner",
            "confirmed": "Confirmed",
            "yes": "Yes",
            "no": "No",
            "notes": "Notes",
            "client": "Client"
          },
          "toolbar": {
            "title": "Probation Review & Confirmation",
            "lede": "LM review → employee acknowledgement → HR confirmation. Pass auto-confirms; HR finalises the Contract Event (Case A new contract · Case B confirmation + optional salary change)."
          },
          "banner": {
            "title": "Cambodia probation rule (ER-1).",
            "body": "Case A (separate Probation Contract) → pass = Contract Conversion (new UDC/FDC). Case B (UDC/FDC with probation clause) → pass = Probation Confirmation milestone + Salary Adjustment if pay changes. Completion requires the review chain — never date alone."
          },
          "case-label": "Case {c}",
          "midway": "MID-WAY",
          "days": {
            "in": "{n} days",
            "today": "today",
            "overdue": "{n} overdue"
          },
          "stage": {
            "pending": "Pending",
            "lm-review": "LM Review",
            "employee-ack": "Employee Ack",
            "hr-confirm": "HR Confirm",
            "confirmed": "Confirmed"
          },
          "action": {
            "confirm": "Confirm & Record",
            "nudge": "Nudge LM",
            "await-employee": "Awaiting employee"
          }
        },
        "templates": {
          "search-placeholder": "Search templates…",
          "chips": {
            "all": "All",
            "active": "Active",
            "archived": "Archived"
          },
          "status": {
            "active": "Active",
            "archived": "Archived"
          },
          "cols": {
            "id": "Code",
            "name": "Template",
            "category": "Category",
            "tasks": "Tasks (req.)",
            "duration": "Duration",
            "updated": "Updated",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} templates",
          "empty": {
            "title": "No templates match",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "tasks": "Tasks",
            "mandatory": "Mandatory",
            "duration": "Duration",
            "updated": "Last updated",
            "owner": "Owner role",
            "notes": "Notes"
          },
          "toolbar": {
            "title": "Onboarding Templates",
            "lede": "Readiness checklists by workforce type + role — applied by the Start Onboarding wizard."
          },
          "new": "New Template",
          "scope": {
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "meta": {
            "tasks": "Tasks (req.)",
            "duration": "Duration",
            "owner": "Owner",
            "updated": "Updated",
            "days": "{n}d"
          },
          "using": "{n} records using this",
          "view-edit": "View / Edit"
        },
        "reports": {
          "search-placeholder": "Search reports…",
          "chips": {
            "all": "All",
            "on-track": "On Track",
            "at-risk": "At Risk",
            "behind": "Behind"
          },
          "cols": {
            "period": "Period",
            "dept": "Department",
            "joiners": "Joiners",
            "completed": "Completed",
            "avg-days": "Avg Days",
            "rate": "Confirm Rate",
            "owner": "Owner",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} reports",
          "empty": {
            "title": "No reports match",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "joiners": "Joiners",
            "completed": "Completed",
            "avg-days": "Avg days to ready",
            "rate": "Probation confirm rate",
            "owner": "Owner"
          },
          "view": {
            "insights": "Insights",
            "completion": "Detail Report"
          },
          "toolbar": {
            "title": "Onboarding Insights",
            "lede": "Live HR analytics across all onboarding records."
          },
          "kpi": {
            "active": "Active Onboardings",
            "active-sub": "{midway} mid-way · {cancelled} cancelled",
            "soon": "Starting ≤ 7 days",
            "soon-sub": "need to be ready",
            "readiness": "Avg Readiness",
            "readiness-sub": "{done} of {total} items",
            "ttd": "Avg Time-to-Deploy",
            "ttd-sub": "record created → start",
            "attention": "Attention Needed",
            "attention-sub": "records with blockers"
          },
          "funnel": {
            "title": "Pipeline Funnel",
            "preboarding": "Preboarding",
            "day1": "Day 1 Ready",
            "active": "Active",
            "probation": "In Probation",
            "completed": "Completed"
          },
          "groups": {
            "title": "Readiness by Group",
            "lede": "Lowest completion shows where onboardings stall.",
            "contract": "Contract",
            "physical": "Physical / Workspace",
            "system": "System Access",
            "payroll": "Payroll",
            "probation": "Probation"
          },
          "blockers": {
            "title": "Top Blockers",
            "empty": "No blockers across active onboardings."
          },
          "dim": {
            "workforce": "Workforce",
            "client": "Client",
            "dept": "Department",
            "category": "Cohort",
            "midway-cohort": "Mid-way",
            "fresh-cohort": "Fresh"
          },
          "breakdown": {
            "title": "Distribution by {dim}"
          },
          "cycle": {
            "title": "Probation Review Cycle",
            "lm": "LM Review",
            "ack": "Employee Ack",
            "confirm": "HR Confirm",
            "overdue": "{n} past probation end — review overdue",
            "no-overdue": "No overdue probation reviews"
          },
          "outcomes": {
            "title": "Outcomes",
            "completed": "Completed (probation confirmed)",
            "pass-rate": "Probation pass rate",
            "midway": "Mid-way (partial) onboardings",
            "cancelled": "Cancelled (incl. probation fail)",
            "avg-ttd": "Avg time-to-deploy",
            "days": "{n} days"
          },
          "completion": {
            "title": "Detail Report",
            "lede": "Cohort breakdown by pipeline stage — anchor on start/join date."
          },
          "flags": {
            "contract": "Contract unsigned",
            "bank": "Bank not set up",
            "laptop": "Laptop not issued",
            "ess": "ESS not invited",
            "payroll": "Payroll not ready"
          }
        },
        "stub": {
          "title": "Onboarding",
          "lede": "Multi-view dashboard (Dashboard / New Hires / Probation) with per-stage checklist progress, document-pending flags, and probation-review reminders. Phase B wires to `recruitment/`."
        }
      },
      "offboarding": {
        "title": "Offboarding",
        "subtitle": "Resignation → Clearance → Final Pay → Exit interview — one control tower for every leaving event.",
        "actions": {
          "start": "Start Offboarding",
          "clear-filters": "Clear filters",
          "view": "View"
        },
        "banner": {
          "title": "Leaving Center is the control tower.",
          "body": "Every departure — from any source — arrives here first and moves through one status track: New → Under Review → Eligible → In Progress → Completed."
        },
        "kpi": {
          "leaving-30d": "Leaving (30d)",
          "asset-recovery": "Asset recovery pending",
          "exit-pending": "Exit interviews pending",
          "final-pay-queue": "Final settlement queue",
          "turnover": "Voluntary turnover %",
          "in-progress": "In progress",
          "final-pay": "Final pay pending",
          "exit-interviews": "Exit interviews",
          "completed": "Completed (YTD)"
        },
        "sub-tabs": {
          "overview": "Overview",
          "center": "Leaving Center",
          "eligible": "Leaver Eligibility",
          "process": "Offboarding Process",
          "templates": "Templates",
          "reports": "Reports"
        },
        "dispatch": {
          "title": "Start Offboarding",
          "lede": "Capture the leaving event — it lands in the Leaving Center for review.",
          "fields": {
            "employee": "Employee",
            "reason": "Reason",
            "last-day": "Last working day",
            "notice": "Notice handling",
            "source": "Source"
          },
          "placeholders": {
            "employee": "Pick an employee…",
            "reason": "e.g. Relocating, better offer, contract end…",
            "source": "Select source…"
          },
          "notice-options": {
            "served": "Serve full notice",
            "garden": "Garden leave",
            "buyout": "Buy out notice",
            "waived": "Notice waived"
          },
          "errors": {
            "employee-required": "Pick an employee",
            "reason-required": "Reason is required",
            "last-day-required": "Last working day is required",
            "source-required": "Source is required"
          },
          "cancel": "Cancel",
          "submit": "Create event",
          "created-toast": "Leaving event created · {employee} — landed in Leaving Center"
        },
        "overview": {
          "toolbar-btn": "Leaving Center",
          "kpi": {
            "intake": "New & Under Review",
            "intake-sub": "intake to assess",
            "eligible": "Eligible to Start",
            "eligible-sub": "ready to offboard",
            "in-progress": "Offboarding In Progress",
            "in-progress-sub": "executing",
            "overdue": "Overdue Actions",
            "overdue-sub": "cases need attention"
          },
          "upcoming": {
            "title": "Upcoming Last Day",
            "empty": "Nothing scheduled.",
            "cols": {
              "employee": "Employee",
              "leaving-reason": "Leaving Reason",
              "last-working-day": "Last Working Day",
              "current-stage": "Current Stage",
              "attention-required": "Attention Required"
            }
          },
          "recent": {
            "title": "Recent Activity",
            "empty": "No recent activity."
          }
        },
        "center": {
          "search-placeholder": "Search leavers…",
          "chips": {
            "all": "All",
            "new": "New",
            "under_review": "Under Review",
            "eligible": "Eligible",
            "in_progress": "In Progress",
            "completed": "Completed",
            "cancelled": "Cancelled"
          },
          "cols": {
            "employee": "Employee",
            "source": "Source",
            "reason": "Reason",
            "last-day": "Last Day",
            "progress": "Progress",
            "owner": "Owner",
            "status": "Status",
            "action": "Action"
          },
          "actions": {
            "review": "Review",
            "eligible": "Mark Eligible",
            "start": "Start",
            "open": "Open",
            "view": "View"
          },
          "action-toasts": {
            "review": "{employee} moved to Under Review",
            "eligible": "{employee} marked Eligible",
            "start": "Offboarding started · {employee}",
            "open": "Opening {employee}'s case",
            "view": "Viewing {employee}'s case"
          },
          "showing": "Showing {filtered} of {total} leaving events",
          "empty": {
            "title": "No leaving events match",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "client": "Client",
            "source": "Source",
            "reason": "Reason",
            "notice-date": "Notice date",
            "last-day": "Last working day",
            "owner": "Owner",
            "progress": "Progress",
            "status": "Status",
            "notes": "Notes",
            "attention": "Attention"
          }
        },
        "eligible": {
          "search-placeholder": "Search eligible leavers…",
          "chips": {
            "all": "All",
            "voluntary": "Voluntary",
            "involuntary": "Involuntary",
            "due-soon": "Last day ≤ 14d"
          },
          "cols": {
            "employee": "Employee",
            "source": "Source",
            "reason": "Reason",
            "last-day": "Last working day",
            "eligible-since": "Eligible since",
            "action": "Action"
          },
          "showing": "Showing {filtered} of {total} eligible",
          "empty": {
            "title": "No one is eligible right now",
            "lede": "Events become Eligible after HR review in Leaving Center."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "client": "Client",
            "reason": "Reason",
            "last-day": "Last working day",
            "eligible-since": "Eligible since",
            "owner": "Owner",
            "notes": "Notes"
          },
          "start-button": "Start",
          "started-toast": "Offboarding started · {employee} — moved to In Progress",
          "in-days": "in {n}d",
          "today": "today",
          "days-ago": "{n}d ago"
        },
        "process": {
          "search-placeholder": "Search in-progress cases…",
          "chips": {
            "all": "All",
            "active": "In Progress",
            "completed": "Completed",
            "needs-attention": "Needs Attention"
          },
          "cols": {
            "employee": "Employee",
            "source": "Source",
            "last-day": "Last Day",
            "progress": "Progress",
            "owner": "Owner",
            "attention": "Attention",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} cases",
          "empty": {
            "title": "No cases in this view",
            "lede": "Start one from Leaver Eligibility."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "client": "Client",
            "source": "Source",
            "reason": "Reason",
            "last-day": "Last working day",
            "owner": "Owner",
            "progress": "Progress",
            "status": "Status",
            "attention": "Attention",
            "notes": "Notes"
          }
        },
        "templates": {
          "search-placeholder": "Search templates…",
          "chips": {
            "all": "All",
            "active": "Active",
            "inactive": "Inactive",
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "cols": {
            "name": "Template",
            "workforce": "Workforce",
            "role-type": "Role type",
            "handover": "Handover",
            "clearance": "Clearance",
            "lastday": "Last day",
            "exit": "Exit",
            "last-used": "Last used",
            "usage": "Usage",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} templates",
          "empty": {
            "title": "No templates match",
            "lede": "Clear filters or widen your search."
          },
          "exit-required": "Required",
          "exit-optional": "Optional",
          "drawer": {
            "name": "Template name",
            "workforce": "Workforce",
            "role-type": "Role type",
            "handover": "Handover items",
            "clearance": "Clearance items",
            "lastday": "Last day items",
            "exit": "Exit interview",
            "last-used": "Last used",
            "usage": "Times used",
            "status": "Status"
          }
        },
        "assets": {
          "search-placeholder": "Search assets…",
          "title": "Asset Recovery",
          "lede": "Track laptops, phones, access cards and uniforms as leavers return them.",
          "chips": {
            "all": "All",
            "pending": "Pending",
            "received": "Received",
            "damaged": "Damaged",
            "lost": "Lost"
          },
          "cols": {
            "employee": "Employee",
            "item": "Item",
            "serial": "Serial",
            "condition": "Condition",
            "status": "Status",
            "due": "Due date",
            "received-by": "Received by"
          },
          "showing": "Showing {filtered} of {total} assets",
          "empty": {
            "title": "No assets match",
            "lede": "Clear filters or widen your search."
          },
          "drawer": {
            "employee": "Employee",
            "item": "Item",
            "serial": "Serial",
            "condition": "Condition",
            "status": "Status",
            "due": "Due date",
            "received-by": "Received by",
            "notes": "Notes"
          },
          "condition": {
            "new": "New",
            "good": "Good",
            "fair": "Fair",
            "damaged": "Damaged",
            "unknown": "Unknown"
          }
        },
        "settlement": {
          "search-placeholder": "Search settlements…",
          "title": "Final Settlement",
          "lede": "Snapshot of final pay calculation — base, accrued leave, unpaid days, severance, deductions.",
          "chips": {
            "all": "All",
            "not_created": "Not Created",
            "created": "Drafted",
            "processing": "Processing",
            "paid": "Paid",
            "disputed": "Disputed"
          },
          "cols": {
            "employee": "Employee",
            "last-day": "Last day",
            "base": "Base pay",
            "accrued": "Accrued leave",
            "unpaid": "Unpaid days",
            "severance": "Severance",
            "deductions": "Deductions",
            "total": "Total",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} settlements",
          "empty": {
            "title": "No settlements match",
            "lede": "Clear filters or widen your search."
          },
          "drawer": {
            "employee": "Employee",
            "last-day": "Last working day",
            "base": "Base pay",
            "accrued": "Accrued leave",
            "unpaid": "Unpaid days",
            "severance": "Severance",
            "deductions": "Deductions",
            "total": "Total",
            "currency": "Currency",
            "prepared-by": "Prepared by",
            "status": "Status",
            "notes": "Notes"
          }
        },
        "source": {
          "ess_resignation": "ESS Resignation",
          "contract_end": "Contract end",
          "probation_fail": "Probation fail",
          "retirement": "Retirement",
          "termination": "Termination",
          "death": "In-service death"
        },
        "status": {
          "new": "New",
          "under_review": "Under Review",
          "eligible": "Eligible",
          "in_progress": "In Progress",
          "completed": "Completed",
          "cancelled": "Cancelled"
        },
        "final-pay": {
          "not_created": "Not created",
          "created": "Drafted",
          "processing": "Processing",
          "paid": "Paid",
          "disputed": "Disputed"
        },
        "reports": {
          "title": "Reports",
          "lede": "Turnover analytics — by reason, source, tenure, department, voluntary vs involuntary.",
          "kpi": {
            "total": "Total events",
            "voluntary": "Voluntary",
            "involuntary": "Involuntary",
            "turnover": "Turnover %",
            "rehire": "Rehire-eligible",
            "clearance-sla": "Clearance SLA",
            "final-pay-sla": "Final pay SLA"
          },
          "by-source": "By source",
          "by-reason": "By reason",
          "by-tenure": "By tenure",
          "by-dept": "By department",
          "voluntary-split": "Voluntary vs Involuntary"
        },
        "stub": {
          "title": "Offboarding",
          "lede": "Operational leaving execution with workstream tracking (Resignation · Clearance · Final Pay · Exit interview)."
        }
      },
      "compliance": {
        "title": "Compliance",
        "subtitle": "Cambodian statutory + operational compliance · tier-1 hard deadlines (MOL, NSSF, GDT) and tier-2 operational filings, with a per-category audit trail.",
        "info-banner": {
          "title": "Compliance scope",
          "body": "Tracks every employer obligation Cambodian law imposes — MOL declarations, NSSF + salary-tax filings, foreign-worker permits/visas, foreign-worker quota, health check-ups, IWR, labour book, fire-safety and workmen's-comp. Deadlines are tenant-configurable in Compliance Settings."
        },
        "scores": {
          "healthy": "Healthy",
          "attention": "Attention needed",
          "critical": "Critical"
        },
        "kpi": {
          "score": "Compliance Score",
          "score-sub": "Across {cats} categories · {items} tracked items",
          "overdue-expiring": "Overdue / Expiring",
          "overdue-expiring-sub": "{overdue} overdue · {expiring} expiring soon",
          "pending-action": "Pending Action",
          "pending-action-clear": "All clear",
          "pending-action-open": "Open declarations + filings"
        },
        "sidebar": {
          "overview": "Overview",
          "tier1": "Tier 1 — hard deadlines",
          "tier2": "Tier 2 — operational",
          "settings": "Settings"
        },
        "categories": {
          "mol-decl": {
            "label": "MOL Declarations",
            "description": "New-hire and separation declarations to Ministry of Labour. Default deadline 15 working days."
          },
          "nssf": {
            "label": "NSSF Contributions",
            "description": "Monthly social security contributions. Default due by day 15 of following month."
          },
          "tax": {
            "label": "Salary Tax (TOS)",
            "description": "Monthly Tax on Salary declaration to General Department of Taxation. Default due by day 20."
          },
          "work-permit": {
            "label": "Work Permits",
            "description": "Annual work permits for foreign employees. Renewal warning 60 days before expiry."
          },
          "visa": {
            "label": "Visa Renewals (Business E)",
            "description": "Annual Business E visa renewals for foreign employees."
          },
          "quota": {
            "label": "Foreign Worker Quota",
            "description": "Annual quota request for foreign workforce. Cap: foreigners ≤ 10% of total (configurable)."
          },
          "health": {
            "label": "Health Check-ups",
            "description": "Annual mandatory medical examinations. Tracked per employee."
          },
          "iwr": {
            "label": "Internal Work Regulations",
            "description": "Required for companies with ≥ 8 employees. Filed with MOL on policy change."
          },
          "labour-book": {
            "label": "Labour Book",
            "description": "Employee registry and hours log. Monthly export available for MOL inspection."
          },
          "fire-safety": {
            "label": "Fire Safety Certificate",
            "description": "Workplace fire safety inspection and certificate. Annual renewal."
          },
          "workmen-comp": {
            "label": "Workmen's Compensation",
            "description": "NSSF Occupational Risk Insurance registration."
          }
        },
        "filters": {
          "all": "All",
          "ok": "OK",
          "pending": "Pending",
          "submitted": "Submitted",
          "approved": "Approved",
          "overdue": "Overdue",
          "expiring-soon": "Expiring Soon"
        },
        "status": {
          "OK": "OK",
          "Pending": "Pending",
          "Submitted": "Submitted",
          "Approved": "Approved",
          "Overdue": "Overdue",
          "Expiring Soon": "Expiring Soon",
          "N/A": "N/A"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "view": "View",
          "action": "Action →",
          "new-item": "New item"
        },
        "search-placeholder": "Search ID, subject, period, details…",
        "days": {
          "overdue": "{n}d overdue",
          "today": "today",
          "in": "in {n}d"
        },
        "action-items": {
          "title": "Action items",
          "lede": "Sorted by urgency. Click any row to open its category.",
          "count": "{n} items needing action",
          "empty": "No urgent items — you're all clear ✓"
        },
        "grid": {
          "all-categories": "All categories",
          "click-hint": "Click any card to drill in",
          "healthy": "{n}% healthy",
          "items": "{n} items",
          "overdue": "{n} overdue"
        },
        "detail": {
          "authority": "Authority",
          "cadence": "Cadence",
          "tier": "Tier",
          "tier-1": "1 (hard deadlines)",
          "tier-2": "2 (operational)",
          "score": "Score",
          "settings": "Settings",
          "config-footnote": "Defaults shown above are tenant-configurable in Compliance Settings — e.g., MOL declaration deadline {mol} working days (hire), NSSF day {nssf}, TOS day {tax}."
        },
        "table": {
          "tracked": "Tracked items ({n})",
          "overdue": "{n} overdue",
          "pending": "{n} pending",
          "expiring": "{n} expiring soon",
          "col": {
            "id": "ID",
            "subject": "Subject / Detail",
            "due": "Due",
            "days": "Days",
            "status": "Status",
            "action": "Action"
          }
        },
        "quota": {
          "title": "Current foreign workforce ratio",
          "within": "Within MOL {cap}% cap",
          "over": "OVER MOL {cap}% cap"
        },
        "foreign": {
          "title": "Foreign employees on record ({n})",
          "col": {
            "code": "Code",
            "name": "Name",
            "nationality": "Nationality",
            "position": "Position",
            "joined": "Joined"
          }
        },
        "empty": {
          "title": "No matches",
          "lede": "No items match these filters. Try clearing one to widen the search."
        },
        "drawer": {
          "fields": {
            "due": "Due",
            "days": "Days remaining",
            "employee": "Employee",
            "details": "Details",
            "audit": "Audit trail"
          },
          "no-audit": "No audit events recorded yet."
        },
        "settings-placeholder": "Compliance Settings — placeholder · editable defaults coming with Settings build"
      },
      "directory": {
        "subtitle": "No employees | {n} employee | {n} employees",
        "subtitle-empty": "No employees found",
        "add-person-cta": "Add Person",
        "add-person": {
          "wizard": {
            "title": {
              "employee": "Add Person",
              "outsourced": "Add Outsourced Employee",
              "vendor-lite": "Add vendor-lite record",
              "external": "Invite external approver"
            },
            "subtitle": {
              "employee": "Direct employee on your company's payroll — HR record, schedule and contract.",
              "outsourced": "Employee owned by this tenant and assigned to a client project / site.",
              "vendor-lite": "Track a worker supplied by a vendor — no payroll on our side.",
              "external": "Limited access — approves requests for staff on one project only."
            },
            "kind": {
              "label": "Person kind",
              "employee": "Direct employee",
              "outsourced": "Outsourced (we run payroll)",
              "vendor-lite": "Vendor-lite (vendor runs payroll)",
              "external": "External approver"
            },
            "offer": {
              "title": "Start from an Offer Letter",
              "body": "Pull a signed offer's data straight in — fewer typos, no rekeying. The Offers surface is coming with the Recruiting module.",
              "cta": "Browse offers",
              "coming-soon": "Offer-letter picker — coming with Recruiting."
            },
            "stepper": {
              "aria": "Add Person wizard progress"
            },
            "steps": {
              "person": "Person",
              "schedule": "Schedule",
              "contract": "Contract",
              "leave": "Leave",
              "project-access": "Project access",
              "vendor": "Vendor",
              "review": "Review"
            },
            "person": {
              "heading": "Person details",
              "code": "Employee code",
              "code-hint": "Auto-generated from the company format — edit to override",
              "code-hint-external": "Client-staff code — auto-generated for cross-tenant reference.",
              "name-latin": "Full name (Latin)",
              "name-latin-placeholder": "e.g. Sok Pisey",
              "name-khmer": "Full name (Khmer)",
              "gender": {
                "label": "Gender",
                "female": "Female",
                "male": "Male",
                "other": "Other",
                "placeholder": "Select gender"
              },
              "dob": "Date of birth",
              "nid": "National ID",
              "nid-placeholder": "e.g. 012345678",
              "title-at-client": "Title at client",
              "title-placeholder": "e.g. Site Supervisor",
              "email": "Work email",
              "email-placeholder": "you\\@company.com",
              "email-client": "Client email",
              "email-client-placeholder": "approver\\@client.com",
              "phone": "Phone",
              "vendor-lite-badge": "Vendor-lite governance",
              "vendor-lite-help": "We will not store statutory IDs or salary for this person — the vendor owns those records.",
              "help-employee": "Direct employees show up everywhere — Directory, Payroll, Leave, Time & Attendance.",
              "help-outsourced": "Outsourced staff show up in the Directory and Outsourced tab. Payroll and statutory entitlements behave like Direct.",
              "help-external": "External approvers can only see + approve requests for staff on the project you assign on the next step.",
              "code-hint-loading": "Loading the next code from the company format…",
              "code-hint-error": "Couldn't load the next code — enter one, or retry.",
              "code-hint-no-format": "This company does not number people automatically — enter a code",
              "code-loading-placeholder": "Loading…",
              "code-retry": "Retry",
              "family-latin": "Family name (Latin)",
              "family-latin-placeholder": "e.g. Touch",
              "given-latin": "Given name (Latin)",
              "given-latin-placeholder": "e.g. Phally",
              "family-khmer": "Khmer Name (ខ្មែរ) — family",
              "given-khmer": "Khmer Name (ខ្មែរ) — given",
              "dob-hint": "YYYY-MM-DD · optional",
              "provider-badge": "Provider-managed employee",
              "provider-badge-help": "this tenant owns the HR profile + payroll · client approver can be invited separately",
              "next-steps": "Schedule, Contract, Leave and Review follow. Date of birth, National ID and email are optional."
            },
            "schedule": {
              "heading": "Assign work schedule",
              "template": "Schedule template",
              "template-hint": "Drives clock-in window, weekly hours, and OT eligibility.",
              "placeholder": "Pick a schedule template",
              "details": "Schedule details",
              "type": "Type",
              "loading": "Loading schedules…",
              "error": "Couldn't load schedules.",
              "retry": "Retry",
              "empty": "No work schedules defined for this company yet.",
              "type-label": "Schedule type",
              "kind": {
                "fixed": "Fixed",
                "rotation": "Rotation"
              },
              "templates-count": "{n} templates | {n} template | {n} templates",
              "type-hint": "Choose the working-time type first — Rotation places the person on the rotation roster.",
              "manage": "Manage in Scheduling →",
              "empty-kind": "No {kind} templates yet. Create one in HR Ops › Scheduling, then assign it here.",
              "optional-hint": "Optional — leave it empty to assign later.",
              "placeholder-kind": "— Select a {kind} schedule —",
              "assign-later": "Assign later",
              "pattern": "Rotation pattern",
              "cycle": "Cycle",
              "cycle-days": "{n} days | {n} day | {n} days",
              "rotation-note": "Working days come from the rotation roster (HR Ops › Scheduling). This person joins the rotation from their start date.",
              "working-days": "Weekly working days",
              "weekly-hours": "Total: {h} h/week.",
              "days": {
                "mon": "Mon",
                "tue": "Tue",
                "wed": "Wed",
                "thu": "Thu",
                "fri": "Fri",
                "sat": "Sat",
                "sun": "Sun"
              }
            },
            "contract": {
              "heading": "Contract",
              "type": "Contract type",
              "vacancy": "Vacancy",
              "vacancy-hint": "Position-first hiring — pick from the open requisitions list. New roles must be opened via Workforce Plan.",
              "vacancy-placeholder": "Pick an open vacancy",
              "start-date": "Start date",
              "end-date": "End date",
              "with-probation": "Include probation period",
              "probation-end-date": "Probation end date",
              "vacancy-loading": "Loading open positions…",
              "vacancy-error": "Couldn't load open positions.",
              "vacancy-retry": "Retry",
              "vacancy-empty": "No open positions for this company. Open a role in Workforce Plan first.",
              "types": {
                "udc": "UDC — Undefined duration",
                "fdc": "FDC — Fixed duration",
                "probation": "Probation contract",
                "internship": "Internship"
              },
              "employment-type": "Employment type",
              "employment-types": {
                "full-time": "Full-time",
                "part-time": "Part-time"
              },
              "mode": {
                "now": "Add the contract now",
                "now-help": "Seat, dates and leave — the person starts on this contract.",
                "later": "Record the person first",
                "later-help": "Skip contract and leave for now — they are saved as Pending."
              },
              "date-hint": "YYYY-MM-DD"
            },
            "leave": {
              "heading": "Leave policy",
              "policy": "Leave policy",
              "policy-hint": "Sets the annual + sick entitlement and accrual cadence.",
              "placeholder": "Pick a leave policy",
              "vendor-title": "Vendor owns leave entitlement",
              "vendor-body": "Leave for vendor-lite records is governed by {vendor}. We only mirror operational time-off requests for site visibility.",
              "vendor-fallback": "the vendor",
              "company-title": "Company leave policy applies",
              "company-body": "This hire inherits the company's standard leave entitlement and accrual cadence. Use the override below only for an individually negotiated entitlement.",
              "override-toggle": "Override the standard entitlement for this hire",
              "override-annual": "Annual leave (days/year)",
              "override-sick": "Sick leave (days/year)",
              "override-justification": "Justification",
              "override-justification-placeholder": "Why this hire gets a non-standard entitlement"
            },
            "project": {
              "heading": "Project access",
              "project": "Project",
              "project-hint": "External approvers can only see requests for staff deployed on this project.",
              "placeholder": "Pick a project",
              "their-project": "their project",
              "can-do-title": "Can do",
              "can-do-1": "Approve / reject leave & expense requests for staff on {project}",
              "can-do-2": "View attendance summaries for the project",
              "can-do-3": "Receive notifications for pending approvals",
              "cannot-do-title": "Cannot do",
              "cannot-do-1": "View payroll, salary, or statutory data",
              "cannot-do-2": "Edit employee records",
              "cannot-do-3": "Access other projects or the Directory"
            },
            "vendor": {
              "heading": "Vendor / provider",
              "name": "Vendor name",
              "name-hint": "Used on attendance reports, vendor invoices, and the Outsourced tab.",
              "placeholder": "e.g. ManpowerKH Co. Ltd.",
              "governance-title": "Vendor-lite governance",
              "governance-body": "The vendor is responsible for salary, statutory contributions, and leave entitlement. We track this person operationally only — no payroll runs against them."
            },
            "review": {
              "heading": "Review and create",
              "heading-external": "Review and invite",
              "section-person": "Person",
              "section-schedule": "Schedule",
              "section-contract": "Contract",
              "section-leave": "Leave",
              "section-vendor": "Vendor",
              "section-project": "Project access",
              "code": "Code",
              "name": "Name",
              "gender": "Gender",
              "dob": "Date of birth",
              "nid": "National ID",
              "email": "Email",
              "phone": "Phone",
              "schedule": "Schedule",
              "contract-type": "Contract type",
              "vacancy": "Vacancy",
              "start-date": "Start date",
              "end-date": "End date",
              "leave-policy": "Leave policy",
              "vendor": "Vendor",
              "project": "Project",
              "edit": "Edit",
              "footer": "Pressing Create writes this person to the directory and generates onboarding tasks. You can edit details from the profile afterwards.",
              "footer-external": "Pressing Invite emails the approver a sign-in link. They never see payroll or other projects.",
              "leave-company-default": "Company default policy",
              "leave-annual": "Annual override (days)",
              "leave-sick": "Sick override (days)",
              "name-khmer": "Khmer name",
              "employment-type": "Employment type",
              "probation-end": "Probation ends",
              "schedule-later": "Assign later",
              "problems-title": "The person could not be saved",
              "add-contract": "Add contract",
              "no-contract": "No contract yet — the person is saved as Pending. Add the contract from their profile when it's ready.",
              "no-signin": "No sign-in is created. Invite the person from Admin › Users & Roles."
            },
            "footer": {
              "cancel": "Cancel",
              "back": "Back",
              "next": "Save & continue",
              "create-employee": "Create employee",
              "create-vendor": "Create record",
              "create-external": "Send invite",
              "step-of": "Step {n} of {total}"
            },
            "toast": {
              "created": "Person created. The directory will refresh shortly.",
              "endpoint-pending": "Create-person endpoint is still being wired on the backend. Your inputs are preserved — retry once the BE lands.",
              "added": "{name} added · {code}",
              "added-no-code": "{name} added",
              "fix-fields": "Some details need attention — see the highlighted fields."
            },
            "errors": {
              "required": "Required",
              "code-required": "Enter an employee code",
              "code-too-long": "Use at most 30 characters",
              "code-colon": "The code can't contain a colon (:)",
              "email": "Enter a valid email address, or leave it empty",
              "date": "Use the format YYYY-MM-DD",
              "dob-future": "Date of birth can't be in the future",
              "start-too-early": "The start date must be within {days} days before today",
              "end-required": "End date is required for a fixed-term contract",
              "end-before-start": "End date must be after the start date",
              "probation-range": "Probation end must be between the start and end dates",
              "number": "Enter a number of days (0 or more)",
              "nid-taken": "This National ID is already used by another person",
              "code-taken": "This code is already used in this company",
              "seat-taken": "This position is no longer available — pick another vacancy",
              "server-field": "{message}",
              "retry": "Couldn't reach the server. Your details are kept — press Create employee again.",
              "forbidden": "You can't add people to this company.",
              "generic": "The person could not be saved. Check the details and try again."
            }
          }
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "direct": "Direct",
          "outsourced": "Outsourced",
          "onboarding": "Onboarding",
          "probation": "On Probation",
          "pending": "Pending",
          "on_leave": "On leave",
          "resigning": "Resigning",
          "leaving": "Leaving",
          "inactive": "Inactive",
          "client_staff": "External Staff"
        },
        "emp-type": {
          "label": "Type: All",
          "all": "Type: All",
          "Full-time": "Full-time",
          "Part-time": "Part-time",
          "not-set": "Not set"
        },
        "contract": {
          "label": "Contract: All",
          "all": "Contract: All",
          "UDC": "UDC (Undetermined Duration)",
          "FDC": "FDC (Fixed Duration)",
          "PROBATION": "Probation",
          "INTERNSHIP": "Internship",
          "OUTSOURCING_SERVICE": "Outsourcing service",
          "None": "No contract",
          "Unknown": "Unknown"
        },
        "search-placeholder": "Search name, code, email…",
        "columns": "Columns",
        "export": "Export",
        "import": "Import",
        "sort-by": "Sort by {column}",
        "table": {
          "employee": "Employee",
          "empCode": "Employee Code",
          "nameLatin": "Full Name (Latin)",
          "nameKhmer": "Full Name (Khmer)",
          "gender": "Gender",
          "dob": "Date of Birth",
          "nid": "National ID / Passport",
          "familyNameLatin": "Family Name (Latin)",
          "middleNameLatin": "Middle Name (Latin)",
          "givenNameLatin": "Given Name (Latin)",
          "nicknameLatin": "Nickname (Latin)",
          "familyNameNative": "Family Name (Khmer)",
          "middleNameNative": "Middle Name (Khmer)",
          "givenNameNative": "Given Name (Khmer)",
          "nicknameNative": "Nickname (Khmer)",
          "countryOfBirth": "Country of Birth",
          "cityProvinceOfBirth": "City/Province of Birth",
          "maritalStatus": "Marital Status",
          "nationality": "Nationality",
          "spouseName": "Spouse's Name",
          "numChildren": "No. of Children",
          "personalPhone": "Personal Phone",
          "personalEmail": "Personal Email",
          "homeAddress": "Home Address",
          "email": "Work Email",
          "phone": "Work Phone",
          "status": "Employment Status",
          "type": "Workforce Type",
          "position": "Position / Job Title",
          "department": "Department",
          "empType": "Employment Type",
          "joined": "Hire Date",
          "contract": "Contract Type",
          "contractStartDate": "Contract Start Date",
          "contractEndDate": "Contract End Date",
          "onProbation": "On Probation",
          "probationEndDate": "Probation End Date",
          "schedule": "Work Schedule",
          "weeklyHours": "Weekly Hours",
          "availableAl": "Available Annual Leave",
          "project": "Project / Client",
          "salary": "Basic Salary",
          "costCenters": "Cost Center(s)",
          "bank": "Bank",
          "account": "Account No.",
          "bankAccountName": "Bank Account Name",
          "nssfId": "NSSF ID",
          "nssfScheme": "NSSF Scheme",
          "nssfEmployerType": "NSSF Employer Type",
          "nssfStatus": "NSSF Status",
          "privateInsuranceProvider": "Private Insurance Provider",
          "privateInsurancePolicyId": "Private Insurance Policy ID",
          "privateInsuranceScheme": "Private Insurance Scheme",
          "lifecycle": "Lifecycle",
          "jobTitle": "Job Title",
          "jobGrade": "Job Grade",
          "seniorityLevel": "Seniority Level",
          "reportsToRole": "Reports to Role",
          "reportsToPerson": "Reports to Person",
          "orgUnitType": "Org Unit Type",
          "orgUnitLayer": "Org Unit Layer",
          "locationName": "Location Name",
          "locationCode": "Location Code",
          "locationLatLong": "Location (Lat/Long)",
          "locationAddress": "Location Address",
          "resignationSubmittedDate": "Resignation Submitted Date",
          "resignationStatus": "Resignation Status",
          "requestedLastDay": "Requested Last Day",
          "resignationReason": "Resignation Reason",
          "agreedLastDay": "Agreed Last Day",
          "resignationDiscussedDate": "Resignation Discussed Date",
          "discussReason": "Discuss Reason",
          "forwardToHrDate": "Forward to HR Date",
          "leavingLastDate": "Leaving Last Date",
          "leavingType": "Leaving Type",
          "leavingReason": "Leaving Reason",
          "client": "Client",
          "externalManager": "External Manager",
          "workforceSource": "Workforce Source",
          "vendor": "Vendor / Provider",
          "providerEmpId": "Provider Employee ID"
        },
        "col-panel": {
          "title": "Customize table",
          "subtitle": "Choose which employee fields to show in the table and export. Required columns cannot be hidden.",
          "hint": "{count} columns selected · drag to reorder · check / uncheck to toggle",
          "close": "Close",
          "reset": "Reset to default",
          "apply": "Apply",
          "required": "Required",
          "locked": "Locked",
          "group": {
            "employee": "Employee",
            "basic-info": "Basic Employee Info",
            "contact-info": "Contact Info",
            "employment": "Employment & Job Details",
            "contract": "Contract Info",
            "schedule-leave": "Schedule & Leave",
            "payroll": "Payroll / Finance Visibility",
            "insurance": "Insurance",
            "offboarding": "Offboarding",
            "other": "Other",
            "assignment": "Assignment",
            "provider": "Provider Information"
          },
          "no-render": "Not yet available as a table column"
        },
        "loading": "Loading columns…",
        "showing": "Showing {shown} of {total} employees",
        "sorted-by": "sorted by {column} {dir}",
        "sort-dir-asc": "↑",
        "sort-dir-desc": "↓",
        "info-banner": {
          "title": "Directory",
          "body": "The single source of truth for everyone working at your company — Direct employees, Outsourced staff, and External Staff. Use status chips to filter, columns to customise the view, and click any row to open the profile.",
          "dismiss": "Dismiss",
          "dismiss-aria": "Dismiss Directory info banner"
        },
        "filter-active": "filter: {filter}",
        "type-active": "type: {type}",
        "contract-active": "contract: {contract}",
        "search-active": "search: \"{q}\"",
        "clear-all": "Clear all",
        "empty": {
          "title": "No matches",
          "with-search": "No employees match \"{q}\" in the {filter} filter.",
          "no-search": "No employees in the {filter} filter.",
          "clear": "Clear filters",
          "first-title": "Add your first employee",
          "first-body": "This workspace has no employees yet. Add one to start building your directory, or import a batch from Excel/CSV.",
          "first-cta-add": "Add employee",
          "first-cta-import": "Import from file"
        },
        "internal": "Optimal Internal",
        "error": "Failed to load employees. Please try refreshing.",
        "error-403": "You don't have permission to view employees.",
        "error-500": "Something went wrong on our end. Please try again.",
        "retry": "Try again",
        "filter-remove": "Remove {filter} filter",
        "sort-employee": "Sort by employee name",
        "sort-position": "Sort by position",
        "sort-department": "Sort by department",
        "sort-project": "Sort by project/client",
        "sort-type": "Sort by type",
        "sort-contract": "Sort by contract",
        "sort-status": "Sort by status",
        "delete": {
          "selected": "Delete {count} selected",
          "modal-title": "Delete employee?",
          "modal-body": "{name} ({code}) will be permanently removed. This action cannot be undone.",
          "modal-body-many": "{count} employees will be permanently removed. This action cannot be undone.",
          "confirm": "Delete",
          "cancel": "Cancel",
          "success": "{name} has been deleted.",
          "success-many": "{count} employees have been deleted.",
          "error": "Failed to delete employee. Please try again.",
          "error-partial": "{deleted} deleted, {failed} could not be removed. Please retry the remaining.",
          "bulk-title": "Delete {n} person? | Delete {n} people?",
          "bulk-body": "This permanently removes {n} person who has not started, with their personal record and documents. It cannot be undone. | This permanently removes {n} people who have not started, with their personal records and documents. It cannot be undone.",
          "and-more": "and {n} more",
          "type-to-confirm": "Type {n} to confirm",
          "progress": "Deleting {done} of {total}…",
          "result-deleted": "{n} deleted",
          "result-failed": "{n} not deleted",
          "close": "Close",
          "failure-forbidden": "Only administrators can delete people.",
          "failure-not-found": "This person no longer exists.",
          "failure-network": "Network error — this person was not deleted. Try again.",
          "failure-generic": "The server did not delete this person.",
          "code": {
            "NOT_DELETABLE_STATUS": "Only a person who has not started can be deleted. Set them to Inactive instead.",
            "HAS_CONTRACT": "This person has a contract. Set them to Inactive instead.",
            "TOO_MANY_ITEMS": "This person has too many records to delete at once."
          }
        },
        "bulkbar": {
          "count": "{n} selected",
          "in-view-all": "all of current view",
          "in-view-mixed": "{inView} in current view · {offView} off-view",
          "export-selected": "Export selected",
          "clear": "Clear",
          "delete": "Delete",
          "delete-disabled": "Only people who have not started and have no contract can be deleted. Set others to Inactive."
        },
        "coming-soon": "Coming soon",
        "download-excel": "Download Excel",
        "export-loading": "Exporting…",
        "export-success": "{count} employees exported",
        "export-sheet": "Employees",
        "export-empty": "No employees to export",
        "export-error": "Export failed — please try again",
        "export-modal": {
          "title": "Export employees",
          "description": "Choose scope, format, and which fields to include",
          "scope": {
            "label": "SCOPE — WHICH EMPLOYEES TO EXPORT",
            "filtered": "Current filtered list",
            "filtered-hint": "{count} employees matching the filters you have applied right now",
            "selected": "Selected only",
            "selected-hint": "{count} employees selected on the table",
            "selected-empty": "You need to select rows on the table first",
            "full": "Full employee directory",
            "full-hint": "{count} employees — ignores filters"
          },
          "format": {
            "label": "FORMAT",
            "xlsx": "Excel (.xlsx)",
            "xlsx-hint": "Recommended for HR — opens in Excel & Google Sheets directly.",
            "csv": "CSV (.csv)",
            "csv-hint": "Plain text — best for re-importing into other systems"
          },
          "fields": {
            "label": "EXTRA FIELDS TO ADD (beyond your table columns)"
          },
          "sensitive-warning": "{count} employees will be exported. Compensation fields included — handle with care.",
          "count": "{count} employees will be exported",
          "cancel": "Cancel",
          "submit": "Export {count} employees"
        },
        "workforce": {
          "label": "Workforce: All",
          "all": "Workforce: All",
          "Direct": "Direct",
          "Outsourced": "Outsourced"
        },
        "workforce-active": "Workforce: {workforce}",
        "colfilter-active": "{count} column filter(s)",
        "facet-option": "{label} · {count}",
        "no-position": "No position",
        "lifecycle": {
          "label": "Lifecycle",
          "all": "All",
          "preboarding": "Pre-boarding",
          "inservice": "In service",
          "inactive": "Inactive"
        },
        "workforce-chips": {
          "label": "Workforce type",
          "all": "All",
          "Direct": "Direct",
          "Outsourced": "Outsourced"
        },
        "scope": {
          "label": "Scope",
          "client-label": "Client",
          "all-clients": "All clients",
          "project-label": "Project",
          "all-projects": "All projects"
        },
        "client-active": "Client: {client}",
        "project-active": "Project: {project}",
        "colfilter-chip": "{column}: {values}",
        "column-filter": {
          "trigger": "Filter {column}",
          "clear": "Clear",
          "empty": "No options",
          "contains": "Contains…"
        },
        "scroll-left": "Scroll left",
        "scroll-right": "Scroll right",
        "export-done": "Exported {count} employees · {file}",
        "status-value": {
          "active": "Active",
          "inactive": "Inactive",
          "pending": "Pending",
          "onboarding": "Onboarding",
          "probation": "Probation",
          "on_leave": "On leave",
          "resigning": "Resigning",
          "leaving": "Leaving"
        },
        "lifecycle-value": {
          "preboarding": "Pre-boarding",
          "inservice": "In Service",
          "longleave": "On Long Leave",
          "offboarding": "Offboarding",
          "inactive": "Inactive",
          "unknown": "Unknown"
        }
      },
      "outsourced": {
        "title": "Outsourced Workforce",
        "subtitle": "Staff owned by this tenant and assigned to client projects. Client approvers are invited by email and receive magic-link login — they do not have an Optimal HR account.",
        "banner": {
          "title": "Outsourced Workforce",
          "all": "all non-direct staff working at our sites — both staff we employ (UDC/FDC/Casual) and staff supplied by outsourcing providers (Service).",
          "provider": "Optimal P's staff deployed at client sites · we pay them · client LMs approve day-to-day.",
          "service": "staff supplied by outsourcing providers · they handle payroll, benefits, statutory · we approve attendance and leave operationally.",
          "detail-all": "This is the operational deep-dive for EOR engagements. The Directory shows the same staff alongside Direct employees; here we surface the EOR-specific columns.",
          "detail-provider": "This is the operational deep-dive for EOR engagements. The Directory shows the same staff alongside Direct employees; here we surface the EOR-specific columns.",
          "detail-service": "No payroll captured — vendor handles employment. We only see who supervises operationally."
        },
        "actions": {
          "invite-approver": "Invite Client Approver",
          "invite-toast": "Client-approver invite flow — coming in a follow-up slice",
          "add-employee": "Add Outsourced Employee",
          "add-toast": "Add-employee flow — coming in a follow-up slice",
          "columns": "Columns",
          "export": "Export",
          "export-toast": "Export to Excel · {count} rows",
          "clear-filters": "Clear filters",
          "add-vendor-lite": "Add Vendor Lite Record"
        },
        "col-groups": {
          "identification": "Identification",
          "job-details": "Job Details",
          "assignment": "Assignment",
          "contract": "Contract",
          "status": "Status"
        },
        "view-mode": {
          "label": "View",
          "all": "All",
          "provider": "Provider-employed",
          "provider-hint": "Staff we employ — UDC / FDC / Casual Workforce",
          "service": "Vendor Lite Records",
          "service-hint": "Staff supplied by vendors — no payroll on our side",
          "assigned": "Assigned by Providers",
          "assigned-hint": "Workers assigned to your projects by on-platform Providers — read-only, owned by the Provider"
        },
        "kpi": {
          "total-outsourced": "Total outsourced",
          "total-provider": "Total provider-employed",
          "total-service": "Total service staff",
          "active": "Active",
          "probation": "On Probation",
          "onboarding": "Onboarding",
          "vendors": "Vendors",
          "expiring-fdc": "FDC expiring ≤ 30d",
          "expiring-service": "Engagements expiring ≤ 30d"
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "probation": "On Probation",
          "onboarding": "Onboarding",
          "onleave": "On leave",
          "resigning": "Resigning",
          "leaving": "Leaving",
          "expiring": "Expiring ≤30d",
          "all-projects": "All projects · {count}",
          "all-managers": "All client LMs"
        },
        "search-placeholder": "Search name, code, position…",
        "table": {
          "showing": "Showing {filtered} of {total} outsourced staff",
          "sorted-by": "sorted by {col} {dir}",
          "click-hint": "Click any row to open the profile",
          "code": "CODE",
          "person": "PERSON",
          "kh-name": "KH NAME",
          "position": "POSITION",
          "dept": "DEPT",
          "project": "PROJECT / CLIENT",
          "ext-mgr": "EXTERNAL MANAGER (LM)",
          "contract": "CONTRACT",
          "contract-end": "CONTRACT END",
          "vendor": "VENDOR",
          "joined": "JOINED DATE",
          "status": "STATUS",
          "actions": "ACTIONS",
          "row-actions": "Row actions",
          "open-profile": "Open profile",
          "open-profile-toast": "Profile drawer — opening {code}",
          "no-end": "—"
        },
        "drawer": {
          "tabs": {
            "overview": "Overview",
            "contract": "Contract"
          },
          "fields": {
            "code": "Employee code",
            "kh-name": "Khmer name",
            "position": "Position",
            "dept": "Department",
            "project": "Project",
            "client": "Client",
            "external-manager": "External Manager (LM)",
            "contract": "Contract type",
            "contract-end": "Contract end",
            "joined": "Joined",
            "base-location": "Base location",
            "phone": "Phone",
            "email": "Email",
            "vendor": "Vendor"
          },
          "no-value": "—"
        },
        "empty": {
          "title": "No matches",
          "lede": "No outsourced staff match these filters."
        },
        "mode-subtitle": {
          "provider-off": "Staff owned by this tenant and assigned to client projects. Client approvers are invited by email and receive magic-link login — they do not have an Optimal HR account.",
          "provider-on": "Staff owned by this tenant and assigned to client projects. When inviting a client approver, the system links to their existing Optimal HR account — no duplicate ESS.",
          "client-on": "Outsourced staff assigned to your projects by on-platform Providers. The Provider owns each worker's HR profile — you only see the assignment shadow and can approve operational requests.",
          "client-off": "Vendor lite records for workers supplied by providers NOT on Optimal HR. Operational tracking only — no payroll by this tenant.",
          "none": "Outsourcing is disabled for this tenant."
        },
        "mode": {
          "label": "Tenant outsourcing mode",
          "demo-tools": "Demo Tools",
          "dev-only": "Prototype only — not in production",
          "prod-note": "Production: configured in Admin → Modules",
          "close": "Close",
          "option": {
            "provider-off": "1 · Outsourcing Provider · Client NOT on Optimal HR",
            "provider-on": "2 · Outsourcing Provider · Client also on Optimal HR",
            "client-on": "3 · Outsourced Client · Provider on Optimal HR",
            "client-off": "4 · Outsourced Client · Provider NOT on Optimal HR",
            "none": "5 · General SMB (no outsourcing)"
          },
          "pill": {
            "role-provider": "Provider role",
            "role-client": "Client role",
            "role-none": "No outsourcing",
            "client-on": "Client on OHR",
            "client-off": "Client off-platform",
            "provider-on": "Provider on OHR",
            "provider-off": "Provider off-platform",
            "disabled": "Disabled"
          }
        },
        "assigned": {
          "banner-title": "Assigned by Providers",
          "banner-lead": "outsourced workers not owned by this tenant. The Provider tenant on Optimal HR owns the full HR profile (payroll, contract, ESS, leave entitlement). This tenant only receives the assignment shadow and can approve operational requests for the named approver.",
          "banner-detail": "Worker data is read-only here — to change personal details, contract terms, or salary, contact the Provider tenant. (Stub data — cross-tenant sync ships in a follow-up.)",
          "empty-title": "No incoming assignments",
          "empty-lede": "No on-platform Provider sends workers to this tenant in this scenario. Switch to Vendor Lite Records to add a manual record for off-platform providers.",
          "empty-cta": "Go to Vendor Lite Records",
          "showing": "Showing {count} incoming assignment(s) · owned by Provider tenant",
          "click-hint": "Worker profile lives in the Provider tenant",
          "accept": "Accept assignment",
          "decline": "Decline assignment",
          "view": "View scope (read-only)",
          "accept-toast": "Accept handshake — Provider will be notified; assignment shadow becomes Active",
          "decline-toast": "Decline handshake — Provider will be notified; assignment expires",
          "view-toast": "Read-only · worker profile lives in Provider tenant ({tenant})",
          "kpi": {
            "total": "Total incoming",
            "active": "Active",
            "pending": "Pending acceptance",
            "ended": "Ended (archive)"
          },
          "col": {
            "worker": "WORKER",
            "provider": "PROVIDER",
            "project": "PROJECT",
            "approver": "APPROVER",
            "scope": "SCOPE",
            "dates": "START–END",
            "status": "STATUS",
            "actions": "ACTIONS"
          }
        }
      },
      "configuration": {
        "sub-nav": {
          "grades": "Job Grades",
          "job-titles": "Job Titles",
          "job-profiles": "Job Profiles",
          "benefits": "Benefits"
        },
        "banner": {
          "lead": "Reference data.",
          "rest": "Job Grades, Job Titles, Job Profiles and the Benefits Catalog are the shared building blocks every Position, Offer Letter and per-employee record refers back to. Edits here propagate to every consumer — change with intent."
        },
        "benefits": {
          "title": "Benefits Catalog",
          "subtitle": "Company-wide master list of insurance · statutory · wellness · in-kind benefits. Defined once · referenced by every employee enrollment.",
          "add": "New Benefit",
          "add-toast": "New benefit · the create modal lands in the next slice once the catalog endpoint ships.",
          "search-placeholder": "Search by name, provider, scheme…",
          "clear-filters": "Clear filters",
          "showing": "Showing {filtered} of {total}",
          "renewal-soon": "SOON",
          "cost-family": "family USD {amt}",
          "auto-enroll": "Auto-enroll on hire",
          "footnote": "To enroll a specific employee, open their profile → Benefits. For bulk enrollment, use Employment Records → Benefits.",
          "kpi": {
            "active": "Active benefits",
            "enrollments": "Active enrollments",
            "monthly-cost": "Monthly cost (employer)",
            "renewing": "Renewing ≤90 days"
          },
          "chips": {
            "all": "All",
            "statutory": "Statutory",
            "insurance": "Insurance",
            "wellness": "Wellness",
            "allowance": "Allowance in-kind",
            "other": "Other"
          },
          "cols": {
            "benefit": "Benefit",
            "kind": "Kind",
            "eligibility": "Eligibility",
            "cost": "Cost / mo",
            "enrolled": "Enrolled",
            "renewal": "Renewal",
            "status": "Status"
          },
          "status": {
            "Active": "Active",
            "Renewing": "Renewing",
            "Ended": "Ended"
          },
          "empty": {
            "title": "No benefits match the current filters",
            "lede": "Try clearing the filters or search for a different keyword."
          },
          "drawer": {
            "scheme": "Scheme",
            "policy-pattern": "Policy ID pattern",
            "coverage": "Coverage",
            "eligibility": "Eligibility",
            "cost-emp": "Cost / employee / mo",
            "cost-fam": "Cost / family / mo",
            "cost-note": "Cost notes",
            "renewal": "Next renewal",
            "enrolled": "Active enrollments"
          }
        },
        "job-titles": {
          "banner-lead": "Job Titles",
          "banner-rest": " are role templates referenced by many Positions. Each title declares a family, a default grade, and 0–2 specifiers (Outlet, Line, Shift, etc.) that distinguish individual seats sharing the same title. e.g. one \"Plant Operator\" Job Title can be referenced by many Positions on different factory lines.",
          "kpi": {
            "active": "Active titles",
            "with-specifiers": "With specifiers",
            "orphan-main": "Orphan titles",
            "orphan-sub": "(0 Positions)",
            "broken-grade": "Broken grade link"
          },
          "families-label": "Families:",
          "toolbar-summary": "{active} active · {inactive} inactive",
          "show-inactive": "Show inactive",
          "add": "Add Job Title",
          "error": "Couldn't load job titles — {message}",
          "retry": "Try again",
          "footnote": "Click any row to edit. To see the Positions of a title, use the Positions page with the Job Title filter.",
          "cols": {
            "id": "ID",
            "title": "Title",
            "family": "Family",
            "grade": "Default grade",
            "specifiers": "Specifiers",
            "positions": "Positions",
            "filled": "Filled",
            "open": "Open",
            "status": "Status"
          },
          "status": {
            "active": "Active",
            "inactive": "Inactive"
          },
          "errors": {
            "conflict": "A job title with this name already exists. Use a different title or add a specifier.",
            "forbidden": "You don't have permission to manage job titles for this company.",
            "generic": "Couldn't save the job title. Please try again."
          },
          "empty": {
            "title": "No job titles yet",
            "subtitle": "Create your first role template to start building the Positions catalogue."
          },
          "modal": {
            "title": "New Job Title",
            "subtitle": "Create a role template for Positions to reference",
            "sections": {
              "identity": "Identity",
              "classification": "Classification",
              "specifiers": "Specifiers",
              "description": "Description"
            },
            "fields": {
              "id": {
                "label": "ID",
                "hint": "Suggested next code — you can change it. It must be unique and is locked once the title is created.",
                "auto": "(auto)"
              },
              "title": {
                "label": "Title",
                "placeholder": "e.g. Senior Engineer"
              },
              "family": {
                "label": "Family",
                "placeholder": "Select family…"
              },
              "grade": {
                "label": "Default grade",
                "placeholder": "— select grade —"
              },
              "specifiers": {
                "placeholder": "Add a specifier…"
              },
              "description": {
                "placeholder": "Brief role summary. Detailed KSAs belong on the Job Profile instead."
              }
            },
            "specifier-add": "Add",
            "specifier-remove": "Remove specifier",
            "specifier-section-hint": "(max 2 — used to distinguish identical-title positions)",
            "specifier-empty": "No specifiers. Each Position is uniquely identified by its Position ID alone. Add one (e.g. Outlet, Line, Shift) when many Positions share the same title.",
            "specifier-fields": {
              "name": "Name",
              "name-placeholder": "Outlet / Line / Shift",
              "source": "Source",
              "location-type": "Location type",
              "location-type-placeholder": "— select type —",
              "free-text-hint": "Typed by HR when filling each Position",
              "projects-hint": "Uses the Outsourcing Projects list"
            },
            "note-before": "New titles start ",
            "note-active": "Active",
            "note-after": " and become available in the New Position picker immediately. Deactivate / Reactivate / History will be available here after the title is created.",
            "errors": {
              "employer-missing": "No active employer — reopen this page and try again.",
              "title-required": "Title is required.",
              "family-required": "Family is required.",
              "grade-required": "Default grade is required.",
              "title-too-long": "Title must be 200 characters or fewer.",
              "description-too-long": "Description must be 4,000 characters or fewer.",
              "code-required": "Code is required.",
              "code-too-long": "Code must be 200 characters or fewer.",
              "code-taken": "Another job title already uses this code. Choose a different code."
            },
            "cancel": "Cancel",
            "create": "Create title",
            "creating": "Creating…",
            "success": "Job title \"{title}\" created.",
            "specifier-empty-1": "No specifiers. Each Position is uniquely identified by its Position ID alone.",
            "specifier-empty-2": "Add a specifier (e.g. Outlet, Line, Shift) when many Positions share the same title."
          },
          "edit": {
            "title": "Edit Job Title · {code}",
            "success": "Job title \"{title}\" updated.",
            "history": "History",
            "history-soon": "History — coming soon",
            "id-locked": "Locked once created.",
            "usage-positions": "Position reference this title",
            "inactive-notice-lead": "This Job Title is Inactive",
            "inactive-notice-rest": ". It is hidden from New Position pickers but preserved for audit. Use the Reactivate button below to bring it back.",
            "inactive-notice-rest-dated": " (deactivated {date}). It is hidden from New Position pickers but preserved for audit. Use the Reactivate button below to bring it back.",
            "cancel": "Cancel",
            "save-changes": "Save changes",
            "saving": "Saving…",
            "deactivate": {
              "heading": "Deactivate Job Title",
              "explanation": "Deactivated titles hide from New Position pickers but are preserved for audit. Hard delete is not allowed — once defined, a Job Title always remains.",
              "cannot": "Cannot deactivate — this title is still used by {count} Position(s) ({filled} Filled, {open} Open).",
              "reassign-note": "Cancel or reassign those Positions first. Open Positions can be Cancelled; Filled Positions need their Job Title changed (or the title needs to keep living).",
              "action": "Deactivate this title",
              "cannot-lead": "Cannot deactivate",
              "cannot-rest": " — this title is still used by:",
              "usage-count": "{count} Position(s)",
              "usage-breakdown": " ({filled} Filled, {open} Open)",
              "explanation-v2": "Deactivated titles hide from New Position pickers but are kept for audit. Positions that already carry the title keep it.",
              "in-use-lead": "Still in use",
              "in-use-rest": " — this title is carried by:",
              "in-use-note": "You can still deactivate it. Those Positions keep the title; it just won't be offered for new Positions.",
              "confirm-in-use": "Deactivate \"{title}\"?\n\n{count} Position(s) still carry it ({filled} Filled, {open} Open). They keep the title, but it won't be offered for new Positions."
            },
            "reactivate": {
              "heading": "Reactivate Job Title",
              "explanation": "Reactivating restores this title to Active. It will appear in the New Position picker again.",
              "action": "Reactivate this title"
            }
          },
          "banner-line1": "<strong>Job Titles</strong> are role templates referenced by many Positions. Each title declares a family, a default grade, and 0–2 specifiers (Outlet, Line, Shift, etc.) that distinguish individual seats sharing the same title.",
          "banner-line2": "e.g. one “Plant Operator” Job Title is referenced by 5 Positions on different factory lines.",
          "specifier": {
            "none": "none",
            "free-text": "free-text",
            "locations": "Locations",
            "projects": "Projects"
          },
          "footnote-pre": "Click any row to edit. To see Positions of a title, use ",
          "footnote-bold": "Positions",
          "footnote-post": " page with the Job Title filter.",
          "search": {
            "label": "Search job titles",
            "placeholder": "Search code, title, family, grade…"
          },
          "export": {
            "label": "Export",
            "empty": "Nothing to export — no rows match the filters."
          },
          "result-count": "{shown} of {total} job titles",
          "no-match": "No job titles match these filters.",
          "filter-chip": {
            "family": "Family: {value}",
            "search": "Search: “{value}”",
            "remove": "Remove filter {label}",
            "clear-all": "Clear all filters"
          },
          "history": {
            "deactivated-at": "Deactivated at"
          },
          "delete": {
            "heading": "Delete Job Title",
            "explanation": "No position uses this title, so it can be deleted. Deleting is permanent — use Deactivate instead if you may need it again.",
            "action": "Delete this title",
            "confirm-title": "Delete “{title}” permanently?",
            "confirm-body": "This cannot be undone. The title disappears from every list and picker.",
            "cancel": "Keep it",
            "confirm": "Delete permanently",
            "deactivate-instead": "Deactivate instead",
            "success": "Job title \"{title}\" deleted.",
            "errors": {
              "in-use": "This job title cannot be deleted because a position still uses it. Deactivate it instead.",
              "not-found": "This job title was already deleted. Close this window to refresh the list.",
              "forbidden": "You don't have permission to delete job titles for this company.",
              "generic": "Couldn't delete the job title. Please try again."
            }
          }
        },
        "job-profiles": {
          "banner-lead": "Job Profile",
          "banner-rest": " is an optional deeper layer attached to a Job Title — KSAs (Knowledge, Skills, Abilities), required certifications, succession planning notes, learning paths, and critical-role flags. Most companies fill these out for senior or critical roles only. Profile is content (not structure), so the action is Update rather than Edit. Remove is reversible — content stays in the database for audit.",
          "kpi": {
            "active-titles": "Active titles",
            "attached": "Profiles attached",
            "critical": "Critical roles",
            "without-succession": "Without succession",
            "succession-unit": "critical roles"
          },
          "filters": {
            "label": "Filter profiles",
            "all": "All titles",
            "with": "With profile",
            "no": "No profile",
            "critical": "Critical only"
          },
          "show-removed": "Show removed profiles ({count})",
          "error": "Couldn't load job profiles — {message}",
          "retry": "Try again",
          "empty": {
            "title": "No job titles yet",
            "subtitle": "Create Job Titles first — profiles attach to them."
          },
          "cols": {
            "title": "Job title",
            "family": "Family",
            "grade": "Default grade",
            "profile": "Profile",
            "updated": "Last updated",
            "action": "Action",
            "hours": "Hours/week"
          },
          "profile-attached": "Profile",
          "profile-critical": "Critical",
          "profile-none": "No profile",
          "action-add": "Add profile",
          "action-update": "Update",
          "action-restore": "Restore",
          "removed-heading": "Removed profiles ({count})",
          "removed-subtitle": "Content is preserved for audit. Restore brings a profile back to Active with no data loss.",
          "removed-cols": {
            "id": "Profile ID",
            "title": "Job title",
            "removed-on": "Removed on",
            "removed-by": "Removed by",
            "action": "Action"
          },
          "removed-toast": "Job profile removed. You can restore it from the removed list.",
          "status": {
            "removed": "Removed"
          },
          "errors": {
            "conflict": "A profile already exists for this job title.",
            "forbidden": "You don't have permission to manage job profiles for this company.",
            "generic": "Couldn't save the job profile. Please try again."
          },
          "modal": {
            "add-title": "Add Job Profile",
            "update-title": "Update Job Profile",
            "add-note": "Adding a new profile. All sections are optional — fill what's useful. Most companies start with senior/critical roles and expand over time.",
            "success": "Job profile created.",
            "sections": {
              "content": "Content",
              "certifications": "Required certifications",
              "strategic": "Strategic flags",
              "overview": "Role overview"
            },
            "fields": {
              "knowledge": {
                "label": "Knowledge",
                "hint": "what to know",
                "placeholder": "e.g. Cambodian Labour Law; NSSF filing procedures; double-entry bookkeeping…"
              },
              "skills": {
                "label": "Skills",
                "hint": "what to do",
                "placeholder": "e.g. Code review; mentoring; Khmer + English business writing…"
              },
              "abilities": {
                "label": "Abilities",
                "hint": "capacities",
                "placeholder": "e.g. Lift 25 kg; work overnight shifts; analyse trends from numerical data…"
              },
              "certification": {
                "placeholder": "e.g. SHRM-SCP or equivalent"
              },
              "critical": {
                "label": "Critical role",
                "hint": "high impact if unfilled; requires succession plan + continuity strategy"
              },
              "succession": {
                "label": "Succession notes",
                "placeholder": "Who is the named successor? Time horizon? Development gaps?",
                "hint": "recommended for critical roles"
              },
              "learning": {
                "label": "Learning paths",
                "placeholder": "Internal mentoring; external courses; rotations…"
              },
              "performance": {
                "label": "Performance dimensions",
                "placeholder": "Which metrics judge success in this role?"
              },
              "hours": {
                "label": "Working hours / week",
                "placeholder": "e.g. 40",
                "hint": "Optional. More than 0 and up to 168, at most 2 decimals."
              },
              "job-summary": {
                "label": "Job summary",
                "placeholder": "A short summary of the role and why it exists."
              },
              "responsibilities": {
                "label": "Responsibilities",
                "placeholder": "What the role is responsible for — one per line."
              },
              "requirements": {
                "label": "Requirements",
                "placeholder": "Education, experience and licences the holder needs."
              },
              "core-competency": {
                "label": "Core competency",
                "placeholder": "The behaviours and competencies the role relies on."
              }
            },
            "cert-add": "Add",
            "cert-empty": "No certifications required.",
            "cert-remove": "Remove certification",
            "succession-warning": "Critical role with no succession notes — add a named successor or development plan.",
            "cancel": "Cancel",
            "create": "Create profile",
            "creating": "Creating…",
            "errors": {
              "employer-missing": "No active employer — reopen this page and try again.",
              "no-title": "No job title selected — reopen and try again.",
              "text-too-long": "Too long — at most {max} characters.",
              "hours-number": "Enter a number, e.g. 40 or 37.5.",
              "hours-range": "Must be more than 0 and at most {max}.",
              "hours-decimals": "Use at most 2 decimal places.",
              "invalid-form": "Please fix the highlighted fields."
            },
            "add-note-lead": "Adding a new profile.",
            "add-note-rest": " All sections are optional — fill what's useful. Most companies start with senior/critical roles and expand over time.",
            "confirm-critical": "Critical role flag is set but Succession notes are empty.\n\nIt is strongly recommended to document a successor for critical roles. Proceed anyway?",
            "counter": "{count} / {max}",
            "discard-confirm": "Discard changes? Your edits to this job profile have not been saved."
          },
          "update": {
            "success": "Job profile updated.",
            "history": "History",
            "history-soon": "History — coming soon",
            "removed-notice": " on {date} by {by}. Content is preserved for audit. Use the Restore button at the bottom to bring it back.",
            "save-changes": "Update profile",
            "saving": "Saving…",
            "remove": {
              "heading": "Remove profile",
              "explanation": "Removes this profile from the Job Title. Content is preserved for audit — this is not a hard delete. You can restore it later from the removed list.",
              "action": "Remove this profile",
              "explanation-pre": "Remove detaches the profile from its Job Title. ",
              "explanation-bold": "Content is preserved",
              "explanation-post": " for audit — this is not a delete. You can restore from “Show removed profiles” later.",
              "confirm": "Remove the Job Profile for “{title}”?\n\nThe profile content is preserved in the database for audit. The Job Title will show as “No profile” but you can restore it later."
            },
            "restore": {
              "heading": "Restore profile",
              "explanation": "Restore brings this profile back to Active. Content was preserved during removal — no loss.",
              "action": "Restore this profile"
            },
            "removed-notice-lead": "This profile was removed",
            "loading": "Loading the job profile…",
            "load-error": "Couldn't load this job profile, so it can't be edited yet."
          },
          "banner-line1": "<strong>Job Profile</strong> is an <em>optional</em> deeper layer attached to a Job Title — KSAs (Knowledge, Skills, Abilities), required certifications, succession planning notes, learning paths, and HiPo/critical-role flags. Most companies fill these out for senior or critical roles only.",
          "banner-line2": "Profile is <strong>content</strong> (not structural), so the action is <strong>Update</strong> rather than Edit. Remove is reversible — content stays in the database for audit.",
          "counts-active": "active",
          "counts-removed": "removed",
          "show-removed-label": "Show removed profiles",
          "guide": {
            "title": "What a Job Profile contains",
            "k": {
              "head": "K · KNOWLEDGE",
              "desc": "What the role must know. e.g.",
              "eg": "\"Cambodian Labour Law\", \"NSSF filing procedures\", \"double-entry bookkeeping\""
            },
            "s": {
              "head": "S · SKILLS",
              "desc": "What the role must do. e.g.",
              "eg": "\"Excel pivot tables\", \"TIG welding to ASME spec\", \"Khmer + English business writing\""
            },
            "a": {
              "head": "A · ABILITIES",
              "desc": "Capacities. e.g.",
              "eg": "\"Lift 25 kg repeatedly\", \"Work overnight shifts\", \"Analyse trends from numerical data\""
            },
            "other": {
              "head": "OTHER",
              "desc": "Required certifications · Learning paths · Critical-role flag · Succession candidates · Performance dimensions."
            }
          },
          "table-caption-lead": "Job Titles",
          "table-caption-rest": " with their profile status — click \"Update\" to refine, \"Add\" to start a new profile",
          "table-count": "{shown} of {total} title(s)",
          "profile-active": "Active",
          "action-review-restore": "Review & restore",
          "action-review": "Review",
          "removed-caption-rest": " — content preserved for audit. Restore from the table above (the row shows \"Removed\" status) or click below.",
          "profile-no-succession": "No succession",
          "action-view": "View",
          "view-label": "View the job profile for {title}",
          "search": {
            "label": "Search job profiles",
            "placeholder": "Search title, family, grade…"
          },
          "filter-chip": {
            "search": "Search: “{value}”",
            "filter": "Showing: {value}",
            "remove": "Remove filter {label}",
            "clear-all": "Clear all"
          },
          "result-count": "{shown} of {total} titles",
          "no-match": "No job titles match these filters.",
          "export": {
            "label": "Export",
            "empty": "Nothing to export"
          },
          "export-cols": {
            "code": "Code",
            "critical": "Critical role",
            "yes": "Yes",
            "no": "No",
            "certifications": "Required certifications"
          },
          "detail": {
            "title": "Job profile · {title}",
            "loading": "Loading the full profile…",
            "load-error": "Couldn’t load the full profile — showing the summary copy.",
            "job-title": "Job title",
            "family": "Family",
            "grade": "Grade",
            "salary-band": "Salary band",
            "hours": "Working hours / week",
            "hours-value": "{hours} h",
            "last-updated": "Last updated",
            "status": "Status",
            "active": "Active",
            "removed": "Removed on {date}",
            "critical-yes": "Critical role",
            "critical-no": "Not a critical role",
            "empty-section": "Not filled in.",
            "none": "—",
            "ksa": "Knowledge, skills & abilities",
            "strategic": "Strategic flags",
            "close": "Close",
            "edit": "Edit profile",
            "print": "Print / Save as PDF",
            "history": "History",
            "body-label": "Job profile content — {title}"
          },
          "print": {
            "heading": "JOB PROFILE",
            "job-title": "Job Title:",
            "job-grade": "Job Grade:",
            "last-update": "Last Update:",
            "job-summary": "Job Summary",
            "responsibilities": "Responsibilities",
            "requirements": "Requirements",
            "core-competencies": "Core Competencies",
            "job-holder": "Job Holder:",
            "line-manager": "Line Manager:",
            "name": "Name:",
            "date": "Date:"
          },
          "history": {
            "title": "Job profile history",
            "job-summary": "Job summary",
            "responsibilities": "Responsibilities",
            "requirements": "Requirements",
            "core-competency": "Core competency",
            "hours": "Working hours / week",
            "knowledge": "Knowledge",
            "skills": "Skills",
            "abilities": "Abilities",
            "certifications": "Required certifications",
            "critical": "Critical role",
            "succession": "Succession notes",
            "learning": "Learning paths",
            "performance": "Performance dimensions",
            "status": "Status",
            "removed-at": "Removed at",
            "removed-by": "Removed by"
          },
          "inactive-title": "Inactive title"
        },
        "grades": {
          "banner-lead": "Job Grades",
          "banner-mid": " set salary bands and define the seniority ladder. Each Job Title declares a ",
          "banner-emphasis": "default grade",
          "banner-rest": ", and each Position inherits its grade from its Job Title. Salary outside the band on Add Person will trigger a soft warning.",
          "kpi": {
            "active": "Active grades",
            "lowest-min": "Lowest min salary",
            "highest-max": "Highest max salary",
            "orphan-main": "Orphan grades",
            "orphan-sub": "(no Job Title)",
            "primary-currency-caption": "({currency} · most grades)"
          },
          "currency-filter-label": "Currency",
          "currency-all": "All",
          "toolbar-summary-head": "{active} active · {inactive} inactive",
          "toolbar-summary-overlaps": "{overlaps} band overlaps",
          "show-inactive": "Show inactive",
          "add": "Add Grade",
          "cols": {
            "code": "Code",
            "grade": "Grade weight",
            "title": "Title",
            "min": "Min salary",
            "max": "Max salary",
            "currency": "Currency",
            "titles": "Job titles",
            "positions": "Filled positions",
            "description": "Description",
            "status": "Status",
            "level": "Seniority level"
          },
          "status": {
            "active": "Active",
            "inactive": "Inactive"
          },
          "loading": "Loading job grades…",
          "error": "Couldn't load job grades — {message}",
          "retry": "Try again",
          "errors": {
            "conflict": "A job grade with this code or grade weight already exists. Use a different code or weight.",
            "forbidden": "You don't have permission to manage job grades for this company.",
            "generic": "Couldn't save the job grade. Please try again."
          },
          "empty": {
            "title": "No job grades yet",
            "subtitle": "Create your first seniority band to start building the grade ladder."
          },
          "modal": {
            "title": "New Job Grade",
            "subtitle": "Define a new seniority band",
            "sections": {
              "identity": "Identity",
              "salary": "Salary band (gross, monthly)",
              "description": "Description"
            },
            "fields": {
              "code": {
                "label": "Code",
                "placeholder": "e.g. L5",
                "hint": "Short display code (e.g. L5)"
              },
              "grade": {
                "label": "Grade",
                "placeholder": "e.g. 5",
                "hint": "Numeric weight for ordering — higher = higher grade"
              },
              "title": {
                "label": "Title",
                "placeholder": "e.g. Senior Manager"
              },
              "min": {
                "label": "Min",
                "placeholder": "e.g. 5000"
              },
              "max": {
                "label": "Max",
                "placeholder": "e.g. 8000"
              },
              "currency": {
                "label": "Currency"
              },
              "description": {
                "placeholder": "Who fits this grade? Years of experience, scope, level of authority…"
              },
              "level": {
                "label": "Seniority level",
                "placeholder": "e.g. Middle Management",
                "hint": "The rank this grade sits at (optional)"
              }
            },
            "note-before": "New grades start ",
            "note-active": "Active",
            "note-after": " and appear in grade pickers immediately. Deactivate / Reactivate / History will be available here after the grade is created.",
            "errors": {
              "grade-required": "Grade is required.",
              "grade-numeric": "Grade must be a valid number.",
              "grade-taken": "This grade is already taken.",
              "code-taken": "This code is already taken.",
              "code-required": "Code is required.",
              "title-required": "Title is required.",
              "salary-required": "Min and Max salary are required.",
              "numeric": "Min and Max must be valid numbers.",
              "max-below-min": "Max salary must be greater than or equal to Min salary.",
              "employer-missing": "No active employer — reopen this page and try again.",
              "level-too-long": "Seniority level must be 200 characters or fewer.",
              "level-cleared": "Seniority level can't be cleared once set — enter a value instead."
            },
            "cancel": "Cancel",
            "create": "Create grade",
            "creating": "Creating…",
            "success": "Job grade {code} created."
          },
          "edit": {
            "title": "Edit Job Grade · {code}",
            "history": "History",
            "history-soon": "History — coming soon",
            "save-changes": "Save changes",
            "saving": "Saving…",
            "cancel": "Cancel",
            "success": "Job grade {code} updated.",
            "code-locked": "Code is locked once created (referenced by Job Titles).",
            "code-editable": "No code yet — add one (referenced by Job Titles, then locked).",
            "inactive-notice-lead": "This Job Grade is Inactive",
            "inactive-notice-rest": ". Edit history is preserved. Use the Reactivate button below to bring it back.",
            "inactive-notice-rest-dated": " (deactivated {date}). Edit history is preserved. Use the Reactivate button below to bring it back.",
            "overlap-lead": "Band overlap",
            "overlap-detail": "with: {code} ({min}–{max}). This is allowed (soft warning) but typically grades should not overlap.",
            "usage": {
              "titles-suffix": "Job Titles reference this grade",
              "positions-suffix": "filled position at this grade"
            },
            "deactivate": {
              "heading": "Deactivate Job Grade",
              "explanation": "Deactivated grades hide from pickers but are preserved for audit. Hard delete is not allowed — once defined, a Job Grade always remains in the database.",
              "cannot": "Cannot deactivate — this grade is still in use:",
              "reason-titles": "{count} Job Title(s) reference it as default grade",
              "reason-positions": "{count} filled Position(s) at this grade",
              "reassign-note": "Reassign those to a different grade first, then return here.",
              "action": "Deactivate this grade",
              "cannot-lead": "Cannot deactivate",
              "cannot-rest": " — this grade is still in use:",
              "reason-titles-count": "{count} Job Title(s)",
              "reason-titles-rest": " reference it as default grade",
              "reason-positions-count": "{count} filled Position(s)",
              "reason-positions-rest": " at this grade"
            },
            "reactivate": {
              "heading": "Reactivate Job Grade",
              "explanation": "Reactivating restores this grade to Active. It will appear in grade pickers again. Edit history continues unchanged.",
              "action": "Reactivate this grade"
            },
            "history-aria": "Show edit history for grade {code}",
            "history-fields": {
              "salary-range": "Salary band",
              "deactivated-at": "Deactivated at"
            }
          },
          "search": {
            "label": "Search job grades",
            "placeholder": "Search code, title, level…"
          },
          "export": "Export",
          "export-aria": "Export the {count} grades shown to Excel",
          "export-empty": "Nothing to export — no grades are shown.",
          "result-count": "{shown} of {total} grades",
          "chips": {
            "search": "Search: {q}",
            "currency": "Currency: {currency}",
            "inactive": "Including inactive",
            "remove": "Remove filter: {label}",
            "clear-all": "Clear all"
          },
          "no-match": {
            "title": "No grades match these filters.",
            "clear": "Clear filters"
          },
          "sort-aria": "Sort by {column}"
        }
      },
      "salaryBatch": {
        "button": "Salary Batch",
        "modal": {
          "title": "Batch Salary Update",
          "subtitle": "Update employee salaries in bulk from Excel with real-time validation."
        },
        "steps": {
          "upload": "Upload file",
          "validation": "Validation",
          "confirm": "Confirm"
        },
        "tabs": {
          "batch": "New Batch",
          "history": "Batch History"
        },
        "footer": {
          "cancel": "Cancel",
          "validate": "Validate",
          "confirmApply": "Confirm & Apply",
          "nextValidation": "Next: Validation",
          "nextConfirm": "Next: Confirm",
          "back": "Back"
        },
        "confirm": {
          "summaryTitle": "Apply summary",
          "rowsToApply": "Rows to apply",
          "warningsOverridden": "Warnings overridden",
          "noRowsToApply": "No valid rows to apply. Please go back and review the validation results.",
          "note": "Salary changes are permanent and cannot be undone. Please review the validation results before confirming."
        },
        "instructions": {
          "title": "Instructions & Requirements",
          "step1Title": "Step 1 — Generate Template",
          "step1Bullet1": "Optionally select scope filters (department, branch/base location), then click Generate Template.",
          "step1Bullet2": "Without filters, the template includes all active employees. With filters, only matching employees are included.",
          "step1Bullet3": "Download the file and fill in: New Basic Salary (positive number), Effective Date (YYYY-MM-DD), Reason (required).",
          "step1Bullet4": "Read-only columns — Employee Code, Full Name, Current Basic Salary — do not edit these.",
          "step2Title": "Step 2 — Upload & Validate",
          "step2Bullet1": "Only .xlsx files accepted. Maximum file size: 5 MB.",
          "step2Bullet2": "Do not modify the hidden metadata sheet — it is used to verify template authenticity.",
          "step2Bullet3": "Clicking Validate is a dry run — no salary records are created.",
          "step2Bullet4": "Rows with errors cannot be applied. Rows with warnings can be overridden."
        },
        "scopeFilters": {
          "title": "Scope & Template",
          "optional": "(optional)",
          "orgUnit": "Org Unit",
          "orgUnitPlaceholder": "All org units",
          "baseLocation": "Base Location",
          "baseLocationPlaceholder": "All base locations",
          "downloadBtn": "Download Template",
          "downloading": "Downloading…",
          "descriptionAll": "All active employees",
          "descriptionFiltered": "Filtered employees only"
        },
        "upload": {
          "title": "Upload Filled Template",
          "dropHint": "Drop file here or click to browse",
          "fileTypeHint": ".xlsx files only",
          "fileSizeLimit": "Max {size} MB",
          "removeFile": "Remove file"
        },
        "preview": {
          "title": "Validation Preview",
          "statTotal": "Total:",
          "statValid": "Valid:",
          "statInvalid": "Errors:",
          "statWarnings": "Warnings:",
          "statPending": "Pending validation",
          "colNum": "#",
          "colStatus": "Status",
          "colEmployeeCode": "Employee Code",
          "colFullName": "Full Name",
          "colCurrentSalary": "Current Salary",
          "colNewSalary": "New Salary",
          "colEffectiveDate": "Effective Date",
          "colReason": "Reason",
          "colRemark": "Remarks",
          "colOverride": "Override",
          "statusValid": "Valid",
          "statusError": "Error",
          "statusWarning": "Warning",
          "statusPending": "Pending",
          "statusUnknown": "Unknown",
          "exportErrors": "Export errors",
          "warningOverrideBanner": "Some rows have warnings. Check the Override box to include them in the apply.",
          "csvColRow": "Row",
          "csvColErrors": "Errors / Warnings"
        },
        "result": {
          "successTitle": "Salary update applied",
          "successSub": "{succeeded} record(s) updated successfully.",
          "successSubFailed": " {failed} failed.",
          "downloadResult": "Download Result File",
          "downloadOriginal": "Download Original File"
        },
        "history": {
          "description": "Previous batch salary updates for this employer.",
          "loading": "Loading history…",
          "empty": "No batch history yet.",
          "unknown": "Unknown",
          "batchId": "Batch ID",
          "validated": "Validated",
          "applied": "Applied",
          "validateSummaryValue": "{valid} valid / {total} total",
          "applySummaryValue": "{succeeded} ok, {failed} failed / {total} total",
          "importedOf": "{succeeded} / {total} applied",
          "rowsCount": "{count} rows",
          "downloadResult": "Download Result",
          "downloadOriginal": "Download Original"
        },
        "errors": {
          "filterLoadFailed": "Could not load filter options. Please retry.",
          "generateFailed": "Could not generate template. Please retry.",
          "invalidTemplateResponse": "Invalid template response from server.",
          "onlyXlsx": "Only .xlsx files are accepted.",
          "fileTooLarge": "File exceeds {size} MB limit.",
          "noDataRows": "The file has no data rows.",
          "parseError": "Could not read the file. Make sure it is a valid .xlsx file.",
          "readError": "Could not read the file from disk.",
          "validateFailed": "Validation failed. Please retry.",
          "applyFailed": "Apply failed. Please retry.",
          "historyLoadFailed": "Could not load batch history.",
          "resultDownloadFailed": "Could not download result file.",
          "originalDownloadFailed": "Could not download original file."
        }
      },
      "profile": {
        "joined": "Joined",
        "message": "Message",
        "edit": "Edit",
        "coming-soon": "Coming in a follow-up slice",
        "photo": {
          "upload-tooltip": "Change profile photo",
          "upload-success": "Profile photo updated.",
          "upload-error": "Failed to update profile photo. Please try again.",
          "remove": "Remove photo"
        },
        "error": "Failed to load employee profile.",
        "retry": "Retry",
        "nav-label": "Profile sections",
        "tabs": {
          "overview": "Overview",
          "job": "Job & Organization",
          "contract": "Contract",
          "employment-actions": "Employment Actions",
          "compensation": "Compensation",
          "benefits": "Benefits",
          "payroll": "Payroll",
          "attendance": "Attendance",
          "documents": "Documents",
          "personal": "Personal Information",
          "journey": "Employment Journey"
        },
        "contract": {
          "current-contract": "Current Contract",
          "readonly-label": "Read-only",
          "readonly-structural": "structural changes are Contract Events",
          "readonly-pay": "pay changes are Salary Adjustments",
          "contract-type": "Contract Type",
          "status": "Status",
          "start-date": "Start Date",
          "end-date": "End Date",
          "ongoing": "ongoing",
          "end-date-ongoing": "— ongoing",
          "probation-end": "Probation End",
          "base-salary-monthly": "Contract Base Salary",
          "base-salary-hint": "/ month — at signing",
          "base-salary-no-adj": "No salary adjustments since signing — contract base = current effective pay.",
          "all-contracts": "All Contracts",
          "all-contracts-desc": "Each row is a distinct signed contract. New contracts come from Contract Events (Renewal · Extension · Conversion · Amendment). Salary adjustments do not create a new contract row.",
          "col-start": "Start",
          "col-end": "End",
          "col-type": "Type",
          "col-base-salary": "Contract Base",
          "col-status": "Status",
          "col-actions": "Actions",
          "no-contracts": "No contracts found",
          "add": "New Contract",
          "edit": "Edit contract",
          "delete": "Delete contract",
          "confirm-delete": "Delete this contract? This cannot be undone.",
          "confirm-delete-yes": "Yes, delete",
          "confirm-delete-no": "Cancel",
          "events-title": "Contract Events",
          "events-subtitle": "Record contract lifecycle changes: renewal · extension · conversion · amendment · probation · termination. Phase 1 — recording only.",
          "events-add": "Add Contract Event",
          "events-empty-title": "No contract events recorded yet",
          "events-empty-hint": "Use this surface when HR receives a signed contract / renewal / amendment / probation memo offline and needs to record it.",
          "events-col-effective": "Effective",
          "events-col-event": "Event",
          "events-col-detail": "Detail",
          "events-col-status": "Status",
          "salary-adj-title": "Salary Adjustments History",
          "salary-adj-subtitle": "Compensation Events that change the effective pay without amending the signed contract.",
          "salary-adj-count": "{n} adjustment | {n} adjustments",
          "salary-adj-col-effective-date": "Effective Date",
          "salary-adj-col-from": "From",
          "salary-adj-col-to": "To",
          "salary-adj-col-reason": "Reason",
          "salary-adj-col-status": "Status",
          "salary-adj-note": "The signed Contract Base Salary above is locked. Amending the contract itself requires a Contract Event (Amendment / Renewal / Conversion). Salary adjustments are recorded via Compensation tab → Record Compensation Event → Salary Adjustment."
        },
        "more-menu": {
          "label": "More actions",
          "section-contract": "Contract Actions",
          "section-other": "Other",
          "new-contract": "New Contract",
          "new-contract-sub": "Create a fresh contract for this employee",
          "renew-contract": "Renew Contract",
          "renew-contract-sub": "Extend the current contract term",
          "rehire": "Rehire Employee",
          "rehire-sub": "Re-engage a previously terminated employee",
          "download-pdf": "Download Contract PDF",
          "download-pdf-unavailable": "Contract PDF export is not yet available.",
          "delete-employee": "Delete Employee Record",
          "delete-employee-confirm-title": "Delete Employee Record",
          "delete-employee-confirm-body": "This action is permanent and cannot be undone. Are you sure you want to permanently delete",
          "delete-employee-confirm-yes": "Yes, Delete",
          "delete-employee-confirm-no": "Cancel",
          "delete-employee-error": "Failed to delete employee. Please try again."
        },
        "contract-drawer": {
          "title": {
            "new": "New Contract",
            "renew": "Renew Contract",
            "rehire": "Rehire Employee"
          },
          "subtitle": {
            "new": "Create a new employment contract",
            "renew": "Extend the current contract with a new term",
            "rehire": "Re-engage this employee under a new contract"
          },
          "rehire-note": "This will create a new contract and mark the employee as rehired. Ensure all required paperwork has been completed before proceeding.",
          "field-type": "Contract Type",
          "field-type-placeholder": "Select contract type",
          "field-employment-type": "Employment Type",
          "field-start-date": "Start Date",
          "field-end-date": "End Date",
          "field-salary": "Basic Salary",
          "field-salary-placeholder": "e.g. 1200",
          "field-position": "Position (Org Chart)",
          "field-position-placeholder": "Select a vacant position",
          "field-position-hint": "Optional — links this contract to a vacant position in the org chart.",
          "position-loading": "Loading positions…",
          "position-empty": "No vacant positions available.",
          "field-reason": "Reason",
          "field-reason-placeholder": "Reason for this contract action",
          "error-start-required": "Start date is required.",
          "error-end-required": "End date is required for this contract type.",
          "error-end-after-start": "End date must be after the start date.",
          "error-reason-required": "Reason is required.",
          "error-save-failed": "Failed to save. Please try again.",
          "cancel": "Cancel",
          "save": "Save Contract",
          "saving": "Saving…"
        },
        "employment-actions": {
          "title": "Employment Actions",
          "subtitle": "Position-aligned EA records · 3-action v1 catalog · §9.6 firewall preserved · derived label persisted at submit.",
          "frozen-chip": "CI Rev 3.2.1 · FROZEN BASELINE",
          "new-action": "+ New Employment Action",
          "error": "Failed to load employment actions.",
          "retry": "Retry",
          "phase1-bold": "Phase 1 · Recording only.",
          "phase1-notice": "HR records what's been agreed offline (memo / letter / LM sign-off). Status is derived from the effective date — Scheduled (future) or Effective (today/past). Approval workflow comes in Phase 2.",
          "empty-title": "No employment actions yet for {name}",
          "empty-hint": "Click New Employment Action above to create the first one.",
          "confirm-cancel": "Cancel this employment action? This cannot be undone.",
          "confirm-cancel-yes": "Yes, cancel",
          "confirm-cancel-no": "Keep",
          "cancel-action": "Cancel",
          "view-detail": "View detail",
          "kpi": {
            "current-position": "CURRENT POSITION",
            "reports-to": "REPORTS TO",
            "eas-employee": "EAs (THIS EMPLOYEE)",
            "eas-tenant": "EAs (TENANT-WIDE)",
            "scheduled": "scheduled",
            "effective": "effective",
            "cancelled": "cancelled",
            "scheduled-future": "scheduled (future-dated)"
          },
          "col": {
            "date": "Date",
            "type": "Action Type",
            "detail": "Detail",
            "label": "Detected Label",
            "status": "Status"
          },
          "info": {
            "current-position": "Current Position",
            "reports-to": "Reports To",
            "eas-employee": "EAs (This Employee)",
            "eas-tenant": "EAs (Tenant-Wide)",
            "scheduled": "scheduled",
            "effective": "effective",
            "cancelled": "cancelled"
          },
          "status": {
            "scheduled": "Scheduled",
            "effective": "Effective",
            "cancelled": "Cancelled",
            "unknown": "Unknown"
          },
          "field": {
            "effective-date": "Effective Date",
            "created-by": "By",
            "reason": "Reason"
          },
          "detail": {
            "col-from": "From",
            "col-to": "To",
            "job-profile": "Job Profile",
            "job-grade": "Job Grade",
            "org-unit": "Org Unit",
            "basic-salary": "Basic Salary",
            "employment-type": "Employment Type",
            "no-changes": "No detail fields recorded for this change."
          },
          "change-type": {
            "PROMOTE": "Promotion",
            "TRANSFER": "Transfer",
            "REDESIGNATION": "Re-Designation",
            "INVOLUNTARY_TERMINATION": "Involuntary Termination",
            "VOLUNTARY_TERMINATION": "Voluntary Termination",
            "SALARY_CHANGE": "Salary Change",
            "SALARY_INCREASE": "Salary Increase",
            "CHANGE_EMPLOYMENT_TYPE": "Employment Type Change",
            "RENEW": "Contract Renewal",
            "SUSPEND": "Suspension",
            "DEMOTE": "Demotion",
            "Unknown": "Unknown"
          },
          "modal": {
            "title-step1": "New Employment Action · {name}",
            "title-step2": "New Employment Action · {name}",
            "step1-desc": "Step 1 of 2 – choose the Employment Event Classification",
            "step2-desc": "Step 2 of 2 – {type} details",
            "for-label": "For:",
            "locked-from-profile": "Locked from Profile (cached)",
            "incoming-feature": "Incoming Feature",
            "upcoming-feature": "⏸ UPCOMING FEATURE",
            "not-actionable-banner": "This employee's status is Pending or Inactive — Employment Actions require an active contract. Use Rehire (Contract → New Contract Event) if they need to return.",
            "not-actionable-badge": "EMPLOYEE NOT ACTIVE",
            "field-effective-date": "Effective Date",
            "field-reason": "Reason",
            "field-reason-placeholder": "Provide a reason for this change",
            "field-org-unit": "Target Department / Org Unit",
            "field-org-unit-placeholder": "e.g. Sales, Finance",
            "field-salary": "New Basic Salary",
            "field-salary-placeholder": "e.g. 1200",
            "field-doc-ref": "Document Reference",
            "field-doc-ref-placeholder": "e.g. MEMO-2026-001, Letter ref",
            "file-upload-phase2": "File attachment — coming in Phase 2",
            "field-offline-approval": "Offline Approval",
            "offline-approval-label": "Offline approval completed (memo / letter / LM sign-off received)",
            "field-offline-notes": "Offline Approval Notes",
            "field-offline-notes-placeholder": "Notes about the offline approval process",
            "cancel": "Cancel",
            "back": "← Back",
            "submit": "Save Record",
            "saving": "Saving…",
            "error-type-required": "Please select an action type.",
            "error-date-required": "Effective date is required.",
            "error-reason-required": "Reason is required.",
            "error-no-contract": "No active contract found for this employee.",
            "error-salary-numeric": "Salary must be a valid number.",
            "error-save-failed": "Failed to save. Please try again.",
            "field-effective-date-hint": "Future date → Scheduled · Today or past → Effective",
            "promotion": {
              "info-banner": "Promotion = career progression in 2 modes. If only salary changes (no Grade · no Position · no Title) use Compensation tab → Salary Adjustment instead. If only title changes with no Grade/Salary increase use Re-Designation.",
              "mode-a-label": "Mode A",
              "mode-a-sub": "New seat in Org Chart",
              "mode-a-desc": "Move to a different Position that exists in the catalog",
              "mode-b-label": "Mode B",
              "mode-b-sub": "Same seat · better Grade or Level",
              "mode-b-desc": "No Position move · Grade must go up · Title change is optional",
              "mode-b-hint": "Mode B: No position move required. Ensure the new grade is higher than the current grade before saving.",
              "target-position": "Target Position",
              "target-position-placeholder": "Pick a target Position…",
              "target-position-hint": "Excludes the employee's current Position. Shows assignable seats only.",
              "companion-label": "Include Salary Adjustment in the same transaction",
              "companion-desc": "Uncheck to record promotion without a salary change.",
              "base-salary-label": "Base Salary",
              "base-salary-source-of-truth": "SOURCE OF TRUTH",
              "new-base-salary-label": "New Base Salary",
              "delta": "Change: USD {from} → USD {to} · {sign}USD {delta} · {sign}{pct}%",
              "error-target-required": "Target Position is required for Mode A.",
              "loading-positions": "Loading positions…",
              "no-positions-promote": "No vacant positions available at this grade.",
              "no-positions-transfer": "No positions available at the same grade."
            },
            "classification": {
              "PROMOTE": {
                "title": "Promotion",
                "desc": "Career progression · Mode A: new seat · Mode B: same seat better Grade"
              },
              "TRANSFER": {
                "title": "Transfer",
                "desc": "Operational movement · Department / Site / Branch · usually no grade change"
              },
              "REDESIGNATION": {
                "title": "Re-Designation",
                "desc": "Title change without career progression · no salary or grade increase (use Promotion if salary changes)"
              },
              "SALARY_CHANGE": {
                "title": "Salary Change",
                "desc": "Adjust base salary or allowances · effective from date · full audit trail"
              },
              "INVOLUNTARY_TERMINATION": {
                "title": "Involuntary Termination",
                "desc": "Dismissal, redundancy, or misconduct · permanently ends employment"
              },
              "VOLUNTARY_TERMINATION": {
                "title": "Voluntary Termination",
                "desc": "Employee resignation · permanently ends employment"
              }
            },
            "salary-change": {
              "info-banner": "Salary change updates the employee's base salary. A full audit trail is recorded with the effective date.",
              "current-label": "Current Base Salary",
              "new-label": "New Base Salary"
            },
            "termination": {
              "warning-title": "This action permanently ends employment",
              "warning-desc": "Ensure all offboarding steps are completed before saving. This cannot be undone from this screen.",
              "voluntary-note": "Voluntary termination — employee-initiated resignation.",
              "involuntary-note": "Involuntary termination — dismissal, redundancy, or misconduct.",
              "confirm-label": "I confirm this action and understand it permanently ends employment."
            }
          }
        },
        "personal": {
          "not-set": "—",
          "edit": "Edit",
          "history": {
            "title": "Change History",
            "empty": "No changes recorded yet."
          },
          "identity": {
            "title": "Identity",
            "first-name": "First Name",
            "last-name": "Last Name",
            "preferred-name": "Preferred Name",
            "gender": "Gender",
            "dob": "Date of Birth",
            "nationality": "Nationality",
            "marital-status": "Marital Status",
            "national-id": "National ID",
            "blood-type": "Blood Type"
          },
          "gov-ids": {
            "title": "Government IDs",
            "national-id": "National ID",
            "nssf": "NSSF",
            "tax-id": "Tax ID",
            "number": "Number",
            "issued": "Issued",
            "expires": "Expires",
            "authority": "Authority",
            "never": "Never"
          },
          "contact": {
            "title": "Contact & Address",
            "section-contact": "Contact",
            "section-address": "Address",
            "email": "Personal Email",
            "mobile": "Mobile Phone",
            "alt-phone": "Alternative Phone",
            "telegram": "Telegram",
            "whatsapp": "WhatsApp",
            "linkedin": "LinkedIn",
            "current-address": "Current Address",
            "modal": {
              "title": "Edit Contact & Address",
              "subtitle": "Changes are applied immediately",
              "cancel": "Cancel",
              "save": "Save",
              "saving": "Saving…",
              "error-save-failed": "Failed to save contact info. Please try again."
            }
          },
          "family": {
            "title": "Family & Dependents",
            "col-name": "Name",
            "col-relationship": "Relationship",
            "col-dob": "DOB",
            "col-national-id": "National ID",
            "col-tax-dependent": "Tax Dependent",
            "col-status": "Status",
            "col-actions": "Actions",
            "tax-note": "Tax dependents feed the Cambodia Tax on Salary (ToS) relief calculation in Payroll.",
            "yes": "Yes",
            "no": "No",
            "empty": "No family members recorded.",
            "btn-add": "Add Member",
            "delete-confirm": "Remove this family member?",
            "modal": {
              "add-title": "Add Family Member",
              "edit-title": "Edit Family Member",
              "subtitle": "Changes are logged immediately · no approval routing",
              "field-fullname": "Full Name",
              "field-relationship": "Relationship",
              "field-dob": "Date of Birth",
              "field-phone": "Phone",
              "field-email": "Email",
              "field-dependent": "Dependent (Tax Exemption)",
              "field-emergency": "Emergency contact",
              "field-occupation": "Occupation",
              "field-note": "Note",
              "cancel": "Cancel",
              "save": "Save",
              "saving": "Saving…",
              "error-name-required": "Full name is required.",
              "error-save-failed": "Failed to save. Please try again."
            }
          },
          "emergency": {
            "title": "Emergency Contacts",
            "primary": "Primary",
            "relationship": "Relationship",
            "phone": "Phone",
            "empty": "No emergency contacts recorded.",
            "btn-add": "Add Contact",
            "delete-confirm": "Remove this emergency contact?"
          },
          "bank": {
            "title": "Bank Account Reference",
            "managed-note": "Managed by Payroll Setup — view only here.",
            "bank": "Bank",
            "account-name": "Account Name",
            "account-number": "Account Number",
            "status": "Status",
            "empty": "No bank account on record.",
            "cash-no-bank": "Cash (no bank)"
          },
          "btn-history": "History",
          "active": "Active"
        },
        "benefits": {
          "banner-intro": "Insurance, entitlements, and non-cash employee programs.",
          "banner": "Cash compensation (salary, allowances) is managed under",
          "banner-link": "Compensation",
          "insurance-title": "Insurance & Statutory Benefits",
          "add": "Add",
          "no-benefits": "No insurance or statutory benefits on record.",
          "policy-id": "Policy ID",
          "scheme": "Scheme",
          "type": "Type",
          "enrolled": "Enrolled",
          "status-active": "Active",
          "status-enrolled": "Enrolled",
          "nssf-title": "NSSF (National Social Security Fund)",
          "nssf-subtitle": "Mandatory · Health + Pension",
          "nssf-id": "NSSF ID",
          "nssf-employment-type": "Employment Type",
          "nssf-employment-status": "Employment Status",
          "nssf-in-scheme": "In-scheme",
          "dependents-title": "Dependents",
          "no-dependents": "No dependents registered.",
          "add-dependent": "Add dependent",
          "delete-insurance": "Delete insurance"
        },
        "documents": {
          "title": "Documents",
          "upload": "Upload",
          "empty": "No documents on record.",
          "options": "Document options",
          "delete": "Delete document",
          "confirm-delete": "Delete",
          "confirm-delete-warning": "This cannot be undone.",
          "confirm-delete-yes": "Yes, delete",
          "confirm-delete-no": "Cancel"
        },
        "attendance": {
          "days-worked": "Days worked (Apr)",
          "overtime": "Overtime",
          "late-missed": "Late / Missed",
          "on-leave": "On leave",
          "leave-balances": "Leave Balances",
          "annual-leave": "Annual Leave",
          "sick-leave": "Sick Leave",
          "special-leave": "Special Leave",
          "maternity": "Maternity",
          "days": "days",
          "recent-attendance": "Recent Attendance",
          "col-day": "Day",
          "col-in": "In",
          "col-out": "Out",
          "col-hours": "Hours",
          "col-notes": "Notes"
        },
        "job": {
          "current-job": "Current Job",
          "modify": "Open Employment Action",
          "position": "Position",
          "department": "Department",
          "employment-type": "Employment Type",
          "contract-type": "Contract Type",
          "reports-to": "Reports To",
          "org-unit": "Org. Unit",
          "project-client": "Project / Client",
          "hire-date": "Hire Date",
          "subordinates": "Subordinates",
          "work-location": "Work Location",
          "working-hours": "Working Hours",
          "employment-change-note": "Position, department and contract changes are governed by {term} — every modification creates an auditable event with effective date, reason, and approval trail.",
          "employment-change-term": "Employment Change",
          "start-one": "Start one →",
          "gov-menu-title": "Choose Employment Change type",
          "gov-transfer": "Transfer",
          "gov-transfer-sub": "Change department / line manager / location",
          "gov-promotion": "Promotion",
          "gov-promotion-sub": "Move to higher position / grade",
          "gov-change-type": "Change Employment Type",
          "gov-change-type-sub": "e.g. Full-time ↔ Part-time / Outsourced",
          "gov-salary": "Salary Change",
          "gov-salary-sub": "Adjust base salary or allowances",
          "gov-renew": "Renew Contract",
          "gov-renew-sub": "Extend current contract end date",
          "gov-menu-title-danger": "Offboarding",
          "gov-suspend": "Suspend",
          "gov-suspend-sub": "Temporarily pause the employment",
          "gov-terminate-involuntary": "Involuntary Termination",
          "gov-terminate-involuntary-sub": "Dismissal, redundancy, or misconduct",
          "gov-terminate-voluntary": "Voluntary Termination",
          "gov-terminate-voluntary-sub": "Employee resignation",
          "emp-change-drawer": {
            "title": "Employment Change",
            "subtitle": "Record a formal employment change for this employee",
            "field-type": "Change Type",
            "field-type-placeholder": "Select change type",
            "field-effective-date": "Effective Date",
            "field-reason": "Reason",
            "field-reason-placeholder": "Describe the reason for this change",
            "field-to-org-unit": "New Department / Position",
            "field-to-org-unit-placeholder": "e.g. Finance – Senior Accountant",
            "field-to-salary": "New Basic Salary",
            "field-to-salary-placeholder": "e.g. 1200",
            "field-new-employment-type": "New Employment Type",
            "field-new-employment-type-placeholder": "Select type",
            "field-suspend-until": "Suspended Until",
            "field-new-contract-end-date": "New Contract End Date",
            "warning-destructive-title": "This action affects employment status",
            "warning-destructive-body": "Please review carefully before saving. This change will be recorded in the employee's employment history.",
            "confirm-destructive": "I confirm this action is approved and correctly recorded",
            "error-type-required": "Please select a change type",
            "error-date-required": "Effective date is required",
            "error-reason-required": "Please provide a reason",
            "error-confirm-required": "Please confirm this action before saving",
            "error-no-contract": "No active contract found — please create a contract first",
            "error-salary-numeric": "Salary must be a valid number",
            "error-save-failed": "Failed to save. Please try again.",
            "cancel": "Cancel",
            "save": "Save Change",
            "saving": "Saving…",
            "type": {
              "TRANSFER": "Transfer",
              "PROMOTE": "Promotion",
              "SALARY_CHANGE": "Salary Change",
              "SALARY_INCREASE": "Salary Increase",
              "CHANGE_EMPLOYMENT_TYPE": "Change Employment Type",
              "INVOLUNTARY_TERMINATION": "Involuntary Termination",
              "VOLUNTARY_TERMINATION": "Voluntary Termination",
              "DEMOTE": "Demotion",
              "REDESIGNATION": "Redesignation",
              "SUSPEND": "Suspend",
              "RENEW": "Renew Contract",
              "Unknown": "Unknown Change"
            }
          }
        },
        "overview": {
          "tenure": "Tenure",
          "status": "Status",
          "current-package": "Current package",
          "recurring-month": "Recurring / month",
          "reports-to": "Reports To",
          "no-manager": "No line manager assigned",
          "compliance": "Compliance",
          "nssf-enrolled": "NSSF enrolled",
          "not-enrolled": "Not enrolled",
          "tax-declaration": "Tax (ToSI) declaration filed",
          "contract-signed": "Contract signed",
          "health-check-due": "Annual health check due",
          "quick-facts": "Quick Facts",
          "working-hours": "Working Hours",
          "workspace": "Workspace",
          "time-zone": "Time Zone",
          "language": "Language",
          "personal-info": "Personal Information",
          "view-full-personal": "View Full Personal Information →",
          "nationality": "Nationality",
          "personal-phone": "Personal Phone",
          "personal-email": "Personal Email",
          "emergency-contact": "Emergency Contact"
        },
        "external": {
          "chip": "External Staff",
          "personal-info": "Personal Information",
          "latin-name": "Latin Name",
          "native-name": "Native Name",
          "gender": "Gender",
          "status": "Status",
          "reporting-structure": "Reporting & Team Structure",
          "org-unit": "Organizational Unit",
          "role": "Role",
          "report-to-role": "Report To Role",
          "subordinates": "Subordinates",
          "line-manager": "Line Manager",
          "no-manager": "No line manager assigned",
          "view-subordinates": "View"
        },
        "subordinates-modal": {
          "title": "Subordinates",
          "search-placeholder": "Search by keyword…",
          "col-name": "Full Name",
          "col-code": "Employee ID",
          "col-status": "Status",
          "col-org-unit": "Org. Unit",
          "col-position": "Position",
          "empty": "No subordinates found.",
          "no-match": "No subordinates match \"{query}\".",
          "loading": "Loading subordinates…",
          "error": "Failed to load subordinates.",
          "retry": "Retry",
          "showing-range": "Showing {from}–{to} of {total}",
          "rows-per-page": "Rows per page",
          "prev": "Previous page",
          "next": "Next page"
        },
        "journey": {
          "title": "Employment Journey",
          "subtitle": "Lifecycle timeline of every Employment Change event · system of record for audit",
          "empty": "No employment change events on record.",
          "reason-label": "Reason",
          "doc-label": {
            "promote": "View promotion letter",
            "transfer": "View transfer letter",
            "salary": "View salary amendment letter",
            "change-employment-type": "View employment type change letter",
            "termination": "View termination letter",
            "joined": "View employment contract",
            "probation-passed": "View probation confirmation",
            "default": "View supporting letter"
          },
          "kpi": {
            "total": "total events",
            "years": "years",
            "pending": "pending"
          },
          "state": {
            "applied": "applied",
            "pending": "pending"
          },
          "event-type": {
            "joined": "Joined Company",
            "probation-passed": "Probation Passed"
          },
          "event": {
            "hired-summary": "Initial hire",
            "hired-reason": "Initial recruitment",
            "probation-summary": "Probation period completed · confirmed in role",
            "probation-reason": "Successful probation review"
          }
        },
        "identity-modal": {
          "title": "Edit Identity",
          "subtitle": "Update name, gender, and work contact details",
          "section-latin": "Latin Name",
          "section-native": "Native Name",
          "section-work-contacts": "Work Contacts",
          "field-latin-first": "First Name",
          "field-latin-last": "Last Name",
          "field-nickname": "Nickname",
          "field-gender": "Gender",
          "field-native-first": "First Name (Native)",
          "field-native-last": "Last Name (Native)",
          "field-work-email": "Work Email",
          "field-work-phone": "Work Phone",
          "section-personal": "Personal Details",
          "field-dob": "Date of Birth",
          "field-nationality": "Nationality",
          "field-marital-status": "Marital Status",
          "field-national-id": "National ID",
          "field-national-id-placeholder": "e.g. 012345678",
          "field-blood-type": "Blood Type",
          "loading": "Loading…",
          "no-results": "No results",
          "pim-note": "",
          "audit-note": "Changes are logged for audit.",
          "save": "Save",
          "cancel": "Cancel",
          "saving": "Saving…",
          "error-name-required": "First name and last name are required.",
          "error-save-failed": "Failed to save. Please try again."
        },
        "document-modal": {
          "title": "Upload Document",
          "drop-zone-label": "Click or drag a file here to upload",
          "drop-zone-cta": "Drag & drop a file here",
          "drop-zone-hint": "or click to browse · PDF, DOC, JPG, PNG accepted",
          "field-name": "Filename",
          "field-name-placeholder": "e.g. Performance review 2026.pdf",
          "field-group": "Document Group",
          "field-group-placeholder": "Select group",
          "group-personal": "Personal",
          "group-spouse": "Spouse",
          "group-children": "Children",
          "field-description": "Description",
          "field-description-placeholder": "Brief note about this document",
          "info-banner": "Filename and document group are required so HR can find and categorise it later.",
          "upload": "Upload",
          "cancel": "Cancel",
          "uploading": "Uploading…",
          "field-type": "Document Type",
          "field-type-placeholder": "Select document type",
          "field-fam-member": "Family Member",
          "field-fam-member-placeholder": "Select child",
          "no-spouse": "No spouse on record for this employee.",
          "no-children": "No children on record for this employee.",
          "error-file-required": "Please select a file to upload.",
          "error-name-required": "Filename is required.",
          "error-group-required": "Please select a document group.",
          "error-type-required": "Please select a document type.",
          "error-fam-required": "Please select a family member.",
          "error-upload-failed": "Upload failed. Please try again."
        },
        "contract-modal": {
          "title-create": "New Contract",
          "title-edit": "Edit Contract",
          "subtitle": "Define contract type, dates, and compensation",
          "section-type": "Contract Type",
          "section-dates": "Dates",
          "section-compensation": "Compensation",
          "field-type": "Contract Type",
          "field-type-placeholder": "Select contract type",
          "field-employment-type": "Employment Type",
          "field-employment-type-placeholder": "Select employment type",
          "field-start": "Start Date",
          "field-end": "End Date (leave blank for open-ended)",
          "field-probation-start": "Probation Start",
          "field-probation-end": "Probation End",
          "field-salary": "Basic Salary",
          "field-salary-placeholder": "Monthly amount",
          "save": "Save",
          "cancel": "Cancel",
          "saving": "Saving…",
          "error-type-required": "Contract type is required.",
          "error-start-required": "Start date is required.",
          "error-salary-numeric": "Salary must be a number.",
          "error-save-failed": "Failed to save. Please try again."
        },
        "insurance-modal": {
          "title-add": "Add Insurance",
          "title-edit": "Edit Insurance",
          "subtitle": "Private health, life, and supplementary insurance plans",
          "field-type": "Insurance Type",
          "field-type-placeholder": "Select type",
          "field-policy-id": "Policy ID",
          "field-policy-id-placeholder": "Policy reference number",
          "field-insurer": "Insurer Name",
          "field-insurer-placeholder": "e.g. Prudential",
          "field-scheme": "Scheme",
          "field-scheme-placeholder": "e.g. Premium Plan",
          "loading": "Loading…",
          "no-results": "No results",
          "field-employment-type": "Employment Type",
          "field-employment-type-placeholder": "Select employment type",
          "field-employment-type-formal": "Formal (ក្នុងប្រព័ន្ធ)",
          "field-employment-type-informal": "Informal (ក្រៅប្រព័ន្ធ)",
          "field-employment-status": "Employment Status",
          "field-employment-status-placeholder": "Select employment status",
          "field-employment-status-active": "Active (កំពុងធ្វើការ)",
          "field-employment-status-maternity": "Maternity Leave (លំហែរមាតុភាព)",
          "field-employment-status-sickness": "Sickness Treatment (កំពុងព្យាបាលជំងឺ)",
          "save": "Save",
          "cancel": "Cancel",
          "saving": "Saving…",
          "confirm-delete": "Delete this insurance record? This cannot be undone.",
          "confirm-delete-yes": "Yes, delete",
          "confirm-delete-no": "Cancel",
          "error-type-required": "Insurance type is required.",
          "error-policy-required": "Policy ID is required.",
          "error-save-failed": "Failed to save. Please try again."
        },
        "employment-action-modal": {
          "title": "Employment Change",
          "subtitle": "All changes create an auditable event in the Employment Journey",
          "field-type": "Change Type",
          "field-type-placeholder": "Select change type",
          "field-effective-date": "Effective Date",
          "field-reason": "Reason",
          "field-reason-placeholder": "Describe the reason for this change",
          "field-to-salary": "New Basic Salary",
          "field-to-salary-placeholder": "Monthly amount",
          "field-to-org-unit": "To Org. Unit / Department",
          "field-to-org-unit-placeholder": "e.g. Engineering",
          "field-new-employment-type": "New Employment Type",
          "type": {
            "PROMOTE": "Promotion",
            "TRANSFER": "Transfer",
            "SALARY_CHANGE": "Salary Change",
            "CHANGE_EMPLOYMENT_TYPE": "Change Employment Type",
            "INVOLUNTARY_TERMINATION": "Involuntary Termination",
            "VOLUNTARY_TERMINATION": "Voluntary Termination"
          },
          "save": "Submit",
          "cancel": "Cancel",
          "saving": "Submitting…",
          "warning-destructive-title": "This action affects employment status",
          "confirm-destructive": "I confirm this action is approved and correctly recorded",
          "error-type-required": "Please select a change type.",
          "error-date-required": "Effective date is required.",
          "error-reason-required": "Reason is required.",
          "error-confirm-required": "Please confirm this action before saving.",
          "error-no-contract": "No active contract found for this employee.",
          "error-salary-numeric": "Salary must be a number.",
          "error-save-failed": "Failed to submit. Please try again."
        },
        "renew-contract-modal": {
          "title": "Renew Contract",
          "subtitle": "{name} · Current contract: {type}",
          "banner": "This will create a new contract record. The previous contract will remain in All Contracts history.",
          "field-type": "New Contract Type",
          "field-type-placeholder": "Select contract type",
          "field-employment-type": "Employment Type",
          "field-start-date": "Start Date",
          "field-start-date-hint": "Automatically set to the day after the current contract ends.",
          "field-end-date": "End Date",
          "field-salary": "Basic Salary",
          "field-salary-placeholder": "e.g. 1200",
          "field-position": "Position (Org Chart)",
          "field-position-placeholder": "Select a vacant position",
          "field-position-hint": "Optional — links this contract to a vacant position in the org chart.",
          "position-loading": "Loading positions…",
          "position-empty": "No vacant positions available.",
          "field-reason": "Reason",
          "field-reason-placeholder": "Reason for renewal",
          "error-start-required": "Start date is required.",
          "error-end-required": "End date is required for this contract type.",
          "error-end-after-start": "End date must be after the start date.",
          "error-reason-required": "Reason is required.",
          "error-save-failed": "Failed to save. Please try again.",
          "cancel": "Cancel",
          "back": "Back",
          "next": "Next",
          "confirm": "Confirm & Renew",
          "confirming": "Renewing…",
          "save": "Renew Contract",
          "saving": "Saving…",
          "step-1": "Contract",
          "step-2": "Annual Leave",
          "step-3": "Review",
          "al-heading": "Annual Leave Setup",
          "al-description": "Specify how to handle the remaining leave balance from the previous contract.",
          "al-current-balance": "Current AL Balance",
          "al-current-taken": "AL Taken",
          "al-entitlement-preview-heading": "AL Entitlement Preview",
          "al-entitled-this-contract": "AL Entitled Under This Contract",
          "al-seniority-bonus": "Seniority Bonus",
          "al-entitlement-as-of": "As of {date}, based on the company's Leave policy",
          "al-days": "days",
          "al-carry-forward-label": "Carry forward remaining AL balance?",
          "al-carry-forward-yes": "Yes, carry forward",
          "al-carry-forward-no": "No, reset to zero",
          "al-prev-amount": "AL Balance to Carry Forward",
          "al-prev-amount-hint": "Days of annual leave balance to carry into the new contract.",
          "al-taken": "AL Taken This Period",
          "al-taken-hint": "Days of annual leave already taken during the current contract period.",
          "review-heading": "Review & Confirm",
          "review-description": "Please review the renewal details before confirming.",
          "review-contract": "Contract Details",
          "review-al": "Annual Leave Setup",
          "review-type": "Contract Type",
          "review-employment-type": "Employment Type",
          "review-start-date": "Start Date",
          "review-end-date": "End Date",
          "review-salary": "Basic Salary",
          "review-position": "Position",
          "review-position-none": "Not specified",
          "review-reason": "Reason",
          "review-carry-forward": "Carry Forward AL",
          "review-carry-amount": "Carry Forward Amount",
          "review-al-taken": "AL Taken",
          "error-al-setup-failed": "Contract created. Annual leave setup could not be completed — please configure it manually in the Compensation tab."
        },
        "new-contract-modal": {
          "title": "New Contract",
          "subtitle": "{name} · First contract setup",
          "confirm": "Confirm & Create"
        },
        "rehire-contract-modal": {
          "title": "Rehire Employee",
          "subtitle": "{name} · Former contract: {type}",
          "banner": "This will create a new contract for a returning employee. Their prior contract remains in All Contracts history.",
          "error-start-overlaps": "Start date must be after the employee's previous contract ended.",
          "error-start-no-gap": "This start date immediately follows the previous contract's end date — that's a Renewal, not a Rehire. Use Renew Contract, or pick a later start date if there was an actual employment gap.",
          "confirm": "Confirm & Rehire"
        },
        "contract-event-modal": {
          "title": "New Contract Event",
          "subtitle": "{name} · Current contract: {type} · Phase 1 · recording only",
          "policy-banner-prefix": "is currently on a",
          "policy-banner-suffix": "contract.",
          "badge-not-terminated": "Available after termination",
          "badge-pending-contract": "Pending contract already exists",
          "cancel": "Cancel",
          "back": "Back",
          "save": "Save Record",
          "saving": "Saving…",
          "policy-note": {
            "UDC": "UDC is open-ended · no renewal/extension applies. Amendment for mid-term changes; Termination to end the contract.",
            "FDC": "FDC term-based · can be renewed, extended, converted to UDC, amended mid-term, or terminated. Cambodia Labour Law caps total FDC duration at 2 years.",
            "Probation": "During probation · confirm (pass), extend (need more time), convert to FDC/UDC after passing, or terminate.",
            "Internship": "Internship · convert to FDC/UDC if hiring, otherwise terminate at end of internship.",
            "Outsourcing Service": "Outsourcing Service contract · amend scope/terms or terminate engagement. Renewal handled by vendor SOW.",
            "none": "No current contract on file · only New Contract applies. Use this for first contract on hire."
          },
          "type": {
            "new_contract": {
              "label": "New Contract",
              "desc": "First contract on hire (or contract restart after gap)",
              "date-label": "Contract Start Date"
            },
            "contract_renewal": {
              "label": "Contract Renewal",
              "desc": "FDC or UDC renewed for a new term",
              "date-label": "Renewal Effective Date"
            },
            "rehire": {
              "label": "Rehire Employee",
              "desc": "Bring a former employee back under a new contract",
              "date-label": "Rehire Start Date"
            },
            "contract_extension": {
              "label": "Contract Extension",
              "desc": "Existing contract extended within current term",
              "date-label": "Extension Start Date"
            },
            "contract_conversion": {
              "label": "Contract Conversion",
              "desc": "Change contract type (e.g. FDC → UDC)",
              "date-label": "Conversion Effective Date"
            },
            "contract_amendment": {
              "label": "Contract Amendment",
              "desc": "Mid-term amendment (hours, location terms, clauses)",
              "date-label": "Amendment Effective Date"
            },
            "probation_confirmation": {
              "label": "Probation Confirmation",
              "desc": "Probation passed · employee confirmed",
              "date-label": "Confirmation Date"
            },
            "probation_extension": {
              "label": "Probation Extension",
              "desc": "Probation extended for additional period",
              "date-label": "New Probation End Date"
            },
            "termination_record": {
              "label": "Termination Record",
              "desc": "Administrative termination record",
              "date-label": "Effective Termination Date"
            }
          },
          "form": {
            "subtitle": "Record this contract change · Phase 1",
            "phase1-label": "Phase 1 · Recording only.",
            "phase1-desc": "Record the offline contract change (signed memo / letter). Approval workflow comes in Phase 2.",
            "field-new-contract-type": "New Contract Type",
            "field-new-end-date": "New End Date",
            "field-new-end-date-hint": "Required for FDC contracts.",
            "field-new-probation-end-date": "New Probation End Date",
            "field-probation-originally-ended": "Probation Originally Ended",
            "field-reason": "Reason / Notes",
            "field-reason-placeholder": "Why this contract change?",
            "field-doc-ref": "Document Reference",
            "field-doc-ref-placeholder": "Filename / reference (e.g., ContractRenewal-2026-007.pdf)",
            "file-upload-phase2": "File attachment — Phase 2",
            "field-offline-approval": "Offline Approval",
            "offline-approval-label": "Offline approval completed — signed offline by LM / HR / Employee",
            "field-offline-notes": "Offline Approval Notes",
            "field-offline-notes-placeholder": "Notes — e.g., Signed by employee 2026-06-28, filed in personnel file",
            "error-date-required": "Effective date is required.",
            "error-reason-required": "Reason / Notes is required.",
            "error-save-failed": "Failed to save. Please try again.",
            "validation-summary-invalid": "✗ Effective date and reason are required",
            "validation-summary-ok": "✓ Ready to save · status will be {status}",
            "status-scheduled": "Scheduled",
            "status-effective": "Effective"
          }
        },
        "schedule": {
          "title": "Work schedule",
          "none": "Not on a work schedule",
          "assign": "Assign",
          "change": "Change",
          "end": "End",
          "history": "View history",
          "hide-history": "Hide history",
          "hours": "{h} h/week",
          "since": "Since {date}",
          "history-title": "Previous schedules",
          "history-empty": "No previous schedules.",
          "loading": "Loading work schedule…",
          "error": "Couldn't load the work schedule.",
          "retry": "Retry",
          "unknown-template": "Removed schedule",
          "from": "From {date}",
          "until": "until {date}",
          "upcoming-label": "Upcoming:",
          "upcoming-from": "from {date}"
        }
      },
      "batch-import": {
        "title": "Import Employees",
        "subtitle": "Batch import employees from Excel with validation and duplicate detection.",
        "tab": {
          "new-import": "New Import",
          "history": "Import History"
        },
        "steps": {
          "upload": "Upload file",
          "validation": "Validation",
          "confirm": "Confirm"
        },
        "mode": {
          "label": "Import Mode",
          "add-label": "Add new only",
          "add-desc": "Create new employee records. Leave Employee Code blank to have one assigned; a code that already exists in this company is refused.",
          "update-label": "Update existing",
          "update-desc": "Update existing records by Employee Code. Rows without a valid Employee Code cannot be updated.",
          "note": "For updates, Employee Code is the unique matching key. The system will not match by name, email, or phone to avoid incorrect updates.",
          "replace-label": "Add or update",
          "replace-desc": "Employee Code is required on every row. A row whose code already exists updates that employee; a row with a new code adds a new employee. Nobody is removed."
        },
        "upload": {
          "tip": "New here? Download the template first to see required columns, then fill in your employees and drop the file back here.",
          "tip-link": "Download the template",
          "download-template": "Download template",
          "export-existing": "Export existing employees",
          "drop-label": "Drop your file here, or click to browse",
          "drop-hint": "Excel (.xlsx) · up to 5 MB · max 5,000 rows · preview shows first 500",
          "remove": "Remove file",
          "preview-truncated": "Preview limited to {cap} of {total} rows — the full file will be validated server-side."
        },
        "validation": {
          "col-errors": "Column Errors",
          "total": "Total: {n}",
          "valid": "Valid: {n}",
          "invalid": "Invalid: {n}",
          "warnings": "Warnings: {n}",
          "status": "Status",
          "issues": "Issues",
          "export-result": "Export result",
          "required": "required",
          "issues-expand": "{n} issues — click to expand",
          "show-less": "Show less"
        },
        "confirm": {
          "summary": "Ready to import",
          "mode": "Mode",
          "rows": "Total rows",
          "valid": "Valid",
          "invalid": "Invalid (will be skipped)",
          "dl-results": "Import Results",
          "dl-original": "Original File",
          "errors-label": "Import Errors ({n})",
          "dl-sign-ins": "Requested sign-ins",
          "blocked-no-valid": "No valid rows to import. Fix the file and validate again.",
          "blocked-has-errors": "{n} row(s) have errors. Fix them and validate again before importing."
        },
        "progress": {
          "completed": "Import complete",
          "completed-errors": "Import completed with errors",
          "failed": "Import failed",
          "in-progress": "Importing employees…",
          "detail": "{succeeded} of {total} imported successfully",
          "error-msg": "Import encountered an error.",
          "processing": "Processing {done} of {total}…",
          "detail-failed-suffix": ", {failed} failed"
        },
        "row": {
          "pending": "Pending",
          "valid": "Valid",
          "invalid": "Invalid",
          "warning": "Warning"
        },
        "history": {
          "loading": "Loading import history…",
          "empty": "No import history yet.",
          "completed": "Completed",
          "completed-errors": "Completed with errors",
          "failed": "Failed",
          "imported": "imported",
          "failed-rows": "failed",
          "batch-id": "Batch ID",
          "results": "Results",
          "dl-original": "Original Upload",
          "dl-results": "Import Results",
          "processing": "Processing",
          "processing-note": "Import in progress — files will be available once complete.",
          "results-detail": "{succeeded} succeeded, {failed} failed / {total} total",
          "dl-sign-ins": "Requested sign-ins"
        },
        "btn": {
          "back": "Back",
          "done": "Done"
        },
        "next": {
          "validation": "Next: Validation",
          "confirm": "Next: Confirm",
          "import": "Import"
        },
        "error": {
          "invalid-format": "Please select a valid .xlsx file.",
          "file-too-large": "File exceeds 5 MB limit. Please choose a smaller file.",
          "empty-file": "The uploaded file has the correct format but contains no employee records.",
          "template-mismatch": "The uploaded file does not match the expected template format.",
          "missing-columns": "Missing columns",
          "unexpected-columns": "Unexpected columns",
          "read-failed": "Could not read the file. Please check the file format.",
          "validation-failed": "Validation failed. Please try again.",
          "import-failed": "Import failed. Please try again.",
          "download-failed": "Failed to download file. The file may not be available yet.",
          "template-failed": "Failed to download template. Please try again.",
          "export-failed": "Failed to export employees. Please try again.",
          "import-timeout": "Import is taking longer than expected. Check Import History for the final result."
        },
        "instructions": {
          "title": "Instructions & Requirements",
          "general": "General",
          "no-delete-headers": "Do not delete rows at the top or edit any column headers — the system may not understand the format of your uploaded file.",
          "required-cols": "Columns marked with an asterisk (*) are required. Validation will check for completeness, data types, and formatting.",
          "max-size": "Maximum file size: 5 MB.",
          "unique-note": "Employee_code, National_ID and NSSF_ID must not repeat within the file. Employee_code and National_ID are also checked against the employees already in this company.",
          "dates": "Date Columns",
          "date-format": "Enter all dates in ISO format: YYYY-MM-DD (e.g., 2022-10-25).",
          "key-cols": "Key Column Notes",
          "employee-code": "Employee_code — In \"Add new only\", leave it empty to have a code assigned, or enter a code nobody in this company has yet. In \"Update existing\" and \"Add or update\" it is required. A code cannot start with G:.",
          "contract-type": "Contract_type — Enter UDC, FDC, PROBATION, or INTERNSHIP.",
          "contract-end-date": "Contract_end_date — Optional. Enter it for contracts with a fixed end (FDC, PROBATION, INTERNSHIP) and leave it empty for UDC. The import does not require it, so check it before uploading.",
          "report-to": "Report_to — The Employee_code of the line manager: an existing employee or someone in the same file. Leave it empty only for the one person at the top of the company. A group commission code (G:SHORT:001) places the row under that manager's seat.",
          "username": "Username / User_email — Required. They are recorded as requested sign-ins and listed in the \"Requested sign-ins\" file after the import. No account is created and no email is sent; to give someone a sign-in, use Add User in Admin › Users & Roles. User_email is also used as the work email when Work_contact_email is empty.",
          "repeatable": "Repeatable Column Sets",
          "repeatable-note": "Some columns can repeat. Add another copy of the header ending in _2, _3 and so on (for example Child_full_name_2):",
          "not-saved": "These columns, and the NSSF, bank, spouse, Available_AL_balance and Remark columns, are checked for format but are not saved by the import yet."
        }
      },
      "add-person": {
        "prefill": {
          "banner": "Filling {position}",
          "change": "Change",
          "not-found": "That position isn't an open seat in this company. Pick a vacancy on the Contract step.",
          "filled": "That position is no longer vacant — someone already holds it. Pick another vacancy on the Contract step.",
          "frozen": "That position is frozen. Unfreeze it on the Org Chart, or pick another vacancy on the Contract step.",
          "cancelled": "That position was cancelled. Pick another vacancy on the Contract step.",
          "load-failed": "Couldn't check that position right now. Pick the vacancy on the Contract step."
        }
      }
    },
    "common": {
      "cancel": "Cancel",
      "save": "Save",
      "edit": "Edit",
      "retry": "Retry",
      "confirm": "Confirm",
      "yes": "Yes",
      "no": "No",
      "remove": "Remove",
      "create": "Create",
      "clear": "Clear",
      "clear-all": "Clear all",
      "previous": "Previous",
      "next": "Next"
    },
    "organization": {
      "title": "Organization",
      "tabs": {
        "profile": "Profile",
        "structure": "Structure",
        "sites": "Sites",
        "outsourcing": "Outsourcing"
      },
      "kind": {
        "company": "Company",
        "os_client": "Client",
        "os_vendor": "Vendor",
        "os_project": "Project",
        "unknown": "Unknown"
      },
      "structure": {
        "org-units": "Org Units",
        "org-chart": "Org Chart",
        "positions": "Positions",
        "workforce-plan": "Workforce Plan",
        "grades": "Job Grades",
        "job-titles": "Job Titles",
        "job-profiles": "Job Profiles"
      },
      "profile": {
        "edit": "Edit",
        "edit-title": "Edit company",
        "industry": "Industry",
        "employee-id-format": "Employee ID format",
        "website": "Website",
        "address": "Address",
        "primary-contact": "Primary contact"
      },
      "form": {
        "company-full-name": "Company full name",
        "company-short-name": "Company short name",
        "project-full-name": "Project full name",
        "project-short-name": "Project short name",
        "short-name-hint": "Used as a compact label and as the employee ID prefix.",
        "client": "Client",
        "client-none": "No parent client",
        "employee-id-format": "Employee ID format",
        "employee-id-format-hint": "Defaults to <short name>-000000. Editable.",
        "industry": "Industry",
        "website": "Website",
        "address": "Address",
        "primary-contact": "Primary contact",
        "contact-name": "Name",
        "contact-email": "Email",
        "contact-phone": "Phone",
        "notes": "Notes",
        "create": "Create",
        "errors": {
          "full-name": "Name is required.",
          "email": "Enter a valid email address."
        },
        "outsourcing-client-flag": "Is this an outsourcing client?",
        "outsourcing-client-hint": "Mark this company as an outsourcing client. You manage their projects, staff, and external approvers.",
        "outsourcing-vendor-flag": "Is this an outsourcing vendor?",
        "outsourcing-vendor-hint": "Mark this company as an outsourcing vendor. You track their workers operationally; the vendor runs payroll."
      },
      "outsourcing": {
        "shell-title": "Outsourcing",
        "shell-desc": "Manage outsourcing clients or vendors, their projects, and external approvers from here.",
        "shell-note": "Coming soon.",
        "clients-title": "Clients",
        "clients-section-desc": "Outsourcing customers you provide staff to. Add a client when you take on a new outsourcing engagement.",
        "vendors-title": "Vendors",
        "vendors-section-desc": "Outsourcing providers who supply staff to you. Add a vendor when you start sourcing staff from a new provider.",
        "add-client": "Add Client",
        "add-vendor": "Add Vendor",
        "create-subtitle": "Outsourcing details auto-provision a full, independent config set.",
        "search-label": "Search",
        "search-placeholder": "Search by name, contact, industry…",
        "showing-clients": "Showing {filtered} of {total} clients",
        "showing-vendors": "Showing {filtered} of {total} vendors",
        "empty-clients": "No clients yet. Add your first outsourcing client.",
        "empty-vendors": "No vendors yet. Add your first outsourcing vendor.",
        "empty-filtered": "No counterparties match the current search.",
        "error": "Failed to load this list.",
        "error-403": "You don't have access to this list.",
        "back-clients": "Back to Clients",
        "back-vendors": "Back to Vendors",
        "projects-title": "Projects",
        "approvers-title": "Approvers",
        "projects-empty": "No projects under this counterparty yet.",
        "projects-error": "Failed to load projects.",
        "back-to-projects": "Back to projects",
        "project-under": "Under {parent}",
        "positions-title": "Positions",
        "positions-count": "{filled} filled · {vacant} vacant · {total} total",
        "positions-empty": "This project's org chart has no positions yet.",
        "positions-error-title": "Couldn't load positions",
        "positions-error-desc": "Something went wrong loading this project's org chart.",
        "position-vacant": "Vacant",
        "position-untitled": "Untitled position",
        "add-project": "Add Project",
        "edit-project": "Edit project",
        "detail-error-title": "Couldn't load this counterparty",
        "detail-error-desc": "Something went wrong fetching the details. Try again.",
        "toasts": {
          "created": "\"{name}\" created.",
          "create-failed": "Could not create. Try again.",
          "saved": "Changes saved.",
          "save-failed": "Could not save. Try again.",
          "project-created": "Project \"{name}\" created.",
          "project-saved": "Project saved.",
          "project-failed": "Could not save the project. Try again."
        },
        "oversight-title": "Executive Oversight"
      },
      "approvers": {
        "title": "External Approvers",
        "invite": "Invite approver",
        "explainer": "An external approver is a client-side line manager placed into a vacant role in this project's org chart. They approve leave and attendance for the project's staff. Inviting one emails them an Accept link; accepting provisions an ESS sign-in scoped to this project.",
        "counterparty-explainer": "External approvers are client-side line managers placed into vacant roles in your projects' org charts. They approve leave and attendance for project staff. The same person can oversee several projects; each placement is set up per project. Inviting one emails an Accept link that provisions an ESS sign-in scoped to that project.",
        "oversees": "Oversees {n} project(s)",
        "edit-in-project": "Edit placement in {project}",
        "target-project": "Project",
        "target-project-placeholder": "Choose which project to place the approver in",
        "empty-no-projects": "Add a project first, then invite approvers to oversee it.",
        "search-placeholder": "Search by name, code, email, phone…",
        "showing": "{n} approver(s)",
        "empty": "No external approvers yet. Invite one to approve requests for this counterparty's projects.",
        "empty-filtered": "No approvers match your filters.",
        "error": "Couldn't load approvers.",
        "filters": {
          "all": "All"
        },
        "status": {
          "active": "Active",
          "invited": "Invited",
          "inactive": "Inactive",
          "unknown": "Unknown"
        },
        "invite-modal": {
          "title": "Invite external approver"
        },
        "edit": {
          "title": "Edit external approver",
          "status": "Status"
        },
        "form": {
          "latin-name": "Latin name",
          "latin-name-placeholder": "e.g. Sok Somnang",
          "native-name": "Native name",
          "native-name-placeholder": "e.g. សុខ សំណាង",
          "gender": "Gender",
          "gender-male": "Male",
          "gender-female": "Female",
          "email": "Work email",
          "email-placeholder": "e.g. name\\@client.com",
          "phone": "Phone number",
          "phone-placeholder": "e.g. 012 345 678",
          "placement-heading": "Org-chart placement",
          "org-unit": "Organizational unit",
          "org-unit-placeholder": "Select an org unit",
          "report-to": "Report to role",
          "report-to-placeholder": "Select who they report to",
          "report-to-none": "(Report to no one)",
          "position": "Role",
          "position-placeholder": "Select a vacant role",
          "position-hint": "These are unfilled roles in this project's org chart. If a role isn't listed, create it first in the org-chart screen.",
          "create": "Create"
        },
        "toasts": {
          "invite-sent": "External approver created — an invite was emailed.",
          "invite-failed": "Could not create the approver. Try again.",
          "saved": "Saved changes.",
          "save-failed": "Could not save. Try again."
        }
      },
      "error": {
        "title": "Couldn't load this company",
        "desc": "Something went wrong fetching the company details. Try again."
      },
      "no-company": {
        "title": "No company selected",
        "desc": "Pick a company from the switcher to view its profile, policies, and structure."
      },
      "company-form": {
        "drawer-title": "Create new company",
        "drawer-subtitle": "Add a new company under your tenant. It will appear in the scope switcher once created.",
        "emails": "Email addresses",
        "email-n": "Email #{n}",
        "add-email": "Add another email",
        "phones": "Phone numbers",
        "phone-n": "Phone #{n}",
        "add-phone": "Add another phone",
        "representatives": "Representatives",
        "representative-n": "Representative #{n}",
        "add-representative": "Add another representative",
        "toasts": {
          "created": "\"{name}\" created.",
          "create-failed": "Could not create the company. Try again."
        },
        "base-location": {
          "legend": "Primary base location",
          "name": "Location name",
          "name-placeholder": "e.g. Head Office",
          "address": "Address",
          "address-placeholder": "Street, building, district…",
          "coordinates": "Coordinates (latitude, longitude)",
          "coordinates-hint": "Set by clicking or dragging the pin on the map, or type them directly.",
          "map-label": "Map — click or drag the pin to set the location",
          "error": "A location name and a valid coordinate are required."
        }
      },
      "org-chart-editor": {
        "title": "Org Chart",
        "subtitle": "Build and edit positions and reporting lines for this company.",
        "canvas-title": "Org Chart",
        "layer-1": "Layer 1",
        "info-banner": "shows every position and its reporting line. Use a position’s menu to fill, edit, move, swap, freeze or cancel it. Pan by dragging the canvas; zoom with the wheel or toolbar.",
        "vacant": "Vacant",
        "untitled": "Untitled position",
        "actions-menu": "Position actions",
        "actions-for": "Position actions",
        "expand": "Expand",
        "collapse": "Collapse",
        "search-ph": "Search position, unit, or person…",
        "error-header": "Org chart",
        "status": {
          "active": "Active",
          "pending": "Pending",
          "probation": "Probation",
          "on-leave": "On leave",
          "inactive-vacant": "Inactive / Vacant"
        },
        "counter": {
          "vacant": "Vacant {n}",
          "disabled": "Disabled {n}"
        },
        "nav": {
          "title": "Position Navigation",
          "hint": "Click to focus a sub-tree",
          "hide": "Hide navigation",
          "show": "Show navigation",
          "short": "Nav",
          "empty": "No positions match your search."
        },
        "toolbar": {
          "show-vacancies": "Show vacancies",
          "default-view": "Default view",
          "expand-all": "Expand all",
          "collapse-all": "Collapse all",
          "zoom-out": "Zoom out",
          "zoom-in": "Zoom in",
          "zoom-100": "Reset to 100%",
          "zoom-fit": "Fit to screen",
          "reset-zoom": "Reset pan & zoom",
          "reset-focus": "Back to full chart"
        },
        "chart": {
          "showing-focused": "Showing the sub-tree under {name}. Use “Back to full chart” to exit focus."
        },
        "action": {
          "edit": "Edit position",
          "add-child": "Add child position",
          "move": "Move position",
          "delete": "Delete position",
          "disable": "Disable position",
          "enable": "Enable position",
          "swap": "Swap role",
          "manage-roles": "Manage additional roles",
          "temp-oversight-on": "Enable temporary oversight",
          "temp-oversight-off": "Disable temporary oversight"
        },
        "form": {
          "add-title": "Add child position",
          "edit-title": "Edit position",
          "org-unit": "Organizational unit",
          "org-unit-ph": "e.g. Department of Marketing",
          "reports-to": "Reports to",
          "top-most": "Top-most position",
          "job-title": "Job title",
          "job-title-ph": "e.g. Software Engineer",
          "base-location": "Base location",
          "base-location-ph": "Select a base location",
          "base-location-loading": "Loading locations…",
          "base-location-empty": "No base locations defined",
          "advanced": "Advanced update options",
          "cascade-org-unit": "Also apply this org unit to all child positions.",
          "cascade-title": "Also update other positions using the same job title.",
          "required": "Required",
          "create": "Create",
          "code": "Position code",
          "org-unit-layer": "{name} — Layer {layer}",
          "job-title-grade": "{title} — Grade {grade}",
          "job-title-below": "Active job titles below grade {grade} (the manager position's grade).",
          "assistant": "Assistant to the line manager",
          "assistant-yes": "Yes",
          "assistant-no": "No",
          "back": "Back",
          "confirm-title": "Update confirmation",
          "confirm-ou": "This also moves 1 position below this one to the new org unit. | This also moves {n} positions below this one to the new org unit.",
          "confirm-title-count": "This also changes the job title on 1 other position. | This also changes the job title on {n} other positions.",
          "confirm-hint": "Go back to change the options, or confirm to save."
        },
        "move": {
          "title": "Move position",
          "current": "Current reporting line",
          "new": "New reporting line",
          "new-ph": "Search for a position",
          "warning": "Changing the reporting line updates the hierarchy immediately.",
          "position": "Position",
          "new-hint": "Positions below this one, its current manager, and frozen or cancelled positions can't be picked.",
          "no-results": "No matching positions",
          "empty": "There is no other position this one can report to.",
          "continue": "Continue",
          "confirm-title": "Confirm changing reporting line",
          "confirm-body": "{position} will report to {to} instead of {from}.",
          "confirm-reports": "The 1 position below it moves with it. | The {n} positions below it move with it.",
          "confirm-cta": "Move position"
        },
        "swap": {
          "title": "Swap position",
          "current": "Current occupant",
          "with": "Swap with",
          "with-ph": "Select a position",
          "reason": "Reason",
          "reason-ph": "Why are these positions being swapped?",
          "submit": "Swap",
          "with-hint": "Same grade only. Frozen and cancelled positions, and positions held by someone from another company, are not offered.",
          "empty": "There is no position at the same grade that this person can swap with.",
          "reason-too-long": "Keep the reason to {max} characters or fewer."
        },
        "manage-roles": {
          "title": "Manage additional positions",
          "lede": "Managing concurrent role assignments for {name}.",
          "primary": "Primary position",
          "additional": "Additional positions",
          "no-candidates": "No eligible vacant positions to oversee.",
          "vacant-only": "Vacant positions only",
          "reason": "Reason / justification",
          "remove-title": "Remove all additional positions",
          "remove-body": "{name} will stop heading 1 additional position. | {name} will stop heading {n} additional positions.",
          "remove-all": "Remove all additional positions",
          "remove-cta": "Remove all",
          "pick-one": "Pick at least one position.",
          "search-ph": "Search positions"
        },
        "vacant-drawer": {
          "open": "Vacant",
          "title": "Vacant positions",
          "reports-to": "Reports to",
          "subtitle": "Positions with nobody in them. Fill one, or edit it.",
          "title-scoped": "Vacant positions within {name}",
          "search-ph": "Search by position, code, org unit or location",
          "count": "{count} vacant positions",
          "count-filtered": "{count} of {total} vacant positions",
          "download": "Download Excel",
          "reports-to-line": "Reports to {name}",
          "fill": "Fill",
          "fill-aria": "Fill {name}",
          "edit": "Edit",
          "edit-aria": "Edit {name}",
          "empty": "No vacant positions.",
          "empty-search": "No vacant positions match this search.",
          "clear-search": "Clear search",
          "load-error": "We could not load the positions.",
          "retry": "Try again"
        },
        "disabled-drawer": {
          "open": "Frozen",
          "title": "Frozen positions",
          "subtitle": "Frozen positions are hidden from the chart and from every position picker. Unfreeze one to bring it back.",
          "title-scoped": "Frozen positions within {name}",
          "search-ph": "Search by position, code, org unit, location or last occupant",
          "count": "{count} frozen positions",
          "count-filtered": "{count} of {total} frozen positions",
          "download": "Download Excel",
          "last-occupant": "Last occupant: {name}",
          "frozen-at-by": "Frozen {date} by {who}",
          "frozen-at": "Frozen {date}",
          "frozen-by": "Frozen by {who}",
          "frozen-unknown": "Frozen (date not recorded)",
          "unfreeze": "Unfreeze",
          "unfreeze-aria": "Unfreeze {name}",
          "empty": "No frozen positions.",
          "empty-search": "No frozen positions match this search.",
          "clear-search": "Clear search",
          "load-error": "We could not load the positions.",
          "retry": "Try again"
        },
        "drawer": {
          "count": "{count} positions",
          "empty": "Nothing here yet."
        },
        "export": "Export",
        "toast": {
          "added": "Position added.",
          "updated": "Position updated.",
          "moved": "Reporting line updated.",
          "swapped": "Roles swapped.",
          "deleted": "Position deleted.",
          "disabled": "Position disabled.",
          "enabled": "Position enabled.",
          "oversight-disabled": "Temporary oversight disabled.",
          "oversight-soon": "Enabling temporary oversight is coming in a follow-up.",
          "save-failed": "Could not save. Please try again.",
          "cancelled": "Position cancelled.",
          "frozen": "Position frozen.",
          "unfrozen": "Position unfrozen.",
          "roles-removed": "Additional positions removed.",
          "oversight-on": "Temporary oversight turned on.",
          "oversight-off": "Temporary oversight turned off.",
          "acting-elsewhere": "{name} works for another company, so their profile opens from that company.",
          "acting-unknown": "The acting holder’s profile is not available here."
        },
        "confirm": {
          "delete-title": "Delete this position?",
          "delete-body": "This permanently removes the position from the org chart. Only vacant leaf positions can be deleted.",
          "disable-title": "Disable this position?",
          "disable-body": "The position is hidden from the chart and every position dropdown. You can re-enable it later.",
          "enable-title": "Enable this position?",
          "enable-body": "The position becomes visible in the chart and selectable again.",
          "cancel-title": "Cancel this position?",
          "cancel-body": "The position leaves the chart, the counts and every picker. It stays in Positions as Cancelled, where you can restore it.",
          "freeze-title": "Freeze this position?",
          "freeze-body": "The position is hidden from the chart and every picker until you unfreeze it.",
          "unfreeze-title": "Unfreeze this position?",
          "unfreeze-body": "The position shows on the chart and can be picked again.",
          "oversight-off-title": "Turn off temporary oversight?",
          "oversight-off-body": "{name} will no longer have an acting overseer."
        },
        "error": {
          "title": "Could not load the org chart",
          "desc": "Something went wrong fetching positions. Try again."
        },
        "empty": {
          "title": "No org chart yet",
          "desc": "This company has no positions. Add the top position to get started."
        },
        "list-export": {
          "code": "Code",
          "title": "Position Title",
          "orgUnit": "Org Unit",
          "baseLocation": "Base Location",
          "occupant": "Occupant",
          "lastOccupant": "Last Occupant",
          "status": "Status",
          "reportsTo": "Reports To",
          "frozenAt": "Frozen At",
          "frozenBy": "Frozen By",
          "failed": "The file could not be created. Please try again."
        },
        "menu": {
          "label": "Actions for {name}",
          "section": {
            "position": "Position",
            "position-vacant": "Position (vacant)",
            "employee": "Employee",
            "acting": "Acting holder"
          },
          "item": {
            "fill": "Fill position",
            "edit": "Edit position",
            "add-child": "Add child position",
            "move": "Move position",
            "manage-roles": "Manage additional positions",
            "remove-additional-roles": "Remove all additional positions",
            "oversight-on": "Turn on temporary oversight",
            "oversight-off": "Turn off temporary oversight",
            "freeze": "Freeze position",
            "unfreeze": "Unfreeze position",
            "cancel": "Cancel position",
            "history": "Edit history",
            "view-profile": "View profile",
            "promote": "Promote",
            "transfer": "Transfer",
            "redesignate": "Redesignate",
            "swap": "Swap position",
            "view-acting": "View acting holder’s profile"
          },
          "reason": {
            "init-root": "Set up this position first.",
            "top-move": "The top position has no manager to change.",
            "needs-active": "Needs an active employee in this position.",
            "oversight-vacant": "Only a vacant position can be put under temporary oversight.",
            "no-grant": "Assign executive oversight to this project first.",
            "top-freeze": "The top position can’t be frozen.",
            "top-cancel": "The top position can’t be cancelled.",
            "vacate-first": "Vacate the position first.",
            "has-reports": "Positions still report to it.",
            "oversight-first": "Turn off temporary oversight first.",
            "acting-first": "Remove the acting holder and additional positions first.",
            "external": "Held by someone from another company.",
            "acting-fill": "Someone is acting in this position."
          },
          "grant-link": "Open Executive Oversight"
        },
        "card": {
          "acting": "{name} (Temporary oversight)",
          "assistant": "Assistant",
          "headcount": "{n} direct reports",
          "double-hat": "Also heads {n} positions — highlight them",
          "orphan": {
            "missing": "Reports to a missing position — move it",
            "cancelled": "Reports to a cancelled position — move it",
            "cycle": "Its reporting line loops back on itself — move it"
          },
          "orphan-move": "Move",
          "manager-frozen": "Its manager position is frozen",
          "super-root": "{n} top positions",
          "super-root-aria": "{company} — the whole chart, not a position"
        },
        "summary": {
          "label": "Position summary",
          "active": "Active {n}",
          "vacant": "Vacant {n}",
          "frozen": "Frozen {n}",
          "within": "within {name}",
          "why-btn": "Why {n} active positions?",
          "why-title": "Why {n} active positions?",
          "why-people": "{people} people hold {n} active positions.",
          "multi": "In {n} positions:",
          "acting": "Someone is only acting in {n} positions:",
          "external": "Held by someone from another company ({n}):",
          "cancelled-link": "{n} cancelled — view in Positions",
          "refresh": "Refresh",
          "close": "Close",
          "frozen-btn": "Frozen"
        },
        "oversight": {
          "title": "Turn on temporary oversight",
          "lede": "Pick who oversees {position} while it is vacant.",
          "overseer": "Overseer",
          "search-ph": "Search overseers…",
          "loading": "Loading overseers…",
          "error": "Could not load the overseers.",
          "empty": "This project’s executive oversight lists no overseers.",
          "no-match": "No overseer matches your search.",
          "no-grant": "Assign executive oversight to this project first.",
          "save": "Turn on",
          "pick-one": "Pick an overseer."
        },
        "history": {
          "title": "Edit history",
          "fields": {
            "assistant": "Assistant",
            "double-head": "Additional positions",
            "oversight": "Temporary oversight",
            "disabled": "Frozen",
            "employee": "Employee",
            "code": "Code"
          }
        }
      },
      "oversight": {
        "showing": "Showing {filtered} of {total} assignments",
        "confirm-remove": "Remove {name} as an overseer?",
        "error": "Could not load oversight assignments.",
        "toasts": {
          "overseer-removed": "Overseer removed.",
          "remove-failed": "Could not remove overseer. Try again.",
          "assigned": "Oversight assignment saved.",
          "assign-failed": "Could not save assignment. Try again."
        }
      },
      "company": {
        "status": {
          "active": "Active",
          "inactive": "Inactive",
          "unknown": "Unknown status"
        },
        "parent": "Parent company",
        "parent-none": "None (top level)",
        "parent-hint": "Only a tenant administrator can move a company to another parent.",
        "emails": "Email addresses",
        "phones": "Phone numbers",
        "representatives": "Representatives",
        "notes": "Notes",
        "created": "Created",
        "updated": "Last updated",
        "never-updated": "Not changed since it was created",
        "by-at": "{who} · {when}",
        "history": "Edit history",
        "history-title": "Edit history — {name}",
        "id-format-locked": "Locked: employee IDs have already been issued from this format, so it can no longer change.",
        "id-format-open": "Can be changed until the first employee is added.",
        "id-format-checking": "Checking whether any employee IDs have been issued…",
        "id-format-unverified": "Could not check whether employee IDs have been issued, so the format stays locked for now.",
        "save-failed": "Could not save the company. Try again.",
        "forbidden": "You don't have permission to change this company.",
        "parent-errors": {
          "SELF_PARENT": "A company cannot be its own parent.",
          "PARENT_NOT_FOUND": "The selected parent company no longer exists. Refresh and try again.",
          "PARENT_KIND_INVALID": "The selected company cannot be a parent company (outsourcing clients, vendors and projects are not allowed).",
          "TENANT_ROOT_IMMUTABLE": "The tenant's own company cannot be moved under another company.",
          "CYCLE_DETECTED": "This change would create a loop in the company structure.",
          "DEPTH_EXCEEDED": "This change would make the company structure deeper than allowed."
        },
        "fields": {
          "Organization": "Name",
          "ParentId": "Parent company",
          "Industry": "Industry",
          "EmployeeIdFormat": "Employee ID format",
          "Website": "Website",
          "Emails": "Email addresses",
          "PhoneNumbers": "Phone numbers",
          "Representatives": "Representatives",
          "Address": "Address",
          "Notes": "Notes",
          "PrimaryContact": "Primary contact",
          "Status": "Status",
          "LogoUpdatedAt": "Logo"
        },
        "logo": {
          "title": "Company logo",
          "alt": "{name} logo",
          "add": "Add company logo",
          "change": "Change company logo",
          "pick": "Choose an image",
          "choose-other": "Choose a different image",
          "rules": "PNG, JPEG or WEBP, up to 2 MB. The image is cropped to a square.",
          "crop-label": "Crop area. Drag, or use the arrow keys, to position the image; + and − zoom.",
          "crop-hint": "Drag the image to position it inside the square.",
          "zoom": "Zoom",
          "zoom-in": "Zoom in",
          "zoom-out": "Zoom out",
          "save": "Save logo",
          "remove": "Remove logo",
          "remove-confirm-title": "Remove company logo?",
          "remove-confirm-body": "The company will show its initials instead of a logo.",
          "errors": {
            "type": "Only PNG, JPEG and WEBP images can be used.",
            "size": "The image must be less than 2 MB.",
            "empty": "The file is empty.",
            "read": "This image could not be read. Try another file.",
            "storage": "The upload did not reach storage. Try again.",
            "generic": "Could not save the logo. Try again."
          },
          "toasts": {
            "saved": "Logo saved.",
            "removed": "Logo removed."
          }
        },
        "danger": {
          "title": "Danger zone",
          "body": "Delete this company and everything it holds — employees, contracts, positions, sites, policies, cost centers and its logo. This cannot be undone.",
          "delete": "Delete company"
        },
        "purge": {
          "title": "Delete company",
          "loading": "Checking what will be deleted…",
          "preview-failed": "Could not load what would be deleted.",
          "blocked-title": "This company can't be deleted yet",
          "blockers": {
            "TENANT_EMPLOYER": "The tenant's own company can never be deleted.",
            "HAS_CHILD_EMPLOYERS": "Other companies, clients, vendors or projects still sit under this one. Delete or move them first."
          },
          "summary": "Deleting {name} removes {total} items:",
          "family-col": "What",
          "count-col": "Items",
          "logo-line": "Company logo",
          "irreversible": "This cannot be undone.",
          "confirm-label": "Type the company ID to confirm",
          "confirm-help": "Type this ID exactly:",
          "mismatch": "The ID doesn't match.",
          "delete": "Delete permanently",
          "progress-start": "Deleting…",
          "progress": "Deleting… {remaining} items left (pass {pass}).",
          "stalled": "Deleting stopped making progress with {remaining} items left. Close this dialog and try again to continue.",
          "failed": "Could not delete the company.",
          "toasts": {
            "done": "\"{name}\" was deleted."
          },
          "families": {
            "Employer": "Company record, counters and policies",
            "Employee": "Employees",
            "EmployeeCode": "Employee codes",
            "Person": "Personal records",
            "FamilyMember": "Family members",
            "PersonDocument": "Personal documents",
            "BankDetail": "Bank details",
            "EmployeeDocument": "Employee documents",
            "Insurance": "Insurance records",
            "EmployeeSetting": "Employee settings",
            "Contract": "Contracts",
            "ContractEvent": "Contract events",
            "EmploymentChange": "Employment changes",
            "EmploymentAction": "Employment actions",
            "CompensationEvent": "Compensation events",
            "Position": "Positions",
            "OrgUnit": "Org units",
            "JobProfile": "Job profiles",
            "JobGrade": "Job grades",
            "JobDescription": "Job titles",
            "BaseLocation": "Sites",
            "WorkZoneBatch": "Work-zone batches",
            "Oversight": "Executive oversight",
            "CostCenter": "Cost centers",
            "CostCenterCode": "Cost-center codes",
            "EmployeeBatch": "Employee batches",
            "Event": "Events",
            "ActionRegistry": "Action registry"
          }
        }
      }
    },
    "tenant-settings": {
      "title": "Workspace & Tenant Settings",
      "subtitle": "Manage your organization’s business type, billing, and platform settings",
      "back": "Back to Admin",
      "live": "Live",
      "coming-soon": "Coming soon",
      "coming-soon-tag": "Soon",
      "stub-toast": "{name} is coming soon",
      "denied": {
        "title": "Top-admin access required",
        "body": "Only tenant-wide administrators can manage workspace settings."
      },
      "business-type": {
        "title": "Business Type",
        "desc": "Promote your workspace to an EOR / outsourcing service provider, or revert to a standard organization. Provider tenants manage clients and projects; standard tenants manage vendors.",
        "provider-label": "Outsourcing service provider",
        "status-provider": "Provider",
        "status-standard": "Standard",
        "hint-provider": "Your workspace is set up for staff outsourcing — you manage clients, projects, and external approvers.",
        "hint-standard": "Standard organization. Enable to run a staff-outsourcing business (manage clients and projects).",
        "toggle-aria": "Toggle outsourcing service provider",
        "promoted": "Workspace promoted to outsourcing service provider.",
        "demoted": "Workspace reverted to a standard organization.",
        "error": "Could not update the business type. Please try again.",
        "demote-confirm-title": "Turn off outsourcing provider?",
        "demote-confirm-desc": "This reverts your workspace to a standard organization.",
        "demote-confirm-body": "Existing clients, projects, and their staff are kept — they’re just no longer surfaced as outsourcing until you re-enable this. You can turn it back on at any time.",
        "demote-confirm-cta": "Turn off"
      },
      "sections": {
        "billing": {
          "title": "Billing",
          "desc": "Payment method, invoices, and billing history."
        },
        "address": {
          "title": "Address & Company Info",
          "desc": "Registered address and legal details."
        },
        "subscription": {
          "title": "Subscription & Plan",
          "desc": "Current plan, seats, and renewal."
        },
        "contacts": {
          "title": "Contacts",
          "desc": "Primary and billing contacts."
        }
      }
    },
    "errors": {
      "dialog": {
        "close": "Close",
        "badRequest": {
          "header": "Request couldn't be completed",
          "message": "We couldn't complete that request. Please review and try again."
        },
        "forbidden": {
          "header": "You don't have access",
          "message": "Your account isn't allowed to do that. If you think this is a mistake, contact your administrator."
        },
        "notFound": {
          "header": "Not found",
          "message": "We couldn't find what you were looking for. It may have moved or been removed."
        },
        "server": {
          "header": "Something went wrong on our end",
          "message": "This is on us, not you. Please try again in a moment — if it keeps happening, let us know."
        },
        "network": {
          "header": "Can't reach the server",
          "message": "We couldn't connect right now. Check your internet connection and try again."
        }
      }
    },
    "admin": {
      "users": {
        "title": "Users & Roles",
        "subtitle": "Manage user accounts, employee links, and company-admin access.",
        "add": "Add User",
        "search-placeholder": "Search username, name, or email",
        "result-count": "{count} users",
        "clear-filter": "Clear {name} filter",
        "clear-search": "Clear search",
        "clear-all": "Clear all",
        "select-all": "Select all users",
        "select-row": "Select {name}",
        "row-actions": "Actions for {name}",
        "retry": "Retry",
        "error": "Couldn't load users. Please try again.",
        "error-403": "You don't have permission to view users for this company.",
        "kpi": {
          "enabled": "Enabled",
          "disabled": "Disabled",
          "admin": "Company Admin",
          "temporary": "Temp Passwords"
        },
        "cols": {
          "username": "Username",
          "employee": "Employee",
          "email": "Email",
          "admin-companies": "Administered Companies",
          "access": "Access Status",
          "password": "Password Status",
          "actions": "Actions",
          "role": "Role"
        },
        "access": {
          "enabled": "Enabled",
          "disabled": "Disabled"
        },
        "password": {
          "temporary": "Temporary",
          "confirmed": "Confirmed",
          "unknown": "Unknown"
        },
        "actions": {
          "edit-email": "Edit email",
          "admin-company": "Company admin access",
          "enable": "Enable access",
          "disable": "Disable access",
          "delete": "Delete user",
          "change-role": "Change role"
        },
        "empty": {
          "title": "No users yet",
          "subtitle": "Add a user to link a sign-in account to an employee."
        },
        "empty-filtered": {
          "title": "No matching users",
          "subtitle": "Try a different search or clear the filters."
        },
        "form": {
          "create-title": "Create User",
          "create-subtitle": "Link a sign-in account to an existing employee.",
          "edit-email-title": "Edit User Email",
          "edit-email-subtitle": "Change the email on this user's account.",
          "admin-company-title": "Company Admin Access",
          "admin-company-subtitle": "Choose which companies this user can administer.",
          "employee": "Employee",
          "employee-placeholder": "Select an employee to link to this user",
          "employee-required": "Select an employee to link.",
          "loading-employees": "Loading employees…",
          "username": "Username",
          "first-name": "First Name",
          "last-name": "Last Name",
          "email": "Email",
          "phone": "Phone Number",
          "invalid-email": "Invalid email address.",
          "new-email": "New Email",
          "new-email-placeholder": "Enter new email",
          "selected-user": "Selected User Information",
          "managed-companies": "Companies Currently Managed",
          "managed-companies-desc": "These are the companies this user currently manages. Remove access using the button on each row.",
          "grant-more": "Grant Admin Access to Additional Companies",
          "grant-more-desc": "Select one or more companies to grant admin access. The user can then manage employees, settings, and attendance for them.",
          "remove-company": "Remove {name}",
          "no-companies": "No companies assigned",
          "no-more-companies": "No additional companies available",
          "add": "Add",
          "new": "new",
          "create": "Create",
          "update": "Update",
          "cancel": "Cancel"
        },
        "confirm": {
          "enable-title": "Enable user?",
          "enable-message": "This user will be able to sign in again.",
          "enable": "Enable",
          "disable-title": "Disable user?",
          "disable-message": "This user will no longer be able to sign in.",
          "disable": "Disable",
          "delete-title": "Delete user?",
          "delete-message": "This permanently removes the user's sign-in account. This can't be undone.",
          "delete": "Delete",
          "cancel": "Cancel"
        },
        "toast": {
          "created": "User {name} created.",
          "create-error": "Couldn't create the user.",
          "updated": "User updated.",
          "update-error": "Couldn't update the user.",
          "enabled": "Enabled {name}.",
          "disabled": "Disabled {name}.",
          "deleted": "Deleted {name}.",
          "action-error": "The action failed. Please try again."
        },
        "role": {
          "TenantAdmin": "Admin",
          "TenantHR": "HR",
          "TenantUser": "User",
          "Unknown": "Unknown"
        },
        "change-role": {
          "title": "Change role",
          "subtitle": "Choose what this account may do.",
          "role-label": "Role",
          "role-placeholder": "Select a role",
          "save": "Save",
          "saving": "Saving…",
          "done": "Done",
          "sign-in-again": "They need to sign out and in again for the new role to apply.",
          "toast-changed": "{name} is now {role}.",
          "toast-unchanged": "{name} already has the {role} role.",
          "error-400": "That role is not one this account can have.",
          "error-403": "Only a tenant admin can grant or remove the Admin role.",
          "error-404": "This account is not linked to this company.",
          "error-409": "You cannot change your own role.",
          "error": "Couldn't change the role. Please try again."
        }
      },
      "costCenters": {
        "title": "Cost Centers",
        "subtitle": "Codes finance books against, for the active company",
        "back": "Back to Admin",
        "add": "Add cost center",
        "retry": "Retry",
        "no-match": "No cost centers match these filters.",
        "result-count": "Showing {shown} of {total} cost centers",
        "status-filter": {
          "label": "Status",
          "active": "Active",
          "inactive": "Inactive",
          "all": "All"
        },
        "search": {
          "label": "Search cost centers",
          "placeholder": "Search code, name or description"
        },
        "filter-chip": {
          "search": "Search: {value}",
          "remove": "Remove filter {label}",
          "clear-all": "Clear all"
        },
        "export": {
          "label": "Export",
          "empty": "Nothing to export"
        },
        "cols": {
          "code": "Code",
          "name": "Name",
          "description": "Description",
          "status": "Status",
          "updated": "Last updated",
          "actions": "Actions"
        },
        "status": {
          "active": "Active",
          "inactive": "Inactive",
          "unknown": "Unknown"
        },
        "empty": {
          "title": "No cost centers yet",
          "desc": "Add the cost centers this company books costs against."
        },
        "actions": {
          "edit": "Edit",
          "edit-aria": "Edit {name}",
          "deactivate": "Deactivate",
          "deactivate-aria": "Deactivate {name}",
          "reactivate": "Reactivate",
          "reactivate-aria": "Reactivate {name}",
          "history": "History",
          "history-aria": "Edit history of {name}"
        },
        "confirm": {
          "deactivate-title": "Deactivate cost center?",
          "deactivate-body": "{name} ({code}) will no longer be offered for new bookings. It keeps its code, and you can reactivate it at any time.",
          "reactivate-title": "Reactivate cost center?",
          "reactivate-body": "{name} ({code}) will be offered for bookings again."
        },
        "history": {
          "title": "Cost center history"
        },
        "form": {
          "add-title": "Add cost center",
          "add-desc": "A new cost center is active straight away.",
          "edit-title": "Edit cost center",
          "name": "Name",
          "name-placeholder": "e.g. HR & Admin Costs",
          "code": "Code",
          "code-placeholder": "e.g. HRADMIN",
          "code-hint": "Unique in this company. Capitals and extra spaces are ignored when comparing.",
          "description": "Description",
          "description-placeholder": "Optional",
          "cancel": "Cancel",
          "save": "Save changes",
          "create": "Add cost center",
          "reload": "Reload",
          "errors": {
            "name-required": "Enter a name.",
            "name-too-long": "Use at most {max} characters.",
            "code-required": "Enter a code.",
            "code-too-long": "Use at most {max} characters.",
            "code-hash": "A code cannot contain \"#\".",
            "description-too-long": "Use at most {max} characters.",
            "code-taken": "Another cost center of this company already uses this code.",
            "version-conflict": "Someone else changed this cost center since you opened it. Reload it and make your change again."
          }
        },
        "errors": {
          "load": "Could not load the cost centers.",
          "forbidden": "You don't have permission to change cost centers for this company.",
          "not-found": "This cost center no longer exists.",
          "no-company": "Choose a company first.",
          "generic": "The change could not be saved. Try again."
        }
      }
    },
    "scope": {
      "all-scopes": "All Scopes",
      "all-companies": "All Companies",
      "this-company": "this company",
      "tenant-fallback": "Tenant",
      "hint": "ownership context",
      "breadcrumb-label": "Active scope",
      "kind": {
        "oversight": "All Scopes · oversight",
        "company": "Company",
        "client": "Client",
        "vendor": "Vendor",
        "project": "Project",
        "direct": "Direct"
      },
      "empty-notice": "No {label} records for {company}. These are recorded per operating company — this company has none in the sample data. Switch to an operating company or All Scopes.",
      "direct-workforce": "Direct Workforce",
      "direct-path-label": "{company} (Direct)"
    },
    "legal": {
      "back-to-sign-in": "Back to sign in",
      "terms": {
        "title": "Terms of Service",
        "updated": "Last updated: 16 June 2026",
        "contact": "Questions about these terms? Contact us at {email}.",
        "sections": [
          {
            "heading": "1. Introduction",
            "body": "These Terms of Service govern your access to and use of the OptimalHR platform, a multi-tenant Human Capital Management service operated by Optimal P HR Strategic Partner Co., Ltd. By signing in or using the service, you agree to these terms on behalf of your organization."
          },
          {
            "heading": "2. Accounts and access",
            "body": "Access is provisioned by your organization’s HR administrator. You are responsible for keeping your credentials confidential and for all activity under your account. Notify your administrator immediately if you suspect unauthorized access."
          },
          {
            "heading": "3. Acceptable use",
            "body": "You agree not to misuse the service, attempt to access data belonging to other tenants, interfere with normal operation, or use the platform in violation of applicable Cambodian law or the labour regulations governing your organization."
          },
          {
            "heading": "4. Customer data",
            "body": "Your organization owns the employee and payroll data it submits. We process that data only to provide the service, under the data-isolation controls described in our Privacy Policy. We do not sell customer data."
          },
          {
            "heading": "5. Service availability",
            "body": "We aim for high availability but do not guarantee uninterrupted service. Scheduled maintenance and updates may temporarily affect access. Critical incidents are communicated to tenant administrators."
          },
          {
            "heading": "6. Changes to these terms",
            "body": "We may update these terms from time to time. Material changes will be communicated to tenant administrators before they take effect. Continued use after changes constitutes acceptance."
          }
        ]
      },
      "privacy": {
        "title": "Privacy Policy",
        "updated": "Last updated: 16 June 2026",
        "contact": "For privacy requests or questions, contact us at {email}.",
        "sections": [
          {
            "heading": "Introduction",
            "body": "This Privacy Policy explains how OptimalHR collects, uses, retains and protects personal information processed through the platform. It applies to all environments (Dev, Staging, Prod) operated for your organization."
          },
          {
            "heading": "Data we collect",
            "body": "We process employee profile data, contact details, employment and contract records, attendance, leave, overtime, and payroll information that your organization enters or uploads. Authentication data is handled by Amazon Cognito."
          },
          {
            "heading": "How we use data",
            "body": "Personal data is used solely to deliver the HR services your organization has configured — processing payroll, tracking attendance and leave, routing approvals, and producing reports. We do not use it for advertising."
          },
          {
            "heading": "Data isolation and security",
            "body": "OptimalHR uses a multi-tenant architecture with isolation enforced at the database (IAM policy) level. Each tenant’s data is partitioned and access-controlled so it cannot be read by another tenant. Sensitive identifiers are never written to operational logs."
          },
          {
            "heading": "Data retention",
            "body": "We retain personal data for as long as your organization maintains its subscription and as required by Cambodian labour and tax law. On termination, data is deleted or returned according to your organization’s instructions."
          },
          {
            "heading": "Your rights",
            "body": "Employees may request access to or correction of their personal data through their HR administrator. Administrators can action these requests within the platform or by contacting our support team."
          },
          {
            "heading": "Contact",
            "body": "Privacy enquiries are handled by our data protection contact below. We respond to verified requests within a reasonable period."
          }
        ]
      }
    },
    "own": {
      "direct-workforce": "Direct Workforce",
      "company-root": "{name} · company root",
      "commercial-owner": "{name} · Commercial Owner",
      "these-operations": "These operations",
      "refusal": {
        "unit": "{label} happen at the owning scope (Direct Workforce / Project) — oversight is read-only review.",
        "company": "{label} are company-owned reference data — manage them at the company context (company root).",
        "governance": "{label} is company-level governance — manage it at the company context (company root).",
        "commercial": "{label} belong to the commercial owner at the provider company root — this scope is a read-only commercial view."
      }
    },
    "demo": {
      "reset": {
        "button": "Reset {module} demo data",
        "title": "Restore the deterministic {module} demo baseline",
        "ask": "Reset all {module} demo data to the baseline?",
        "keep": "Keep",
        "go": "Reset demo data",
        "flash": "{module} demo data reset to the deterministic baseline."
      }
    }
  }
}
